import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  DateTime: { input: any; output: any };
  Json: { input: any; output: any };
};

export type ActiveEngagementChangedPayload = {
  __typename?: 'ActiveEngagementChangedPayload';
  activeEngagement?: Maybe<Engagement>;
};

export type Ban = {
  __typename?: 'Ban';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  hiddenCount: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  sourceEngagement?: Maybe<Engagement>;
  sourceEngagementId?: Maybe<Scalars['String']['output']>;
  sourceEvent?: Maybe<Event>;
  sourceEventId?: Maybe<Scalars['String']['output']>;
  sourcePhotoUrl?: Maybe<Scalars['String']['output']>;
  sourceSubmissionId?: Maybe<Scalars['String']['output']>;
  user: User;
  userId: Scalars['String']['output'];
};

export type BanPayload = {
  __typename?: 'BanPayload';
  ban: Ban;
  hiddenCount: Scalars['Int']['output'];
};

export type BetaSignup = {
  __typename?: 'BetaSignup';
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type CanMakeEventLiveResponse = {
  __typename?: 'CanMakeEventLiveResponse';
  liveCount: Scalars['Int']['output'];
  withEventPass: Scalars['Boolean']['output'];
  withSubscription: Scalars['Boolean']['output'];
};

export type CookiePreferences = {
  __typename?: 'CookiePreferences';
  analytics: Scalars['Boolean']['output'];
  consentDate?: Maybe<Scalars['String']['output']>;
  functional: Scalars['Boolean']['output'];
  marketing: Scalars['Boolean']['output'];
};

export type CookiePreferencesInput = {
  analytics: Scalars['Boolean']['input'];
  consentDate?: InputMaybe<Scalars['String']['input']>;
  functional: Scalars['Boolean']['input'];
  marketing: Scalars['Boolean']['input'];
};

export type CreateCustomerPortalSessionResponse = {
  __typename?: 'CreateCustomerPortalSessionResponse';
  url: Scalars['String']['output'];
};

export type CreateEngagementInput = {
  config?: InputMaybe<Scalars['Json']['input']>;
  data?: InputMaybe<Scalars['Json']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  qrCodeCta?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  title: Scalars['String']['input'];
  type: EngagementType;
};

export type CreateEventInput = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  live?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  startingEngagements?: InputMaybe<Array<CreateEngagementInput>>;
  themeConfig?: InputMaybe<EventThemeConfigUpdateInput>;
};

export type CreateEventPassCheckoutSessionInput = {
  cancelUrl: Scalars['String']['input'];
  successUrl: Scalars['String']['input'];
};

export type CreateEventPassCheckoutSessionResponse = {
  __typename?: 'CreateEventPassCheckoutSessionResponse';
  eventPassId: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type CreateEventPassPaymentIntentResponse = {
  __typename?: 'CreateEventPassPaymentIntentResponse';
  clientSecret: Scalars['String']['output'];
  eventPassId: Scalars['String']['output'];
};

export type CreateReactionInput = {
  type: Scalars['String']['input'];
};

export type CreateSubmissionInput = {
  data: Scalars['Json']['input'];
};

export type CreateSubscriptionCheckoutSessionInput = {
  cancelUrl: Scalars['String']['input'];
  successUrl: Scalars['String']['input'];
};

export type CreateSubscriptionCheckoutSessionResponse = {
  __typename?: 'CreateSubscriptionCheckoutSessionResponse';
  sessionId: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type DeviceAccess = {
  __typename?: 'DeviceAccess';
  allowed: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type Engagement = {
  __typename?: 'Engagement';
  config?: Maybe<EngagementAdminConfig>;
  createdAt: Scalars['DateTime']['output'];
  data?: Maybe<EngagementAdminData>;
  description?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['DateTime']['output']>;
  eventId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  qrCodeCta?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['DateTime']['output']>;
  submissions: Array<Submission>;
  title: Scalars['String']['output'];
  type: EngagementType;
  updatedAt: Scalars['DateTime']['output'];
  viewConfig: EngagementViewConfig;
  viewData: EngagementViewData;
};

export type EngagementAdminConfig =
  | NowPlayingAdminConfig
  | PhotoCarouselAdminConfig
  | RaffleAdminConfig
  | SlidesAdminConfig
  | TriviaAdminConfig
  | VoteForAdminConfig;

export type EngagementAdminData =
  | NowPlayingAdminData
  | PhotoCarouselAdminData
  | RaffleAdminData
  | SlidesAdminData
  | TriviaAdminData
  | VoteForAdminData;

export type EngagementChangedPayload = {
  __typename?: 'EngagementChangedPayload';
  engagement: Engagement;
};

export type EngagementSubmissionData =
  | NowPlayingSubmissionData
  | PhotoCarouselSubmissionData
  | RaffleSubmissionData
  | SlidesSubmissionData
  | TriviaSubmissionData
  | VoteForSubmissionData;

export type EngagementSubmissionsChangedPayload = {
  __typename?: 'EngagementSubmissionsChangedPayload';
  submissions: Array<Submission>;
};

export enum EngagementType {
  NowPlaying = 'NOW_PLAYING',
  PhotoCarousel = 'PHOTO_CAROUSEL',
  Raffle = 'RAFFLE',
  Slides = 'SLIDES',
  Trivia = 'TRIVIA',
  VoteFor = 'VOTE_FOR',
}

export type EngagementViewConfig =
  | NowPlayingViewConfig
  | PhotoCarouselViewConfig
  | RaffleViewConfig
  | SlidesViewConfig
  | TriviaViewConfig
  | VoteForViewConfig;

export type EngagementViewData =
  | NowPlayingViewData
  | PhotoCarouselViewData
  | RaffleViewData
  | SlidesViewData
  | TriviaViewData
  | VoteForViewData;

export type EngagementViewDataChangedPayload = {
  __typename?: 'EngagementViewDataChangedPayload';
  viewData: EngagementViewData;
};

export type Event = {
  __typename?: 'Event';
  activeEngagement?: Maybe<Engagement>;
  activeEngagementId?: Maybe<Scalars['String']['output']>;
  collaborators: Array<User>;
  createdAt: Scalars['DateTime']['output'];
  date?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  engagements: Array<Engagement>;
  eventPassRedemptionInUse?: Maybe<EventPassRedemption>;
  eventPassRedemptions: Array<EventPassRedemption>;
  id: Scalars['String']['output'];
  live: Scalars['Boolean']['output'];
  location?: Maybe<Scalars['String']['output']>;
  locked: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  screenCode?: Maybe<Scalars['String']['output']>;
  subscriptionInUse?: Maybe<PaymentSubscription>;
  themeConfig?: Maybe<EventThemeConfig>;
  updatedAt: Scalars['DateTime']['output'];
};

export type EventByCodeResponse = {
  __typename?: 'EventByCodeResponse';
  eventId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type EventPass = {
  __typename?: 'EventPass';
  amountPaid?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  redemptions: Array<EventPassRedemption>;
  status: EventPassStatus;
  stripeChargeId?: Maybe<Scalars['String']['output']>;
  stripeCheckoutSessionId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  userId: Scalars['String']['output'];
};

export type EventPassRedemption = {
  __typename?: 'EventPassRedemption';
  description?: Maybe<Scalars['String']['output']>;
  eventId: Scalars['String']['output'];
  eventPassId: Scalars['String']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  redeemedAt: Scalars['DateTime']['output'];
};

export enum EventPassStatus {
  Expired = 'EXPIRED',
  Paid = 'PAID',
  PendingPayment = 'PENDING_PAYMENT',
  Redeemed = 'REDEEMED',
  Refunded = 'REFUNDED',
}

export type EventThemeConfig = {
  __typename?: 'EventThemeConfig';
  backgroundColor?: Maybe<Scalars['String']['output']>;
  bodyFontFamily?: Maybe<Array<Scalars['String']['output']>>;
  fanBackgroundImage?: Maybe<Scalars['String']['output']>;
  fanElements?: Maybe<Array<ScreenElement>>;
  foregroundColor?: Maybe<Scalars['String']['output']>;
  headingFontFamily?: Maybe<Array<Scalars['String']['output']>>;
  qrBackgroundColor?: Maybe<Scalars['String']['output']>;
  qrForegroundColor?: Maybe<Scalars['String']['output']>;
  qrTextColor?: Maybe<Scalars['String']['output']>;
  qrWrapperBackgroundColor?: Maybe<Scalars['String']['output']>;
  stageBackgroundImage?: Maybe<Scalars['String']['output']>;
  stageElements?: Maybe<Array<ScreenElement>>;
};

export type EventThemeConfigUpdateInput = {
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  bodyFontFamily?: InputMaybe<Array<Scalars['String']['input']>>;
  fanBackgroundImage?: InputMaybe<Scalars['String']['input']>;
  fanElements?: InputMaybe<Array<ScreenElementInput>>;
  foregroundColor?: InputMaybe<Scalars['String']['input']>;
  headingFontFamily?: InputMaybe<Array<Scalars['String']['input']>>;
  qrBackgroundColor?: InputMaybe<Scalars['String']['input']>;
  qrForegroundColor?: InputMaybe<Scalars['String']['input']>;
  qrTextColor?: InputMaybe<Scalars['String']['input']>;
  qrWrapperBackgroundColor?: InputMaybe<Scalars['String']['input']>;
  stageBackgroundImage?: InputMaybe<Scalars['String']['input']>;
  stageElements?: InputMaybe<Array<ScreenElementInput>>;
};

export type FeatureFlags = {
  __typename?: 'FeatureFlags';
  bansEnabled: Scalars['Boolean']['output'];
  eventPassPromoCode: Scalars['String']['output'];
  googleAuth: Scalars['Boolean']['output'];
  monetizationEnabled: Scalars['Boolean']['output'];
  subscriptionPromoCode: Scalars['String']['output'];
};

export type GenerateImageInput = {
  prompt: Scalars['String']['input'];
  size: Scalars['String']['input'];
};

export type GenerateImageResponse = {
  __typename?: 'GenerateImageResponse';
  error?: Maybe<Scalars['String']['output']>;
  uri?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  banUser: BanPayload;
  cancelSubscription: PaymentSubscription;
  changeEventActiveEngagement: Event;
  createCustomerPortalSession: CreateCustomerPortalSessionResponse;
  createEngagement: Engagement;
  createEvent: Event;
  createEventPassCheckoutSession: CreateEventPassCheckoutSessionResponse;
  createPresignedUrl: PresignedUrlResponse;
  createReaction: Reaction;
  createScreenTemplate: ScreenTemplate;
  createSubmission: Submission;
  createSubmissionPresignedUrl: PresignedUrlResponse;
  createSubscriptionCheckoutSession: CreateSubscriptionCheckoutSessionResponse;
  deleteEngagement: Engagement;
  deleteEvent: Event;
  deleteReaction: Reaction;
  deleteScreenTemplate: ScreenTemplate;
  deleteSubmission: Submission;
  endLiveSession: Event;
  extendMockEngagement: Scalars['Boolean']['output'];
  generateImage: GenerateImageResponse;
  goLiveWithSubscription: Event;
  logout: Scalars['Boolean']['output'];
  moveEngagement: Array<Engagement>;
  raffleBeginDrawing: Engagement;
  raffleClose: Engagement;
  raffleReopen: Engagement;
  raffleReset: Engagement;
  raffleRestartDrawing: Engagement;
  raffleWiggleTicket: Scalars['Boolean']['output'];
  redeemEventPass: RedeemEventPassResponse;
  requestPasswordReset: RequestPasswordResetResponse;
  resetPassword: ResetPasswordResponse;
  setCookieConsent: SetCookieConsentResponse;
  signup: User;
  signupForBeta: SignupForBetaResponse;
  startMockEngagement: StartMockEngagementResponse;
  stopMockEngagement: Scalars['Boolean']['output'];
  triviaCloseAnswers: Engagement;
  triviaExtendTimer: Engagement;
  triviaJoin: Engagement;
  triviaNextQuestion: Engagement;
  triviaPrevious: Engagement;
  triviaReset: Engagement;
  triviaReveal: Engagement;
  triviaSkipReveal: Engagement;
  triviaStartRound: Engagement;
  triviaSubmitAnswer: TriviaMyAnswer;
  unbanUser: UnbanPayload;
  updateEngagement: Engagement;
  updateEvent: Event;
  updateEventThemeConfig: EventThemeConfig;
  updateReaction: Reaction;
  updateScreenTemplate: ScreenTemplate;
  updateSubmission: Submission;
  updateSubscriptionStatus: Subscription;
  voteForDeclareWinners: Engagement;
  voteForResetVotes: Engagement;
  voteForUndeclareWinners: Engagement;
};

export type MutationBanUserArgs = {
  hideExisting: Scalars['Boolean']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  submissionId: Scalars['String']['input'];
};

export type MutationCancelSubscriptionArgs = {
  subscriptionId: Scalars['String']['input'];
};

export type MutationChangeEventActiveEngagementArgs = {
  engagementId?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['String']['input'];
};

export type MutationCreateEngagementArgs = {
  data: CreateEngagementInput;
  eventId: Scalars['String']['input'];
};

export type MutationCreateEventArgs = {
  data?: InputMaybe<CreateEventInput>;
};

export type MutationCreateEventPassCheckoutSessionArgs = {
  data: CreateEventPassCheckoutSessionInput;
};

export type MutationCreatePresignedUrlArgs = {
  mimeType: Scalars['String']['input'];
};

export type MutationCreateReactionArgs = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
  submissionId: Scalars['String']['input'];
  type: Scalars['String']['input'];
  visitorId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateScreenTemplateArgs = {
  data: ScreenTemplateCreateInput;
};

export type MutationCreateSubmissionArgs = {
  data: Scalars['Json']['input'];
  deviceId?: InputMaybe<Scalars['String']['input']>;
  engagementId: Scalars['String']['input'];
  visitorId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateSubmissionPresignedUrlArgs = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
  engagementId: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
  visitorId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateSubscriptionCheckoutSessionArgs = {
  data: CreateSubscriptionCheckoutSessionInput;
};

export type MutationDeleteEngagementArgs = {
  engagementId: Scalars['String']['input'];
};

export type MutationDeleteEventArgs = {
  eventId: Scalars['String']['input'];
};

export type MutationDeleteReactionArgs = {
  reactionId: Scalars['String']['input'];
};

export type MutationDeleteScreenTemplateArgs = {
  id: Scalars['String']['input'];
};

export type MutationDeleteSubmissionArgs = {
  submissionId: Scalars['String']['input'];
};

export type MutationEndLiveSessionArgs = {
  eventId: Scalars['String']['input'];
};

export type MutationExtendMockEngagementArgs = {
  mockRunId: Scalars['String']['input'];
};

export type MutationGenerateImageArgs = {
  data: GenerateImageInput;
};

export type MutationGoLiveWithSubscriptionArgs = {
  eventId: Scalars['String']['input'];
};

export type MutationMoveEngagementArgs = {
  direction: Scalars['String']['input'];
  engagementId: Scalars['String']['input'];
};

export type MutationRaffleBeginDrawingArgs = {
  engagementId: Scalars['String']['input'];
  winnerCount: Scalars['Int']['input'];
};

export type MutationRaffleCloseArgs = {
  engagementId: Scalars['String']['input'];
};

export type MutationRaffleReopenArgs = {
  engagementId: Scalars['String']['input'];
};

export type MutationRaffleResetArgs = {
  engagementId: Scalars['String']['input'];
};

export type MutationRaffleRestartDrawingArgs = {
  engagementId: Scalars['String']['input'];
};

export type MutationRaffleWiggleTicketArgs = {
  engagementId: Scalars['String']['input'];
  submissionId: Scalars['String']['input'];
};

export type MutationRedeemEventPassArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['String']['input'];
  eventPassId: Scalars['String']['input'];
};

export type MutationRequestPasswordResetArgs = {
  email: Scalars['String']['input'];
};

export type MutationResetPasswordArgs = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type MutationSetCookieConsentArgs = {
  preferences: CookiePreferencesInput;
};

export type MutationSignupArgs = {
  data: SignupInput;
};

export type MutationSignupForBetaArgs = {
  email: Scalars['String']['input'];
};

export type MutationStartMockEngagementArgs = {
  engagementId: Scalars['String']['input'];
};

export type MutationStopMockEngagementArgs = {
  mockRunId: Scalars['String']['input'];
};

export type MutationTriviaCloseAnswersArgs = {
  engagementId: Scalars['String']['input'];
};

export type MutationTriviaExtendTimerArgs = {
  engagementId: Scalars['String']['input'];
};

export type MutationTriviaJoinArgs = {
  engagementId: Scalars['String']['input'];
};

export type MutationTriviaNextQuestionArgs = {
  engagementId: Scalars['String']['input'];
};

export type MutationTriviaPreviousArgs = {
  engagementId: Scalars['String']['input'];
};

export type MutationTriviaResetArgs = {
  engagementId: Scalars['String']['input'];
};

export type MutationTriviaRevealArgs = {
  engagementId: Scalars['String']['input'];
};

export type MutationTriviaSkipRevealArgs = {
  engagementId: Scalars['String']['input'];
};

export type MutationTriviaStartRoundArgs = {
  engagementId: Scalars['String']['input'];
};

export type MutationTriviaSubmitAnswerArgs = {
  choiceId: Scalars['String']['input'];
  engagementId: Scalars['String']['input'];
  questionId: Scalars['String']['input'];
};

export type MutationUnbanUserArgs = {
  banId: Scalars['String']['input'];
  eventId: Scalars['String']['input'];
};

export type MutationUpdateEngagementArgs = {
  data: UpdateEngagementInput;
  engagementId: Scalars['String']['input'];
};

export type MutationUpdateEventArgs = {
  data?: InputMaybe<UpdateEventInput>;
  eventId: Scalars['String']['input'];
};

export type MutationUpdateEventThemeConfigArgs = {
  data?: InputMaybe<EventThemeConfigUpdateInput>;
  eventId: Scalars['String']['input'];
};

export type MutationUpdateReactionArgs = {
  reactionId: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type MutationUpdateScreenTemplateArgs = {
  data: ScreenTemplateUpdateInput;
  id: Scalars['String']['input'];
};

export type MutationUpdateSubmissionArgs = {
  data: Scalars['Json']['input'];
  submissionId: Scalars['String']['input'];
};

export type MutationUpdateSubscriptionStatusArgs = {
  cancelAtPeriodEnd: Scalars['Boolean']['input'];
  canceledAt?: InputMaybe<Scalars['DateTime']['input']>;
  currentPeriodEnd: Scalars['DateTime']['input'];
  currentPeriodStart: Scalars['DateTime']['input'];
  status: PaymentSubscriptionStatus;
  stripeSubscriptionId: Scalars['String']['input'];
};

export type MutationVoteForDeclareWinnersArgs = {
  engagementId: Scalars['String']['input'];
};

export type MutationVoteForResetVotesArgs = {
  engagementId: Scalars['String']['input'];
};

export type MutationVoteForUndeclareWinnersArgs = {
  engagementId: Scalars['String']['input'];
};

export type NowPlayingAdminConfig = {
  __typename?: 'NowPlayingAdminConfig';
  /** Whether to allow comments on the now playing engagement. */
  allowComments: Scalars['Boolean']['output'];
  /** The types of reactions that are allowed on the now playing engagement. */
  allowedReactions: Array<Scalars['String']['output']>;
  /**
   * The default type of visualization to use for this now playing engagement.
   *
   * Supported values: "default"
   */
  visualizationType: Scalars['String']['output'];
};

export type NowPlayingAdminData = {
  __typename?: 'NowPlayingAdminData';
  /** The id of the current song (submission) in the list of songs */
  currentSong?: Maybe<Scalars['String']['output']>;
};

export type NowPlayingSubmissionData = {
  __typename?: 'NowPlayingSubmissionData';
  /** The order of the slide in the slideshow. */
  order: Scalars['Int']['output'];
  /** The url of the photo to display on the slide. */
  songAlbumArt?: Maybe<Scalars['String']['output']>;
  /** The artist of the song. */
  songArtist?: Maybe<Scalars['String']['output']>;
  /** The lyrics of the song that are displayed on the slide. Not recommended to be more than a few lines. */
  songLyrics?: Maybe<Scalars['String']['output']>;
  /** The notes of the song. */
  songNotes?: Maybe<Scalars['String']['output']>;
  /** The title of the song. */
  songTitle?: Maybe<Scalars['String']['output']>;
  /** The Spotify link for the song. */
  spotifyUrl?: Maybe<Scalars['String']['output']>;
  /** Optional override for the visualization type. */
  visualizationType?: Maybe<Scalars['String']['output']>;
};

export type NowPlayingViewConfig = {
  __typename?: 'NowPlayingViewConfig';
  /** Whether to allow comments on the now playing engagement. */
  allowComments: Scalars['Boolean']['output'];
  /** The types of reactions that are allowed on the now playing engagement. */
  allowedReactions: Array<Scalars['String']['output']>;
  /** The type of visualization to use for the now playing engagement. */
  visualizationType: Scalars['String']['output'];
};

export type NowPlayingViewData = {
  __typename?: 'NowPlayingViewData';
  /** The id of the current song (submission) in the list of songs */
  currentSong?: Maybe<Scalars['String']['output']>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PaymentSubscription = {
  __typename?: 'PaymentSubscription';
  cancelAtPeriodEnd: Scalars['Boolean']['output'];
  canceledAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currentPeriodEnd?: Maybe<Scalars['DateTime']['output']>;
  currentPeriodStart?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  liveEvents: Array<Event>;
  maxConcurrentEvents: Scalars['Int']['output'];
  status: PaymentSubscriptionStatus;
  stripeCustomerId: Scalars['String']['output'];
  stripePriceId: Scalars['String']['output'];
  stripeSubscriptionId: Scalars['String']['output'];
  trialEnd?: Maybe<Scalars['DateTime']['output']>;
  trialStart?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  userId: Scalars['String']['output'];
};

export enum PaymentSubscriptionStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Incomplete = 'INCOMPLETE',
  IncompleteExpired = 'INCOMPLETE_EXPIRED',
  PastDue = 'PAST_DUE',
  Trialing = 'TRIALING',
  Unpaid = 'UNPAID',
}

/** Full configuration options for the photo carousel engagement */
export type PhotoCarouselAdminConfig = {
  __typename?: 'PhotoCarouselAdminConfig';
  /** Whether to ask the user for permission to use their photo in a social media post. */
  askSharePermission?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The maximum number of submissions a user can make for this engagement.
   * 0 means no limit.
   */
  maxSubmissionsPerUser: Scalars['Int']['output'];
  /**
   * How many photos stay stacked on Stage. Older photos re-layer once
   * there are more than this many. Defaults to 10. Min 1, max 50.
   */
  maxVisiblePhotos: Scalars['Int']['output'];
  /** The message to display when there are no photos. */
  noPhotosMessage?: Maybe<Scalars['String']['output']>;
  /** The interval in milliseconds to poll for new submissions. */
  pollInterval?: Maybe<Scalars['Int']['output']>;
  /** The predefined captions to use for the photos. */
  predefinedCaptions?: Maybe<Array<Scalars['String']['output']>>;
  /** Whether to require approval of submissions by admins before they are visible. */
  requireApproval: Scalars['Boolean']['output'];
  /** The text of the share permission prompt. */
  sharePrompt?: Maybe<Scalars['String']['output']>;
};

/** Data structure for the photo carousel admin view */
export type PhotoCarouselAdminData = {
  __typename?: 'PhotoCarouselAdminData';
  /** The queue of submission ids that have been rejected by admins. */
  rejectedQueue: Array<Scalars['String']['output']>;
  /** The queue of submission ids that have been seen by the user. */
  seenQueue: Array<Scalars['String']['output']>;
  /** The pointer to the next submission to be seen. */
  seenQueuePointer: Scalars['Int']['output'];
  /** The queue of submission ids that have not yet been approved by admins. */
  unapprovedQueue: Array<Scalars['String']['output']>;
  /** The queue of submission ids that have not yet been seen by the user. */
  unseenQueue: Array<Scalars['String']['output']>;
  /** The id of the submission that is currently visible to the user. */
  visibleSubmission?: Maybe<Scalars['String']['output']>;
};

export type PhotoCarouselDownloadResponse = {
  __typename?: 'PhotoCarouselDownloadResponse';
  downloadUrl: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/** Data structure for a photo carousel submission */
export type PhotoCarouselSubmissionData = {
  __typename?: 'PhotoCarouselSubmissionData';
  /** Whether the submission has been approved by admins. */
  approved?: Maybe<Scalars['Boolean']['output']>;
  /** The caption of the photo submission. */
  caption?: Maybe<Scalars['String']['output']>;
  /** The url of the photo submission. */
  photoUrl?: Maybe<Scalars['String']['output']>;
  /** Whether the user has granted permission to use their photo in a social media post. */
  sharingPermissionGranted?: Maybe<Scalars['Boolean']['output']>;
  /** social media handles */
  socialMediaHandles?: Maybe<SocialMediaHandles>;
};

/** Configuration options for the photo carousel view */
export type PhotoCarouselViewConfig = {
  __typename?: 'PhotoCarouselViewConfig';
  /** Whether to ask the user for permission to use their photo in a social media post. */
  askSharePermission?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The maximum number of submissions a user can make for this engagement.
   * 0 means no limit.
   */
  maxSubmissionsPerUser: Scalars['Int']['output'];
  /**
   * How many photos stay stacked on Stage. Older photos re-layer once
   * there are more than this many. Defaults to 10.
   */
  maxVisiblePhotos: Scalars['Int']['output'];
  /** The message to display when there are no photos. */
  noPhotosMessage?: Maybe<Scalars['String']['output']>;
  /** The text of the share permission prompt. */
  sharePrompt?: Maybe<Scalars['String']['output']>;
};

/** Data structure for the photo carousel view */
export type PhotoCarouselViewData = {
  __typename?: 'PhotoCarouselViewData';
  /** The id of the submission that is currently visible to the user. */
  visibleSubmission?: Maybe<Scalars['String']['output']>;
};

export type PresignedUrlResponse = {
  __typename?: 'PresignedUrlResponse';
  key: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Pricing = {
  __typename?: 'Pricing';
  eventPass: Scalars['Int']['output'];
  subscription: Scalars['Int']['output'];
};

export type Query = {
  __typename?: 'Query';
  activeEventEngagement?: Maybe<Engagement>;
  banCount: Scalars['Int']['output'];
  bans: Array<Ban>;
  betaSignups: Array<BetaSignup>;
  canCreateSubmission: Scalars['Boolean']['output'];
  canMakeEventLive: CanMakeEventLiveResponse;
  deviceAccess: DeviceAccess;
  engagement?: Maybe<Engagement>;
  engagementReactions: Array<Reaction>;
  engagementSubmissionsByUser: Array<Submission>;
  engagements: Array<Engagement>;
  event?: Maybe<Event>;
  eventByCode: EventByCodeResponse;
  eventPassRedemptions: Array<EventPassRedemption>;
  events: Array<Event>;
  featureFlags: FeatureFlags;
  myEventPasses: Array<EventPass>;
  mySubscription?: Maybe<PaymentSubscription>;
  photoCarouselDownload: PhotoCarouselDownloadResponse;
  photoCarouselRandomCaption: Scalars['String']['output'];
  pricing: Pricing;
  privacyPolicy: Scalars['String']['output'];
  randomName: Scalars['String']['output'];
  screenTemplate?: Maybe<ScreenTemplate>;
  screenTemplates: Array<ScreenTemplate>;
  submission?: Maybe<Submission>;
  submissions: Array<Submission>;
  termsOfUse: Scalars['String']['output'];
  triviaMyAnswers: TriviaMyProgress;
  users: UserConnection;
  validateGoogleFont: Scalars['Boolean']['output'];
  whoami?: Maybe<User>;
};

export type QueryActiveEventEngagementArgs = {
  eventId: Scalars['String']['input'];
};

export type QueryBanCountArgs = {
  eventId: Scalars['String']['input'];
};

export type QueryBansArgs = {
  eventId: Scalars['String']['input'];
};

export type QueryCanCreateSubmissionArgs = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
  engagementId: Scalars['String']['input'];
  visitorId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCanMakeEventLiveArgs = {
  eventId: Scalars['String']['input'];
};

export type QueryDeviceAccessArgs = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
  engagementId: Scalars['String']['input'];
  visitorId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryEngagementArgs = {
  id: Scalars['String']['input'];
};

export type QueryEngagementReactionsArgs = {
  engagementId: Scalars['String']['input'];
};

export type QueryEngagementSubmissionsByUserArgs = {
  engagementId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type QueryEngagementsArgs = {
  eventId: Scalars['String']['input'];
};

export type QueryEventArgs = {
  id: Scalars['String']['input'];
};

export type QueryEventByCodeArgs = {
  code: Scalars['String']['input'];
};

export type QueryEventPassRedemptionsArgs = {
  eventId: Scalars['String']['input'];
};

export type QueryPhotoCarouselDownloadArgs = {
  engagementId: Scalars['String']['input'];
};

export type QueryPhotoCarouselRandomCaptionArgs = {
  engagementId: Scalars['String']['input'];
};

export type QueryScreenTemplateArgs = {
  id: Scalars['String']['input'];
};

export type QueryScreenTemplatesArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};

export type QuerySubmissionArgs = {
  id: Scalars['String']['input'];
};

export type QuerySubmissionsArgs = {
  engagementId: Scalars['String']['input'];
};

export type QueryTriviaMyAnswersArgs = {
  engagementId: Scalars['String']['input'];
};

export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryValidateGoogleFontArgs = {
  fontName: Scalars['String']['input'];
};

/** Full configuration options for the raffle engagement */
export type RaffleAdminConfig = {
  __typename?: 'RaffleAdminConfig';
  /** Completed-state claim copy shown on Stage and Fan. */
  claimYourPrize?: Maybe<Scalars['String']['output']>;
  /** The url of an optional image to display in the raffle view. */
  optionalImageUrl?: Maybe<Scalars['String']['output']>;
  /** Flip order for newly added Stage tickets. */
  ticketFlipDirection: RaffleTicketFlipDirection;
};

/** Data structure for the raffle admin view */
export type RaffleAdminData = {
  __typename?: 'RaffleAdminData';
  /** Submission id most recently eliminated. */
  lastEliminatedSubmissionId?: Maybe<Scalars['String']['output']>;
  /**
   * User ids of everyone who entered. Kept in sync with Submission rows on
   * enter, ticket remove, and Reset. Stage and Admin list tickets from
   * submissions; this is the parallel user-id list on engagement data.
   */
  raffleCandidates: Array<Scalars['String']['output']>;
  /** The status of the raffle. */
  raffleStatus: RaffleStatus;
  /** First winner submission id, when any. Kept for older clients. */
  raffleWinner?: Maybe<Scalars['String']['output']>;
  /** Submission ids of the raffle winners. Empty until drawing completes. */
  raffleWinners: Array<Scalars['String']['output']>;
  /** Submission ids still in the drawing. Empty before drawing starts. */
  remainingSubmissionIds: Array<Scalars['String']['output']>;
  /** How many winners the admin requested for this drawing. */
  winnerCount: Scalars['Int']['output'];
};

export enum RaffleStatus {
  Completed = 'COMPLETED',
  Drawing = 'DRAWING',
  Open = 'OPEN',
  ReadyToDraw = 'READY_TO_DRAW',
}

/** Data structure for a raffle submission. In this context, a submission is a user's entry in the raffle. */
export type RaffleSubmissionData = {
  __typename?: 'RaffleSubmissionData';
  name: Scalars['String']['output'];
  optionalImageUrl?: Maybe<Scalars['String']['output']>;
};

/**
 * How newly added Stage tickets animate: start on one face, then flip to the other.
 * Existing tickets already on Stage keep the direction they first used.
 */
export enum RaffleTicketFlipDirection {
  /**
   * Start on the admit (printed) face, then flip to the drawing (signed) face.
   * This is the historical default.
   */
  AdmitToDrawing = 'ADMIT_TO_DRAWING',
  /** Start on the drawing (signed) face, then flip to the admit (printed) face. */
  DrawingToAdmit = 'DRAWING_TO_ADMIT',
}

export type RaffleTicketWiggledPayload = {
  __typename?: 'RaffleTicketWiggledPayload';
  engagementId: Scalars['String']['output'];
  submissionId: Scalars['String']['output'];
};

/** Configuration options for the raffle view */
export type RaffleViewConfig = {
  __typename?: 'RaffleViewConfig';
  /** Completed-state claim copy shown on Stage and Fan. */
  claimYourPrize?: Maybe<Scalars['String']['output']>;
  /** The url of an optional image to display in the raffle view. */
  optionalImageUrl?: Maybe<Scalars['String']['output']>;
  /** Flip order for newly added Stage tickets. */
  ticketFlipDirection: RaffleTicketFlipDirection;
};

/** Data structure for the raffle view */
export type RaffleViewData = {
  __typename?: 'RaffleViewData';
  /**
   * Submission id most recently eliminated. Used so Stage and Fan play the
   * same disposal; not a stored animation type.
   */
  lastEliminatedSubmissionId?: Maybe<Scalars['String']['output']>;
  /**
   * User ids of everyone who entered. Kept in sync with Submission rows on
   * enter, ticket remove, and Reset. Stage and Admin list tickets from
   * submissions; this is the parallel user-id list on engagement data.
   */
  raffleCandidates: Array<Scalars['String']['output']>;
  raffleStatus: RaffleStatus;
  /** First winner submission id, when any. Kept for older clients. */
  raffleWinner?: Maybe<Scalars['String']['output']>;
  /** Submission ids of the raffle winners. Empty until drawing completes. */
  raffleWinners: Array<Scalars['String']['output']>;
  /**
   * Submission ids still in the drawing. During OPEN / READY TO DRAW this is
   * empty and clients show every entry. During DRAWING it shrinks one-by-one.
   * On COMPLETED it matches raffleWinners.
   */
  remainingSubmissionIds: Array<Scalars['String']['output']>;
  /** How many winners the admin requested for this drawing. */
  winnerCount: Scalars['Int']['output'];
};

export type Reaction = {
  __typename?: 'Reaction';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  submissionId: Scalars['String']['output'];
  type: Scalars['String']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ReactionsCreatedPayload = {
  __typename?: 'ReactionsCreatedPayload';
  reactions: Array<Reaction>;
};

export type RedeemEventPassResponse = {
  __typename?: 'RedeemEventPassResponse';
  event: Event;
  eventPassRedemption: EventPassRedemption;
};

export type RequestPasswordResetResponse = {
  __typename?: 'RequestPasswordResetResponse';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type ResetPasswordResponse = {
  __typename?: 'ResetPasswordResponse';
  success: Scalars['Boolean']['output'];
};

export enum Role {
  Admin = 'ADMIN',
  Anon = 'ANON',
  User = 'USER',
}

export type ScreenElement = {
  __typename?: 'ScreenElement';
  color?: Maybe<Scalars['String']['output']>;
  defaultClassNames?: Maybe<Scalars['String']['output']>;
  defaultStyles?: Maybe<Scalars['Json']['output']>;
  engagementClassNames?: Maybe<Scalars['String']['output']>;
  engagementStyles?: Maybe<Scalars['Json']['output']>;
  fontFamily?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  linkHref?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  textType?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type ScreenElementInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  defaultClassNames?: InputMaybe<Scalars['String']['input']>;
  defaultStyles?: InputMaybe<Scalars['Json']['input']>;
  engagementClassNames?: InputMaybe<Scalars['String']['input']>;
  engagementStyles?: InputMaybe<Scalars['Json']['input']>;
  fontFamily?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['String']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  linkHref?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  textType?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type ScreenTemplate = {
  __typename?: 'ScreenTemplate';
  config?: Maybe<EventThemeConfig>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  engagements: Array<ScreenTemplateEngagementInput>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ScreenTemplateCreateInput = {
  config: EventThemeConfigUpdateInput;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  engagements: Array<CreateEngagementInput>;
  name: Scalars['String']['input'];
};

export type ScreenTemplateEngagementInput = {
  __typename?: 'ScreenTemplateEngagementInput';
  config?: Maybe<Scalars['Json']['output']>;
  data?: Maybe<Scalars['Json']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['DateTime']['output']>;
  qrCodeCta?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['DateTime']['output']>;
  title: Scalars['String']['output'];
  type: EngagementType;
};

export type ScreenTemplateUpdateInput = {
  config?: InputMaybe<EventThemeConfigUpdateInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  engagements?: InputMaybe<Array<CreateEngagementInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type SetCookieConsentResponse = {
  __typename?: 'SetCookieConsentResponse';
  success: Scalars['Boolean']['output'];
  user: User;
};

export type SignupForBetaResponse = {
  __typename?: 'SignupForBetaResponse';
  success: Scalars['Boolean']['output'];
};

export type SignupInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Slide background. type defaults to THEME when omitted.
 * color is required when type is COLOR (hex). imageUrl is required when type is IMAGE.
 */
export type SlideBackground = {
  __typename?: 'SlideBackground';
  color?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  type: SlideBackgroundType;
};

export type SlideBackgroundInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<SlideBackgroundType>;
};

/**
 * How the slide fills the 16:9 frame behind elements.
 * THEME uses the event Stage background (historical default).
 */
export enum SlideBackgroundType {
  Color = 'COLOR',
  Image = 'IMAGE',
  Theme = 'THEME',
}

/**
 * Bounding box as percentages of the 16:9 slide frame.
 * On save, x and y are clamped to 0–100. w and h must be > 0, then are
 * clamped so x+w ≤ 100 and y+h ≤ 100 (remaining frame after x/y clamp).
 * A box with no remaining area after that clamp is rejected.
 */
export type SlideBox = {
  __typename?: 'SlideBox';
  h: Scalars['Float']['output'];
  w: Scalars['Float']['output'];
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export type SlideBoxInput = {
  h: Scalars['Float']['input'];
  w: Scalars['Float']['input'];
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

/**
 * Free-form canvas element. List order is stacking order (later = on top).
 * Positions are percentages of the slide, not vw/vh like ScreenElement.
 */
export type SlideElement = {
  __typename?: 'SlideElement';
  box?: Maybe<SlideBox>;
  color?: Maybe<Scalars['String']['output']>;
  fit?: Maybe<SlideImageFit>;
  fontFamily?: Maybe<Array<Scalars['String']['output']>>;
  /** Font size as a percent of slide height. Clamped to 1–50 on save. */
  fontSize?: Maybe<Scalars['Float']['output']>;
  fontWeight?: Maybe<SlideFontWeight>;
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Editor-only lock; ignored by Stage playback. */
  locked?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  textAlign?: Maybe<SlideTextAlign>;
  textType?: Maybe<Scalars['String']['output']>;
  type: SlideElementType;
  verticalAlign?: Maybe<SlideVerticalAlign>;
};

export type SlideElementInput = {
  box?: InputMaybe<SlideBoxInput>;
  color?: InputMaybe<Scalars['String']['input']>;
  fit?: InputMaybe<SlideImageFit>;
  fontFamily?: InputMaybe<Array<Scalars['String']['input']>>;
  fontSize?: InputMaybe<Scalars['Float']['input']>;
  fontWeight?: InputMaybe<SlideFontWeight>;
  id: Scalars['String']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  textAlign?: InputMaybe<SlideTextAlign>;
  textType?: InputMaybe<Scalars['String']['input']>;
  type: SlideElementType;
  verticalAlign?: InputMaybe<SlideVerticalAlign>;
};

export enum SlideElementType {
  Image = 'IMAGE',
  Text = 'TEXT',
}

export enum SlideFontWeight {
  Bold = 'BOLD',
  Regular = 'REGULAR',
}

export enum SlideImageFit {
  Contain = 'CONTAIN',
  Cover = 'COVER',
}

/**
 * Angle the Stage image animates to. NONE disables the tilt animation.
 * Missing values are treated as RIGHT, matching the historical Stage default.
 */
export enum SlideImageTilt {
  Left = 'LEFT',
  None = 'NONE',
  Right = 'RIGHT',
}

/**
 * Slide editor/layout mode. Missing values are treated as MARKDOWN everywhere
 * (GraphQL reads, Stage, validation). Stored JSON is not backfilled.
 */
export enum SlideLayout {
  Freeform = 'FREEFORM',
  Markdown = 'MARKDOWN',
}

export enum SlideTextAlign {
  Center = 'CENTER',
  Left = 'LEFT',
  Right = 'RIGHT',
}

export enum SlideVerticalAlign {
  Bottom = 'BOTTOM',
  Middle = 'MIDDLE',
  Top = 'TOP',
}

/** Full configuration options for the slides engagement */
export type SlidesAdminConfig = {
  __typename?: 'SlidesAdminConfig';
  autoPlay: Scalars['Boolean']['output'];
  /** Deck-level auto-play interval in milliseconds. Used when a slide has no slideDuration. */
  autoPlayIntervalMs?: Maybe<Scalars['Int']['output']>;
};

/** Data structure for the slides admin view */
export type SlidesAdminData = {
  __typename?: 'SlidesAdminData';
  /** The id of the slide that is currently visible to the user. */
  currentSlide: Scalars['String']['output'];
  slidesDisplayOrder: Array<Scalars['String']['output']>;
};

/** Data structure for a slides submission */
export type SlidesSubmissionData = {
  __typename?: 'SlidesSubmissionData';
  /** Slide background. Omitted means THEME (event Stage background). */
  background?: Maybe<SlideBackground>;
  /**
   * The content of the slide. Always a string (empty when omitted on FREEFORM).
   * Required as a string for MARKDOWN slides.
   */
  content: Scalars['String']['output'];
  /** Ordered free-form elements. List order is stacking order. */
  elements?: Maybe<Array<SlideElement>>;
  /** Per-slide image tilt used on Stage. Defaults to RIGHT when omitted. */
  imageTilt?: Maybe<SlideImageTilt>;
  /** MARKDOWN (default when omitted) or FREEFORM canvas. Not backfilled in storage. */
  layout?: Maybe<SlideLayout>;
  /** The url of the photo to display on the slide. */
  optionalImageUrl?: Maybe<Scalars['String']['output']>;
  /**
   * Stage join CTA (pill + QR card) on FREEFORM slides. Missing means true.
   * Not backfilled. MARKDOWN slides ignore this and always show the sidebar CTA.
   */
  showQr?: Maybe<Scalars['Boolean']['output']>;
  /** The duration of the slide in milliseconds, if autoPlay is true. */
  slideDuration?: Maybe<Scalars['Int']['output']>;
  /**
   * The title of the slide. Always a string (empty when omitted on FREEFORM).
   * Required as a string for MARKDOWN slides.
   */
  title: Scalars['String']['output'];
};

/**
 * Write shape for createSubmission / updateSubmission JSON.
 * showQr: missing means true; only a real boolean is accepted (no backfill).
 */
export type SlidesSubmissionDataInput = {
  background?: InputMaybe<SlideBackgroundInput>;
  content?: InputMaybe<Scalars['String']['input']>;
  elements?: InputMaybe<Array<SlideElementInput>>;
  imageTilt?: InputMaybe<SlideImageTilt>;
  layout?: InputMaybe<SlideLayout>;
  optionalImageUrl?: InputMaybe<Scalars['String']['input']>;
  showQr?: InputMaybe<Scalars['Boolean']['input']>;
  slideDuration?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Configuration options for the slides engagement */
export type SlidesViewConfig = {
  __typename?: 'SlidesViewConfig';
  autoPlay: Scalars['Boolean']['output'];
  /** Deck-level auto-play interval in milliseconds. Used when a slide has no slideDuration. */
  autoPlayIntervalMs?: Maybe<Scalars['Int']['output']>;
};

/** Data structure for the slides view */
export type SlidesViewData = {
  __typename?: 'SlidesViewData';
  /** The id of the slide that is currently visible to the user. */
  currentSlide: Scalars['String']['output'];
  slidesDisplayOrder: Array<Scalars['String']['output']>;
};

export type SocialMediaHandles = {
  __typename?: 'SocialMediaHandles';
  facebook?: Maybe<Scalars['String']['output']>;
  instagram?: Maybe<Scalars['String']['output']>;
  snapchat?: Maybe<Scalars['String']['output']>;
  tiktok?: Maybe<Scalars['String']['output']>;
  twitch?: Maybe<Scalars['String']['output']>;
  twitter?: Maybe<Scalars['String']['output']>;
  youtube?: Maybe<Scalars['String']['output']>;
};

export type StartMockEngagementResponse = {
  __typename?: 'StartMockEngagementResponse';
  mockRunId: Scalars['String']['output'];
};

export type Submission = {
  __typename?: 'Submission';
  createdAt: Scalars['DateTime']['output'];
  data: EngagementSubmissionData;
  engagementId: Scalars['String']['output'];
  hash?: Maybe<Scalars['String']['output']>;
  hidden: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  matchedBanCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  possibleBannedDevice: Scalars['Boolean']['output'];
  reactions?: Maybe<Array<Reaction>>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type SubmissionCreatedPayload = {
  __typename?: 'SubmissionCreatedPayload';
  submission: Submission;
};

export type SubmissionDeletedPayload = {
  __typename?: 'SubmissionDeletedPayload';
  submissionId: Scalars['String']['output'];
};

export type Subscription = {
  __typename?: 'Subscription';
  activeEngagementChanged?: Maybe<ActiveEngagementChangedPayload>;
  engagementChanged?: Maybe<EngagementChangedPayload>;
  engagementSubmissionsChanged?: Maybe<EngagementSubmissionsChangedPayload>;
  mockEngagementChanged?: Maybe<EngagementChangedPayload>;
  mockEngagementSubmissionsChanged?: Maybe<EngagementSubmissionsChangedPayload>;
  mockRaffleTicketWiggled: RaffleTicketWiggledPayload;
  mockReactionsCreated?: Maybe<ReactionsCreatedPayload>;
  mockSubmissionCreated?: Maybe<SubmissionCreatedPayload>;
  mockSubmissionDeleted?: Maybe<SubmissionDeletedPayload>;
  mockVoteForVotesReset: VoteForVotesResetPayload;
  raffleTicketWiggled: RaffleTicketWiggledPayload;
  reactionsCreated?: Maybe<ReactionsCreatedPayload>;
  submissionCreated?: Maybe<SubmissionCreatedPayload>;
  submissionDeleted?: Maybe<SubmissionDeletedPayload>;
  voteForVotesReset: VoteForVotesResetPayload;
};

export type SubscriptionActiveEngagementChangedArgs = {
  eventId: Scalars['String']['input'];
};

export type SubscriptionEngagementChangedArgs = {
  engagementId: Scalars['String']['input'];
};

export type SubscriptionEngagementSubmissionsChangedArgs = {
  engagementId: Scalars['String']['input'];
};

export type SubscriptionMockEngagementChangedArgs = {
  engagementId: Scalars['String']['input'];
};

export type SubscriptionMockEngagementSubmissionsChangedArgs = {
  engagementId: Scalars['String']['input'];
};

export type SubscriptionMockRaffleTicketWiggledArgs = {
  engagementId: Scalars['String']['input'];
};

export type SubscriptionMockReactionsCreatedArgs = {
  submissionId: Scalars['String']['input'];
};

export type SubscriptionMockSubmissionCreatedArgs = {
  engagementId: Scalars['String']['input'];
};

export type SubscriptionMockSubmissionDeletedArgs = {
  engagementId: Scalars['String']['input'];
};

export type SubscriptionMockVoteForVotesResetArgs = {
  engagementId: Scalars['String']['input'];
};

export type SubscriptionRaffleTicketWiggledArgs = {
  engagementId: Scalars['String']['input'];
};

export type SubscriptionReactionsCreatedArgs = {
  submissionId: Scalars['String']['input'];
};

export type SubscriptionSubmissionCreatedArgs = {
  engagementId: Scalars['String']['input'];
};

export type SubscriptionSubmissionDeletedArgs = {
  engagementId: Scalars['String']['input'];
};

export type SubscriptionVoteForVotesResetArgs = {
  engagementId: Scalars['String']['input'];
};

export type TriviaAdminConfig = {
  __typename?: 'TriviaAdminConfig';
  defaultTimerMs: Scalars['Int']['output'];
  instructions?: Maybe<Scalars['String']['output']>;
  questions: Array<TriviaQuestion>;
  useQuestionTimer: Scalars['Boolean']['output'];
};

export type TriviaAdminData = {
  __typename?: 'TriviaAdminData';
  answeredCount: Scalars['Int']['output'];
  correctChoiceId?: Maybe<Scalars['String']['output']>;
  correctCount?: Maybe<Scalars['Int']['output']>;
  leaderboard: Array<TriviaLeaderboardRow>;
  playedThroughIndex: Scalars['Int']['output'];
  playerCount: Scalars['Int']['output'];
  questionEndsAt?: Maybe<Scalars['DateTime']['output']>;
  questionIndex: Scalars['Int']['output'];
  revealedQuestionIds: Array<Scalars['String']['output']>;
  reviewing: Scalars['Boolean']['output'];
  skipRevealedQuestionIds: Array<Scalars['String']['output']>;
  skipped: Scalars['Boolean']['output'];
  status: TriviaRoundStatus;
  tallies: Array<TriviaTally>;
};

export type TriviaChoice = {
  __typename?: 'TriviaChoice';
  id: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type TriviaLeaderboardRow = {
  __typename?: 'TriviaLeaderboardRow';
  name: Scalars['String']['output'];
  rank: Scalars['Int']['output'];
  score: Scalars['Int']['output'];
  tied: Scalars['Boolean']['output'];
  userId: Scalars['String']['output'];
};

export type TriviaMyAnswer = {
  __typename?: 'TriviaMyAnswer';
  choiceId: Scalars['String']['output'];
  questionId: Scalars['String']['output'];
};

export type TriviaMyProgress = {
  __typename?: 'TriviaMyProgress';
  answers: Array<TriviaMyAnswer>;
  rank?: Maybe<Scalars['Int']['output']>;
  score: Scalars['Int']['output'];
  scored: Array<TriviaMyScoredQuestion>;
};

export type TriviaMyScoredQuestion = {
  __typename?: 'TriviaMyScoredQuestion';
  correctChoiceId: Scalars['String']['output'];
  questionId: Scalars['String']['output'];
};

export type TriviaQuestion = {
  __typename?: 'TriviaQuestion';
  choices: Array<TriviaChoice>;
  correctChoiceId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  text: Scalars['String']['output'];
  timerMs?: Maybe<Scalars['Int']['output']>;
};

export enum TriviaRoundStatus {
  Idle = 'IDLE',
  QuestionClosed = 'QUESTION_CLOSED',
  QuestionOpen = 'QUESTION_OPEN',
  Revealed = 'REVEALED',
  RoundComplete = 'ROUND_COMPLETE',
}

export type TriviaSubmissionData = {
  __typename?: 'TriviaSubmissionData';
  choiceId?: Maybe<Scalars['String']['output']>;
  questionId?: Maybe<Scalars['String']['output']>;
};

export type TriviaTally = {
  __typename?: 'TriviaTally';
  choiceId: Scalars['String']['output'];
  count: Scalars['Int']['output'];
};

export type TriviaViewConfig = {
  __typename?: 'TriviaViewConfig';
  defaultTimerMs: Scalars['Int']['output'];
  instructions?: Maybe<Scalars['String']['output']>;
  questions: Array<TriviaViewQuestion>;
  useQuestionTimer: Scalars['Boolean']['output'];
};

export type TriviaViewData = {
  __typename?: 'TriviaViewData';
  answeredCount: Scalars['Int']['output'];
  correctChoiceId?: Maybe<Scalars['String']['output']>;
  correctCount?: Maybe<Scalars['Int']['output']>;
  leaderboard: Array<TriviaLeaderboardRow>;
  leaderboardOverflow: Scalars['Int']['output'];
  playerCount: Scalars['Int']['output'];
  questionEndsAt?: Maybe<Scalars['DateTime']['output']>;
  questionIndex: Scalars['Int']['output'];
  skipped: Scalars['Boolean']['output'];
  status: TriviaRoundStatus;
  tallies: Array<TriviaTally>;
};

export type TriviaViewQuestion = {
  __typename?: 'TriviaViewQuestion';
  choices: Array<TriviaChoice>;
  id: Scalars['String']['output'];
  text: Scalars['String']['output'];
  timerMs?: Maybe<Scalars['Int']['output']>;
};

export type UnbanPayload = {
  __typename?: 'UnbanPayload';
  banId: Scalars['String']['output'];
  restoredCount: Scalars['Int']['output'];
};

export type UpdateEngagementInput = {
  config?: InputMaybe<Scalars['Json']['input']>;
  data?: InputMaybe<Scalars['Json']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  qrCodeCta?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEventInput = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  live?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateReactionInput = {
  type: Scalars['String']['input'];
};

export type UpdateSubmissionInput = {
  data: Scalars['Json']['input'];
};

export type User = {
  __typename?: 'User';
  cookieConsent?: Maybe<CookiePreferences>;
  cookieConsentUpdated?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  eventPasses?: Maybe<Array<EventPass>>;
  googleId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastLogin?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  role: Role;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  subscriptions?: Maybe<Array<PaymentSubscription>>;
  username?: Maybe<Scalars['String']['output']>;
};

export type UserConnection = {
  __typename?: 'UserConnection';
  edges: Array<UserEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserEdge = {
  __typename?: 'UserEdge';
  cursor: Scalars['String']['output'];
  node: User;
};

export type UserFilter = {
  includeRoles?: InputMaybe<Array<Role>>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};

export type VoteCount = {
  __typename?: 'VoteCount';
  count: Scalars['Int']['output'];
  submissionId: Scalars['String']['output'];
};

export type VoteForAdminConfig = {
  __typename?: 'VoteForAdminConfig';
  /** Whether to allow users to submit candidates. */
  allowUserSubmissions: Scalars['Boolean']['output'];
  /**
   * The maximum number of submissions a user can make for this engagement.
   * 0 means no limit.
   */
  maxSubmissionsPerUser: Scalars['Int']['output'];
  /** The number of votes a user can cast for this engagement. */
  votesPerUser: Scalars['Int']['output'];
};

export type VoteForAdminData = {
  __typename?: 'VoteForAdminData';
  choiceDisplayOrder: Array<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['DateTime']['output']>;
  startTime?: Maybe<Scalars['DateTime']['output']>;
  voteWinners?: Maybe<Array<Scalars['String']['output']>>;
  /** A map of submission id to the number of votes it has received. */
  votes: Array<VoteCount>;
};

export type VoteForSubmissionData = {
  __typename?: 'VoteForSubmissionData';
  /** The color of the candidate. */
  color: Scalars['String']['output'];
  /** The description of the candidate. */
  description: Scalars['String']['output'];
  /** The url of the candidate's photo. */
  optionalImageUrl?: Maybe<Scalars['String']['output']>;
  /** The title of the candidate. */
  title: Scalars['String']['output'];
};

export type VoteForViewConfig = {
  __typename?: 'VoteForViewConfig';
  votesPerUser: Scalars['Int']['output'];
};

export type VoteForViewData = {
  __typename?: 'VoteForViewData';
  choiceDisplayOrder: Array<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['DateTime']['output']>;
  startTime?: Maybe<Scalars['DateTime']['output']>;
  voteWinners?: Maybe<Array<Scalars['String']['output']>>;
  votes: Array<VoteCount>;
};

export type VoteForVotesResetPayload = {
  __typename?: 'VoteForVotesResetPayload';
  engagement: Engagement;
};

export type NowPlayingAdminConfigFieldsFragment = {
  __typename?: 'NowPlayingAdminConfig';
  visualizationType: string;
  allowComments: boolean;
  allowedReactions: Array<string>;
};

export type NowPlayingViewConfigFieldsFragment = {
  __typename?: 'NowPlayingViewConfig';
  visualizationType: string;
  allowComments: boolean;
  allowedReactions: Array<string>;
};

export type NowPlayingAdminDataFieldsFragment = {
  __typename?: 'NowPlayingAdminData';
  currentSong?: string | null;
};

export type NowPlayingViewDataFieldsFragment = {
  __typename?: 'NowPlayingViewData';
  currentSong?: string | null;
};

export type NowPlayingSubmissionFieldsFragment = {
  __typename?: 'NowPlayingSubmissionData';
  order: number;
  songAlbumArt?: string | null;
  songTitle?: string | null;
  songArtist?: string | null;
  songNotes?: string | null;
  songLyrics?: string | null;
  visualizationType?: string | null;
  spotifyUrl?: string | null;
};

export type PhotoCarouselViewConfigFieldsFragment = {
  __typename?: 'PhotoCarouselViewConfig';
  maxSubmissionsPerUser: number;
  askSharePermission?: boolean | null;
  sharePrompt?: string | null;
  noPhotosMessage?: string | null;
  maxVisiblePhotos: number;
};

export type PhotoCarouselViewDataFieldsFragment = {
  __typename?: 'PhotoCarouselViewData';
  visibleSubmission?: string | null;
};

export type PhotoCarouselSubmissionFieldsFragment = {
  __typename?: 'PhotoCarouselSubmissionData';
  photoUrl?: string | null;
  caption?: string | null;
  approved?: boolean | null;
  sharingPermissionGranted?: boolean | null;
};

export type PhotoCarouselAdminConfigFieldsFragment = {
  __typename?: 'PhotoCarouselAdminConfig';
  maxSubmissionsPerUser: number;
  requireApproval: boolean;
  askSharePermission?: boolean | null;
  sharePrompt?: string | null;
  noPhotosMessage?: string | null;
  pollInterval?: number | null;
  predefinedCaptions?: Array<string> | null;
  maxVisiblePhotos: number;
};

export type PhotoCarouselAdminDataFieldsFragment = {
  __typename?: 'PhotoCarouselAdminData';
  visibleSubmission?: string | null;
  rejectedQueue: Array<string>;
  unapprovedQueue: Array<string>;
  unseenQueue: Array<string>;
  seenQueuePointer: number;
  seenQueue: Array<string>;
};

export type PhotoCarouselDownloadQueryVariables = Exact<{
  engagementId: Scalars['String']['input'];
}>;

export type PhotoCarouselDownloadQuery = {
  __typename?: 'Query';
  photoCarouselDownload: {
    __typename?: 'PhotoCarouselDownloadResponse';
    success: boolean;
    message: string;
    downloadUrl: string;
  };
};

export type PhotoCarouselRandomCaptionQueryVariables = Exact<{
  engagementId: Scalars['String']['input'];
}>;

export type PhotoCarouselRandomCaptionQuery = {
  __typename?: 'Query';
  photoCarouselRandomCaption: string;
};

export type RaffleAdminConfigFieldsFragment = {
  __typename?: 'RaffleAdminConfig';
  optionalImageUrl?: string | null;
  claimYourPrize?: string | null;
  ticketFlipDirection: RaffleTicketFlipDirection;
};

export type RaffleViewConfigFieldsFragment = {
  __typename?: 'RaffleViewConfig';
  optionalImageUrl?: string | null;
  claimYourPrize?: string | null;
  ticketFlipDirection: RaffleTicketFlipDirection;
};

export type RaffleAdminDataFieldsFragment = {
  __typename?: 'RaffleAdminData';
  raffleStatus: RaffleStatus;
  raffleCandidates: Array<string>;
  raffleWinners: Array<string>;
  raffleWinner?: string | null;
  winnerCount: number;
  remainingSubmissionIds: Array<string>;
  lastEliminatedSubmissionId?: string | null;
};

export type RaffleViewDataFieldsFragment = {
  __typename?: 'RaffleViewData';
  raffleStatus: RaffleStatus;
  raffleCandidates: Array<string>;
  raffleWinners: Array<string>;
  raffleWinner?: string | null;
  winnerCount: number;
  remainingSubmissionIds: Array<string>;
  lastEliminatedSubmissionId?: string | null;
};

export type RaffleSubmissionFieldsFragment = {
  __typename?: 'RaffleSubmissionData';
  name: string;
  optionalImageUrl?: string | null;
};

export type RaffleCloseMutationVariables = Exact<{
  engagementId: Scalars['String']['input'];
}>;

export type RaffleCloseMutation = {
  __typename?: 'Mutation';
  raffleClose: {
    __typename?: 'Engagement';
    id: string;
    eventId: string;
    createdAt: any;
    updatedAt: any;
    title: string;
    description?: string | null;
    qrCodeCta?: string | null;
    startTime?: any | null;
    order: number;
    endTime?: any | null;
    type: EngagementType;
    data?:
      | { __typename?: 'NowPlayingAdminData'; currentSong?: string | null }
      | {
          __typename?: 'PhotoCarouselAdminData';
          visibleSubmission?: string | null;
          rejectedQueue: Array<string>;
          unapprovedQueue: Array<string>;
          unseenQueue: Array<string>;
          seenQueuePointer: number;
          seenQueue: Array<string>;
        }
      | {
          __typename?: 'RaffleAdminData';
          raffleStatus: RaffleStatus;
          raffleCandidates: Array<string>;
          raffleWinners: Array<string>;
          raffleWinner?: string | null;
          winnerCount: number;
          remainingSubmissionIds: Array<string>;
          lastEliminatedSubmissionId?: string | null;
        }
      | {
          __typename?: 'SlidesAdminData';
          currentSlide: string;
          slidesDisplayOrder: Array<string>;
        }
      | {
          __typename?: 'TriviaAdminData';
          status: TriviaRoundStatus;
          questionIndex: number;
          playedThroughIndex: number;
          reviewing: boolean;
          questionEndsAt?: any | null;
          answeredCount: number;
          playerCount: number;
          correctChoiceId?: string | null;
          correctCount?: number | null;
          revealedQuestionIds: Array<string>;
          tallies: Array<{
            __typename?: 'TriviaTally';
            choiceId: string;
            count: number;
          }>;
          leaderboard: Array<{
            __typename?: 'TriviaLeaderboardRow';
            userId: string;
            name: string;
            score: number;
            rank: number;
            tied: boolean;
          }>;
        }
      | {
          __typename?: 'VoteForAdminData';
          startTime?: any | null;
          endTime?: any | null;
          voteWinners?: Array<string> | null;
          choiceDisplayOrder: Array<string>;
          votes: Array<{
            __typename?: 'VoteCount';
            submissionId: string;
            count: number;
          }>;
        }
      | null;
    config?:
      | {
          __typename?: 'NowPlayingAdminConfig';
          visualizationType: string;
          allowComments: boolean;
          allowedReactions: Array<string>;
        }
      | {
          __typename?: 'PhotoCarouselAdminConfig';
          maxSubmissionsPerUser: number;
          requireApproval: boolean;
          askSharePermission?: boolean | null;
          sharePrompt?: string | null;
          noPhotosMessage?: string | null;
          pollInterval?: number | null;
          predefinedCaptions?: Array<string> | null;
          maxVisiblePhotos: number;
        }
      | {
          __typename?: 'RaffleAdminConfig';
          optionalImageUrl?: string | null;
          claimYourPrize?: string | null;
          ticketFlipDirection: RaffleTicketFlipDirection;
        }
      | {
          __typename?: 'SlidesAdminConfig';
          autoPlay: boolean;
          autoPlayIntervalMs?: number | null;
        }
      | {
          __typename?: 'TriviaAdminConfig';
          instructions?: string | null;
          useQuestionTimer: boolean;
          defaultTimerMs: number;
          questions: Array<{
            __typename?: 'TriviaQuestion';
            id: string;
            text: string;
            correctChoiceId?: string | null;
            timerMs?: number | null;
            choices: Array<{
              __typename?: 'TriviaChoice';
              id: string;
              text: string;
            }>;
          }>;
        }
      | {
          __typename?: 'VoteForAdminConfig';
          votesPerUser: number;
          allowUserSubmissions: boolean;
          maxSubmissionsPerUser: number;
        }
      | null;
    viewConfig:
      | {
          __typename?: 'NowPlayingViewConfig';
          visualizationType: string;
          allowComments: boolean;
          allowedReactions: Array<string>;
        }
      | {
          __typename?: 'PhotoCarouselViewConfig';
          maxSubmissionsPerUser: number;
          askSharePermission?: boolean | null;
          sharePrompt?: string | null;
          noPhotosMessage?: string | null;
          maxVisiblePhotos: number;
        }
      | {
          __typename?: 'RaffleViewConfig';
          optionalImageUrl?: string | null;
          claimYourPrize?: string | null;
          ticketFlipDirection: RaffleTicketFlipDirection;
        }
      | {
          __typename?: 'SlidesViewConfig';
          autoPlay: boolean;
          autoPlayIntervalMs?: number | null;
        }
      | {
          __typename?: 'TriviaViewConfig';
          instructions?: string | null;
          useQuestionTimer: boolean;
          defaultTimerMs: number;
          questions: Array<{
            __typename?: 'TriviaViewQuestion';
            id: string;
            text: string;
            timerMs?: number | null;
            choices: Array<{
              __typename?: 'TriviaChoice';
              id: string;
              text: string;
            }>;
          }>;
        }
      | { __typename?: 'VoteForViewConfig'; votesPerUser: number };
    viewData:
      | { __typename?: 'NowPlayingViewData'; currentSong?: string | null }
      | {
          __typename?: 'PhotoCarouselViewData';
          visibleSubmission?: string | null;
        }
      | {
          __typename?: 'RaffleViewData';
          raffleStatus: RaffleStatus;
          raffleCandidates: Array<string>;
          raffleWinners: Array<string>;
          raffleWinner?: string | null;
          winnerCount: number;
          remainingSubmissionIds: Array<string>;
          lastEliminatedSubmissionId?: string | null;
        }
      | {
          __typename?: 'SlidesViewData';
          currentSlide: string;
          slidesDisplayOrder: Array<string>;
        }
      | {
          __typename?: 'TriviaViewData';
          status: TriviaRoundStatus;
          questionIndex: number;
          questionEndsAt?: any | null;
          answeredCount: number;
          playerCount: number;
          correctChoiceId?: string | null;
          correctCount?: number | null;
          leaderboardOverflow: number;
          tallies: Array<{
            __typename?: 'TriviaTally';
            choiceId: string;
            count: number;
          }>;
          leaderboard: Array<{
            __typename?: 'TriviaLeaderboardRow';
            userId: string;
            name: string;
            score: number;
            rank: number;
            tied: boolean;
          }>;
        }
      | {
          __typename?: 'VoteForViewData';
          voteWinners?: Array<string> | null;
          choiceDisplayOrder: Array<string>;
          votes: Array<{
            __typename?: 'VoteCount';
            submissionId: string;
            count: number;
          }>;
        };
  };
};

export type RaffleReopenMutationVariables = Exact<{
  engagementId: Scalars['String']['input'];
}>;

export type RaffleReopenMutation = {
  __typename?: 'Mutation';
  raffleReopen: {
    __typename?: 'Engagement';
    id: string;
    eventId: string;
    createdAt: any;
    updatedAt: any;
    title: string;
    description?: string | null;
    qrCodeCta?: string | null;
    startTime?: any | null;
    order: number;
    endTime?: any | null;
    type: EngagementType;
    data?:
      | { __typename?: 'NowPlayingAdminData'; currentSong?: string | null }
      | {
          __typename?: 'PhotoCarouselAdminData';
          visibleSubmission?: string | null;
          rejectedQueue: Array<string>;
          unapprovedQueue: Array<string>;
          unseenQueue: Array<string>;
          seenQueuePointer: number;
          seenQueue: Array<string>;
        }
      | {
          __typename?: 'RaffleAdminData';
          raffleStatus: RaffleStatus;
          raffleCandidates: Array<string>;
          raffleWinners: Array<string>;
          raffleWinner?: string | null;
          winnerCount: number;
          remainingSubmissionIds: Array<string>;
          lastEliminatedSubmissionId?: string | null;
        }
      | {
          __typename?: 'SlidesAdminData';
          currentSlide: string;
          slidesDisplayOrder: Array<string>;
        }
      | {
          __typename?: 'TriviaAdminData';
          status: TriviaRoundStatus;
          questionIndex: number;
          playedThroughIndex: number;
          reviewing: boolean;
          questionEndsAt?: any | null;
          answeredCount: number;
          playerCount: number;
          correctChoiceId?: string | null;
          correctCount?: number | null;
          revealedQuestionIds: Array<string>;
          tallies: Array<{
            __typename?: 'TriviaTally';
            choiceId: string;
            count: number;
          }>;
          leaderboard: Array<{
            __typename?: 'TriviaLeaderboardRow';
            userId: string;
            name: string;
            score: number;
            rank: number;
            tied: boolean;
          }>;
        }
      | {
          __typename?: 'VoteForAdminData';
          startTime?: any | null;
          endTime?: any | null;
          voteWinners?: Array<string> | null;
          choiceDisplayOrder: Array<string>;
          votes: Array<{
            __typename?: 'VoteCount';
            submissionId: string;
            count: number;
          }>;
        }
      | null;
    config?:
      | {
          __typename?: 'NowPlayingAdminConfig';
          visualizationType: string;
          allowComments: boolean;
          allowedReactions: Array<string>;
        }
      | {
          __typename?: 'PhotoCarouselAdminConfig';
          maxSubmissionsPerUser: number;
          requireApproval: boolean;
          askSharePermission?: boolean | null;
          sharePrompt?: string | null;
          noPhotosMessage?: string | null;
          pollInterval?: number | null;
          predefinedCaptions?: Array<string> | null;
          maxVisiblePhotos: number;
        }
      | {
          __typename?: 'RaffleAdminConfig';
          optionalImageUrl?: string | null;
          claimYourPrize?: string | null;
          ticketFlipDirection: RaffleTicketFlipDirection;
        }
      | {
          __typename?: 'SlidesAdminConfig';
          autoPlay: boolean;
          autoPlayIntervalMs?: number | null;
        }
      | {
          __typename?: 'TriviaAdminConfig';
          instructions?: string | null;
          useQuestionTimer: boolean;
          defaultTimerMs: number;
          questions: Array<{
            __typename?: 'TriviaQuestion';
            id: string;
            text: string;
            correctChoiceId?: string | null;
            timerMs?: number | null;
            choices: Array<{
              __typename?: 'TriviaChoice';
              id: string;
              text: string;
            }>;
          }>;
        }
      | {
          __typename?: 'VoteForAdminConfig';
          votesPerUser: number;
          allowUserSubmissions: boolean;
          maxSubmissionsPerUser: number;
        }
      | null;
    viewConfig:
      | {
          __typename?: 'NowPlayingViewConfig';
          visualizationType: string;
          allowComments: boolean;
          allowedReactions: Array<string>;
        }
      | {
          __typename?: 'PhotoCarouselViewConfig';
          maxSubmissionsPerUser: number;
          askSharePermission?: boolean | null;
          sharePrompt?: string | null;
          noPhotosMessage?: string | null;
          maxVisiblePhotos: number;
        }
      | {
          __typename?: 'RaffleViewConfig';
          optionalImageUrl?: string | null;
          claimYourPrize?: string | null;
          ticketFlipDirection: RaffleTicketFlipDirection;
        }
      | {
          __typename?: 'SlidesViewConfig';
          autoPlay: boolean;
          autoPlayIntervalMs?: number | null;
        }
      | {
          __typename?: 'TriviaViewConfig';
          instructions?: string | null;
          useQuestionTimer: boolean;
          defaultTimerMs: number;
          questions: Array<{
            __typename?: 'TriviaViewQuestion';
            id: string;
            text: string;
            timerMs?: number | null;
            choices: Array<{
              __typename?: 'TriviaChoice';
              id: string;
              text: string;
            }>;
          }>;
        }
      | { __typename?: 'VoteForViewConfig'; votesPerUser: number };
    viewData:
      | { __typename?: 'NowPlayingViewData'; currentSong?: string | null }
      | {
          __typename?: 'PhotoCarouselViewData';
          visibleSubmission?: string | null;
        }
      | {
          __typename?: 'RaffleViewData';
          raffleStatus: RaffleStatus;
          raffleCandidates: Array<string>;
          raffleWinners: Array<string>;
          raffleWinner?: string | null;
          winnerCount: number;
          remainingSubmissionIds: Array<string>;
          lastEliminatedSubmissionId?: string | null;
        }
      | {
          __typename?: 'SlidesViewData';
          currentSlide: string;
          slidesDisplayOrder: Array<string>;
        }
      | {
          __typename?: 'TriviaViewData';
          status: TriviaRoundStatus;
          questionIndex: number;
          questionEndsAt?: any | null;
          answeredCount: number;
          playerCount: number;
          correctChoiceId?: string | null;
          correctCount?: number | null;
          leaderboardOverflow: number;
          tallies: Array<{
            __typename?: 'TriviaTally';
            choiceId: string;
            count: number;
          }>;
          leaderboard: Array<{
            __typename?: 'TriviaLeaderboardRow';
            userId: string;
            name: string;
            score: number;
            rank: number;
            tied: boolean;
          }>;
        }
      | {
          __typename?: 'VoteForViewData';
          voteWinners?: Array<string> | null;
          choiceDisplayOrder: Array<string>;
          votes: Array<{
            __typename?: 'VoteCount';
            submissionId: string;
            count: number;
          }>;
        };
  };
};

export type RaffleBeginDrawingMutationVariables = Exact<{
  engagementId: Scalars['String']['input'];
  winnerCount: Scalars['Int']['input'];
}>;

export type RaffleBeginDrawingMutation = {
  __typename?: 'Mutation';
  raffleBeginDrawing: {
    __typename?: 'Engagement';
    id: string;
    eventId: string;
    createdAt: any;
    updatedAt: any;
    title: string;
    description?: string | null;
    qrCodeCta?: string | null;
    startTime?: any | null;
    order: number;
    endTime?: any | null;
    type: EngagementType;
    data?:
      | { __typename?: 'NowPlayingAdminData'; currentSong?: string | null }
      | {
          __typename?: 'PhotoCarouselAdminData';
          visibleSubmission?: string | null;
          rejectedQueue: Array<string>;
          unapprovedQueue: Array<string>;
          unseenQueue: Array<string>;
          seenQueuePointer: number;
          seenQueue: Array<string>;
        }
      | {
          __typename?: 'RaffleAdminData';
          raffleStatus: RaffleStatus;
          raffleCandidates: Array<string>;
          raffleWinners: Array<string>;
          raffleWinner?: string | null;
          winnerCount: number;
          remainingSubmissionIds: Array<string>;
          lastEliminatedSubmissionId?: string | null;
        }
      | {
          __typename?: 'SlidesAdminData';
          currentSlide: string;
          slidesDisplayOrder: Array<string>;
        }
      | {
          __typename?: 'TriviaAdminData';
          status: TriviaRoundStatus;
          questionIndex: number;
          playedThroughIndex: number;
          reviewing: boolean;
          questionEndsAt?: any | null;
          answeredCount: number;
          playerCount: number;
          correctChoiceId?: string | null;
          correctCount?: number | null;
          revealedQuestionIds: Array<string>;
          tallies: Array<{
            __typename?: 'TriviaTally';
            choiceId: string;
            count: number;
          }>;
          leaderboard: Array<{
            __typename?: 'TriviaLeaderboardRow';
            userId: string;
            name: string;
            score: number;
            rank: number;
            tied: boolean;
          }>;
        }
      | {
          __typename?: 'VoteForAdminData';
          startTime?: any | null;
          endTime?: any | null;
          voteWinners?: Array<string> | null;
          choiceDisplayOrder: Array<string>;
          votes: Array<{
            __typename?: 'VoteCount';
            submissionId: string;
            count: number;
          }>;
        }
      | null;
    config?:
      | {
          __typename?: 'NowPlayingAdminConfig';
          visualizationType: string;
          allowComments: boolean;
          allowedReactions: Array<string>;
        }
      | {
          __typename?: 'PhotoCarouselAdminConfig';
          maxSubmissionsPerUser: number;
          requireApproval: boolean;
          askSharePermission?: boolean | null;
          sharePrompt?: string | null;
          noPhotosMessage?: string | null;
          pollInterval?: number | null;
          predefinedCaptions?: Array<string> | null;
          maxVisiblePhotos: number;
        }
      | {
          __typename?: 'RaffleAdminConfig';
          optionalImageUrl?: string | null;
          claimYourPrize?: string | null;
          ticketFlipDirection: RaffleTicketFlipDirection;
        }
      | {
          __typename?: 'SlidesAdminConfig';
          autoPlay: boolean;
          autoPlayIntervalMs?: number | null;
        }
      | {
          __typename?: 'TriviaAdminConfig';
          instructions?: string | null;
          useQuestionTimer: boolean;
          defaultTimerMs: number;
          questions: Array<{
            __typename?: 'TriviaQuestion';
            id: string;
            text: string;
            correctChoiceId?: string | null;
            timerMs?: number | null;
            choices: Array<{
              __typename?: 'TriviaChoice';
              id: string;
              text: string;
            }>;
          }>;
        }
      | {
          __typename?: 'VoteForAdminConfig';
          votesPerUser: number;
          allowUserSubmissions: boolean;
          maxSubmissionsPerUser: number;
        }
      | null;
    viewConfig:
      | {
          __typename?: 'NowPlayingViewConfig';
          visualizationType: string;
          allowComments: boolean;
          allowedReactions: Array<string>;
        }
      | {
          __typename?: 'PhotoCarouselViewConfig';
          maxSubmissionsPerUser: number;
          askSharePermission?: boolean | null;
          sharePrompt?: string | null;
          noPhotosMessage?: string | null;
          maxVisiblePhotos: number;
        }
      | {
          __typename?: 'RaffleViewConfig';
          optionalImageUrl?: string | null;
          claimYourPrize?: string | null;
          ticketFlipDirection: RaffleTicketFlipDirection;
        }
      | {
          __typename?: 'SlidesViewConfig';
          autoPlay: boolean;
          autoPlayIntervalMs?: number | null;
        }
      | {
          __typename?: 'TriviaViewConfig';
          instructions?: string | null;
          useQuestionTimer: boolean;
          defaultTimerMs: number;
          questions: Array<{
            __typename?: 'TriviaViewQuestion';
            id: string;
            text: string;
            timerMs?: number | null;
            choices: Array<{
              __typename?: 'TriviaChoice';
              id: string;
              text: string;
            }>;
          }>;
        }
      | { __typename?: 'VoteForViewConfig'; votesPerUser: number };
    viewData:
      | { __typename?: 'NowPlayingViewData'; currentSong?: string | null }
      | {
          __typename?: 'PhotoCarouselViewData';
          visibleSubmission?: string | null;
        }
      | {
          __typename?: 'RaffleViewData';
          raffleStatus: RaffleStatus;
          raffleCandidates: Array<string>;
          raffleWinners: Array<string>;
          raffleWinner?: string | null;
          winnerCount: number;
          remainingSubmissionIds: Array<string>;
          lastEliminatedSubmissionId?: string | null;
        }
      | {
          __typename?: 'SlidesViewData';
          currentSlide: string;
          slidesDisplayOrder: Array<string>;
        }
      | {
          __typename?: 'TriviaViewData';
          status: TriviaRoundStatus;
          questionIndex: number;
          questionEndsAt?: any | null;
          answeredCount: number;
          playerCount: number;
          correctChoiceId?: string | null;
          correctCount?: number | null;
          leaderboardOverflow: number;
          tallies: Array<{
            __typename?: 'TriviaTally';
            choiceId: string;
            count: number;
          }>;
          leaderboard: Array<{
            __typename?: 'TriviaLeaderboardRow';
            userId: string;
            name: string;
            score: number;
            rank: number;
            tied: boolean;
          }>;
        }
      | {
          __typename?: 'VoteForViewData';
          voteWinners?: Array<string> | null;
          choiceDisplayOrder: Array<string>;
          votes: Array<{
            __typename?: 'VoteCount';
            submissionId: string;
            count: number;
          }>;
        };
  };
};

export type RaffleResetMutationVariables = Exact<{
  engagementId: Scalars['String']['input'];
}>;

export type RaffleResetMutation = {
  __typename?: 'Mutation';
  raffleReset: {
    __typename?: 'Engagement';
    id: string;
    eventId: string;
    createdAt: any;
    updatedAt: any;
    title: string;
    description?: string | null;
    qrCodeCta?: string | null;
    startTime?: any | null;
    order: number;
    endTime?: any | null;
    type: EngagementType;
    data?:
      | { __typename?: 'NowPlayingAdminData'; currentSong?: string | null }
      | {
          __typename?: 'PhotoCarouselAdminData';
          visibleSubmission?: string | null;
          rejectedQueue: Array<string>;
          unapprovedQueue: Array<string>;
          unseenQueue: Array<string>;
          seenQueuePointer: number;
          seenQueue: Array<string>;
        }
      | {
          __typename?: 'RaffleAdminData';
          raffleStatus: RaffleStatus;
          raffleCandidates: Array<string>;
          raffleWinners: Array<string>;
          raffleWinner?: string | null;
          winnerCount: number;
          remainingSubmissionIds: Array<string>;
          lastEliminatedSubmissionId?: string | null;
        }
      | {
          __typename?: 'SlidesAdminData';
          currentSlide: string;
          slidesDisplayOrder: Array<string>;
        }
      | {
          __typename?: 'TriviaAdminData';
          status: TriviaRoundStatus;
          questionIndex: number;
          playedThroughIndex: number;
          reviewing: boolean;
          questionEndsAt?: any | null;
          answeredCount: number;
          playerCount: number;
          correctChoiceId?: string | null;
          correctCount?: number | null;
          revealedQuestionIds: Array<string>;
          tallies: Array<{
            __typename?: 'TriviaTally';
            choiceId: string;
            count: number;
          }>;
          leaderboard: Array<{
            __typename?: 'TriviaLeaderboardRow';
            userId: string;
            name: string;
            score: number;
            rank: number;
            tied: boolean;
          }>;
        }
      | {
          __typename?: 'VoteForAdminData';
          startTime?: any | null;
          endTime?: any | null;
          voteWinners?: Array<string> | null;
          choiceDisplayOrder: Array<string>;
          votes: Array<{
            __typename?: 'VoteCount';
            submissionId: string;
            count: number;
          }>;
        }
      | null;
    config?:
      | {
          __typename?: 'NowPlayingAdminConfig';
          visualizationType: string;
          allowComments: boolean;
          allowedReactions: Array<string>;
        }
      | {
          __typename?: 'PhotoCarouselAdminConfig';
          maxSubmissionsPerUser: number;
          requireApproval: boolean;
          askSharePermission?: boolean | null;
          sharePrompt?: string | null;
          noPhotosMessage?: string | null;
          pollInterval?: number | null;
          predefinedCaptions?: Array<string> | null;
          maxVisiblePhotos: number;
        }
      | {
          __typename?: 'RaffleAdminConfig';
          optionalImageUrl?: string | null;
          claimYourPrize?: string | null;
          ticketFlipDirection: RaffleTicketFlipDirection;
        }
      | {
          __typename?: 'SlidesAdminConfig';
          autoPlay: boolean;
          autoPlayIntervalMs?: number | null;
        }
      | {
          __typename?: 'TriviaAdminConfig';
          instructions?: string | null;
          useQuestionTimer: boolean;
          defaultTimerMs: number;
          questions: Array<{
            __typename?: 'TriviaQuestion';
            id: string;
            text: string;
            correctChoiceId?: string | null;
            timerMs?: number | null;
            choices: Array<{
              __typename?: 'TriviaChoice';
              id: string;
              text: string;
            }>;
          }>;
        }
      | {
          __typename?: 'VoteForAdminConfig';
          votesPerUser: number;
          allowUserSubmissions: boolean;
          maxSubmissionsPerUser: number;
        }
      | null;
    viewConfig:
      | {
          __typename?: 'NowPlayingViewConfig';
          visualizationType: string;
          allowComments: boolean;
          allowedReactions: Array<string>;
        }
      | {
          __typename?: 'PhotoCarouselViewConfig';
          maxSubmissionsPerUser: number;
          askSharePermission?: boolean | null;
          sharePrompt?: string | null;
          noPhotosMessage?: string | null;
          maxVisiblePhotos: number;
        }
      | {
          __typename?: 'RaffleViewConfig';
          optionalImageUrl?: string | null;
          claimYourPrize?: string | null;
          ticketFlipDirection: RaffleTicketFlipDirection;
        }
      | {
          __typename?: 'SlidesViewConfig';
          autoPlay: boolean;
          autoPlayIntervalMs?: number | null;
        }
      | {
          __typename?: 'TriviaViewConfig';
          instructions?: string | null;
          useQuestionTimer: boolean;
          defaultTimerMs: number;
          questions: Array<{
            __typename?: 'TriviaViewQuestion';
            id: string;
            text: string;
            timerMs?: number | null;
            choices: Array<{
              __typename?: 'TriviaChoice';
              id: string;
              text: string;
            }>;
          }>;
        }
      | { __typename?: 'VoteForViewConfig'; votesPerUser: number };
    viewData:
      | { __typename?: 'NowPlayingViewData'; currentSong?: string | null }
      | {
          __typename?: 'PhotoCarouselViewData';
          visibleSubmission?: string | null;
        }
      | {
          __typename?: 'RaffleViewData';
          raffleStatus: RaffleStatus;
          raffleCandidates: Array<string>;
          raffleWinners: Array<string>;
          raffleWinner?: string | null;
          winnerCount: number;
          remainingSubmissionIds: Array<string>;
          lastEliminatedSubmissionId?: string | null;
        }
      | {
          __typename?: 'SlidesViewData';
          currentSlide: string;
          slidesDisplayOrder: Array<string>;
        }
      | {
          __typename?: 'TriviaViewData';
          status: TriviaRoundStatus;
          questionIndex: number;
          questionEndsAt?: any | null;
          answeredCount: number;
          playerCount: number;
          correctChoiceId?: string | null;
          correctCount?: number | null;
          leaderboardOverflow: number;
          tallies: Array<{
            __typename?: 'TriviaTally';
            choiceId: string;
            count: number;
          }>;
          leaderboard: Array<{
            __typename?: 'TriviaLeaderboardRow';
            userId: string;
            name: string;
            score: number;
            rank: number;
            tied: boolean;
          }>;
        }
      | {
          __typename?: 'VoteForViewData';
          voteWinners?: Array<string> | null;
          choiceDisplayOrder: Array<string>;
          votes: Array<{
            __typename?: 'VoteCount';
            submissionId: string;
            count: number;
          }>;
        };
  };
};

export type RaffleRestartDrawingMutationVariables = Exact<{
  engagementId: Scalars['String']['input'];
}>;

export type RaffleRestartDrawingMutation = {
  __typename?: 'Mutation';
  raffleRestartDrawing: {
    __typename?: 'Engagement';
    id: string;
    eventId: string;
    createdAt: any;
    updatedAt: any;
    title: string;
    description?: string | null;
    qrCodeCta?: string | null;
    startTime?: any | null;
    order: number;
    endTime?: any | null;
    type: EngagementType;
    data?:
      | { __typename?: 'NowPlayingAdminData'; currentSong?: string | null }
      | {
          __typename?: 'PhotoCarouselAdminData';
          visibleSubmission?: string | null;
          rejectedQueue: Array<string>;
          unapprovedQueue: Array<string>;
          unseenQueue: Array<string>;
          seenQueuePointer: number;
          seenQueue: Array<string>;
        }
      | {
          __typename?: 'RaffleAdminData';
          raffleStatus: RaffleStatus;
          raffleCandidates: Array<string>;
          raffleWinners: Array<string>;
          raffleWinner?: string | null;
          winnerCount: number;
          remainingSubmissionIds: Array<string>;
          lastEliminatedSubmissionId?: string | null;
        }
      | {
          __typename?: 'SlidesAdminData';
          currentSlide: string;
          slidesDisplayOrder: Array<string>;
        }
      | {
          __typename?: 'TriviaAdminData';
          status: TriviaRoundStatus;
          questionIndex: number;
          playedThroughIndex: number;
          reviewing: boolean;
          questionEndsAt?: any | null;
          answeredCount: number;
          playerCount: number;
          correctChoiceId?: string | null;
          correctCount?: number | null;
          revealedQuestionIds: Array<string>;
          tallies: Array<{
            __typename?: 'TriviaTally';
            choiceId: string;
            count: number;
          }>;
          leaderboard: Array<{
            __typename?: 'TriviaLeaderboardRow';
            userId: string;
            name: string;
            score: number;
            rank: number;
            tied: boolean;
          }>;
        }
      | {
          __typename?: 'VoteForAdminData';
          startTime?: any | null;
          endTime?: any | null;
          voteWinners?: Array<string> | null;
          choiceDisplayOrder: Array<string>;
          votes: Array<{
            __typename?: 'VoteCount';
            submissionId: string;
            count: number;
          }>;
        }
      | null;
    config?:
      | {
          __typename?: 'NowPlayingAdminConfig';
          visualizationType: string;
          allowComments: boolean;
          allowedReactions: Array<string>;
        }
      | {
          __typename?: 'PhotoCarouselAdminConfig';
          maxSubmissionsPerUser: number;
          requireApproval: boolean;
          askSharePermission?: boolean | null;
          sharePrompt?: string | null;
          noPhotosMessage?: string | null;
          pollInterval?: number | null;
          predefinedCaptions?: Array<string> | null;
          maxVisiblePhotos: number;
        }
      | {
          __typename?: 'RaffleAdminConfig';
          optionalImageUrl?: string | null;
          claimYourPrize?: string | null;
          ticketFlipDirection: RaffleTicketFlipDirection;
        }
      | {
          __typename?: 'SlidesAdminConfig';
          autoPlay: boolean;
          autoPlayIntervalMs?: number | null;
        }
      | {
          __typename?: 'TriviaAdminConfig';
          instructions?: string | null;
          useQuestionTimer: boolean;
          defaultTimerMs: number;
          questions: Array<{
            __typename?: 'TriviaQuestion';
            id: string;
            text: string;
            correctChoiceId?: string | null;
            timerMs?: number | null;
            choices: Array<{
              __typename?: 'TriviaChoice';
              id: string;
              text: string;
            }>;
          }>;
        }
      | {
          __typename?: 'VoteForAdminConfig';
          votesPerUser: number;
          allowUserSubmissions: boolean;
          maxSubmissionsPerUser: number;
        }
      | null;
    viewConfig:
      | {
          __typename?: 'NowPlayingViewConfig';
          visualizationType: string;
          allowComments: boolean;
          allowedReactions: Array<string>;
        }
      | {
          __typename?: 'PhotoCarouselViewConfig';
          maxSubmissionsPerUser: number;
          askSharePermission?: boolean | null;
          sharePrompt?: string | null;
          noPhotosMessage?: string | null;
          maxVisiblePhotos: number;
        }
      | {
          __typename?: 'RaffleViewConfig';
          optionalImageUrl?: string | null;
          claimYourPrize?: string | null;
          ticketFlipDirection: RaffleTicketFlipDirection;
        }
      | {
          __typename?: 'SlidesViewConfig';
          autoPlay: boolean;
          autoPlayIntervalMs?: number | null;
        }
      | {
          __typename?: 'TriviaViewConfig';
          instructions?: string | null;
          useQuestionTimer: boolean;
          defaultTimerMs: number;
          questions: Array<{
            __typename?: 'TriviaViewQuestion';
            id: string;
            text: string;
            timerMs?: number | null;
            choices: Array<{
              __typename?: 'TriviaChoice';
              id: string;
              text: string;
            }>;
          }>;
        }
      | { __typename?: 'VoteForViewConfig'; votesPerUser: number };
    viewData:
      | { __typename?: 'NowPlayingViewData'; currentSong?: string | null }
      | {
          __typename?: 'PhotoCarouselViewData';
          visibleSubmission?: string | null;
        }
      | {
          __typename?: 'RaffleViewData';
          raffleStatus: RaffleStatus;
          raffleCandidates: Array<string>;
          raffleWinners: Array<string>;
          raffleWinner?: string | null;
          winnerCount: number;
          remainingSubmissionIds: Array<string>;
          lastEliminatedSubmissionId?: string | null;
        }
      | {
          __typename?: 'SlidesViewData';
          currentSlide: string;
          slidesDisplayOrder: Array<string>;
        }
      | {
          __typename?: 'TriviaViewData';
          status: TriviaRoundStatus;
          questionIndex: number;
          questionEndsAt?: any | null;
          answeredCount: number;
          playerCount: number;
          correctChoiceId?: string | null;
          correctCount?: number | null;
          leaderboardOverflow: number;
          tallies: Array<{
            __typename?: 'TriviaTally';
            choiceId: string;
            count: number;
          }>;
          leaderboard: Array<{
            __typename?: 'TriviaLeaderboardRow';
            userId: string;
            name: string;
            score: number;
            rank: number;
            tied: boolean;
          }>;
        }
      | {
          __typename?: 'VoteForViewData';
          voteWinners?: Array<string> | null;
          choiceDisplayOrder: Array<string>;
          votes: Array<{
            __typename?: 'VoteCount';
            submissionId: string;
            count: number;
          }>;
        };
  };
};

export type RaffleWiggleTicketMutationVariables = Exact<{
  engagementId: Scalars['String']['input'];
  submissionId: Scalars['String']['input'];
}>;

export type RaffleWiggleTicketMutation = {
  __typename?: 'Mutation';
  raffleWiggleTicket: boolean;
};

export type RaffleTicketWiggledSubscriptionVariables = Exact<{
  engagementId: Scalars['String']['input'];
}>;

export type RaffleTicketWiggledSubscription = {
  __typename?: 'Subscription';
  raffleTicketWiggled: {
    __typename?: 'RaffleTicketWiggledPayload';
    engagementId: string;
    submissionId: string;
  };
};

export type MockRaffleTicketWiggledSubscriptionVariables = Exact<{
  engagementId: Scalars['String']['input'];
}>;

export type MockRaffleTicketWiggledSubscription = {
  __typename?: 'Subscription';
  mockRaffleTicketWiggled: {
    __typename?: 'RaffleTicketWiggledPayload';
    engagementId: string;
    submissionId: string;
  };
};

export type SlidesViewConfigFieldsFragment = {
  __typename?: 'SlidesViewConfig';
  autoPlay: boolean;
  autoPlayIntervalMs?: number | null;
};

export type SlidesViewDataFieldsFragment = {
  __typename?: 'SlidesViewData';
  currentSlide: string;
  slidesDisplayOrder: Array<string>;
};

export type SlidesSubmissionFieldsFragment = {
  __typename?: 'SlidesSubmissionData';
  optionalImageUrl?: string | null;
  title: string;
  content: string;
  slideDuration?: number | null;
  imageTilt?: SlideImageTilt | null;
  layout?: SlideLayout | null;
  showQr?: boolean | null;
  background?: {
    __typename?: 'SlideBackground';
    type: SlideBackgroundType;
    color?: string | null;
    imageUrl?: string | null;
  } | null;
  elements?: Array<{
    __typename?: 'SlideElement';
    id: string;
    type: SlideElementType;
    name?: string | null;
    locked?: boolean | null;
    text?: string | null;
    textType?: string | null;
    fontFamily?: Array<string> | null;
    color?: string | null;
    fontSize?: number | null;
    fontWeight?: SlideFontWeight | null;
    textAlign?: SlideTextAlign | null;
    verticalAlign?: SlideVerticalAlign | null;
    imageUrl?: string | null;
    fit?: SlideImageFit | null;
    box?: {
      __typename?: 'SlideBox';
      x: number;
      y: number;
      w: number;
      h: number;
    } | null;
  }> | null;
};

export type SlidesAdminConfigFieldsFragment = {
  __typename?: 'SlidesAdminConfig';
  autoPlay: boolean;
  autoPlayIntervalMs?: number | null;
};

export type SlidesAdminDataFieldsFragment = {
  __typename?: 'SlidesAdminData';
  currentSlide: string;
  slidesDisplayOrder: Array<string>;
};

export type TriviaChoiceFieldsFragment = {
  __typename?: 'TriviaChoice';
  id: string;
  text: string;
};

export type TriviaQuestionFieldsFragment = {
  __typename?: 'TriviaQuestion';
  id: string;
  text: string;
  correctChoiceId?: string | null;
  timerMs?: number | null;
  choices: Array<{ __typename?: 'TriviaChoice'; id: string; text: string }>;
};

export type TriviaViewQuestionFieldsFragment = {
  __typename?: 'TriviaViewQuestion';
  id: string;
  text: string;
  timerMs?: number | null;
  choices: Array<{ __typename?: 'TriviaChoice'; id: string; text: string }>;
};

export type TriviaTallyFieldsFragment = {
  __typename?: 'TriviaTally';
  choiceId: string;
  count: number;
};

export type TriviaLeaderboardRowFieldsFragment = {
  __typename?: 'TriviaLeaderboardRow';
  userId: string;
  name: string;
  score: number;
  rank: number;
  tied: boolean;
};

export type TriviaAdminConfigFieldsFragment = {
  __typename?: 'TriviaAdminConfig';
  instructions?: string | null;
  useQuestionTimer: boolean;
  defaultTimerMs: number;
  questions: Array<{
    __typename?: 'TriviaQuestion';
    id: string;
    text: string;
    correctChoiceId?: string | null;
    timerMs?: number | null;
    choices: Array<{ __typename?: 'TriviaChoice'; id: string; text: string }>;
  }>;
};

export type TriviaViewConfigFieldsFragment = {
  __typename?: 'TriviaViewConfig';
  instructions?: string | null;
  useQuestionTimer: boolean;
  defaultTimerMs: number;
  questions: Array<{
    __typename?: 'TriviaViewQuestion';
    id: string;
    text: string;
    timerMs?: number | null;
    choices: Array<{ __typename?: 'TriviaChoice'; id: string; text: string }>;
  }>;
};

export type TriviaViewDataFieldsFragment = {
  __typename?: 'TriviaViewData';
  status: TriviaRoundStatus;
  questionIndex: number;
  questionEndsAt?: any | null;
  answeredCount: number;
  playerCount: number;
  correctChoiceId?: string | null;
  correctCount?: number | null;
  leaderboardOverflow: number;
  skipped: boolean;
  tallies: Array<{
    __typename?: 'TriviaTally';
    choiceId: string;
    count: number;
  }>;
  leaderboard: Array<{
    __typename?: 'TriviaLeaderboardRow';
    userId: string;
    name: string;
    score: number;
    rank: number;
    tied: boolean;
  }>;
};

export type TriviaAdminDataFieldsFragment = {
  __typename?: 'TriviaAdminData';
  status: TriviaRoundStatus;
  questionIndex: number;
  playedThroughIndex: number;
  reviewing: boolean;
  questionEndsAt?: any | null;
  answeredCount: number;
  playerCount: number;
  correctChoiceId?: string | null;
  correctCount?: number | null;
  revealedQuestionIds: Array<string>;
  skipRevealedQuestionIds: Array<string>;
  skipped: boolean;
  tallies: Array<{
    __typename?: 'TriviaTally';
    choiceId: string;
    count: number;
  }>;
  leaderboard: Array<{
    __typename?: 'TriviaLeaderboardRow';
    userId: string;
    name: string;
    score: number;
    rank: number;
    tied: boolean;
  }>;
};

export type TriviaSubmissionFieldsFragment = {
  __typename?: 'TriviaSubmissionData';
  questionId?: string | null;
  choiceId?: string | null;
};

export type TriviaMyAnswerFieldsFragment = {
  __typename?: 'TriviaMyAnswer';
  questionId: string;
  choiceId: string;
};

export type TriviaMyAnswersQueryVariables = Exact<{
  engagementId: Scalars['String']['input'];
}>;

export type TriviaMyAnswersQuery = {
  __typename?: 'Query';
  triviaMyAnswers: {
    __typename?: 'TriviaMyProgress';
    score: number;
    rank?: number | null;
    answers: Array<{
      __typename?: 'TriviaMyAnswer';
      questionId: string;
      choiceId: string;
    }>;
    scored: Array<{
      __typename?: 'TriviaMyScoredQuestion';
      questionId: string;
      correctChoiceId: string;
    }>;
  };
};

export type TriviaStartRoundMutationVariables = Exact<{
  engagementId: Scalars['String']['input'];
}>;

export type TriviaStartRoundMutation = {
  __typename?: 'Mutation';
  triviaStartRound: {
    __typename?: 'Engagement';
    id: string;
    eventId: string;
    createdAt: any;
    updatedAt: any;
    title: string;
    description?: string | null;
    qrCodeCta?: string | null;
    startTime?: any | null;
    order: number;
    endTime?: any | null;
    type: EngagementType;
    data?:
      | { __typename?: 'NowPlayingAdminData'; currentSong?: string | null }
      | {
          __typename?: 'PhotoCarouselAdminData';
          visibleSubmission?: string | null;
          rejectedQueue: Array<string>;
          unapprovedQueue: Array<string>;
          unseenQueue: Array<string>;
          seenQueuePointer: number;
          seenQueue: Array<string>;
        }
      | {
          __typename?: 'RaffleAdminData';
          raffleStatus: RaffleStatus;
          raffleCandidates: Array<string>;
          raffleWinners: Array<string>;
          raffleWinner?: string | null;
          winnerCount: number;
          remainingSubmissionIds: Array<string>;
          lastEliminatedSubmissionId?: string | null;
        }
      | {
          __typename?: 'SlidesAdminData';
          currentSlide: string;
          slidesDisplayOrder: Array<string>;
        }
      | {
          __typename?: 'TriviaAdminData';
          status: TriviaRoundStatus;
          questionIndex: number;
          playedThroughIndex: number;
          reviewing: boolean;
          questionEndsAt?: any | null;
          answeredCount: number;
          playerCount: number;
          correctChoiceId?: string | null;
          correctCount?: number | null;
          revealedQuestionIds: Array<string>;
          tallies: Array<{
            __typename?: 'TriviaTally';
            choiceId: string;
            count: number;
          }>;
          leaderboard: Array<{
            __typename?: 'TriviaLeaderboardRow';
            userId: string;
            name: string;
            score: number;
            rank: number;
            tied: boolean;
          }>;
        }
      | {
          __typename?: 'VoteForAdminData';
          startTime?: any | null;
          endTime?: any | null;
          voteWinners?: Array<string> | null;
          choiceDisplayOrder: Array<string>;
          votes: Array<{
            __typename?: 'VoteCount';
            submissionId: string;
            count: number;
          }>;
        }
      | null;
    config?:
      | {
          __typename?: 'NowPlayingAdminConfig';
          visualizationType: string;
          allowComments: boolean;
          allowedReactions: Array<string>;
        }
      | {
          __typename?: 'PhotoCarouselAdminConfig';
          maxSubmissionsPerUser: number;
          requireApproval: boolean;
          askSharePermission?: boolean | null;
          sharePrompt?: string | null;
          noPhotosMessage?: string | null;
          pollInterval?: number | null;
          predefinedCaptions?: Array<string> | null;
          maxVisiblePhotos: number;
        }
      | {
          __typename?: 'RaffleAdminConfig';
          optionalImageUrl?: string | null;
          claimYourPrize?: string | null;
          ticketFlipDirection: RaffleTicketFlipDirection;
        }
      | {
          __typename?: 'SlidesAdminConfig';
          autoPlay: boolean;
          autoPlayIntervalMs?: number | null;
        }
      | {
          __typename?: 'TriviaAdminConfig';
          instructions?: string | null;
          useQuestionTimer: boolean;
          defaultTimerMs: number;
          questions: Array<{
            __typename?: 'TriviaQuestion';
            id: string;
            text: string;
            correctChoiceId?: string | null;
            timerMs?: number | null;
            choices: Array<{
              __typename?: 'TriviaChoice';
              id: string;
              text: string;
            }>;
          }>;
        }
      | {
          __typename?: 'VoteForAdminConfig';
          votesPerUser: number;
          allowUserSubmissions: boolean;
          maxSubmissionsPerUser: number;
        }
      | null;
    viewConfig:
      | {
          __typename?: 'NowPlayingViewConfig';
          visualizationType: string;
          allowComments: boolean;
          allowedReactions: Array<string>;
        }
      | {
          __typename?: 'PhotoCarouselViewConfig';
          maxSubmissionsPerUser: number;
          askSharePermission?: boolean | null;
          sharePrompt?: string | null;
          noPhotosMessage?: string | null;
          maxVisiblePhotos: number;
        }
      | {
          __typename?: 'RaffleViewConfig';
          optionalImageUrl?: string | null;
          claimYourPrize?: string | null;
          ticketFlipDirection: RaffleTicketFlipDirection;
        }
      | {
          __typename?: 'SlidesViewConfig';
          autoPlay: boolean;
          autoPlayIntervalMs?: number | null;
        }
      | {
          __typename?: 'TriviaViewConfig';
          instructions?: string | null;
          useQuestionTimer: boolean;
          defaultTimerMs: number;
          questions: Array<{
            __typename?: 'TriviaViewQuestion';
            id: string;
            text: string;
            timerMs?: number | null;
            choices: Array<{
              __typename?: 'TriviaChoice';
              id: string;
              text: string;
            }>;
          }>;
        }
      | { __typename?: 'VoteForViewConfig'; votesPerUser: number };
    viewData:
      | { __typename?: 'NowPlayingViewData'; currentSong?: string | null }
      | {
          __typename?: 'PhotoCarouselViewData';
          visibleSubmission?: string | null;
        }
      | {
          __typename?: 'RaffleViewData';
          raffleStatus: RaffleStatus;
          raffleCandidates: Array<string>;
          raffleWinners: Array<string>;
          raffleWinner?: string | null;
          winnerCount: number;
          remainingSubmissionIds: Array<string>;
          lastEliminatedSubmissionId?: string | null;
        }
      | {
          __typename?: 'SlidesViewData';
          currentSlide: string;
          slidesDisplayOrder: Array<string>;
        }
      | {
          __typename?: 'TriviaViewData';
          status: TriviaRoundStatus;
          questionIndex: number;
          questionEndsAt?: any | null;
          answeredCount: number;
          playerCount: number;
          correctChoiceId?: string | null;
          correctCount?: number | null;
          leaderboardOverflow: number;
          tallies: Array<{
            __typename?: 'TriviaTally';
            choiceId: string;
            count: number;
          }>;
          leaderboard: Array<{
            __typename?: 'TriviaLeaderboardRow';
            userId: string;
            name: string;
            score: number;
            rank: number;
            tied: boolean;
          }>;
        }
      | {
          __typename?: 'VoteForViewData';
          voteWinners?: Array<string> | null;
          choiceDisplayOrder: Array<string>;
          votes: Array<{
            __typename?: 'VoteCount';
            submissionId: string;
            count: number;
          }>;
        };
  };
};

export type TriviaCloseAnswersMutationVariables = Exact<{
  engagementId: Scalars['String']['input'];
}>;

export type TriviaCloseAnswersMutation = {
  __typename?: 'Mutation';
  triviaCloseAnswers: {
    __typename?: 'Engagement';
    id: string;
    eventId: string;
    createdAt: any;
    updatedAt: any;
    title: string;
    description?: string | null;
    qrCodeCta?: string | null;
    startTime?: any | null;
    order: number;
    endTime?: any | null;
    type: EngagementType;
    data?:
      | { __typename?: 'NowPlayingAdminData'; currentSong?: string | null }
      | {
          __typename?: 'PhotoCarouselAdminData';
          visibleSubmission?: string | null;
          rejectedQueue: Array<string>;
          unapprovedQueue: Array<string>;
          unseenQueue: Array<string>;
          seenQueuePointer: number;
          seenQueue: Array<string>;
        }
      | {
          __typename?: 'RaffleAdminData';
          raffleStatus: RaffleStatus;
          raffleCandidates: Array<string>;
          raffleWinners: Array<string>;
          raffleWinner?: string | null;
          winnerCount: number;
          remainingSubmissionIds: Array<string>;
          lastEliminatedSubmissionId?: string | null;
        }
      | {
          __typename?: 'SlidesAdminData';
          currentSlide: string;
          slidesDisplayOrder: Array<string>;
        }
      | {
          __typename?: 'TriviaAdminData';
          status: TriviaRoundStatus;
          questionIndex: number;
          playedThroughIndex: number;
          reviewing: boolean;
          questionEndsAt?: any | null;
          answeredCount: number;
          playerCount: number;
          correctChoiceId?: string | null;
          correctCount?: number | null;
          revealedQuestionIds: Array<string>;
          tallies: Array<{
            __typename?: 'TriviaTally';
            choiceId: string;
            count: number;
          }>;
          leaderboard: Array<{
            __typename?: 'TriviaLeaderboardRow';
            userId: string;
            name: string;
            score: number;
            rank: number;
            tied: boolean;
          }>;
        }
      | {
          __typename?: 'VoteForAdminData';
          startTime?: any | null;
          endTime?: any | null;
          voteWinners?: Array<string> | null;
          choiceDisplayOrder: Array<string>;
          votes: Array<{
            __typename?: 'VoteCount';
            submissionId: string;
            count: number;
          }>;
        }
      | null;
    config?:
      | {
          __typename?: 'NowPlayingAdminConfig';
          visualizationType: string;
          allowComments: boolean;
          allowedReactions: Array<string>;
        }
      | {
          __typename?: 'PhotoCarouselAdminConfig';
          maxSubmissionsPerUser: number;
          requireApproval: boolean;
          askSharePermission?: boolean | null;
          sharePrompt?: string | null;
          noPhotosMessage?: string | null;
          pollInterval?: number | null;
          predefinedCaptions?: Array<string> | null;
          maxVisiblePhotos: number;
        }
      | {
          __typename?: 'RaffleAdminConfig';
          optionalImageUrl?: string | null;
          claimYourPrize?: string | null;
          ticketFlipDirection: RaffleTicketFlipDirection;
        }
      | {
          __typename?: 'SlidesAdminConfig';
          autoPlay: boolean;
          autoPlayIntervalMs?: number | null;
        }
      | {
          __typename?: 'TriviaAdminConfig';
          instructions?: string | null;
          useQuestionTimer: boolean;
          defaultTimerMs: number;
          questions: Array<{
            __typename?: 'TriviaQuestion';
            id: string;
            text: string;
            correctChoiceId?: string | null;
            timerMs?: number | null;
            choices: Array<{
              __typename?: 'TriviaChoice';
              id: string;
              text: string;
            }>;
          }>;
        }
      | {
          __typename?: 'VoteForAdminConfig';
          votesPerUser: number;
          allowUserSubmissions: boolean;
          maxSubmissionsPerUser: number;
        }
      | null;
    viewConfig:
      | {
          __typename?: 'NowPlayingViewConfig';
          visualizationType: string;
          allowComments: boolean;
          allowedReactions: Array<string>;
        }
      | {
          __typename?: 'PhotoCarouselViewConfig';
          maxSubmissionsPerUser: number;
          askSharePermission?: boolean | null;
          sharePrompt?: string | null;
          noPhotosMessage?: string | null;
          maxVisiblePhotos: number;
        }
      | {
          __typename?: 'RaffleViewConfig';
          optionalImageUrl?: string | null;
          claimYourPrize?: string | null;
          ticketFlipDirection: RaffleTicketFlipDirection;
        }
      | {
          __typename?: 'SlidesViewConfig';
          autoPlay: boolean;
          autoPlayIntervalMs?: number | null;
        }
      | {
          __typename?: 'TriviaViewConfig';
          instructions?: string | null;
          useQuestionTimer: boolean;
          defaultTimerMs: number;
          questions: Array<{
            __typename?: 'TriviaViewQuestion';
            id: string;
            text: string;
            timerMs?: number | null;
            choices: Array<{
              __typename?: 'TriviaChoice';
              id: string;
              text: string;
            }>;
          }>;
        }
      | { __typename?: 'VoteForViewConfig'; votesPerUser: number };
    viewData:
      | { __typename?: 'NowPlayingViewData'; currentSong?: string | null }
      | {
          __typename?: 'PhotoCarouselViewData';
          visibleSubmission?: string | null;
        }
      | {
          __typename?: 'RaffleViewData';
          raffleStatus: RaffleStatus;
          raffleCandidates: Array<string>;
          raffleWinners: Array<string>;
          raffleWinner?: string | null;
          winnerCount: number;
          remainingSubmissionIds: Array<string>;
          lastEliminatedSubmissionId?: string | null;
        }
      | {
          __typename?: 'SlidesViewData';
          currentSlide: string;
          slidesDisplayOrder: Array<string>;
        }
      | {
          __typename?: 'TriviaViewData';
          status: TriviaRoundStatus;
          questionIndex: number;
          questionEndsAt?: any | null;
          answeredCount: number;
          playerCount: number;
          correctChoiceId?: string | null;
          correctCount?: number | null;
          leaderboardOverflow: number;
          tallies: Array<{
            __typename?: 'TriviaTally';
            choiceId: string;
            count: number;
          }>;
          leaderboard: Array<{
            __typename?: 'TriviaLeaderboardRow';
            userId: string;
            name: string;
            score: number;
            rank: number;
            tied: boolean;
          }>;
        }
      | {
          __typename?: 'VoteForViewData';
          voteWinners?: Array<string> | null;
          choiceDisplayOrder: Array<string>;
          votes: Array<{
            __typename?: 'VoteCount';
            submissionId: string;
            count: number;
          }>;
        };
  };
};

export type TriviaRevealMutationVariables = Exact<{
  engagementId: Scalars['String']['input'];
}>;

export type TriviaRevealMutation = {
  __typename?: 'Mutation';
  triviaReveal: {
    __typename?: 'Engagement';
    id: string;
    eventId: string;
    createdAt: any;
    updatedAt: any;
    title: string;
    description?: string | null;
    qrCodeCta?: string | null;
    startTime?: any | null;
    order: number;
    endTime?: any | null;
    type: EngagementType;
    data?:
      | { __typename?: 'NowPlayingAdminData'; currentSong?: string | null }
      | {
          __typename?: 'PhotoCarouselAdminData';
          visibleSubmission?: string | null;
          rejectedQueue: Array<string>;
          unapprovedQueue: Array<string>;
          unseenQueue: Array<string>;
          seenQueuePointer: number;
          seenQueue: Array<string>;
        }
      | {
          __typename?: 'RaffleAdminData';
          raffleStatus: RaffleStatus;
          raffleCandidates: Array<string>;
          raffleWinners: Array<string>;
          raffleWinner?: string | null;
          winnerCount: number;
          remainingSubmissionIds: Array<string>;
          lastEliminatedSubmissionId?: string | null;
        }
      | {
          __typename?: 'SlidesAdminData';
          currentSlide: string;
          slidesDisplayOrder: Array<string>;
        }
      | {
          __typename?: 'TriviaAdminData';
          status: TriviaRoundStatus;
          questionIndex: number;
          playedThroughIndex: number;
          reviewing: boolean;
          questionEndsAt?: any | null;
          answeredCount: number;
          playerCount: number;
          correctChoiceId?: string | null;
          correctCount?: number | null;
          revealedQuestionIds: Array<string>;
          tallies: Array<{
            __typename?: 'TriviaTally';
            choiceId: string;
            count: number;
          }>;
          leaderboard: Array<{
            __typename?: 'TriviaLeaderboardRow';
            userId: string;
            name: string;
            score: number;
            rank: number;
            tied: boolean;
          }>;
        }
      | {
          __typename?: 'VoteForAdminData';
          startTime?: any | null;
          endTime?: any | null;
          voteWinners?: Array<string> | null;
          choiceDisplayOrder: Array<string>;
          votes: Array<{
            __typename?: 'VoteCount';
            submissionId: string;
            count: number;
          }>;
        }
      | null;
    config?:
      | {
          __typename?: 'NowPlayingAdminConfig';
          visualizationType: string;
          allowComments: boolean;
          allowedReactions: Array<string>;
        }
      | {
          __typename?: 'PhotoCarouselAdminConfig';
          maxSubmissionsPerUser: number;
          requireApproval: boolean;
          askSharePermission?: boolean | null;
          sharePrompt?: string | null;
          noPhotosMessage?: string | null;
          pollInterval?: number | null;
          predefinedCaptions?: Array<string> | null;
          maxVisiblePhotos: number;
        }
      | {
          __typename?: 'RaffleAdminConfig';
          optionalImageUrl?: string | null;
          claimYourPrize?: string | null;
          ticketFlipDirection: RaffleTicketFlipDirection;
        }
      | {
          __typename?: 'SlidesAdminConfig';
          autoPlay: boolean;
          autoPlayIntervalMs?: number | null;
        }
      | {
          __typename?: 'TriviaAdminConfig';
          instructions?: string | null;
          useQuestionTimer: boolean;
          defaultTimerMs: number;
          questions: Array<{
            __typename?: 'TriviaQuestion';
            id: string;
            text: string;
            correctChoiceId?: string | null;
            timerMs?: number | null;
            choices: Array<{
              __typename?: 'TriviaChoice';
              id: string;
              text: string;
            }>;
          }>;
        }
      | {
          __typename?: 'VoteForAdminConfig';
          votesPerUser: number;
          allowUserSubmissions: boolean;
          maxSubmissionsPerUser: number;
        }
      | null;
    viewConfig:
      | {
          __typename?: 'NowPlayingViewConfig';
          visualizationType: string;
          allowComments: boolean;
          allowedReactions: Array<string>;
        }
      | {
          __typename?: 'PhotoCarouselViewConfig';
          maxSubmissionsPerUser: number;
          askSharePermission?: boolean | null;
          sharePrompt?: string | null;
          noPhotosMessage?: string | null;
          maxVisiblePhotos: number;
        }
      | {
          __typename?: 'RaffleViewConfig';
          optionalImageUrl?: string | null;
          claimYourPrize?: string | null;
          ticketFlipDirection: RaffleTicketFlipDirection;
        }
      | {
          __typename?: 'SlidesViewConfig';
          autoPlay: boolean;
          autoPlayIntervalMs?: number | null;
        }
      | {
          __typename?: 'TriviaViewConfig';
          instructions?: string | null;
          useQuestionTimer: boolean;
          defaultTimerMs: number;
          questions: Array<{
            __typename?: 'TriviaViewQuestion';
            id: string;
            text: string;
            timerMs?: number | null;
            choices: Array<{
              __typename?: 'TriviaChoice';
              id: string;
              text: string;
            }>;
          }>;
        }
      | { __typename?: 'VoteForViewConfig'; votesPerUser: number };
    viewData:
      | { __typename?: 'NowPlayingViewData'; currentSong?: string | null }
      | {
          __typename?: 'PhotoCarouselViewData';
          visibleSubmission?: string | null;
        }
      | {
          __typename?: 'RaffleViewData';
          raffleStatus: RaffleStatus;
          raffleCandidates: Array<string>;
          raffleWinners: Array<string>;
          raffleWinner?: string | null;
          winnerCount: number;
          remainingSubmissionIds: Array<string>;
          lastEliminatedSubmissionId?: string | null;
        }
      | {
          __typename?: 'SlidesViewData';
          currentSlide: string;
          slidesDisplayOrder: Array<string>;
        }
      | {
          __typename?: 'TriviaViewData';
          status: TriviaRoundStatus;
          questionIndex: number;
          questionEndsAt?: any | null;
          answeredCount: number;
          playerCount: number;
          correctChoiceId?: string | null;
          correctCount?: number | null;
          leaderboardOverflow: number;
          tallies: Array<{
            __typename?: 'TriviaTally';
            choiceId: string;
            count: number;
          }>;
          leaderboard: Array<{
            __typename?: 'TriviaLeaderboardRow';
            userId: string;
            name: string;
            score: number;
            rank: number;
            tied: boolean;
          }>;
        }
      | {
          __typename?: 'VoteForViewData';
          voteWinners?: Array<string> | null;
          choiceDisplayOrder: Array<string>;
          votes: Array<{
            __typename?: 'VoteCount';
            submissionId: string;
            count: number;
          }>;
        };
  };
};

export type TriviaNextQuestionMutationVariables = Exact<{
  engagementId: Scalars['String']['input'];
}>;

export type TriviaNextQuestionMutation = {
  __typename?: 'Mutation';
  triviaNextQuestion: {
    __typename?: 'Engagement';
    id: string;
    eventId: string;
    createdAt: any;
    updatedAt: any;
    title: string;
    description?: string | null;
    qrCodeCta?: string | null;
    startTime?: any | null;
    order: number;
    endTime?: any | null;
    type: EngagementType;
    data?:
      | { __typename?: 'NowPlayingAdminData'; currentSong?: string | null }
      | {
          __typename?: 'PhotoCarouselAdminData';
          visibleSubmission?: string | null;
          rejectedQueue: Array<string>;
          unapprovedQueue: Array<string>;
          unseenQueue: Array<string>;
          seenQueuePointer: number;
          seenQueue: Array<string>;
        }
      | {
          __typename?: 'RaffleAdminData';
          raffleStatus: RaffleStatus;
          raffleCandidates: Array<string>;
          raffleWinners: Array<string>;
          raffleWinner?: string | null;
          winnerCount: number;
          remainingSubmissionIds: Array<string>;
          lastEliminatedSubmissionId?: string | null;
        }
      | {
          __typename?: 'SlidesAdminData';
          currentSlide: string;
          slidesDisplayOrder: Array<string>;
        }
      | {
          __typename?: 'TriviaAdminData';
          status: TriviaRoundStatus;
          questionIndex: number;
          playedThroughIndex: number;
          reviewing: boolean;
          questionEndsAt?: any | null;
          answeredCount: number;
          playerCount: number;
          correctChoiceId?: string | null;
          correctCount?: number | null;
          revealedQuestionIds: Array<string>;
          tallies: Array<{
            __typename?: 'TriviaTally';
            choiceId: string;
            count: number;
          }>;
          leaderboard: Array<{
            __typename?: 'TriviaLeaderboardRow';
            userId: string;
            name: string;
            score: number;
            rank: number;
            tied: boolean;
          }>;
        }
      | {
          __typename?: 'VoteForAdminData';
          startTime?: any | null;
          endTime?: any | null;
          voteWinners?: Array<string> | null;
          choiceDisplayOrder: Array<string>;
          votes: Array<{
            __typename?: 'VoteCount';
            submissionId: string;
            count: number;
          }>;
        }
      | null;
    config?:
      | {
          __typename?: 'NowPlayingAdminConfig';
          visualizationType: string;
          allowComments: boolean;
          allowedReactions: Array<string>;
        }
      | {
          __typename?: 'PhotoCarouselAdminConfig';
          maxSubmissionsPerUser: number;
          requireApproval: boolean;
          askSharePermission?: boolean | null;
          sharePrompt?: string | null;
          noPhotosMessage?: string | null;
          pollInterval?: number | null;
          predefinedCaptions?: Array<string> | null;
          maxVisiblePhotos: number;
        }
      | {
          __typename?: 'RaffleAdminConfig';
          optionalImageUrl?: string | null;
          claimYourPrize?: string | null;
          ticketFlipDirection: RaffleTicketFlipDirection;
        }
      | {
          __typename?: 'SlidesAdminConfig';
          autoPlay: boolean;
          autoPlayIntervalMs?: number | null;
        }
      | {
          __typename?: 'TriviaAdminConfig';
          instructions?: string | null;
          useQuestionTimer: boolean;
          defaultTimerMs: number;
          questions: Array<{
            __typename?: 'TriviaQuestion';
            id: string;
            text: string;
            correctChoiceId?: string | null;
            timerMs?: number | null;
            choices: Array<{
              __typename?: 'TriviaChoice';
              id: string;
              text: string;
            }>;
          }>;
        }
      | {
          __typename?: 'VoteForAdminConfig';
          votesPerUser: number;
          allowUserSubmissions: boolean;
          maxSubmissionsPerUser: number;
        }
      | null;
    viewConfig:
      | {
          __typename?: 'NowPlayingViewConfig';
          visualizationType: string;
          allowComments: boolean;
          allowedReactions: Array<string>;
        }
      | {
          __typename?: 'PhotoCarouselViewConfig';
          maxSubmissionsPerUser: number;
          askSharePermission?: boolean | null;
          sharePrompt?: string | null;
          noPhotosMessage?: string | null;
          maxVisiblePhotos: number;
        }
      | {
          __typename?: 'RaffleViewConfig';
          optionalImageUrl?: string | null;
          claimYourPrize?: string | null;
          ticketFlipDirection: RaffleTicketFlipDirection;
        }
      | {
          __typename?: 'SlidesViewConfig';
          autoPlay: boolean;
          autoPlayIntervalMs?: number | null;
        }
      | {
          __typename?: 'TriviaViewConfig';
          instructions?: string | null;
          useQuestionTimer: boolean;
          defaultTimerMs: number;
          questions: Array<{
            __typename?: 'TriviaViewQuestion';
            id: string;
            text: string;
            timerMs?: number | null;
            choices: Array<{
              __typename?: 'TriviaChoice';
              id: string;
              text: string;
            }>;
          }>;
        }
      | { __typename?: 'VoteForViewConfig'; votesPerUser: number };
    viewData:
      | { __typename?: 'NowPlayingViewData'; currentSong?: string | null }
      | {
          __typename?: 'PhotoCarouselViewData';
          visibleSubmission?: string | null;
        }
      | {
          __typename?: 'RaffleViewData';
          raffleStatus: RaffleStatus;
          raffleCandidates: Array<string>;
          raffleWinners: Array<string>;
          raffleWinner?: string | null;
          winnerCount: number;
          remainingSubmissionIds: Array<string>;
          lastEliminatedSubmissionId?: string | null;
        }
      | {
          __typename?: 'SlidesViewData';
          currentSlide: string;
          slidesDisplayOrder: Array<string>;
        }
      | {
          __typename?: 'TriviaViewData';
          status: TriviaRoundStatus;
          questionIndex: number;
          questionEndsAt?: any | null;
          answeredCount: number;
          playerCount: number;
          correctChoiceId?: string | null;
          correctCount?: number | null;
          leaderboardOverflow: number;
          tallies: Array<{
            __typename?: 'TriviaTally';
            choiceId: string;
            count: number;
          }>;
          leaderboard: Array<{
            __typename?: 'TriviaLeaderboardRow';
            userId: string;
            name: string;
            score: number;
            rank: number;
            tied: boolean;
          }>;
        }
      | {
          __typename?: 'VoteForViewData';
          voteWinners?: Array<string> | null;
          choiceDisplayOrder: Array<string>;
          votes: Array<{
            __typename?: 'VoteCount';
            submissionId: string;
            count: number;
          }>;
        };
  };
};

export type TriviaSkipRevealMutationVariables = Exact<{
  engagementId: Scalars['String']['input'];
}>;

export type TriviaSkipRevealMutation = {
  __typename?: 'Mutation';
  triviaSkipReveal: {
    __typename?: 'Engagement';
    id: string;
    eventId: string;
    createdAt: any;
    updatedAt: any;
    title: string;
    description?: string | null;
    qrCodeCta?: string | null;
    startTime?: any | null;
    order: number;
    endTime?: any | null;
    type: EngagementType;
    data?:
      | { __typename?: 'NowPlayingAdminData'; currentSong?: string | null }
      | {
          __typename?: 'PhotoCarouselAdminData';
          visibleSubmission?: string | null;
          rejectedQueue: Array<string>;
          unapprovedQueue: Array<string>;
          unseenQueue: Array<string>;
          seenQueuePointer: number;
          seenQueue: Array<string>;
        }
      | {
          __typename?: 'RaffleAdminData';
          raffleStatus: RaffleStatus;
          raffleCandidates: Array<string>;
          raffleWinners: Array<string>;
          raffleWinner?: string | null;
          winnerCount: number;
          remainingSubmissionIds: Array<string>;
          lastEliminatedSubmissionId?: string | null;
        }
      | {
          __typename?: 'SlidesAdminData';
          currentSlide: string;
          slidesDisplayOrder: Array<string>;
        }
      | {
          __typename?: 'TriviaAdminData';
          status: TriviaRoundStatus;
          questionIndex: number;
          playedThroughIndex: number;
          reviewing: boolean;
          questionEndsAt?: any | null;
          answeredCount: number;
          playerCount: number;
          correctChoiceId?: string | null;
          correctCount?: number | null;
          revealedQuestionIds: Array<string>;
          tallies: Array<{
            __typename?: 'TriviaTally';
            choiceId: string;
            count: number;
          }>;
          leaderboard: Array<{
            __typename?: 'TriviaLeaderboardRow';
            userId: string;
            name: string;
            score: number;
            rank: number;
            tied: boolean;
          }>;
        }
      | {
          __typename?: 'VoteForAdminData';
          startTime?: any | null;
          endTime?: any | null;
          voteWinners?: Array<string> | null;
          choiceDisplayOrder: Array<string>;
          votes: Array<{
            __typename?: 'VoteCount';
            submissionId: string;
            count: number;
          }>;
        }
      | null;
    config?:
      | {
          __typename?: 'NowPlayingAdminConfig';
          visualizationType: string;
          allowComments: boolean;
          allowedReactions: Array<string>;
        }
      | {
          __typename?: 'PhotoCarouselAdminConfig';
          maxSubmissionsPerUser: number;
          requireApproval: boolean;
          askSharePermission?: boolean | null;
          sharePrompt?: string | null;
          noPhotosMessage?: string | null;
          pollInterval?: number | null;
          predefinedCaptions?: Array<string> | null;
          maxVisiblePhotos: number;
        }
      | {
          __typename?: 'RaffleAdminConfig';
          optionalImageUrl?: string | null;
          claimYourPrize?: string | null;
          ticketFlipDirection: RaffleTicketFlipDirection;
        }
      | {
          __typename?: 'SlidesAdminConfig';
          autoPlay: boolean;
          autoPlayIntervalMs?: number | null;
        }
      | {
          __typename?: 'TriviaAdminConfig';
          instructions?: string | null;
          useQuestionTimer: boolean;
          defaultTimerMs: number;
          questions: Array<{
            __typename?: 'TriviaQuestion';
            id: string;
            text: string;
            correctChoiceId?: string | null;
            timerMs?: number | null;
            choices: Array<{
              __typename?: 'TriviaChoice';
              id: string;
              text: string;
            }>;
          }>;
        }
      | {
          __typename?: 'VoteForAdminConfig';
          votesPerUser: number;
          allowUserSubmissions: boolean;
          maxSubmissionsPerUser: number;
        }
      | null;
    viewConfig:
      | {
          __typename?: 'NowPlayingViewConfig';
          visualizationType: string;
          allowComments: boolean;
          allowedReactions: Array<string>;
        }
      | {
          __typename?: 'PhotoCarouselViewConfig';
          maxSubmissionsPerUser: number;
          askSharePermission?: boolean | null;
          sharePrompt?: string | null;
          noPhotosMessage?: string | null;
          maxVisiblePhotos: number;
        }
      | {
          __typename?: 'RaffleViewConfig';
          optionalImageUrl?: string | null;
          claimYourPrize?: string | null;
          ticketFlipDirection: RaffleTicketFlipDirection;
        }
      | {
          __typename?: 'SlidesViewConfig';
          autoPlay: boolean;
          autoPlayIntervalMs?: number | null;
        }
      | {
          __typename?: 'TriviaViewConfig';
          instructions?: string | null;
          useQuestionTimer: boolean;
          defaultTimerMs: number;
          questions: Array<{
            __typename?: 'TriviaViewQuestion';
            id: string;
            text: string;
            timerMs?: number | null;
            choices: Array<{
              __typename?: 'TriviaChoice';
              id: string;
              text: string;
            }>;
          }>;
        }
      | { __typename?: 'VoteForViewConfig'; votesPerUser: number };
    viewData:
      | { __typename?: 'NowPlayingViewData'; currentSong?: string | null }
      | {
          __typename?: 'PhotoCarouselViewData';
          visibleSubmission?: string | null;
        }
      | {
          __typename?: 'RaffleViewData';
          raffleStatus: RaffleStatus;
          raffleCandidates: Array<string>;
          raffleWinners: Array<string>;
          raffleWinner?: string | null;
          winnerCount: number;
          remainingSubmissionIds: Array<string>;
          lastEliminatedSubmissionId?: string | null;
        }
      | {
          __typename?: 'SlidesViewData';
          currentSlide: string;
          slidesDisplayOrder: Array<string>;
        }
      | {
          __typename?: 'TriviaViewData';
          status: TriviaRoundStatus;
          questionIndex: number;
          questionEndsAt?: any | null;
          answeredCount: number;
          playerCount: number;
          correctChoiceId?: string | null;
          correctCount?: number | null;
          leaderboardOverflow: number;
          tallies: Array<{
            __typename?: 'TriviaTally';
            choiceId: string;
            count: number;
          }>;
          leaderboard: Array<{
            __typename?: 'TriviaLeaderboardRow';
            userId: string;
            name: string;
            score: number;
            rank: number;
            tied: boolean;
          }>;
        }
      | {
          __typename?: 'VoteForViewData';
          voteWinners?: Array<string> | null;
          choiceDisplayOrder: Array<string>;
          votes: Array<{
            __typename?: 'VoteCount';
            submissionId: string;
            count: number;
          }>;
        };
  };
};

export type TriviaPreviousMutationVariables = Exact<{
  engagementId: Scalars['String']['input'];
}>;

export type TriviaPreviousMutation = {
  __typename?: 'Mutation';
  triviaPrevious: {
    __typename?: 'Engagement';
    id: string;
    eventId: string;
    createdAt: any;
    updatedAt: any;
    title: string;
    description?: string | null;
    qrCodeCta?: string | null;
    startTime?: any | null;
    order: number;
    endTime?: any | null;
    type: EngagementType;
    data?:
      | { __typename?: 'NowPlayingAdminData'; currentSong?: string | null }
      | {
          __typename?: 'PhotoCarouselAdminData';
          visibleSubmission?: string | null;
          rejectedQueue: Array<string>;
          unapprovedQueue: Array<string>;
          unseenQueue: Array<string>;
          seenQueuePointer: number;
          seenQueue: Array<string>;
        }
      | {
          __typename?: 'RaffleAdminData';
          raffleStatus: RaffleStatus;
          raffleCandidates: Array<string>;
          raffleWinners: Array<string>;
          raffleWinner?: string | null;
          winnerCount: number;
          remainingSubmissionIds: Array<string>;
          lastEliminatedSubmissionId?: string | null;
        }
      | {
          __typename?: 'SlidesAdminData';
          currentSlide: string;
          slidesDisplayOrder: Array<string>;
        }
      | {
          __typename?: 'TriviaAdminData';
          status: TriviaRoundStatus;
          questionIndex: number;
          playedThroughIndex: number;
          reviewing: boolean;
          questionEndsAt?: any | null;
          answeredCount: number;
          playerCount: number;
          correctChoiceId?: string | null;
          correctCount?: number | null;
          revealedQuestionIds: Array<string>;
          tallies: Array<{
            __typename?: 'TriviaTally';
            choiceId: string;
            count: number;
          }>;
          leaderboard: Array<{
            __typename?: 'TriviaLeaderboardRow';
            userId: string;
            name: string;
            score: number;
            rank: number;
            tied: boolean;
          }>;
        }
      | {
          __typename?: 'VoteForAdminData';
          startTime?: any | null;
          endTime?: any | null;
          voteWinners?: Array<string> | null;
          choiceDisplayOrder: Array<string>;
          votes: Array<{
            __typename?: 'VoteCount';
            submissionId: string;
            count: number;
          }>;
        }
      | null;
    config?:
      | {
          __typename?: 'NowPlayingAdminConfig';
          visualizationType: string;
          allowComments: boolean;
          allowedReactions: Array<string>;
        }
      | {
          __typename?: 'PhotoCarouselAdminConfig';
          maxSubmissionsPerUser: number;
          requireApproval: boolean;
          askSharePermission?: boolean | null;
          sharePrompt?: string | null;
          noPhotosMessage?: string | null;
          pollInterval?: number | null;
          predefinedCaptions?: Array<string> | null;
          maxVisiblePhotos: number;
        }
      | {
          __typename?: 'RaffleAdminConfig';
          optionalImageUrl?: string | null;
          claimYourPrize?: string | null;
          ticketFlipDirection: RaffleTicketFlipDirection;
        }
      | {
          __typename?: 'SlidesAdminConfig';
          autoPlay: boolean;
          autoPlayIntervalMs?: number | null;
        }
      | {
          __typename?: 'TriviaAdminConfig';
          instructions?: string | null;
          useQuestionTimer: boolean;
          defaultTimerMs: number;
          questions: Array<{
            __typename?: 'TriviaQuestion';
            id: string;
            text: string;
            correctChoiceId?: string | null;
            timerMs?: number | null;
            choices: Array<{
              __typename?: 'TriviaChoice';
              id: string;
              text: string;
            }>;
          }>;
        }
      | {
          __typename?: 'VoteForAdminConfig';
          votesPerUser: number;
          allowUserSubmissions: boolean;
          maxSubmissionsPerUser: number;
        }
      | null;
    viewConfig:
      | {
          __typename?: 'NowPlayingViewConfig';
          visualizationType: string;
          allowComments: boolean;
          allowedReactions: Array<string>;
        }
      | {
          __typename?: 'PhotoCarouselViewConfig';
          maxSubmissionsPerUser: number;
          askSharePermission?: boolean | null;
          sharePrompt?: string | null;
          noPhotosMessage?: string | null;
          maxVisiblePhotos: number;
        }
      | {
          __typename?: 'RaffleViewConfig';
          optionalImageUrl?: string | null;
          claimYourPrize?: string | null;
          ticketFlipDirection: RaffleTicketFlipDirection;
        }
      | {
          __typename?: 'SlidesViewConfig';
          autoPlay: boolean;
          autoPlayIntervalMs?: number | null;
        }
      | {
          __typename?: 'TriviaViewConfig';
          instructions?: string | null;
          useQuestionTimer: boolean;
          defaultTimerMs: number;
          questions: Array<{
            __typename?: 'TriviaViewQuestion';
            id: string;
            text: string;
            timerMs?: number | null;
            choices: Array<{
              __typename?: 'TriviaChoice';
              id: string;
              text: string;
            }>;
          }>;
        }
      | { __typename?: 'VoteForViewConfig'; votesPerUser: number };
    viewData:
      | { __typename?: 'NowPlayingViewData'; currentSong?: string | null }
      | {
          __typename?: 'PhotoCarouselViewData';
          visibleSubmission?: string | null;
        }
      | {
          __typename?: 'RaffleViewData';
          raffleStatus: RaffleStatus;
          raffleCandidates: Array<string>;
          raffleWinners: Array<string>;
          raffleWinner?: string | null;
          winnerCount: number;
          remainingSubmissionIds: Array<string>;
          lastEliminatedSubmissionId?: string | null;
        }
      | {
          __typename?: 'SlidesViewData';
          currentSlide: string;
          slidesDisplayOrder: Array<string>;
        }
      | {
          __typename?: 'TriviaViewData';
          status: TriviaRoundStatus;
          questionIndex: number;
          questionEndsAt?: any | null;
          answeredCount: number;
          playerCount: number;
          correctChoiceId?: string | null;
          correctCount?: number | null;
          leaderboardOverflow: number;
          tallies: Array<{
            __typename?: 'TriviaTally';
            choiceId: string;
            count: number;
          }>;
          leaderboard: Array<{
            __typename?: 'TriviaLeaderboardRow';
            userId: string;
            name: string;
            score: number;
            rank: number;
            tied: boolean;
          }>;
        }
      | {
          __typename?: 'VoteForViewData';
          voteWinners?: Array<string> | null;
          choiceDisplayOrder: Array<string>;
          votes: Array<{
            __typename?: 'VoteCount';
            submissionId: string;
            count: number;
          }>;
        };
  };
};

export type TriviaResetMutationVariables = Exact<{
  engagementId: Scalars['String']['input'];
}>;

export type TriviaResetMutation = {
  __typename?: 'Mutation';
  triviaReset: {
    __typename?: 'Engagement';
    id: string;
    eventId: string;
    createdAt: any;
    updatedAt: any;
    title: string;
    description?: string | null;
    qrCodeCta?: string | null;
    startTime?: any | null;
    order: number;
    endTime?: any | null;
    type: EngagementType;
    data?:
      | { __typename?: 'NowPlayingAdminData'; currentSong?: string | null }
      | {
          __typename?: 'PhotoCarouselAdminData';
          visibleSubmission?: string | null;
          rejectedQueue: Array<string>;
          unapprovedQueue: Array<string>;
          unseenQueue: Array<string>;
          seenQueuePointer: number;
          seenQueue: Array<string>;
        }
      | {
          __typename?: 'RaffleAdminData';
          raffleStatus: RaffleStatus;
          raffleCandidates: Array<string>;
          raffleWinners: Array<string>;
          raffleWinner?: string | null;
          winnerCount: number;
          remainingSubmissionIds: Array<string>;
          lastEliminatedSubmissionId?: string | null;
        }
      | {
          __typename?: 'SlidesAdminData';
          currentSlide: string;
          slidesDisplayOrder: Array<string>;
        }
      | {
          __typename?: 'TriviaAdminData';
          status: TriviaRoundStatus;
          questionIndex: number;
          playedThroughIndex: number;
          reviewing: boolean;
          questionEndsAt?: any | null;
          answeredCount: number;
          playerCount: number;
          correctChoiceId?: string | null;
          correctCount?: number | null;
          revealedQuestionIds: Array<string>;
          tallies: Array<{
            __typename?: 'TriviaTally';
            choiceId: string;
            count: number;
          }>;
          leaderboard: Array<{
            __typename?: 'TriviaLeaderboardRow';
            userId: string;
            name: string;
            score: number;
            rank: number;
            tied: boolean;
          }>;
        }
      | {
          __typename?: 'VoteForAdminData';
          startTime?: any | null;
          endTime?: any | null;
          voteWinners?: Array<string> | null;
          choiceDisplayOrder: Array<string>;
          votes: Array<{
            __typename?: 'VoteCount';
            submissionId: string;
            count: number;
          }>;
        }
      | null;
    config?:
      | {
          __typename?: 'NowPlayingAdminConfig';
          visualizationType: string;
          allowComments: boolean;
          allowedReactions: Array<string>;
        }
      | {
          __typename?: 'PhotoCarouselAdminConfig';
          maxSubmissionsPerUser: number;
          requireApproval: boolean;
          askSharePermission?: boolean | null;
          sharePrompt?: string | null;
          noPhotosMessage?: string | null;
          pollInterval?: number | null;
          predefinedCaptions?: Array<string> | null;
          maxVisiblePhotos: number;
        }
      | {
          __typename?: 'RaffleAdminConfig';
          optionalImageUrl?: string | null;
          claimYourPrize?: string | null;
          ticketFlipDirection: RaffleTicketFlipDirection;
        }
      | {
          __typename?: 'SlidesAdminConfig';
          autoPlay: boolean;
          autoPlayIntervalMs?: number | null;
        }
      | {
          __typename?: 'TriviaAdminConfig';
          instructions?: string | null;
          useQuestionTimer: boolean;
          defaultTimerMs: number;
          questions: Array<{
            __typename?: 'TriviaQuestion';
            id: string;
            text: string;
            correctChoiceId?: string | null;
            timerMs?: number | null;
            choices: Array<{
              __typename?: 'TriviaChoice';
              id: string;
              text: string;
            }>;
          }>;
        }
      | {
          __typename?: 'VoteForAdminConfig';
          votesPerUser: number;
          allowUserSubmissions: boolean;
          maxSubmissionsPerUser: number;
        }
      | null;
    viewConfig:
      | {
          __typename?: 'NowPlayingViewConfig';
          visualizationType: string;
          allowComments: boolean;
          allowedReactions: Array<string>;
        }
      | {
          __typename?: 'PhotoCarouselViewConfig';
          maxSubmissionsPerUser: number;
          askSharePermission?: boolean | null;
          sharePrompt?: string | null;
          noPhotosMessage?: string | null;
          maxVisiblePhotos: number;
        }
      | {
          __typename?: 'RaffleViewConfig';
          optionalImageUrl?: string | null;
          claimYourPrize?: string | null;
          ticketFlipDirection: RaffleTicketFlipDirection;
        }
      | {
          __typename?: 'SlidesViewConfig';
          autoPlay: boolean;
          autoPlayIntervalMs?: number | null;
        }
      | {
          __typename?: 'TriviaViewConfig';
          instructions?: string | null;
          useQuestionTimer: boolean;
          defaultTimerMs: number;
          questions: Array<{
            __typename?: 'TriviaViewQuestion';
            id: string;
            text: string;
            timerMs?: number | null;
            choices: Array<{
              __typename?: 'TriviaChoice';
              id: string;
              text: string;
            }>;
          }>;
        }
      | { __typename?: 'VoteForViewConfig'; votesPerUser: number };
    viewData:
      | { __typename?: 'NowPlayingViewData'; currentSong?: string | null }
      | {
          __typename?: 'PhotoCarouselViewData';
          visibleSubmission?: string | null;
        }
      | {
          __typename?: 'RaffleViewData';
          raffleStatus: RaffleStatus;
          raffleCandidates: Array<string>;
          raffleWinners: Array<string>;
          raffleWinner?: string | null;
          winnerCount: number;
          remainingSubmissionIds: Array<string>;
          lastEliminatedSubmissionId?: string | null;
        }
      | {
          __typename?: 'SlidesViewData';
          currentSlide: string;
          slidesDisplayOrder: Array<string>;
        }
      | {
          __typename?: 'TriviaViewData';
          status: TriviaRoundStatus;
          questionIndex: number;
          questionEndsAt?: any | null;
          answeredCount: number;
          playerCount: number;
          correctChoiceId?: string | null;
          correctCount?: number | null;
          leaderboardOverflow: number;
          tallies: Array<{
            __typename?: 'TriviaTally';
            choiceId: string;
            count: number;
          }>;
          leaderboard: Array<{
            __typename?: 'TriviaLeaderboardRow';
            userId: string;
            name: string;
            score: number;
            rank: number;
            tied: boolean;
          }>;
        }
      | {
          __typename?: 'VoteForViewData';
          voteWinners?: Array<string> | null;
          choiceDisplayOrder: Array<string>;
          votes: Array<{
            __typename?: 'VoteCount';
            submissionId: string;
            count: number;
          }>;
        };
  };
};

export type TriviaExtendTimerMutationVariables = Exact<{
  engagementId: Scalars['String']['input'];
}>;

export type TriviaExtendTimerMutation = {
  __typename?: 'Mutation';
  triviaExtendTimer: {
    __typename?: 'Engagement';
    id: string;
    eventId: string;
    createdAt: any;
    updatedAt: any;
    title: string;
    description?: string | null;
    qrCodeCta?: string | null;
    startTime?: any | null;
    order: number;
    endTime?: any | null;
    type: EngagementType;
    data?:
      | { __typename?: 'NowPlayingAdminData'; currentSong?: string | null }
      | {
          __typename?: 'PhotoCarouselAdminData';
          visibleSubmission?: string | null;
          rejectedQueue: Array<string>;
          unapprovedQueue: Array<string>;
          unseenQueue: Array<string>;
          seenQueuePointer: number;
          seenQueue: Array<string>;
        }
      | {
          __typename?: 'RaffleAdminData';
          raffleStatus: RaffleStatus;
          raffleCandidates: Array<string>;
          raffleWinners: Array<string>;
          raffleWinner?: string | null;
          winnerCount: number;
          remainingSubmissionIds: Array<string>;
          lastEliminatedSubmissionId?: string | null;
        }
      | {
          __typename?: 'SlidesAdminData';
          currentSlide: string;
          slidesDisplayOrder: Array<string>;
        }
      | {
          __typename?: 'TriviaAdminData';
          status: TriviaRoundStatus;
          questionIndex: number;
          playedThroughIndex: number;
          reviewing: boolean;
          questionEndsAt?: any | null;
          answeredCount: number;
          playerCount: number;
          correctChoiceId?: string | null;
          correctCount?: number | null;
          revealedQuestionIds: Array<string>;
          tallies: Array<{
            __typename?: 'TriviaTally';
            choiceId: string;
            count: number;
          }>;
          leaderboard: Array<{
            __typename?: 'TriviaLeaderboardRow';
            userId: string;
            name: string;
            score: number;
            rank: number;
            tied: boolean;
          }>;
        }
      | {
          __typename?: 'VoteForAdminData';
          startTime?: any | null;
          endTime?: any | null;
          voteWinners?: Array<string> | null;
          choiceDisplayOrder: Array<string>;
          votes: Array<{
            __typename?: 'VoteCount';
            submissionId: string;
            count: number;
          }>;
        }
      | null;
    config?:
      | {
          __typename?: 'NowPlayingAdminConfig';
          visualizationType: string;
          allowComments: boolean;
          allowedReactions: Array<string>;
        }
      | {
          __typename?: 'PhotoCarouselAdminConfig';
          maxSubmissionsPerUser: number;
          requireApproval: boolean;
          askSharePermission?: boolean | null;
          sharePrompt?: string | null;
          noPhotosMessage?: string | null;
          pollInterval?: number | null;
          predefinedCaptions?: Array<string> | null;
          maxVisiblePhotos: number;
        }
      | {
          __typename?: 'RaffleAdminConfig';
          optionalImageUrl?: string | null;
          claimYourPrize?: string | null;
          ticketFlipDirection: RaffleTicketFlipDirection;
        }
      | {
          __typename?: 'SlidesAdminConfig';
          autoPlay: boolean;
          autoPlayIntervalMs?: number | null;
        }
      | {
          __typename?: 'TriviaAdminConfig';
          instructions?: string | null;
          useQuestionTimer: boolean;
          defaultTimerMs: number;
          questions: Array<{
            __typename?: 'TriviaQuestion';
            id: string;
            text: string;
            correctChoiceId?: string | null;
            timerMs?: number | null;
            choices: Array<{
              __typename?: 'TriviaChoice';
              id: string;
              text: string;
            }>;
          }>;
        }
      | {
          __typename?: 'VoteForAdminConfig';
          votesPerUser: number;
          allowUserSubmissions: boolean;
          maxSubmissionsPerUser: number;
        }
      | null;
    viewConfig:
      | {
          __typename?: 'NowPlayingViewConfig';
          visualizationType: string;
          allowComments: boolean;
          allowedReactions: Array<string>;
        }
      | {
          __typename?: 'PhotoCarouselViewConfig';
          maxSubmissionsPerUser: number;
          askSharePermission?: boolean | null;
          sharePrompt?: string | null;
          noPhotosMessage?: string | null;
          maxVisiblePhotos: number;
        }
      | {
          __typename?: 'RaffleViewConfig';
          optionalImageUrl?: string | null;
          claimYourPrize?: string | null;
          ticketFlipDirection: RaffleTicketFlipDirection;
        }
      | {
          __typename?: 'SlidesViewConfig';
          autoPlay: boolean;
          autoPlayIntervalMs?: number | null;
        }
      | {
          __typename?: 'TriviaViewConfig';
          instructions?: string | null;
          useQuestionTimer: boolean;
          defaultTimerMs: number;
          questions: Array<{
            __typename?: 'TriviaViewQuestion';
            id: string;
            text: string;
            timerMs?: number | null;
            choices: Array<{
              __typename?: 'TriviaChoice';
              id: string;
              text: string;
            }>;
          }>;
        }
      | { __typename?: 'VoteForViewConfig'; votesPerUser: number };
    viewData:
      | { __typename?: 'NowPlayingViewData'; currentSong?: string | null }
      | {
          __typename?: 'PhotoCarouselViewData';
          visibleSubmission?: string | null;
        }
      | {
          __typename?: 'RaffleViewData';
          raffleStatus: RaffleStatus;
          raffleCandidates: Array<string>;
          raffleWinners: Array<string>;
          raffleWinner?: string | null;
          winnerCount: number;
          remainingSubmissionIds: Array<string>;
          lastEliminatedSubmissionId?: string | null;
        }
      | {
          __typename?: 'SlidesViewData';
          currentSlide: string;
          slidesDisplayOrder: Array<string>;
        }
      | {
          __typename?: 'TriviaViewData';
          status: TriviaRoundStatus;
          questionIndex: number;
          questionEndsAt?: any | null;
          answeredCount: number;
          playerCount: number;
          correctChoiceId?: string | null;
          correctCount?: number | null;
          leaderboardOverflow: number;
          tallies: Array<{
            __typename?: 'TriviaTally';
            choiceId: string;
            count: number;
          }>;
          leaderboard: Array<{
            __typename?: 'TriviaLeaderboardRow';
            userId: string;
            name: string;
            score: number;
            rank: number;
            tied: boolean;
          }>;
        }
      | {
          __typename?: 'VoteForViewData';
          voteWinners?: Array<string> | null;
          choiceDisplayOrder: Array<string>;
          votes: Array<{
            __typename?: 'VoteCount';
            submissionId: string;
            count: number;
          }>;
        };
  };
};

export type TriviaJoinMutationVariables = Exact<{
  engagementId: Scalars['String']['input'];
}>;

export type TriviaJoinMutation = {
  __typename?: 'Mutation';
  triviaJoin: {
    __typename?: 'Engagement';
    id: string;
    createdAt: any;
    updatedAt: any;
    title: string;
    description?: string | null;
    startTime?: any | null;
    endTime?: any | null;
    type: EngagementType;
    order: number;
    viewConfig:
      | {
          __typename?: 'NowPlayingViewConfig';
          visualizationType: string;
          allowComments: boolean;
          allowedReactions: Array<string>;
        }
      | {
          __typename?: 'PhotoCarouselViewConfig';
          maxSubmissionsPerUser: number;
          askSharePermission?: boolean | null;
          sharePrompt?: string | null;
          noPhotosMessage?: string | null;
          maxVisiblePhotos: number;
        }
      | {
          __typename?: 'RaffleViewConfig';
          optionalImageUrl?: string | null;
          claimYourPrize?: string | null;
          ticketFlipDirection: RaffleTicketFlipDirection;
        }
      | {
          __typename?: 'SlidesViewConfig';
          autoPlay: boolean;
          autoPlayIntervalMs?: number | null;
        }
      | {
          __typename?: 'TriviaViewConfig';
          instructions?: string | null;
          useQuestionTimer: boolean;
          defaultTimerMs: number;
          questions: Array<{
            __typename?: 'TriviaViewQuestion';
            id: string;
            text: string;
            timerMs?: number | null;
            choices: Array<{
              __typename?: 'TriviaChoice';
              id: string;
              text: string;
            }>;
          }>;
        }
      | { __typename?: 'VoteForViewConfig'; votesPerUser: number };
    viewData:
      | { __typename?: 'NowPlayingViewData'; currentSong?: string | null }
      | {
          __typename?: 'PhotoCarouselViewData';
          visibleSubmission?: string | null;
        }
      | {
          __typename?: 'RaffleViewData';
          raffleStatus: RaffleStatus;
          raffleCandidates: Array<string>;
          raffleWinners: Array<string>;
          raffleWinner?: string | null;
          winnerCount: number;
          remainingSubmissionIds: Array<string>;
          lastEliminatedSubmissionId?: string | null;
        }
      | {
          __typename?: 'SlidesViewData';
          currentSlide: string;
          slidesDisplayOrder: Array<string>;
        }
      | {
          __typename?: 'TriviaViewData';
          status: TriviaRoundStatus;
          questionIndex: number;
          questionEndsAt?: any | null;
          answeredCount: number;
          playerCount: number;
          correctChoiceId?: string | null;
          correctCount?: number | null;
          leaderboardOverflow: number;
          tallies: Array<{
            __typename?: 'TriviaTally';
            choiceId: string;
            count: number;
          }>;
          leaderboard: Array<{
            __typename?: 'TriviaLeaderboardRow';
            userId: string;
            name: string;
            score: number;
            rank: number;
            tied: boolean;
          }>;
        }
      | {
          __typename?: 'VoteForViewData';
          voteWinners?: Array<string> | null;
          choiceDisplayOrder: Array<string>;
          votes: Array<{
            __typename?: 'VoteCount';
            submissionId: string;
            count: number;
          }>;
        };
  };
};

export type TriviaSubmitAnswerMutationVariables = Exact<{
  engagementId: Scalars['String']['input'];
  questionId: Scalars['String']['input'];
  choiceId: Scalars['String']['input'];
}>;

export type TriviaSubmitAnswerMutation = {
  __typename?: 'Mutation';
  triviaSubmitAnswer: {
    __typename?: 'TriviaMyAnswer';
    questionId: string;
    choiceId: string;
  };
};

export type VoteForViewConfigFieldsFragment = {
  __typename?: 'VoteForViewConfig';
  votesPerUser: number;
};

export type VoteForViewDataFieldsFragment = {
  __typename?: 'VoteForViewData';
  voteWinners?: Array<string> | null;
  choiceDisplayOrder: Array<string>;
  votes: Array<{
    __typename?: 'VoteCount';
    submissionId: string;
    count: number;
  }>;
};

export type VoteForSubmissionFieldsFragment = {
  __typename?: 'VoteForSubmissionData';
  title: string;
  color: string;
  description: string;
  optionalImageUrl?: string | null;
};

export type VoteForAdminConfigFieldsFragment = {
  __typename?: 'VoteForAdminConfig';
  votesPerUser: number;
  allowUserSubmissions: boolean;
  maxSubmissionsPerUser: number;
};

export type VoteForAdminDataFieldsFragment = {
  __typename?: 'VoteForAdminData';
  startTime?: any | null;
  endTime?: any | null;
  voteWinners?: Array<string> | null;
  choiceDisplayOrder: Array<string>;
  votes: Array<{
    __typename?: 'VoteCount';
    submissionId: string;
    count: number;
  }>;
};

export type VoteForResetVotesMutationVariables = Exact<{
  engagementId: Scalars['String']['input'];
}>;

export type VoteForResetVotesMutation = {
  __typename?: 'Mutation';
  voteForResetVotes: {
    __typename?: 'Engagement';
    id: string;
    eventId: string;
    createdAt: any;
    updatedAt: any;
    title: string;
    description?: string | null;
    qrCodeCta?: string | null;
    startTime?: any | null;
    order: number;
    endTime?: any | null;
    type: EngagementType;
    data?:
      | { __typename?: 'NowPlayingAdminData'; currentSong?: string | null }
      | {
          __typename?: 'PhotoCarouselAdminData';
          visibleSubmission?: string | null;
          rejectedQueue: Array<string>;
          unapprovedQueue: Array<string>;
          unseenQueue: Array<string>;
          seenQueuePointer: number;
          seenQueue: Array<string>;
        }
      | {
          __typename?: 'RaffleAdminData';
          raffleStatus: RaffleStatus;
          raffleCandidates: Array<string>;
          raffleWinners: Array<string>;
          raffleWinner?: string | null;
          winnerCount: number;
          remainingSubmissionIds: Array<string>;
          lastEliminatedSubmissionId?: string | null;
        }
      | {
          __typename?: 'SlidesAdminData';
          currentSlide: string;
          slidesDisplayOrder: Array<string>;
        }
      | {
          __typename?: 'TriviaAdminData';
          status: TriviaRoundStatus;
          questionIndex: number;
          playedThroughIndex: number;
          reviewing: boolean;
          questionEndsAt?: any | null;
          answeredCount: number;
          playerCount: number;
          correctChoiceId?: string | null;
          correctCount?: number | null;
          revealedQuestionIds: Array<string>;
          tallies: Array<{
            __typename?: 'TriviaTally';
            choiceId: string;
            count: number;
          }>;
          leaderboard: Array<{
            __typename?: 'TriviaLeaderboardRow';
            userId: string;
            name: string;
            score: number;
            rank: number;
            tied: boolean;
          }>;
        }
      | {
          __typename?: 'VoteForAdminData';
          startTime?: any | null;
          endTime?: any | null;
          voteWinners?: Array<string> | null;
          choiceDisplayOrder: Array<string>;
          votes: Array<{
            __typename?: 'VoteCount';
            submissionId: string;
            count: number;
          }>;
        }
      | null;
    config?:
      | {
          __typename?: 'NowPlayingAdminConfig';
          visualizationType: string;
          allowComments: boolean;
          allowedReactions: Array<string>;
        }
      | {
          __typename?: 'PhotoCarouselAdminConfig';
          maxSubmissionsPerUser: number;
          requireApproval: boolean;
          askSharePermission?: boolean | null;
          sharePrompt?: string | null;
          noPhotosMessage?: string | null;
          pollInterval?: number | null;
          predefinedCaptions?: Array<string> | null;
          maxVisiblePhotos: number;
        }
      | {
          __typename?: 'RaffleAdminConfig';
          optionalImageUrl?: string | null;
          claimYourPrize?: string | null;
          ticketFlipDirection: RaffleTicketFlipDirection;
        }
      | {
          __typename?: 'SlidesAdminConfig';
          autoPlay: boolean;
          autoPlayIntervalMs?: number | null;
        }
      | {
          __typename?: 'TriviaAdminConfig';
          instructions?: string | null;
          useQuestionTimer: boolean;
          defaultTimerMs: number;
          questions: Array<{
            __typename?: 'TriviaQuestion';
            id: string;
            text: string;
            correctChoiceId?: string | null;
            timerMs?: number | null;
            choices: Array<{
              __typename?: 'TriviaChoice';
              id: string;
              text: string;
            }>;
          }>;
        }
      | {
          __typename?: 'VoteForAdminConfig';
          votesPerUser: number;
          allowUserSubmissions: boolean;
          maxSubmissionsPerUser: number;
        }
      | null;
    viewConfig:
      | {
          __typename?: 'NowPlayingViewConfig';
          visualizationType: string;
          allowComments: boolean;
          allowedReactions: Array<string>;
        }
      | {
          __typename?: 'PhotoCarouselViewConfig';
          maxSubmissionsPerUser: number;
          askSharePermission?: boolean | null;
          sharePrompt?: string | null;
          noPhotosMessage?: string | null;
          maxVisiblePhotos: number;
        }
      | {
          __typename?: 'RaffleViewConfig';
          optionalImageUrl?: string | null;
          claimYourPrize?: string | null;
          ticketFlipDirection: RaffleTicketFlipDirection;
        }
      | {
          __typename?: 'SlidesViewConfig';
          autoPlay: boolean;
          autoPlayIntervalMs?: number | null;
        }
      | {
          __typename?: 'TriviaViewConfig';
          instructions?: string | null;
          useQuestionTimer: boolean;
          defaultTimerMs: number;
          questions: Array<{
            __typename?: 'TriviaViewQuestion';
            id: string;
            text: string;
            timerMs?: number | null;
            choices: Array<{
              __typename?: 'TriviaChoice';
              id: string;
              text: string;
            }>;
          }>;
        }
      | { __typename?: 'VoteForViewConfig'; votesPerUser: number };
    viewData:
      | { __typename?: 'NowPlayingViewData'; currentSong?: string | null }
      | {
          __typename?: 'PhotoCarouselViewData';
          visibleSubmission?: string | null;
        }
      | {
          __typename?: 'RaffleViewData';
          raffleStatus: RaffleStatus;
          raffleCandidates: Array<string>;
          raffleWinners: Array<string>;
          raffleWinner?: string | null;
          winnerCount: number;
          remainingSubmissionIds: Array<string>;
          lastEliminatedSubmissionId?: string | null;
        }
      | {
          __typename?: 'SlidesViewData';
          currentSlide: string;
          slidesDisplayOrder: Array<string>;
        }
      | {
          __typename?: 'TriviaViewData';
          status: TriviaRoundStatus;
          questionIndex: number;
          questionEndsAt?: any | null;
          answeredCount: number;
          playerCount: number;
          correctChoiceId?: string | null;
          correctCount?: number | null;
          leaderboardOverflow: number;
          tallies: Array<{
            __typename?: 'TriviaTally';
            choiceId: string;
            count: number;
          }>;
          leaderboard: Array<{
            __typename?: 'TriviaLeaderboardRow';
            userId: string;
            name: string;
            score: number;
            rank: number;
            tied: boolean;
          }>;
        }
      | {
          __typename?: 'VoteForViewData';
          voteWinners?: Array<string> | null;
          choiceDisplayOrder: Array<string>;
          votes: Array<{
            __typename?: 'VoteCount';
            submissionId: string;
            count: number;
          }>;
        };
  };
};

export type VoteForDeclareWinnersMutationVariables = Exact<{
  engagementId: Scalars['String']['input'];
}>;

export type VoteForDeclareWinnersMutation = {
  __typename?: 'Mutation';
  voteForDeclareWinners: {
    __typename?: 'Engagement';
    id: string;
    eventId: string;
    createdAt: any;
    updatedAt: any;
    title: string;
    description?: string | null;
    qrCodeCta?: string | null;
    startTime?: any | null;
    order: number;
    endTime?: any | null;
    type: EngagementType;
    data?:
      | { __typename?: 'NowPlayingAdminData'; currentSong?: string | null }
      | {
          __typename?: 'PhotoCarouselAdminData';
          visibleSubmission?: string | null;
          rejectedQueue: Array<string>;
          unapprovedQueue: Array<string>;
          unseenQueue: Array<string>;
          seenQueuePointer: number;
          seenQueue: Array<string>;
        }
      | {
          __typename?: 'RaffleAdminData';
          raffleStatus: RaffleStatus;
          raffleCandidates: Array<string>;
          raffleWinners: Array<string>;
          raffleWinner?: string | null;
          winnerCount: number;
          remainingSubmissionIds: Array<string>;
          lastEliminatedSubmissionId?: string | null;
        }
      | {
          __typename?: 'SlidesAdminData';
          currentSlide: string;
          slidesDisplayOrder: Array<string>;
        }
      | {
          __typename?: 'TriviaAdminData';
          status: TriviaRoundStatus;
          questionIndex: number;
          playedThroughIndex: number;
          reviewing: boolean;
          questionEndsAt?: any | null;
          answeredCount: number;
          playerCount: number;
          correctChoiceId?: string | null;
          correctCount?: number | null;
          revealedQuestionIds: Array<string>;
          tallies: Array<{
            __typename?: 'TriviaTally';
            choiceId: string;
            count: number;
          }>;
          leaderboard: Array<{
            __typename?: 'TriviaLeaderboardRow';
            userId: string;
            name: string;
            score: number;
            rank: number;
            tied: boolean;
          }>;
        }
      | {
          __typename?: 'VoteForAdminData';
          startTime?: any | null;
          endTime?: any | null;
          voteWinners?: Array<string> | null;
          choiceDisplayOrder: Array<string>;
          votes: Array<{
            __typename?: 'VoteCount';
            submissionId: string;
            count: number;
          }>;
        }
      | null;
    config?:
      | {
          __typename?: 'NowPlayingAdminConfig';
          visualizationType: string;
          allowComments: boolean;
          allowedReactions: Array<string>;
        }
      | {
          __typename?: 'PhotoCarouselAdminConfig';
          maxSubmissionsPerUser: number;
          requireApproval: boolean;
          askSharePermission?: boolean | null;
          sharePrompt?: string | null;
          noPhotosMessage?: string | null;
          pollInterval?: number | null;
          predefinedCaptions?: Array<string> | null;
          maxVisiblePhotos: number;
        }
      | {
          __typename?: 'RaffleAdminConfig';
          optionalImageUrl?: string | null;
          claimYourPrize?: string | null;
          ticketFlipDirection: RaffleTicketFlipDirection;
        }
      | {
          __typename?: 'SlidesAdminConfig';
          autoPlay: boolean;
          autoPlayIntervalMs?: number | null;
        }
      | {
          __typename?: 'TriviaAdminConfig';
          instructions?: string | null;
          useQuestionTimer: boolean;
          defaultTimerMs: number;
          questions: Array<{
            __typename?: 'TriviaQuestion';
            id: string;
            text: string;
            correctChoiceId?: string | null;
            timerMs?: number | null;
            choices: Array<{
              __typename?: 'TriviaChoice';
              id: string;
              text: string;
            }>;
          }>;
        }
      | {
          __typename?: 'VoteForAdminConfig';
          votesPerUser: number;
          allowUserSubmissions: boolean;
          maxSubmissionsPerUser: number;
        }
      | null;
    viewConfig:
      | {
          __typename?: 'NowPlayingViewConfig';
          visualizationType: string;
          allowComments: boolean;
          allowedReactions: Array<string>;
        }
      | {
          __typename?: 'PhotoCarouselViewConfig';
          maxSubmissionsPerUser: number;
          askSharePermission?: boolean | null;
          sharePrompt?: string | null;
          noPhotosMessage?: string | null;
          maxVisiblePhotos: number;
        }
      | {
          __typename?: 'RaffleViewConfig';
          optionalImageUrl?: string | null;
          claimYourPrize?: string | null;
          ticketFlipDirection: RaffleTicketFlipDirection;
        }
      | {
          __typename?: 'SlidesViewConfig';
          autoPlay: boolean;
          autoPlayIntervalMs?: number | null;
        }
      | {
          __typename?: 'TriviaViewConfig';
          instructions?: string | null;
          useQuestionTimer: boolean;
          defaultTimerMs: number;
          questions: Array<{
            __typename?: 'TriviaViewQuestion';
            id: string;
            text: string;
            timerMs?: number | null;
            choices: Array<{
              __typename?: 'TriviaChoice';
              id: string;
              text: string;
            }>;
          }>;
        }
      | { __typename?: 'VoteForViewConfig'; votesPerUser: number };
    viewData:
      | { __typename?: 'NowPlayingViewData'; currentSong?: string | null }
      | {
          __typename?: 'PhotoCarouselViewData';
          visibleSubmission?: string | null;
        }
      | {
          __typename?: 'RaffleViewData';
          raffleStatus: RaffleStatus;
          raffleCandidates: Array<string>;
          raffleWinners: Array<string>;
          raffleWinner?: string | null;
          winnerCount: number;
          remainingSubmissionIds: Array<string>;
          lastEliminatedSubmissionId?: string | null;
        }
      | {
          __typename?: 'SlidesViewData';
          currentSlide: string;
          slidesDisplayOrder: Array<string>;
        }
      | {
          __typename?: 'TriviaViewData';
          status: TriviaRoundStatus;
          questionIndex: number;
          questionEndsAt?: any | null;
          answeredCount: number;
          playerCount: number;
          correctChoiceId?: string | null;
          correctCount?: number | null;
          leaderboardOverflow: number;
          tallies: Array<{
            __typename?: 'TriviaTally';
            choiceId: string;
            count: number;
          }>;
          leaderboard: Array<{
            __typename?: 'TriviaLeaderboardRow';
            userId: string;
            name: string;
            score: number;
            rank: number;
            tied: boolean;
          }>;
        }
      | {
          __typename?: 'VoteForViewData';
          voteWinners?: Array<string> | null;
          choiceDisplayOrder: Array<string>;
          votes: Array<{
            __typename?: 'VoteCount';
            submissionId: string;
            count: number;
          }>;
        };
  };
};

export type VoteForUndeclareWinnersMutationVariables = Exact<{
  engagementId: Scalars['String']['input'];
}>;

export type VoteForUndeclareWinnersMutation = {
  __typename?: 'Mutation';
  voteForUndeclareWinners: {
    __typename?: 'Engagement';
    id: string;
    eventId: string;
    createdAt: any;
    updatedAt: any;
    title: string;
    description?: string | null;
    qrCodeCta?: string | null;
    startTime?: any | null;
    order: number;
    endTime?: any | null;
    type: EngagementType;
    data?:
      | { __typename?: 'NowPlayingAdminData'; currentSong?: string | null }
      | {
          __typename?: 'PhotoCarouselAdminData';
          visibleSubmission?: string | null;
          rejectedQueue: Array<string>;
          unapprovedQueue: Array<string>;
          unseenQueue: Array<string>;
          seenQueuePointer: number;
          seenQueue: Array<string>;
        }
      | {
          __typename?: 'RaffleAdminData';
          raffleStatus: RaffleStatus;
          raffleCandidates: Array<string>;
          raffleWinners: Array<string>;
          raffleWinner?: string | null;
          winnerCount: number;
          remainingSubmissionIds: Array<string>;
          lastEliminatedSubmissionId?: string | null;
        }
      | {
          __typename?: 'SlidesAdminData';
          currentSlide: string;
          slidesDisplayOrder: Array<string>;
        }
      | {
          __typename?: 'TriviaAdminData';
          status: TriviaRoundStatus;
          questionIndex: number;
          playedThroughIndex: number;
          reviewing: boolean;
          questionEndsAt?: any | null;
          answeredCount: number;
          playerCount: number;
          correctChoiceId?: string | null;
          correctCount?: number | null;
          revealedQuestionIds: Array<string>;
          tallies: Array<{
            __typename?: 'TriviaTally';
            choiceId: string;
            count: number;
          }>;
          leaderboard: Array<{
            __typename?: 'TriviaLeaderboardRow';
            userId: string;
            name: string;
            score: number;
            rank: number;
            tied: boolean;
          }>;
        }
      | {
          __typename?: 'VoteForAdminData';
          startTime?: any | null;
          endTime?: any | null;
          voteWinners?: Array<string> | null;
          choiceDisplayOrder: Array<string>;
          votes: Array<{
            __typename?: 'VoteCount';
            submissionId: string;
            count: number;
          }>;
        }
      | null;
    config?:
      | {
          __typename?: 'NowPlayingAdminConfig';
          visualizationType: string;
          allowComments: boolean;
          allowedReactions: Array<string>;
        }
      | {
          __typename?: 'PhotoCarouselAdminConfig';
          maxSubmissionsPerUser: number;
          requireApproval: boolean;
          askSharePermission?: boolean | null;
          sharePrompt?: string | null;
          noPhotosMessage?: string | null;
          pollInterval?: number | null;
          predefinedCaptions?: Array<string> | null;
          maxVisiblePhotos: number;
        }
      | {
          __typename?: 'RaffleAdminConfig';
          optionalImageUrl?: string | null;
          claimYourPrize?: string | null;
          ticketFlipDirection: RaffleTicketFlipDirection;
        }
      | {
          __typename?: 'SlidesAdminConfig';
          autoPlay: boolean;
          autoPlayIntervalMs?: number | null;
        }
      | {
          __typename?: 'TriviaAdminConfig';
          instructions?: string | null;
          useQuestionTimer: boolean;
          defaultTimerMs: number;
          questions: Array<{
            __typename?: 'TriviaQuestion';
            id: string;
            text: string;
            correctChoiceId?: string | null;
            timerMs?: number | null;
            choices: Array<{
              __typename?: 'TriviaChoice';
              id: string;
              text: string;
            }>;
          }>;
        }
      | {
          __typename?: 'VoteForAdminConfig';
          votesPerUser: number;
          allowUserSubmissions: boolean;
          maxSubmissionsPerUser: number;
        }
      | null;
    viewConfig:
      | {
          __typename?: 'NowPlayingViewConfig';
          visualizationType: string;
          allowComments: boolean;
          allowedReactions: Array<string>;
        }
      | {
          __typename?: 'PhotoCarouselViewConfig';
          maxSubmissionsPerUser: number;
          askSharePermission?: boolean | null;
          sharePrompt?: string | null;
          noPhotosMessage?: string | null;
          maxVisiblePhotos: number;
        }
      | {
          __typename?: 'RaffleViewConfig';
          optionalImageUrl?: string | null;
          claimYourPrize?: string | null;
          ticketFlipDirection: RaffleTicketFlipDirection;
        }
      | {
          __typename?: 'SlidesViewConfig';
          autoPlay: boolean;
          autoPlayIntervalMs?: number | null;
        }
      | {
          __typename?: 'TriviaViewConfig';
          instructions?: string | null;
          useQuestionTimer: boolean;
          defaultTimerMs: number;
          questions: Array<{
            __typename?: 'TriviaViewQuestion';
            id: string;
            text: string;
            timerMs?: number | null;
            choices: Array<{
              __typename?: 'TriviaChoice';
              id: string;
              text: string;
            }>;
          }>;
        }
      | { __typename?: 'VoteForViewConfig'; votesPerUser: number };
    viewData:
      | { __typename?: 'NowPlayingViewData'; currentSong?: string | null }
      | {
          __typename?: 'PhotoCarouselViewData';
          visibleSubmission?: string | null;
        }
      | {
          __typename?: 'RaffleViewData';
          raffleStatus: RaffleStatus;
          raffleCandidates: Array<string>;
          raffleWinners: Array<string>;
          raffleWinner?: string | null;
          winnerCount: number;
          remainingSubmissionIds: Array<string>;
          lastEliminatedSubmissionId?: string | null;
        }
      | {
          __typename?: 'SlidesViewData';
          currentSlide: string;
          slidesDisplayOrder: Array<string>;
        }
      | {
          __typename?: 'TriviaViewData';
          status: TriviaRoundStatus;
          questionIndex: number;
          questionEndsAt?: any | null;
          answeredCount: number;
          playerCount: number;
          correctChoiceId?: string | null;
          correctCount?: number | null;
          leaderboardOverflow: number;
          tallies: Array<{
            __typename?: 'TriviaTally';
            choiceId: string;
            count: number;
          }>;
          leaderboard: Array<{
            __typename?: 'TriviaLeaderboardRow';
            userId: string;
            name: string;
            score: number;
            rank: number;
            tied: boolean;
          }>;
        }
      | {
          __typename?: 'VoteForViewData';
          voteWinners?: Array<string> | null;
          choiceDisplayOrder: Array<string>;
          votes: Array<{
            __typename?: 'VoteCount';
            submissionId: string;
            count: number;
          }>;
        };
  };
};

export type VoteForVotesResetSubscriptionVariables = Exact<{
  engagementId: Scalars['String']['input'];
}>;

export type VoteForVotesResetSubscription = {
  __typename?: 'Subscription';
  voteForVotesReset: {
    __typename?: 'VoteForVotesResetPayload';
    engagement: {
      __typename?: 'Engagement';
      id: string;
      eventId: string;
      createdAt: any;
      updatedAt: any;
      title: string;
      description?: string | null;
      qrCodeCta?: string | null;
      startTime?: any | null;
      order: number;
      endTime?: any | null;
      type: EngagementType;
      data?:
        | { __typename?: 'NowPlayingAdminData'; currentSong?: string | null }
        | {
            __typename?: 'PhotoCarouselAdminData';
            visibleSubmission?: string | null;
            rejectedQueue: Array<string>;
            unapprovedQueue: Array<string>;
            unseenQueue: Array<string>;
            seenQueuePointer: number;
            seenQueue: Array<string>;
          }
        | {
            __typename?: 'RaffleAdminData';
            raffleStatus: RaffleStatus;
            raffleCandidates: Array<string>;
            raffleWinners: Array<string>;
            raffleWinner?: string | null;
            winnerCount: number;
            remainingSubmissionIds: Array<string>;
            lastEliminatedSubmissionId?: string | null;
          }
        | {
            __typename?: 'SlidesAdminData';
            currentSlide: string;
            slidesDisplayOrder: Array<string>;
          }
        | {
            __typename?: 'TriviaAdminData';
            status: TriviaRoundStatus;
            questionIndex: number;
            playedThroughIndex: number;
            reviewing: boolean;
            questionEndsAt?: any | null;
            answeredCount: number;
            playerCount: number;
            correctChoiceId?: string | null;
            correctCount?: number | null;
            revealedQuestionIds: Array<string>;
            tallies: Array<{
              __typename?: 'TriviaTally';
              choiceId: string;
              count: number;
            }>;
            leaderboard: Array<{
              __typename?: 'TriviaLeaderboardRow';
              userId: string;
              name: string;
              score: number;
              rank: number;
              tied: boolean;
            }>;
          }
        | {
            __typename?: 'VoteForAdminData';
            startTime?: any | null;
            endTime?: any | null;
            voteWinners?: Array<string> | null;
            choiceDisplayOrder: Array<string>;
            votes: Array<{
              __typename?: 'VoteCount';
              submissionId: string;
              count: number;
            }>;
          }
        | null;
      config?:
        | {
            __typename?: 'NowPlayingAdminConfig';
            visualizationType: string;
            allowComments: boolean;
            allowedReactions: Array<string>;
          }
        | {
            __typename?: 'PhotoCarouselAdminConfig';
            maxSubmissionsPerUser: number;
            requireApproval: boolean;
            askSharePermission?: boolean | null;
            sharePrompt?: string | null;
            noPhotosMessage?: string | null;
            pollInterval?: number | null;
            predefinedCaptions?: Array<string> | null;
            maxVisiblePhotos: number;
          }
        | {
            __typename?: 'RaffleAdminConfig';
            optionalImageUrl?: string | null;
            claimYourPrize?: string | null;
            ticketFlipDirection: RaffleTicketFlipDirection;
          }
        | {
            __typename?: 'SlidesAdminConfig';
            autoPlay: boolean;
            autoPlayIntervalMs?: number | null;
          }
        | {
            __typename?: 'TriviaAdminConfig';
            instructions?: string | null;
            useQuestionTimer: boolean;
            defaultTimerMs: number;
            questions: Array<{
              __typename?: 'TriviaQuestion';
              id: string;
              text: string;
              correctChoiceId?: string | null;
              timerMs?: number | null;
              choices: Array<{
                __typename?: 'TriviaChoice';
                id: string;
                text: string;
              }>;
            }>;
          }
        | {
            __typename?: 'VoteForAdminConfig';
            votesPerUser: number;
            allowUserSubmissions: boolean;
            maxSubmissionsPerUser: number;
          }
        | null;
      viewConfig:
        | {
            __typename?: 'NowPlayingViewConfig';
            visualizationType: string;
            allowComments: boolean;
            allowedReactions: Array<string>;
          }
        | {
            __typename?: 'PhotoCarouselViewConfig';
            maxSubmissionsPerUser: number;
            askSharePermission?: boolean | null;
            sharePrompt?: string | null;
            noPhotosMessage?: string | null;
            maxVisiblePhotos: number;
          }
        | {
            __typename?: 'RaffleViewConfig';
            optionalImageUrl?: string | null;
            claimYourPrize?: string | null;
            ticketFlipDirection: RaffleTicketFlipDirection;
          }
        | {
            __typename?: 'SlidesViewConfig';
            autoPlay: boolean;
            autoPlayIntervalMs?: number | null;
          }
        | {
            __typename?: 'TriviaViewConfig';
            instructions?: string | null;
            useQuestionTimer: boolean;
            defaultTimerMs: number;
            questions: Array<{
              __typename?: 'TriviaViewQuestion';
              id: string;
              text: string;
              timerMs?: number | null;
              choices: Array<{
                __typename?: 'TriviaChoice';
                id: string;
                text: string;
              }>;
            }>;
          }
        | { __typename?: 'VoteForViewConfig'; votesPerUser: number };
      viewData:
        | { __typename?: 'NowPlayingViewData'; currentSong?: string | null }
        | {
            __typename?: 'PhotoCarouselViewData';
            visibleSubmission?: string | null;
          }
        | {
            __typename?: 'RaffleViewData';
            raffleStatus: RaffleStatus;
            raffleCandidates: Array<string>;
            raffleWinners: Array<string>;
            raffleWinner?: string | null;
            winnerCount: number;
            remainingSubmissionIds: Array<string>;
            lastEliminatedSubmissionId?: string | null;
          }
        | {
            __typename?: 'SlidesViewData';
            currentSlide: string;
            slidesDisplayOrder: Array<string>;
          }
        | {
            __typename?: 'TriviaViewData';
            status: TriviaRoundStatus;
            questionIndex: number;
            questionEndsAt?: any | null;
            answeredCount: number;
            playerCount: number;
            correctChoiceId?: string | null;
            correctCount?: number | null;
            leaderboardOverflow: number;
            tallies: Array<{
              __typename?: 'TriviaTally';
              choiceId: string;
              count: number;
            }>;
            leaderboard: Array<{
              __typename?: 'TriviaLeaderboardRow';
              userId: string;
              name: string;
              score: number;
              rank: number;
              tied: boolean;
            }>;
          }
        | {
            __typename?: 'VoteForViewData';
            voteWinners?: Array<string> | null;
            choiceDisplayOrder: Array<string>;
            votes: Array<{
              __typename?: 'VoteCount';
              submissionId: string;
              count: number;
            }>;
          };
    };
  };
};

export type MockVoteForVotesResetSubscriptionVariables = Exact<{
  engagementId: Scalars['String']['input'];
}>;

export type MockVoteForVotesResetSubscription = {
  __typename?: 'Subscription';
  mockVoteForVotesReset: {
    __typename?: 'VoteForVotesResetPayload';
    engagement: {
      __typename?: 'Engagement';
      id: string;
      eventId: string;
      createdAt: any;
      updatedAt: any;
      title: string;
      description?: string | null;
      qrCodeCta?: string | null;
      startTime?: any | null;
      order: number;
      endTime?: any | null;
      type: EngagementType;
      data?:
        | { __typename?: 'NowPlayingAdminData'; currentSong?: string | null }
        | {
            __typename?: 'PhotoCarouselAdminData';
            visibleSubmission?: string | null;
            rejectedQueue: Array<string>;
            unapprovedQueue: Array<string>;
            unseenQueue: Array<string>;
            seenQueuePointer: number;
            seenQueue: Array<string>;
          }
        | {
            __typename?: 'RaffleAdminData';
            raffleStatus: RaffleStatus;
            raffleCandidates: Array<string>;
            raffleWinners: Array<string>;
            raffleWinner?: string | null;
            winnerCount: number;
            remainingSubmissionIds: Array<string>;
            lastEliminatedSubmissionId?: string | null;
          }
        | {
            __typename?: 'SlidesAdminData';
            currentSlide: string;
            slidesDisplayOrder: Array<string>;
          }
        | {
            __typename?: 'TriviaAdminData';
            status: TriviaRoundStatus;
            questionIndex: number;
            playedThroughIndex: number;
            reviewing: boolean;
            questionEndsAt?: any | null;
            answeredCount: number;
            playerCount: number;
            correctChoiceId?: string | null;
            correctCount?: number | null;
            revealedQuestionIds: Array<string>;
            tallies: Array<{
              __typename?: 'TriviaTally';
              choiceId: string;
              count: number;
            }>;
            leaderboard: Array<{
              __typename?: 'TriviaLeaderboardRow';
              userId: string;
              name: string;
              score: number;
              rank: number;
              tied: boolean;
            }>;
          }
        | {
            __typename?: 'VoteForAdminData';
            startTime?: any | null;
            endTime?: any | null;
            voteWinners?: Array<string> | null;
            choiceDisplayOrder: Array<string>;
            votes: Array<{
              __typename?: 'VoteCount';
              submissionId: string;
              count: number;
            }>;
          }
        | null;
      config?:
        | {
            __typename?: 'NowPlayingAdminConfig';
            visualizationType: string;
            allowComments: boolean;
            allowedReactions: Array<string>;
          }
        | {
            __typename?: 'PhotoCarouselAdminConfig';
            maxSubmissionsPerUser: number;
            requireApproval: boolean;
            askSharePermission?: boolean | null;
            sharePrompt?: string | null;
            noPhotosMessage?: string | null;
            pollInterval?: number | null;
            predefinedCaptions?: Array<string> | null;
            maxVisiblePhotos: number;
          }
        | {
            __typename?: 'RaffleAdminConfig';
            optionalImageUrl?: string | null;
            claimYourPrize?: string | null;
            ticketFlipDirection: RaffleTicketFlipDirection;
          }
        | {
            __typename?: 'SlidesAdminConfig';
            autoPlay: boolean;
            autoPlayIntervalMs?: number | null;
          }
        | {
            __typename?: 'TriviaAdminConfig';
            instructions?: string | null;
            useQuestionTimer: boolean;
            defaultTimerMs: number;
            questions: Array<{
              __typename?: 'TriviaQuestion';
              id: string;
              text: string;
              correctChoiceId?: string | null;
              timerMs?: number | null;
              choices: Array<{
                __typename?: 'TriviaChoice';
                id: string;
                text: string;
              }>;
            }>;
          }
        | {
            __typename?: 'VoteForAdminConfig';
            votesPerUser: number;
            allowUserSubmissions: boolean;
            maxSubmissionsPerUser: number;
          }
        | null;
      viewConfig:
        | {
            __typename?: 'NowPlayingViewConfig';
            visualizationType: string;
            allowComments: boolean;
            allowedReactions: Array<string>;
          }
        | {
            __typename?: 'PhotoCarouselViewConfig';
            maxSubmissionsPerUser: number;
            askSharePermission?: boolean | null;
            sharePrompt?: string | null;
            noPhotosMessage?: string | null;
            maxVisiblePhotos: number;
          }
        | {
            __typename?: 'RaffleViewConfig';
            optionalImageUrl?: string | null;
            claimYourPrize?: string | null;
            ticketFlipDirection: RaffleTicketFlipDirection;
          }
        | {
            __typename?: 'SlidesViewConfig';
            autoPlay: boolean;
            autoPlayIntervalMs?: number | null;
          }
        | {
            __typename?: 'TriviaViewConfig';
            instructions?: string | null;
            useQuestionTimer: boolean;
            defaultTimerMs: number;
            questions: Array<{
              __typename?: 'TriviaViewQuestion';
              id: string;
              text: string;
              timerMs?: number | null;
              choices: Array<{
                __typename?: 'TriviaChoice';
                id: string;
                text: string;
              }>;
            }>;
          }
        | { __typename?: 'VoteForViewConfig'; votesPerUser: number };
      viewData:
        | { __typename?: 'NowPlayingViewData'; currentSong?: string | null }
        | {
            __typename?: 'PhotoCarouselViewData';
            visibleSubmission?: string | null;
          }
        | {
            __typename?: 'RaffleViewData';
            raffleStatus: RaffleStatus;
            raffleCandidates: Array<string>;
            raffleWinners: Array<string>;
            raffleWinner?: string | null;
            winnerCount: number;
            remainingSubmissionIds: Array<string>;
            lastEliminatedSubmissionId?: string | null;
          }
        | {
            __typename?: 'SlidesViewData';
            currentSlide: string;
            slidesDisplayOrder: Array<string>;
          }
        | {
            __typename?: 'TriviaViewData';
            status: TriviaRoundStatus;
            questionIndex: number;
            questionEndsAt?: any | null;
            answeredCount: number;
            playerCount: number;
            correctChoiceId?: string | null;
            correctCount?: number | null;
            leaderboardOverflow: number;
            tallies: Array<{
              __typename?: 'TriviaTally';
              choiceId: string;
              count: number;
            }>;
            leaderboard: Array<{
              __typename?: 'TriviaLeaderboardRow';
              userId: string;
              name: string;
              score: number;
              rank: number;
              tied: boolean;
            }>;
          }
        | {
            __typename?: 'VoteForViewData';
            voteWinners?: Array<string> | null;
            choiceDisplayOrder: Array<string>;
            votes: Array<{
              __typename?: 'VoteCount';
              submissionId: string;
              count: number;
            }>;
          };
    };
  };
};

export type FullEngagementFragment = {
  __typename?: 'Engagement';
  id: string;
  eventId: string;
  createdAt: any;
  updatedAt: any;
  title: string;
  description?: string | null;
  qrCodeCta?: string | null;
  startTime?: any | null;
  order: number;
  endTime?: any | null;
  type: EngagementType;
  data?:
    | { __typename?: 'NowPlayingAdminData'; currentSong?: string | null }
    | {
        __typename?: 'PhotoCarouselAdminData';
        visibleSubmission?: string | null;
        rejectedQueue: Array<string>;
        unapprovedQueue: Array<string>;
        unseenQueue: Array<string>;
        seenQueuePointer: number;
        seenQueue: Array<string>;
      }
    | {
        __typename?: 'RaffleAdminData';
        raffleStatus: RaffleStatus;
        raffleCandidates: Array<string>;
        raffleWinners: Array<string>;
        raffleWinner?: string | null;
        winnerCount: number;
        remainingSubmissionIds: Array<string>;
        lastEliminatedSubmissionId?: string | null;
      }
    | {
        __typename?: 'SlidesAdminData';
        currentSlide: string;
        slidesDisplayOrder: Array<string>;
      }
    | {
        __typename?: 'TriviaAdminData';
        status: TriviaRoundStatus;
        questionIndex: number;
        playedThroughIndex: number;
        reviewing: boolean;
        questionEndsAt?: any | null;
        answeredCount: number;
        playerCount: number;
        correctChoiceId?: string | null;
        correctCount?: number | null;
        revealedQuestionIds: Array<string>;
        tallies: Array<{
          __typename?: 'TriviaTally';
          choiceId: string;
          count: number;
        }>;
        leaderboard: Array<{
          __typename?: 'TriviaLeaderboardRow';
          userId: string;
          name: string;
          score: number;
          rank: number;
          tied: boolean;
        }>;
      }
    | {
        __typename?: 'VoteForAdminData';
        startTime?: any | null;
        endTime?: any | null;
        voteWinners?: Array<string> | null;
        choiceDisplayOrder: Array<string>;
        votes: Array<{
          __typename?: 'VoteCount';
          submissionId: string;
          count: number;
        }>;
      }
    | null;
  config?:
    | {
        __typename?: 'NowPlayingAdminConfig';
        visualizationType: string;
        allowComments: boolean;
        allowedReactions: Array<string>;
      }
    | {
        __typename?: 'PhotoCarouselAdminConfig';
        maxSubmissionsPerUser: number;
        requireApproval: boolean;
        askSharePermission?: boolean | null;
        sharePrompt?: string | null;
        noPhotosMessage?: string | null;
        pollInterval?: number | null;
        predefinedCaptions?: Array<string> | null;
        maxVisiblePhotos: number;
      }
    | {
        __typename?: 'RaffleAdminConfig';
        optionalImageUrl?: string | null;
        claimYourPrize?: string | null;
        ticketFlipDirection: RaffleTicketFlipDirection;
      }
    | {
        __typename?: 'SlidesAdminConfig';
        autoPlay: boolean;
        autoPlayIntervalMs?: number | null;
      }
    | {
        __typename?: 'TriviaAdminConfig';
        instructions?: string | null;
        useQuestionTimer: boolean;
        defaultTimerMs: number;
        questions: Array<{
          __typename?: 'TriviaQuestion';
          id: string;
          text: string;
          correctChoiceId?: string | null;
          timerMs?: number | null;
          choices: Array<{
            __typename?: 'TriviaChoice';
            id: string;
            text: string;
          }>;
        }>;
      }
    | {
        __typename?: 'VoteForAdminConfig';
        votesPerUser: number;
        allowUserSubmissions: boolean;
        maxSubmissionsPerUser: number;
      }
    | null;
  viewConfig:
    | {
        __typename?: 'NowPlayingViewConfig';
        visualizationType: string;
        allowComments: boolean;
        allowedReactions: Array<string>;
      }
    | {
        __typename?: 'PhotoCarouselViewConfig';
        maxSubmissionsPerUser: number;
        askSharePermission?: boolean | null;
        sharePrompt?: string | null;
        noPhotosMessage?: string | null;
        maxVisiblePhotos: number;
      }
    | {
        __typename?: 'RaffleViewConfig';
        optionalImageUrl?: string | null;
        claimYourPrize?: string | null;
        ticketFlipDirection: RaffleTicketFlipDirection;
      }
    | {
        __typename?: 'SlidesViewConfig';
        autoPlay: boolean;
        autoPlayIntervalMs?: number | null;
      }
    | {
        __typename?: 'TriviaViewConfig';
        instructions?: string | null;
        useQuestionTimer: boolean;
        defaultTimerMs: number;
        questions: Array<{
          __typename?: 'TriviaViewQuestion';
          id: string;
          text: string;
          timerMs?: number | null;
          choices: Array<{
            __typename?: 'TriviaChoice';
            id: string;
            text: string;
          }>;
        }>;
      }
    | { __typename?: 'VoteForViewConfig'; votesPerUser: number };
  viewData:
    | { __typename?: 'NowPlayingViewData'; currentSong?: string | null }
    | {
        __typename?: 'PhotoCarouselViewData';
        visibleSubmission?: string | null;
      }
    | {
        __typename?: 'RaffleViewData';
        raffleStatus: RaffleStatus;
        raffleCandidates: Array<string>;
        raffleWinners: Array<string>;
        raffleWinner?: string | null;
        winnerCount: number;
        remainingSubmissionIds: Array<string>;
        lastEliminatedSubmissionId?: string | null;
      }
    | {
        __typename?: 'SlidesViewData';
        currentSlide: string;
        slidesDisplayOrder: Array<string>;
      }
    | {
        __typename?: 'TriviaViewData';
        status: TriviaRoundStatus;
        questionIndex: number;
        questionEndsAt?: any | null;
        answeredCount: number;
        playerCount: number;
        correctChoiceId?: string | null;
        correctCount?: number | null;
        leaderboardOverflow: number;
        tallies: Array<{
          __typename?: 'TriviaTally';
          choiceId: string;
          count: number;
        }>;
        leaderboard: Array<{
          __typename?: 'TriviaLeaderboardRow';
          userId: string;
          name: string;
          score: number;
          rank: number;
          tied: boolean;
        }>;
      }
    | {
        __typename?: 'VoteForViewData';
        voteWinners?: Array<string> | null;
        choiceDisplayOrder: Array<string>;
        votes: Array<{
          __typename?: 'VoteCount';
          submissionId: string;
          count: number;
        }>;
      };
};

export type FullSubmissionFragment = {
  __typename?: 'Submission';
  id: string;
  engagementId: string;
  createdAt: any;
  userId?: string | null;
  hidden: boolean;
  possibleBannedDevice: boolean;
  matchedBanCreatedAt?: any | null;
  data:
    | {
        __typename?: 'NowPlayingSubmissionData';
        order: number;
        songAlbumArt?: string | null;
        songTitle?: string | null;
        songArtist?: string | null;
        songNotes?: string | null;
        songLyrics?: string | null;
        visualizationType?: string | null;
        spotifyUrl?: string | null;
      }
    | {
        __typename?: 'PhotoCarouselSubmissionData';
        photoUrl?: string | null;
        caption?: string | null;
        approved?: boolean | null;
        sharingPermissionGranted?: boolean | null;
      }
    | {
        __typename?: 'RaffleSubmissionData';
        name: string;
        optionalImageUrl?: string | null;
      }
    | {
        __typename?: 'SlidesSubmissionData';
        optionalImageUrl?: string | null;
        title: string;
        content: string;
        slideDuration?: number | null;
        imageTilt?: SlideImageTilt | null;
        layout?: SlideLayout | null;
        showQr?: boolean | null;
        background?: {
          __typename?: 'SlideBackground';
          type: SlideBackgroundType;
          color?: string | null;
          imageUrl?: string | null;
        } | null;
        elements?: Array<{
          __typename?: 'SlideElement';
          id: string;
          type: SlideElementType;
          name?: string | null;
          locked?: boolean | null;
          text?: string | null;
          textType?: string | null;
          fontFamily?: Array<string> | null;
          color?: string | null;
          fontSize?: number | null;
          fontWeight?: SlideFontWeight | null;
          textAlign?: SlideTextAlign | null;
          verticalAlign?: SlideVerticalAlign | null;
          imageUrl?: string | null;
          fit?: SlideImageFit | null;
          box?: {
            __typename?: 'SlideBox';
            x: number;
            y: number;
            w: number;
            h: number;
          } | null;
        }> | null;
      }
    | {
        __typename?: 'TriviaSubmissionData';
        questionId?: string | null;
        choiceId?: string | null;
      }
    | {
        __typename?: 'VoteForSubmissionData';
        title: string;
        color: string;
        description: string;
        optionalImageUrl?: string | null;
      };
  user?: { __typename?: 'User'; id: string; name?: string | null } | null;
  reactions?: Array<{
    __typename?: 'Reaction';
    id: string;
    type: string;
    createdAt: any;
  }> | null;
};

export type BanFieldsFragment = {
  __typename?: 'Ban';
  id: string;
  userId: string;
  reason?: string | null;
  createdAt: any;
  hiddenCount: number;
  sourceEventId?: string | null;
  sourceEngagementId?: string | null;
  sourceSubmissionId?: string | null;
  sourcePhotoUrl?: string | null;
  user: { __typename?: 'User'; id: string; name?: string | null };
  sourceEvent?: { __typename?: 'Event'; id: string; name: string } | null;
  sourceEngagement?: {
    __typename?: 'Engagement';
    id: string;
    title: string;
  } | null;
};

export type FanEngagementFragment = {
  __typename?: 'Engagement';
  id: string;
  createdAt: any;
  updatedAt: any;
  title: string;
  description?: string | null;
  startTime?: any | null;
  endTime?: any | null;
  type: EngagementType;
  order: number;
  viewConfig:
    | {
        __typename?: 'NowPlayingViewConfig';
        visualizationType: string;
        allowComments: boolean;
        allowedReactions: Array<string>;
      }
    | {
        __typename?: 'PhotoCarouselViewConfig';
        maxSubmissionsPerUser: number;
        askSharePermission?: boolean | null;
        sharePrompt?: string | null;
        noPhotosMessage?: string | null;
        maxVisiblePhotos: number;
      }
    | {
        __typename?: 'RaffleViewConfig';
        optionalImageUrl?: string | null;
        claimYourPrize?: string | null;
        ticketFlipDirection: RaffleTicketFlipDirection;
      }
    | {
        __typename?: 'SlidesViewConfig';
        autoPlay: boolean;
        autoPlayIntervalMs?: number | null;
      }
    | {
        __typename?: 'TriviaViewConfig';
        instructions?: string | null;
        useQuestionTimer: boolean;
        defaultTimerMs: number;
        questions: Array<{
          __typename?: 'TriviaViewQuestion';
          id: string;
          text: string;
          timerMs?: number | null;
          choices: Array<{
            __typename?: 'TriviaChoice';
            id: string;
            text: string;
          }>;
        }>;
      }
    | { __typename?: 'VoteForViewConfig'; votesPerUser: number };
  viewData:
    | { __typename?: 'NowPlayingViewData'; currentSong?: string | null }
    | {
        __typename?: 'PhotoCarouselViewData';
        visibleSubmission?: string | null;
      }
    | {
        __typename?: 'RaffleViewData';
        raffleStatus: RaffleStatus;
        raffleCandidates: Array<string>;
        raffleWinners: Array<string>;
        raffleWinner?: string | null;
        winnerCount: number;
        remainingSubmissionIds: Array<string>;
        lastEliminatedSubmissionId?: string | null;
      }
    | {
        __typename?: 'SlidesViewData';
        currentSlide: string;
        slidesDisplayOrder: Array<string>;
      }
    | {
        __typename?: 'TriviaViewData';
        status: TriviaRoundStatus;
        questionIndex: number;
        questionEndsAt?: any | null;
        answeredCount: number;
        playerCount: number;
        correctChoiceId?: string | null;
        correctCount?: number | null;
        leaderboardOverflow: number;
        tallies: Array<{
          __typename?: 'TriviaTally';
          choiceId: string;
          count: number;
        }>;
        leaderboard: Array<{
          __typename?: 'TriviaLeaderboardRow';
          userId: string;
          name: string;
          score: number;
          rank: number;
          tied: boolean;
        }>;
      }
    | {
        __typename?: 'VoteForViewData';
        voteWinners?: Array<string> | null;
        choiceDisplayOrder: Array<string>;
        votes: Array<{
          __typename?: 'VoteCount';
          submissionId: string;
          count: number;
        }>;
      };
};

export type FanSubmissionFragment = {
  __typename?: 'Submission';
  id: string;
  createdAt: any;
  engagementId: string;
  hidden: boolean;
  possibleBannedDevice: boolean;
  data:
    | {
        __typename?: 'NowPlayingSubmissionData';
        order: number;
        songAlbumArt?: string | null;
        songTitle?: string | null;
        songArtist?: string | null;
        songNotes?: string | null;
        songLyrics?: string | null;
        visualizationType?: string | null;
        spotifyUrl?: string | null;
      }
    | {
        __typename?: 'PhotoCarouselSubmissionData';
        photoUrl?: string | null;
        caption?: string | null;
        approved?: boolean | null;
        sharingPermissionGranted?: boolean | null;
      }
    | {
        __typename?: 'RaffleSubmissionData';
        name: string;
        optionalImageUrl?: string | null;
      }
    | {
        __typename?: 'SlidesSubmissionData';
        optionalImageUrl?: string | null;
        title: string;
        content: string;
        slideDuration?: number | null;
        imageTilt?: SlideImageTilt | null;
        layout?: SlideLayout | null;
        showQr?: boolean | null;
        background?: {
          __typename?: 'SlideBackground';
          type: SlideBackgroundType;
          color?: string | null;
          imageUrl?: string | null;
        } | null;
        elements?: Array<{
          __typename?: 'SlideElement';
          id: string;
          type: SlideElementType;
          name?: string | null;
          locked?: boolean | null;
          text?: string | null;
          textType?: string | null;
          fontFamily?: Array<string> | null;
          color?: string | null;
          fontSize?: number | null;
          fontWeight?: SlideFontWeight | null;
          textAlign?: SlideTextAlign | null;
          verticalAlign?: SlideVerticalAlign | null;
          imageUrl?: string | null;
          fit?: SlideImageFit | null;
          box?: {
            __typename?: 'SlideBox';
            x: number;
            y: number;
            w: number;
            h: number;
          } | null;
        }> | null;
      }
    | {
        __typename?: 'TriviaSubmissionData';
        questionId?: string | null;
        choiceId?: string | null;
      }
    | {
        __typename?: 'VoteForSubmissionData';
        title: string;
        color: string;
        description: string;
        optionalImageUrl?: string | null;
      };
  reactions?: Array<{
    __typename?: 'Reaction';
    id: string;
    type: string;
    createdAt: any;
    submissionId: string;
  }> | null;
};

export type StageEngagementFragment = {
  __typename?: 'Engagement';
  id: string;
  createdAt: any;
  updatedAt: any;
  title: string;
  qrCodeCta?: string | null;
  description?: string | null;
  startTime?: any | null;
  endTime?: any | null;
  type: EngagementType;
  order: number;
  viewConfig:
    | {
        __typename?: 'NowPlayingViewConfig';
        visualizationType: string;
        allowComments: boolean;
        allowedReactions: Array<string>;
      }
    | {
        __typename?: 'PhotoCarouselViewConfig';
        maxSubmissionsPerUser: number;
        askSharePermission?: boolean | null;
        sharePrompt?: string | null;
        noPhotosMessage?: string | null;
        maxVisiblePhotos: number;
      }
    | {
        __typename?: 'RaffleViewConfig';
        optionalImageUrl?: string | null;
        claimYourPrize?: string | null;
        ticketFlipDirection: RaffleTicketFlipDirection;
      }
    | {
        __typename?: 'SlidesViewConfig';
        autoPlay: boolean;
        autoPlayIntervalMs?: number | null;
      }
    | {
        __typename?: 'TriviaViewConfig';
        instructions?: string | null;
        useQuestionTimer: boolean;
        defaultTimerMs: number;
        questions: Array<{
          __typename?: 'TriviaViewQuestion';
          id: string;
          text: string;
          timerMs?: number | null;
          choices: Array<{
            __typename?: 'TriviaChoice';
            id: string;
            text: string;
          }>;
        }>;
      }
    | { __typename?: 'VoteForViewConfig'; votesPerUser: number };
  viewData:
    | { __typename?: 'NowPlayingViewData'; currentSong?: string | null }
    | {
        __typename?: 'PhotoCarouselViewData';
        visibleSubmission?: string | null;
      }
    | {
        __typename?: 'RaffleViewData';
        raffleStatus: RaffleStatus;
        raffleCandidates: Array<string>;
        raffleWinners: Array<string>;
        raffleWinner?: string | null;
        winnerCount: number;
        remainingSubmissionIds: Array<string>;
        lastEliminatedSubmissionId?: string | null;
      }
    | {
        __typename?: 'SlidesViewData';
        currentSlide: string;
        slidesDisplayOrder: Array<string>;
      }
    | {
        __typename?: 'TriviaViewData';
        status: TriviaRoundStatus;
        questionIndex: number;
        questionEndsAt?: any | null;
        answeredCount: number;
        playerCount: number;
        correctChoiceId?: string | null;
        correctCount?: number | null;
        leaderboardOverflow: number;
        tallies: Array<{
          __typename?: 'TriviaTally';
          choiceId: string;
          count: number;
        }>;
        leaderboard: Array<{
          __typename?: 'TriviaLeaderboardRow';
          userId: string;
          name: string;
          score: number;
          rank: number;
          tied: boolean;
        }>;
      }
    | {
        __typename?: 'VoteForViewData';
        voteWinners?: Array<string> | null;
        choiceDisplayOrder: Array<string>;
        votes: Array<{
          __typename?: 'VoteCount';
          submissionId: string;
          count: number;
        }>;
      };
};

export type StageSubmissionFragment = {
  __typename?: 'Submission';
  id: string;
  createdAt: any;
  engagementId: string;
  hidden: boolean;
  possibleBannedDevice: boolean;
  matchedBanCreatedAt?: any | null;
  userId?: string | null;
  data:
    | {
        __typename?: 'NowPlayingSubmissionData';
        order: number;
        songAlbumArt?: string | null;
        songTitle?: string | null;
        songArtist?: string | null;
        songNotes?: string | null;
        songLyrics?: string | null;
        visualizationType?: string | null;
        spotifyUrl?: string | null;
      }
    | {
        __typename?: 'PhotoCarouselSubmissionData';
        photoUrl?: string | null;
        caption?: string | null;
        approved?: boolean | null;
        sharingPermissionGranted?: boolean | null;
      }
    | {
        __typename?: 'RaffleSubmissionData';
        name: string;
        optionalImageUrl?: string | null;
      }
    | {
        __typename?: 'SlidesSubmissionData';
        optionalImageUrl?: string | null;
        title: string;
        content: string;
        slideDuration?: number | null;
        imageTilt?: SlideImageTilt | null;
        layout?: SlideLayout | null;
        showQr?: boolean | null;
        background?: {
          __typename?: 'SlideBackground';
          type: SlideBackgroundType;
          color?: string | null;
          imageUrl?: string | null;
        } | null;
        elements?: Array<{
          __typename?: 'SlideElement';
          id: string;
          type: SlideElementType;
          name?: string | null;
          locked?: boolean | null;
          text?: string | null;
          textType?: string | null;
          fontFamily?: Array<string> | null;
          color?: string | null;
          fontSize?: number | null;
          fontWeight?: SlideFontWeight | null;
          textAlign?: SlideTextAlign | null;
          verticalAlign?: SlideVerticalAlign | null;
          imageUrl?: string | null;
          fit?: SlideImageFit | null;
          box?: {
            __typename?: 'SlideBox';
            x: number;
            y: number;
            w: number;
            h: number;
          } | null;
        }> | null;
      }
    | {
        __typename?: 'TriviaSubmissionData';
        questionId?: string | null;
        choiceId?: string | null;
      }
    | {
        __typename?: 'VoteForSubmissionData';
        title: string;
        color: string;
        description: string;
        optionalImageUrl?: string | null;
      };
  reactions?: Array<{
    __typename?: 'Reaction';
    id: string;
    type: string;
    createdAt: any;
  }> | null;
};

export type FullEventFragment = {
  __typename?: 'Event';
  id: string;
  name: string;
  date?: any | null;
  live: boolean;
  location?: string | null;
  locked: boolean;
  description?: string | null;
  createdAt: any;
  updatedAt: any;
  activeEngagementId?: string | null;
  screenCode?: string | null;
  themeConfig?: {
    __typename?: 'EventThemeConfig';
    headingFontFamily?: Array<string> | null;
    bodyFontFamily?: Array<string> | null;
    foregroundColor?: string | null;
    backgroundColor?: string | null;
    stageBackgroundImage?: string | null;
    fanBackgroundImage?: string | null;
    qrForegroundColor?: string | null;
    qrBackgroundColor?: string | null;
    qrTextColor?: string | null;
    qrWrapperBackgroundColor?: string | null;
    stageElements?: Array<{
      __typename?: 'ScreenElement';
      id: string;
      type: string;
      name?: string | null;
      imageUrl?: string | null;
      defaultStyles?: any | null;
      engagementStyles?: any | null;
      defaultClassNames?: string | null;
      engagementClassNames?: string | null;
      text?: string | null;
      textType?: string | null;
      fontFamily?: Array<string> | null;
      linkHref?: string | null;
      color?: string | null;
    }> | null;
    fanElements?: Array<{
      __typename?: 'ScreenElement';
      id: string;
      type: string;
      name?: string | null;
      imageUrl?: string | null;
      defaultStyles?: any | null;
      engagementStyles?: any | null;
      defaultClassNames?: string | null;
      engagementClassNames?: string | null;
      text?: string | null;
      textType?: string | null;
      fontFamily?: Array<string> | null;
      linkHref?: string | null;
      color?: string | null;
    }> | null;
  } | null;
  activeEngagement?: {
    __typename?: 'Engagement';
    id: string;
    eventId: string;
    createdAt: any;
    updatedAt: any;
    title: string;
    description?: string | null;
    qrCodeCta?: string | null;
    startTime?: any | null;
    order: number;
    endTime?: any | null;
    type: EngagementType;
    data?:
      | { __typename?: 'NowPlayingAdminData'; currentSong?: string | null }
      | {
          __typename?: 'PhotoCarouselAdminData';
          visibleSubmission?: string | null;
          rejectedQueue: Array<string>;
          unapprovedQueue: Array<string>;
          unseenQueue: Array<string>;
          seenQueuePointer: number;
          seenQueue: Array<string>;
        }
      | {
          __typename?: 'RaffleAdminData';
          raffleStatus: RaffleStatus;
          raffleCandidates: Array<string>;
          raffleWinners: Array<string>;
          raffleWinner?: string | null;
          winnerCount: number;
          remainingSubmissionIds: Array<string>;
          lastEliminatedSubmissionId?: string | null;
        }
      | {
          __typename?: 'SlidesAdminData';
          currentSlide: string;
          slidesDisplayOrder: Array<string>;
        }
      | {
          __typename?: 'TriviaAdminData';
          status: TriviaRoundStatus;
          questionIndex: number;
          playedThroughIndex: number;
          reviewing: boolean;
          questionEndsAt?: any | null;
          answeredCount: number;
          playerCount: number;
          correctChoiceId?: string | null;
          correctCount?: number | null;
          revealedQuestionIds: Array<string>;
          tallies: Array<{
            __typename?: 'TriviaTally';
            choiceId: string;
            count: number;
          }>;
          leaderboard: Array<{
            __typename?: 'TriviaLeaderboardRow';
            userId: string;
            name: string;
            score: number;
            rank: number;
            tied: boolean;
          }>;
        }
      | {
          __typename?: 'VoteForAdminData';
          startTime?: any | null;
          endTime?: any | null;
          voteWinners?: Array<string> | null;
          choiceDisplayOrder: Array<string>;
          votes: Array<{
            __typename?: 'VoteCount';
            submissionId: string;
            count: number;
          }>;
        }
      | null;
    config?:
      | {
          __typename?: 'NowPlayingAdminConfig';
          visualizationType: string;
          allowComments: boolean;
          allowedReactions: Array<string>;
        }
      | {
          __typename?: 'PhotoCarouselAdminConfig';
          maxSubmissionsPerUser: number;
          requireApproval: boolean;
          askSharePermission?: boolean | null;
          sharePrompt?: string | null;
          noPhotosMessage?: string | null;
          pollInterval?: number | null;
          predefinedCaptions?: Array<string> | null;
          maxVisiblePhotos: number;
        }
      | {
          __typename?: 'RaffleAdminConfig';
          optionalImageUrl?: string | null;
          claimYourPrize?: string | null;
          ticketFlipDirection: RaffleTicketFlipDirection;
        }
      | {
          __typename?: 'SlidesAdminConfig';
          autoPlay: boolean;
          autoPlayIntervalMs?: number | null;
        }
      | {
          __typename?: 'TriviaAdminConfig';
          instructions?: string | null;
          useQuestionTimer: boolean;
          defaultTimerMs: number;
          questions: Array<{
            __typename?: 'TriviaQuestion';
            id: string;
            text: string;
            correctChoiceId?: string | null;
            timerMs?: number | null;
            choices: Array<{
              __typename?: 'TriviaChoice';
              id: string;
              text: string;
            }>;
          }>;
        }
      | {
          __typename?: 'VoteForAdminConfig';
          votesPerUser: number;
          allowUserSubmissions: boolean;
          maxSubmissionsPerUser: number;
        }
      | null;
    viewConfig:
      | {
          __typename?: 'NowPlayingViewConfig';
          visualizationType: string;
          allowComments: boolean;
          allowedReactions: Array<string>;
        }
      | {
          __typename?: 'PhotoCarouselViewConfig';
          maxSubmissionsPerUser: number;
          askSharePermission?: boolean | null;
          sharePrompt?: string | null;
          noPhotosMessage?: string | null;
          maxVisiblePhotos: number;
        }
      | {
          __typename?: 'RaffleViewConfig';
          optionalImageUrl?: string | null;
          claimYourPrize?: string | null;
          ticketFlipDirection: RaffleTicketFlipDirection;
        }
      | {
          __typename?: 'SlidesViewConfig';
          autoPlay: boolean;
          autoPlayIntervalMs?: number | null;
        }
      | {
          __typename?: 'TriviaViewConfig';
          instructions?: string | null;
          useQuestionTimer: boolean;
          defaultTimerMs: number;
          questions: Array<{
            __typename?: 'TriviaViewQuestion';
            id: string;
            text: string;
            timerMs?: number | null;
            choices: Array<{
              __typename?: 'TriviaChoice';
              id: string;
              text: string;
            }>;
          }>;
        }
      | { __typename?: 'VoteForViewConfig'; votesPerUser: number };
    viewData:
      | { __typename?: 'NowPlayingViewData'; currentSong?: string | null }
      | {
          __typename?: 'PhotoCarouselViewData';
          visibleSubmission?: string | null;
        }
      | {
          __typename?: 'RaffleViewData';
          raffleStatus: RaffleStatus;
          raffleCandidates: Array<string>;
          raffleWinners: Array<string>;
          raffleWinner?: string | null;
          winnerCount: number;
          remainingSubmissionIds: Array<string>;
          lastEliminatedSubmissionId?: string | null;
        }
      | {
          __typename?: 'SlidesViewData';
          currentSlide: string;
          slidesDisplayOrder: Array<string>;
        }
      | {
          __typename?: 'TriviaViewData';
          status: TriviaRoundStatus;
          questionIndex: number;
          questionEndsAt?: any | null;
          answeredCount: number;
          playerCount: number;
          correctChoiceId?: string | null;
          correctCount?: number | null;
          leaderboardOverflow: number;
          tallies: Array<{
            __typename?: 'TriviaTally';
            choiceId: string;
            count: number;
          }>;
          leaderboard: Array<{
            __typename?: 'TriviaLeaderboardRow';
            userId: string;
            name: string;
            score: number;
            rank: number;
            tied: boolean;
          }>;
        }
      | {
          __typename?: 'VoteForViewData';
          voteWinners?: Array<string> | null;
          choiceDisplayOrder: Array<string>;
          votes: Array<{
            __typename?: 'VoteCount';
            submissionId: string;
            count: number;
          }>;
        };
  } | null;
  engagements: Array<{
    __typename?: 'Engagement';
    id: string;
    eventId: string;
    createdAt: any;
    updatedAt: any;
    title: string;
    description?: string | null;
    qrCodeCta?: string | null;
    startTime?: any | null;
    order: number;
    endTime?: any | null;
    type: EngagementType;
    data?:
      | { __typename?: 'NowPlayingAdminData'; currentSong?: string | null }
      | {
          __typename?: 'PhotoCarouselAdminData';
          visibleSubmission?: string | null;
          rejectedQueue: Array<string>;
          unapprovedQueue: Array<string>;
          unseenQueue: Array<string>;
          seenQueuePointer: number;
          seenQueue: Array<string>;
        }
      | {
          __typename?: 'RaffleAdminData';
          raffleStatus: RaffleStatus;
          raffleCandidates: Array<string>;
          raffleWinners: Array<string>;
          raffleWinner?: string | null;
          winnerCount: number;
          remainingSubmissionIds: Array<string>;
          lastEliminatedSubmissionId?: string | null;
        }
      | {
          __typename?: 'SlidesAdminData';
          currentSlide: string;
          slidesDisplayOrder: Array<string>;
        }
      | {
          __typename?: 'TriviaAdminData';
          status: TriviaRoundStatus;
          questionIndex: number;
          playedThroughIndex: number;
          reviewing: boolean;
          questionEndsAt?: any | null;
          answeredCount: number;
          playerCount: number;
          correctChoiceId?: string | null;
          correctCount?: number | null;
          revealedQuestionIds: Array<string>;
          tallies: Array<{
            __typename?: 'TriviaTally';
            choiceId: string;
            count: number;
          }>;
          leaderboard: Array<{
            __typename?: 'TriviaLeaderboardRow';
            userId: string;
            name: string;
            score: number;
            rank: number;
            tied: boolean;
          }>;
        }
      | {
          __typename?: 'VoteForAdminData';
          startTime?: any | null;
          endTime?: any | null;
          voteWinners?: Array<string> | null;
          choiceDisplayOrder: Array<string>;
          votes: Array<{
            __typename?: 'VoteCount';
            submissionId: string;
            count: number;
          }>;
        }
      | null;
    config?:
      | {
          __typename?: 'NowPlayingAdminConfig';
          visualizationType: string;
          allowComments: boolean;
          allowedReactions: Array<string>;
        }
      | {
          __typename?: 'PhotoCarouselAdminConfig';
          maxSubmissionsPerUser: number;
          requireApproval: boolean;
          askSharePermission?: boolean | null;
          sharePrompt?: string | null;
          noPhotosMessage?: string | null;
          pollInterval?: number | null;
          predefinedCaptions?: Array<string> | null;
          maxVisiblePhotos: number;
        }
      | {
          __typename?: 'RaffleAdminConfig';
          optionalImageUrl?: string | null;
          claimYourPrize?: string | null;
          ticketFlipDirection: RaffleTicketFlipDirection;
        }
      | {
          __typename?: 'SlidesAdminConfig';
          autoPlay: boolean;
          autoPlayIntervalMs?: number | null;
        }
      | {
          __typename?: 'TriviaAdminConfig';
          instructions?: string | null;
          useQuestionTimer: boolean;
          defaultTimerMs: number;
          questions: Array<{
            __typename?: 'TriviaQuestion';
            id: string;
            text: string;
            correctChoiceId?: string | null;
            timerMs?: number | null;
            choices: Array<{
              __typename?: 'TriviaChoice';
              id: string;
              text: string;
            }>;
          }>;
        }
      | {
          __typename?: 'VoteForAdminConfig';
          votesPerUser: number;
          allowUserSubmissions: boolean;
          maxSubmissionsPerUser: number;
        }
      | null;
    viewConfig:
      | {
          __typename?: 'NowPlayingViewConfig';
          visualizationType: string;
          allowComments: boolean;
          allowedReactions: Array<string>;
        }
      | {
          __typename?: 'PhotoCarouselViewConfig';
          maxSubmissionsPerUser: number;
          askSharePermission?: boolean | null;
          sharePrompt?: string | null;
          noPhotosMessage?: string | null;
          maxVisiblePhotos: number;
        }
      | {
          __typename?: 'RaffleViewConfig';
          optionalImageUrl?: string | null;
          claimYourPrize?: string | null;
          ticketFlipDirection: RaffleTicketFlipDirection;
        }
      | {
          __typename?: 'SlidesViewConfig';
          autoPlay: boolean;
          autoPlayIntervalMs?: number | null;
        }
      | {
          __typename?: 'TriviaViewConfig';
          instructions?: string | null;
          useQuestionTimer: boolean;
          defaultTimerMs: number;
          questions: Array<{
            __typename?: 'TriviaViewQuestion';
            id: string;
            text: string;
            timerMs?: number | null;
            choices: Array<{
              __typename?: 'TriviaChoice';
              id: string;
              text: string;
            }>;
          }>;
        }
      | { __typename?: 'VoteForViewConfig'; votesPerUser: number };
    viewData:
      | { __typename?: 'NowPlayingViewData'; currentSong?: string | null }
      | {
          __typename?: 'PhotoCarouselViewData';
          visibleSubmission?: string | null;
        }
      | {
          __typename?: 'RaffleViewData';
          raffleStatus: RaffleStatus;
          raffleCandidates: Array<string>;
          raffleWinners: Array<string>;
          raffleWinner?: string | null;
          winnerCount: number;
          remainingSubmissionIds: Array<string>;
          lastEliminatedSubmissionId?: string | null;
        }
      | {
          __typename?: 'SlidesViewData';
          currentSlide: string;
          slidesDisplayOrder: Array<string>;
        }
      | {
          __typename?: 'TriviaViewData';
          status: TriviaRoundStatus;
          questionIndex: number;
          questionEndsAt?: any | null;
          answeredCount: number;
          playerCount: number;
          correctChoiceId?: string | null;
          correctCount?: number | null;
          leaderboardOverflow: number;
          tallies: Array<{
            __typename?: 'TriviaTally';
            choiceId: string;
            count: number;
          }>;
          leaderboard: Array<{
            __typename?: 'TriviaLeaderboardRow';
            userId: string;
            name: string;
            score: number;
            rank: number;
            tied: boolean;
          }>;
        }
      | {
          __typename?: 'VoteForViewData';
          voteWinners?: Array<string> | null;
          choiceDisplayOrder: Array<string>;
          votes: Array<{
            __typename?: 'VoteCount';
            submissionId: string;
            count: number;
          }>;
        };
  }>;
  subscriptionInUse?: {
    __typename?: 'PaymentSubscription';
    id: string;
    userId: string;
    status: PaymentSubscriptionStatus;
    stripeSubscriptionId: string;
    currentPeriodStart?: any | null;
    currentPeriodEnd?: any | null;
    cancelAtPeriodEnd: boolean;
    canceledAt?: any | null;
    trialStart?: any | null;
    trialEnd?: any | null;
    maxConcurrentEvents: number;
    createdAt: any;
    updatedAt: any;
    liveEvents: Array<{ __typename?: 'Event'; id: string; name: string }>;
  } | null;
  eventPassRedemptionInUse?: {
    __typename?: 'EventPassRedemption';
    id: string;
    eventPassId: string;
    eventId: string;
    redeemedAt: any;
    description?: string | null;
    expiresAt?: any | null;
  } | null;
};

export type EventThemeConfigFragment = {
  __typename?: 'EventThemeConfig';
  headingFontFamily?: Array<string> | null;
  bodyFontFamily?: Array<string> | null;
  foregroundColor?: string | null;
  backgroundColor?: string | null;
  stageBackgroundImage?: string | null;
  fanBackgroundImage?: string | null;
  qrForegroundColor?: string | null;
  qrBackgroundColor?: string | null;
  qrTextColor?: string | null;
  qrWrapperBackgroundColor?: string | null;
  stageElements?: Array<{
    __typename?: 'ScreenElement';
    id: string;
    type: string;
    name?: string | null;
    imageUrl?: string | null;
    defaultStyles?: any | null;
    engagementStyles?: any | null;
    defaultClassNames?: string | null;
    engagementClassNames?: string | null;
    text?: string | null;
    textType?: string | null;
    fontFamily?: Array<string> | null;
    linkHref?: string | null;
    color?: string | null;
  }> | null;
  fanElements?: Array<{
    __typename?: 'ScreenElement';
    id: string;
    type: string;
    name?: string | null;
    imageUrl?: string | null;
    defaultStyles?: any | null;
    engagementStyles?: any | null;
    defaultClassNames?: string | null;
    engagementClassNames?: string | null;
    text?: string | null;
    textType?: string | null;
    fontFamily?: Array<string> | null;
    linkHref?: string | null;
    color?: string | null;
  }> | null;
};

export type FanEventFragment = {
  __typename?: 'Event';
  id: string;
  name: string;
  live: boolean;
  description?: string | null;
  date?: any | null;
  location?: string | null;
  themeConfig?: {
    __typename?: 'EventThemeConfig';
    headingFontFamily?: Array<string> | null;
    bodyFontFamily?: Array<string> | null;
    foregroundColor?: string | null;
    backgroundColor?: string | null;
    stageBackgroundImage?: string | null;
    fanBackgroundImage?: string | null;
    qrForegroundColor?: string | null;
    qrBackgroundColor?: string | null;
    qrTextColor?: string | null;
    qrWrapperBackgroundColor?: string | null;
    stageElements?: Array<{
      __typename?: 'ScreenElement';
      id: string;
      type: string;
      name?: string | null;
      imageUrl?: string | null;
      defaultStyles?: any | null;
      engagementStyles?: any | null;
      defaultClassNames?: string | null;
      engagementClassNames?: string | null;
      text?: string | null;
      textType?: string | null;
      fontFamily?: Array<string> | null;
      linkHref?: string | null;
      color?: string | null;
    }> | null;
    fanElements?: Array<{
      __typename?: 'ScreenElement';
      id: string;
      type: string;
      name?: string | null;
      imageUrl?: string | null;
      defaultStyles?: any | null;
      engagementStyles?: any | null;
      defaultClassNames?: string | null;
      engagementClassNames?: string | null;
      text?: string | null;
      textType?: string | null;
      fontFamily?: Array<string> | null;
      linkHref?: string | null;
      color?: string | null;
    }> | null;
  } | null;
  activeEngagement?: {
    __typename?: 'Engagement';
    id: string;
    createdAt: any;
    updatedAt: any;
    title: string;
    description?: string | null;
    startTime?: any | null;
    endTime?: any | null;
    type: EngagementType;
    order: number;
    viewConfig:
      | {
          __typename?: 'NowPlayingViewConfig';
          visualizationType: string;
          allowComments: boolean;
          allowedReactions: Array<string>;
        }
      | {
          __typename?: 'PhotoCarouselViewConfig';
          maxSubmissionsPerUser: number;
          askSharePermission?: boolean | null;
          sharePrompt?: string | null;
          noPhotosMessage?: string | null;
          maxVisiblePhotos: number;
        }
      | {
          __typename?: 'RaffleViewConfig';
          optionalImageUrl?: string | null;
          claimYourPrize?: string | null;
          ticketFlipDirection: RaffleTicketFlipDirection;
        }
      | {
          __typename?: 'SlidesViewConfig';
          autoPlay: boolean;
          autoPlayIntervalMs?: number | null;
        }
      | {
          __typename?: 'TriviaViewConfig';
          instructions?: string | null;
          useQuestionTimer: boolean;
          defaultTimerMs: number;
          questions: Array<{
            __typename?: 'TriviaViewQuestion';
            id: string;
            text: string;
            timerMs?: number | null;
            choices: Array<{
              __typename?: 'TriviaChoice';
              id: string;
              text: string;
            }>;
          }>;
        }
      | { __typename?: 'VoteForViewConfig'; votesPerUser: number };
    viewData:
      | { __typename?: 'NowPlayingViewData'; currentSong?: string | null }
      | {
          __typename?: 'PhotoCarouselViewData';
          visibleSubmission?: string | null;
        }
      | {
          __typename?: 'RaffleViewData';
          raffleStatus: RaffleStatus;
          raffleCandidates: Array<string>;
          raffleWinners: Array<string>;
          raffleWinner?: string | null;
          winnerCount: number;
          remainingSubmissionIds: Array<string>;
          lastEliminatedSubmissionId?: string | null;
        }
      | {
          __typename?: 'SlidesViewData';
          currentSlide: string;
          slidesDisplayOrder: Array<string>;
        }
      | {
          __typename?: 'TriviaViewData';
          status: TriviaRoundStatus;
          questionIndex: number;
          questionEndsAt?: any | null;
          answeredCount: number;
          playerCount: number;
          correctChoiceId?: string | null;
          correctCount?: number | null;
          leaderboardOverflow: number;
          tallies: Array<{
            __typename?: 'TriviaTally';
            choiceId: string;
            count: number;
          }>;
          leaderboard: Array<{
            __typename?: 'TriviaLeaderboardRow';
            userId: string;
            name: string;
            score: number;
            rank: number;
            tied: boolean;
          }>;
        }
      | {
          __typename?: 'VoteForViewData';
          voteWinners?: Array<string> | null;
          choiceDisplayOrder: Array<string>;
          votes: Array<{
            __typename?: 'VoteCount';
            submissionId: string;
            count: number;
          }>;
        };
  } | null;
};

export type FanReactionFragment = {
  __typename?: 'Reaction';
  id: string;
  type: string;
  createdAt: any;
  submissionId: string;
};

export type ScreenElementFragment = {
  __typename?: 'ScreenElement';
  id: string;
  type: string;
  name?: string | null;
  imageUrl?: string | null;
  defaultStyles?: any | null;
  engagementStyles?: any | null;
  defaultClassNames?: string | null;
  engagementClassNames?: string | null;
  text?: string | null;
  textType?: string | null;
  fontFamily?: Array<string> | null;
  linkHref?: string | null;
  color?: string | null;
};

export type ScreenTemplateEngagementInputFragment = {
  __typename?: 'ScreenTemplateEngagementInput';
  data?: any | null;
  description?: string | null;
  config?: any | null;
  endTime?: any | null;
  qrCodeCta?: string | null;
  startTime?: any | null;
  title: string;
  type: EngagementType;
};

export type ScreenTemplateFragment = {
  __typename?: 'ScreenTemplate';
  id: string;
  name: string;
  description?: string | null;
  createdAt: any;
  updatedAt: any;
  enabled: boolean;
  config?: {
    __typename?: 'EventThemeConfig';
    headingFontFamily?: Array<string> | null;
    bodyFontFamily?: Array<string> | null;
    foregroundColor?: string | null;
    backgroundColor?: string | null;
    stageBackgroundImage?: string | null;
    fanBackgroundImage?: string | null;
    qrForegroundColor?: string | null;
    qrBackgroundColor?: string | null;
    qrTextColor?: string | null;
    qrWrapperBackgroundColor?: string | null;
    stageElements?: Array<{
      __typename?: 'ScreenElement';
      id: string;
      type: string;
      name?: string | null;
      imageUrl?: string | null;
      defaultStyles?: any | null;
      engagementStyles?: any | null;
      defaultClassNames?: string | null;
      engagementClassNames?: string | null;
      text?: string | null;
      textType?: string | null;
      fontFamily?: Array<string> | null;
      linkHref?: string | null;
      color?: string | null;
    }> | null;
    fanElements?: Array<{
      __typename?: 'ScreenElement';
      id: string;
      type: string;
      name?: string | null;
      imageUrl?: string | null;
      defaultStyles?: any | null;
      engagementStyles?: any | null;
      defaultClassNames?: string | null;
      engagementClassNames?: string | null;
      text?: string | null;
      textType?: string | null;
      fontFamily?: Array<string> | null;
      linkHref?: string | null;
      color?: string | null;
    }> | null;
  } | null;
  engagements: Array<{
    __typename?: 'ScreenTemplateEngagementInput';
    data?: any | null;
    description?: string | null;
    config?: any | null;
    endTime?: any | null;
    qrCodeCta?: string | null;
    startTime?: any | null;
    title: string;
    type: EngagementType;
  }>;
};

export type StageEventFragment = {
  __typename?: 'Event';
  id: string;
  name: string;
  live: boolean;
  description?: string | null;
  date?: any | null;
  location?: string | null;
  themeConfig?: {
    __typename?: 'EventThemeConfig';
    headingFontFamily?: Array<string> | null;
    bodyFontFamily?: Array<string> | null;
    foregroundColor?: string | null;
    backgroundColor?: string | null;
    stageBackgroundImage?: string | null;
    fanBackgroundImage?: string | null;
    qrForegroundColor?: string | null;
    qrBackgroundColor?: string | null;
    qrTextColor?: string | null;
    qrWrapperBackgroundColor?: string | null;
    stageElements?: Array<{
      __typename?: 'ScreenElement';
      id: string;
      type: string;
      name?: string | null;
      imageUrl?: string | null;
      defaultStyles?: any | null;
      engagementStyles?: any | null;
      defaultClassNames?: string | null;
      engagementClassNames?: string | null;
      text?: string | null;
      textType?: string | null;
      fontFamily?: Array<string> | null;
      linkHref?: string | null;
      color?: string | null;
    }> | null;
    fanElements?: Array<{
      __typename?: 'ScreenElement';
      id: string;
      type: string;
      name?: string | null;
      imageUrl?: string | null;
      defaultStyles?: any | null;
      engagementStyles?: any | null;
      defaultClassNames?: string | null;
      engagementClassNames?: string | null;
      text?: string | null;
      textType?: string | null;
      fontFamily?: Array<string> | null;
      linkHref?: string | null;
      color?: string | null;
    }> | null;
  } | null;
  activeEngagement?: {
    __typename?: 'Engagement';
    id: string;
    createdAt: any;
    updatedAt: any;
    title: string;
    qrCodeCta?: string | null;
    description?: string | null;
    startTime?: any | null;
    endTime?: any | null;
    type: EngagementType;
    order: number;
    viewConfig:
      | {
          __typename?: 'NowPlayingViewConfig';
          visualizationType: string;
          allowComments: boolean;
          allowedReactions: Array<string>;
        }
      | {
          __typename?: 'PhotoCarouselViewConfig';
          maxSubmissionsPerUser: number;
          askSharePermission?: boolean | null;
          sharePrompt?: string | null;
          noPhotosMessage?: string | null;
          maxVisiblePhotos: number;
        }
      | {
          __typename?: 'RaffleViewConfig';
          optionalImageUrl?: string | null;
          claimYourPrize?: string | null;
          ticketFlipDirection: RaffleTicketFlipDirection;
        }
      | {
          __typename?: 'SlidesViewConfig';
          autoPlay: boolean;
          autoPlayIntervalMs?: number | null;
        }
      | {
          __typename?: 'TriviaViewConfig';
          instructions?: string | null;
          useQuestionTimer: boolean;
          defaultTimerMs: number;
          questions: Array<{
            __typename?: 'TriviaViewQuestion';
            id: string;
            text: string;
            timerMs?: number | null;
            choices: Array<{
              __typename?: 'TriviaChoice';
              id: string;
              text: string;
            }>;
          }>;
        }
      | { __typename?: 'VoteForViewConfig'; votesPerUser: number };
    viewData:
      | { __typename?: 'NowPlayingViewData'; currentSong?: string | null }
      | {
          __typename?: 'PhotoCarouselViewData';
          visibleSubmission?: string | null;
        }
      | {
          __typename?: 'RaffleViewData';
          raffleStatus: RaffleStatus;
          raffleCandidates: Array<string>;
          raffleWinners: Array<string>;
          raffleWinner?: string | null;
          winnerCount: number;
          remainingSubmissionIds: Array<string>;
          lastEliminatedSubmissionId?: string | null;
        }
      | {
          __typename?: 'SlidesViewData';
          currentSlide: string;
          slidesDisplayOrder: Array<string>;
        }
      | {
          __typename?: 'TriviaViewData';
          status: TriviaRoundStatus;
          questionIndex: number;
          questionEndsAt?: any | null;
          answeredCount: number;
          playerCount: number;
          correctChoiceId?: string | null;
          correctCount?: number | null;
          leaderboardOverflow: number;
          tallies: Array<{
            __typename?: 'TriviaTally';
            choiceId: string;
            count: number;
          }>;
          leaderboard: Array<{
            __typename?: 'TriviaLeaderboardRow';
            userId: string;
            name: string;
            score: number;
            rank: number;
            tied: boolean;
          }>;
        }
      | {
          __typename?: 'VoteForViewData';
          voteWinners?: Array<string> | null;
          choiceDisplayOrder: Array<string>;
          votes: Array<{
            __typename?: 'VoteCount';
            submissionId: string;
            count: number;
          }>;
        };
  } | null;
};

export type StageReactionFragment = {
  __typename?: 'Reaction';
  id: string;
  type: string;
  createdAt: any;
};

export type FullUserFragment = {
  __typename?: 'User';
  id: string;
  email?: string | null;
  role: Role;
  name?: string | null;
  username?: string | null;
  lastLogin?: any | null;
  googleId?: string | null;
  stripeCustomerId?: string | null;
  createdAt: any;
};

export type UserFragment = {
  __typename?: 'User';
  id: string;
  email?: string | null;
  role: Role;
  createdAt: any;
};

export type PaymentSubscriptionFragment = {
  __typename?: 'PaymentSubscription';
  id: string;
  userId: string;
  status: PaymentSubscriptionStatus;
  stripeSubscriptionId: string;
  currentPeriodStart?: any | null;
  currentPeriodEnd?: any | null;
  cancelAtPeriodEnd: boolean;
  canceledAt?: any | null;
  trialStart?: any | null;
  trialEnd?: any | null;
  maxConcurrentEvents: number;
  createdAt: any;
  updatedAt: any;
  liveEvents: Array<{ __typename?: 'Event'; id: string; name: string }>;
};

export type EventPassFragment = {
  __typename?: 'EventPass';
  id: string;
  userId: string;
  status: EventPassStatus;
  stripeCheckoutSessionId?: string | null;
  stripeChargeId?: string | null;
  amountPaid?: number | null;
  currency?: string | null;
  createdAt: any;
  updatedAt: any;
  expiresAt?: any | null;
  redemptions: Array<{
    __typename?: 'EventPassRedemption';
    id: string;
    eventPassId: string;
    eventId: string;
    redeemedAt: any;
    description?: string | null;
    expiresAt?: any | null;
  }>;
};

export type EventPassRedemptionFragment = {
  __typename?: 'EventPassRedemption';
  id: string;
  eventPassId: string;
  eventId: string;
  redeemedAt: any;
  description?: string | null;
  expiresAt?: any | null;
};

export type CookiePreferencesFragment = {
  __typename?: 'CookiePreferences';
  functional: boolean;
  analytics: boolean;
  marketing: boolean;
  consentDate?: string | null;
};

export type CreateSubmissionMutationVariables = Exact<{
  engagementId: Scalars['String']['input'];
  data: Scalars['Json']['input'];
  deviceId?: InputMaybe<Scalars['String']['input']>;
  visitorId?: InputMaybe<Scalars['String']['input']>;
}>;

export type CreateSubmissionMutation = {
  __typename?: 'Mutation';
  createSubmission: {
    __typename?: 'Submission';
    id: string;
    createdAt: any;
    engagementId: string;
    hidden: boolean;
    possibleBannedDevice: boolean;
    data:
      | {
          __typename?: 'NowPlayingSubmissionData';
          order: number;
          songAlbumArt?: string | null;
          songTitle?: string | null;
          songArtist?: string | null;
          songNotes?: string | null;
          songLyrics?: string | null;
          visualizationType?: string | null;
          spotifyUrl?: string | null;
        }
      | {
          __typename?: 'PhotoCarouselSubmissionData';
          photoUrl?: string | null;
          caption?: string | null;
          approved?: boolean | null;
          sharingPermissionGranted?: boolean | null;
        }
      | {
          __typename?: 'RaffleSubmissionData';
          name: string;
          optionalImageUrl?: string | null;
        }
      | {
          __typename?: 'SlidesSubmissionData';
          optionalImageUrl?: string | null;
          title: string;
          content: string;
          slideDuration?: number | null;
          imageTilt?: SlideImageTilt | null;
          layout?: SlideLayout | null;
          showQr?: boolean | null;
          background?: {
            __typename?: 'SlideBackground';
            type: SlideBackgroundType;
            color?: string | null;
            imageUrl?: string | null;
          } | null;
          elements?: Array<{
            __typename?: 'SlideElement';
            id: string;
            type: SlideElementType;
            name?: string | null;
            locked?: boolean | null;
            text?: string | null;
            textType?: string | null;
            fontFamily?: Array<string> | null;
            color?: string | null;
            fontSize?: number | null;
            fontWeight?: SlideFontWeight | null;
            textAlign?: SlideTextAlign | null;
            verticalAlign?: SlideVerticalAlign | null;
            imageUrl?: string | null;
            fit?: SlideImageFit | null;
            box?: {
              __typename?: 'SlideBox';
              x: number;
              y: number;
              w: number;
              h: number;
            } | null;
          }> | null;
        }
      | {
          __typename?: 'TriviaSubmissionData';
          questionId?: string | null;
          choiceId?: string | null;
        }
      | {
          __typename?: 'VoteForSubmissionData';
          title: string;
          color: string;
          description: string;
          optionalImageUrl?: string | null;
        };
    reactions?: Array<{
      __typename?: 'Reaction';
      id: string;
      type: string;
      createdAt: any;
      submissionId: string;
    }> | null;
  };
};

export type ChangeEventActiveEngagementMutationVariables = Exact<{
  eventId: Scalars['String']['input'];
  engagementId?: InputMaybe<Scalars['String']['input']>;
}>;

export type ChangeEventActiveEngagementMutation = {
  __typename?: 'Mutation';
  changeEventActiveEngagement: {
    __typename?: 'Event';
    id: string;
    name: string;
    date?: any | null;
    live: boolean;
    location?: string | null;
    locked: boolean;
    description?: string | null;
    createdAt: any;
    updatedAt: any;
    activeEngagementId?: string | null;
    screenCode?: string | null;
    themeConfig?: {
      __typename?: 'EventThemeConfig';
      headingFontFamily?: Array<string> | null;
      bodyFontFamily?: Array<string> | null;
      foregroundColor?: string | null;
      backgroundColor?: string | null;
      stageBackgroundImage?: string | null;
      fanBackgroundImage?: string | null;
      qrForegroundColor?: string | null;
      qrBackgroundColor?: string | null;
      qrTextColor?: string | null;
      qrWrapperBackgroundColor?: string | null;
      stageElements?: Array<{
        __typename?: 'ScreenElement';
        id: string;
        type: string;
        name?: string | null;
        imageUrl?: string | null;
        defaultStyles?: any | null;
        engagementStyles?: any | null;
        defaultClassNames?: string | null;
        engagementClassNames?: string | null;
        text?: string | null;
        textType?: string | null;
        fontFamily?: Array<string> | null;
        linkHref?: string | null;
        color?: string | null;
      }> | null;
      fanElements?: Array<{
        __typename?: 'ScreenElement';
        id: string;
        type: string;
        name?: string | null;
        imageUrl?: string | null;
        defaultStyles?: any | null;
        engagementStyles?: any | null;
        defaultClassNames?: string | null;
        engagementClassNames?: string | null;
        text?: string | null;
        textType?: string | null;
        fontFamily?: Array<string> | null;
        linkHref?: string | null;
        color?: string | null;
      }> | null;
    } | null;
    activeEngagement?: {
      __typename?: 'Engagement';
      id: string;
      eventId: string;
      createdAt: any;
      updatedAt: any;
      title: string;
      description?: string | null;
      qrCodeCta?: string | null;
      startTime?: any | null;
      order: number;
      endTime?: any | null;
      type: EngagementType;
      data?:
        | { __typename?: 'NowPlayingAdminData'; currentSong?: string | null }
        | {
            __typename?: 'PhotoCarouselAdminData';
            visibleSubmission?: string | null;
            rejectedQueue: Array<string>;
            unapprovedQueue: Array<string>;
            unseenQueue: Array<string>;
            seenQueuePointer: number;
            seenQueue: Array<string>;
          }
        | {
            __typename?: 'RaffleAdminData';
            raffleStatus: RaffleStatus;
            raffleCandidates: Array<string>;
            raffleWinners: Array<string>;
            raffleWinner?: string | null;
            winnerCount: number;
            remainingSubmissionIds: Array<string>;
            lastEliminatedSubmissionId?: string | null;
          }
        | {
            __typename?: 'SlidesAdminData';
            currentSlide: string;
            slidesDisplayOrder: Array<string>;
          }
        | {
            __typename?: 'TriviaAdminData';
            status: TriviaRoundStatus;
            questionIndex: number;
            playedThroughIndex: number;
            reviewing: boolean;
            questionEndsAt?: any | null;
            answeredCount: number;
            playerCount: number;
            correctChoiceId?: string | null;
            correctCount?: number | null;
            revealedQuestionIds: Array<string>;
            tallies: Array<{
              __typename?: 'TriviaTally';
              choiceId: string;
              count: number;
            }>;
            leaderboard: Array<{
              __typename?: 'TriviaLeaderboardRow';
              userId: string;
              name: string;
              score: number;
              rank: number;
              tied: boolean;
            }>;
          }
        | {
            __typename?: 'VoteForAdminData';
            startTime?: any | null;
            endTime?: any | null;
            voteWinners?: Array<string> | null;
            choiceDisplayOrder: Array<string>;
            votes: Array<{
              __typename?: 'VoteCount';
              submissionId: string;
              count: number;
            }>;
          }
        | null;
      config?:
        | {
            __typename?: 'NowPlayingAdminConfig';
            visualizationType: string;
            allowComments: boolean;
            allowedReactions: Array<string>;
          }
        | {
            __typename?: 'PhotoCarouselAdminConfig';
            maxSubmissionsPerUser: number;
            requireApproval: boolean;
            askSharePermission?: boolean | null;
            sharePrompt?: string | null;
            noPhotosMessage?: string | null;
            pollInterval?: number | null;
            predefinedCaptions?: Array<string> | null;
            maxVisiblePhotos: number;
          }
        | {
            __typename?: 'RaffleAdminConfig';
            optionalImageUrl?: string | null;
            claimYourPrize?: string | null;
            ticketFlipDirection: RaffleTicketFlipDirection;
          }
        | {
            __typename?: 'SlidesAdminConfig';
            autoPlay: boolean;
            autoPlayIntervalMs?: number | null;
          }
        | {
            __typename?: 'TriviaAdminConfig';
            instructions?: string | null;
            useQuestionTimer: boolean;
            defaultTimerMs: number;
            questions: Array<{
              __typename?: 'TriviaQuestion';
              id: string;
              text: string;
              correctChoiceId?: string | null;
              timerMs?: number | null;
              choices: Array<{
                __typename?: 'TriviaChoice';
                id: string;
                text: string;
              }>;
            }>;
          }
        | {
            __typename?: 'VoteForAdminConfig';
            votesPerUser: number;
            allowUserSubmissions: boolean;
            maxSubmissionsPerUser: number;
          }
        | null;
      viewConfig:
        | {
            __typename?: 'NowPlayingViewConfig';
            visualizationType: string;
            allowComments: boolean;
            allowedReactions: Array<string>;
          }
        | {
            __typename?: 'PhotoCarouselViewConfig';
            maxSubmissionsPerUser: number;
            askSharePermission?: boolean | null;
            sharePrompt?: string | null;
            noPhotosMessage?: string | null;
            maxVisiblePhotos: number;
          }
        | {
            __typename?: 'RaffleViewConfig';
            optionalImageUrl?: string | null;
            claimYourPrize?: string | null;
            ticketFlipDirection: RaffleTicketFlipDirection;
          }
        | {
            __typename?: 'SlidesViewConfig';
            autoPlay: boolean;
            autoPlayIntervalMs?: number | null;
          }
        | {
            __typename?: 'TriviaViewConfig';
            instructions?: string | null;
            useQuestionTimer: boolean;
            defaultTimerMs: number;
            questions: Array<{
              __typename?: 'TriviaViewQuestion';
              id: string;
              text: string;
              timerMs?: number | null;
              choices: Array<{
                __typename?: 'TriviaChoice';
                id: string;
                text: string;
              }>;
            }>;
          }
        | { __typename?: 'VoteForViewConfig'; votesPerUser: number };
      viewData:
        | { __typename?: 'NowPlayingViewData'; currentSong?: string | null }
        | {
            __typename?: 'PhotoCarouselViewData';
            visibleSubmission?: string | null;
          }
        | {
            __typename?: 'RaffleViewData';
            raffleStatus: RaffleStatus;
            raffleCandidates: Array<string>;
            raffleWinners: Array<string>;
            raffleWinner?: string | null;
            winnerCount: number;
            remainingSubmissionIds: Array<string>;
            lastEliminatedSubmissionId?: string | null;
          }
        | {
            __typename?: 'SlidesViewData';
            currentSlide: string;
            slidesDisplayOrder: Array<string>;
          }
        | {
            __typename?: 'TriviaViewData';
            status: TriviaRoundStatus;
            questionIndex: number;
            questionEndsAt?: any | null;
            answeredCount: number;
            playerCount: number;
            correctChoiceId?: string | null;
            correctCount?: number | null;
            leaderboardOverflow: number;
            tallies: Array<{
              __typename?: 'TriviaTally';
              choiceId: string;
              count: number;
            }>;
            leaderboard: Array<{
              __typename?: 'TriviaLeaderboardRow';
              userId: string;
              name: string;
              score: number;
              rank: number;
              tied: boolean;
            }>;
          }
        | {
            __typename?: 'VoteForViewData';
            voteWinners?: Array<string> | null;
            choiceDisplayOrder: Array<string>;
            votes: Array<{
              __typename?: 'VoteCount';
              submissionId: string;
              count: number;
            }>;
          };
    } | null;
    engagements: Array<{
      __typename?: 'Engagement';
      id: string;
      eventId: string;
      createdAt: any;
      updatedAt: any;
      title: string;
      description?: string | null;
      qrCodeCta?: string | null;
      startTime?: any | null;
      order: number;
      endTime?: any | null;
      type: EngagementType;
      data?:
        | { __typename?: 'NowPlayingAdminData'; currentSong?: string | null }
        | {
            __typename?: 'PhotoCarouselAdminData';
            visibleSubmission?: string | null;
            rejectedQueue: Array<string>;
            unapprovedQueue: Array<string>;
            unseenQueue: Array<string>;
            seenQueuePointer: number;
            seenQueue: Array<string>;
          }
        | {
            __typename?: 'RaffleAdminData';
            raffleStatus: RaffleStatus;
            raffleCandidates: Array<string>;
            raffleWinners: Array<string>;
            raffleWinner?: string | null;
            winnerCount: number;
            remainingSubmissionIds: Array<string>;
            lastEliminatedSubmissionId?: string | null;
          }
        | {
            __typename?: 'SlidesAdminData';
            currentSlide: string;
            slidesDisplayOrder: Array<string>;
          }
        | {
            __typename?: 'TriviaAdminData';
            status: TriviaRoundStatus;
            questionIndex: number;
            playedThroughIndex: number;
            reviewing: boolean;
            questionEndsAt?: any | null;
            answeredCount: number;
            playerCount: number;
            correctChoiceId?: string | null;
            correctCount?: number | null;
            revealedQuestionIds: Array<string>;
            tallies: Array<{
              __typename?: 'TriviaTally';
              choiceId: string;
              count: number;
            }>;
            leaderboard: Array<{
              __typename?: 'TriviaLeaderboardRow';
              userId: string;
              name: string;
              score: number;
              rank: number;
              tied: boolean;
            }>;
          }
        | {
            __typename?: 'VoteForAdminData';
            startTime?: any | null;
            endTime?: any | null;
            voteWinners?: Array<string> | null;
            choiceDisplayOrder: Array<string>;
            votes: Array<{
              __typename?: 'VoteCount';
              submissionId: string;
              count: number;
            }>;
          }
        | null;
      config?:
        | {
            __typename?: 'NowPlayingAdminConfig';
            visualizationType: string;
            allowComments: boolean;
            allowedReactions: Array<string>;
          }
        | {
            __typename?: 'PhotoCarouselAdminConfig';
            maxSubmissionsPerUser: number;
            requireApproval: boolean;
            askSharePermission?: boolean | null;
            sharePrompt?: string | null;
            noPhotosMessage?: string | null;
            pollInterval?: number | null;
            predefinedCaptions?: Array<string> | null;
            maxVisiblePhotos: number;
          }
        | {
            __typename?: 'RaffleAdminConfig';
            optionalImageUrl?: string | null;
            claimYourPrize?: string | null;
            ticketFlipDirection: RaffleTicketFlipDirection;
          }
        | {
            __typename?: 'SlidesAdminConfig';
            autoPlay: boolean;
            autoPlayIntervalMs?: number | null;
          }
        | {
            __typename?: 'TriviaAdminConfig';
            instructions?: string | null;
            useQuestionTimer: boolean;
            defaultTimerMs: number;
            questions: Array<{
              __typename?: 'TriviaQuestion';
              id: string;
              text: string;
              correctChoiceId?: string | null;
              timerMs?: number | null;
              choices: Array<{
                __typename?: 'TriviaChoice';
                id: string;
                text: string;
              }>;
            }>;
          }
        | {
            __typename?: 'VoteForAdminConfig';
            votesPerUser: number;
            allowUserSubmissions: boolean;
            maxSubmissionsPerUser: number;
          }
        | null;
      viewConfig:
        | {
            __typename?: 'NowPlayingViewConfig';
            visualizationType: string;
            allowComments: boolean;
            allowedReactions: Array<string>;
          }
        | {
            __typename?: 'PhotoCarouselViewConfig';
            maxSubmissionsPerUser: number;
            askSharePermission?: boolean | null;
            sharePrompt?: string | null;
            noPhotosMessage?: string | null;
            maxVisiblePhotos: number;
          }
        | {
            __typename?: 'RaffleViewConfig';
            optionalImageUrl?: string | null;
            claimYourPrize?: string | null;
            ticketFlipDirection: RaffleTicketFlipDirection;
          }
        | {
            __typename?: 'SlidesViewConfig';
            autoPlay: boolean;
            autoPlayIntervalMs?: number | null;
          }
        | {
            __typename?: 'TriviaViewConfig';
            instructions?: string | null;
            useQuestionTimer: boolean;
            defaultTimerMs: number;
            questions: Array<{
              __typename?: 'TriviaViewQuestion';
              id: string;
              text: string;
              timerMs?: number | null;
              choices: Array<{
                __typename?: 'TriviaChoice';
                id: string;
                text: string;
              }>;
            }>;
          }
        | { __typename?: 'VoteForViewConfig'; votesPerUser: number };
      viewData:
        | { __typename?: 'NowPlayingViewData'; currentSong?: string | null }
        | {
            __typename?: 'PhotoCarouselViewData';
            visibleSubmission?: string | null;
          }
        | {
            __typename?: 'RaffleViewData';
            raffleStatus: RaffleStatus;
            raffleCandidates: Array<string>;
            raffleWinners: Array<string>;
            raffleWinner?: string | null;
            winnerCount: number;
            remainingSubmissionIds: Array<string>;
            lastEliminatedSubmissionId?: string | null;
          }
        | {
            __typename?: 'SlidesViewData';
            currentSlide: string;
            slidesDisplayOrder: Array<string>;
          }
        | {
            __typename?: 'TriviaViewData';
            status: TriviaRoundStatus;
            questionIndex: number;
            questionEndsAt?: any | null;
            answeredCount: number;
            playerCount: number;
            correctChoiceId?: string | null;
            correctCount?: number | null;
            leaderboardOverflow: number;
            tallies: Array<{
              __typename?: 'TriviaTally';
              choiceId: string;
              count: number;
            }>;
            leaderboard: Array<{
              __typename?: 'TriviaLeaderboardRow';
              userId: string;
              name: string;
              score: number;
              rank: number;
              tied: boolean;
            }>;
          }
        | {
            __typename?: 'VoteForViewData';
            voteWinners?: Array<string> | null;
            choiceDisplayOrder: Array<string>;
            votes: Array<{
              __typename?: 'VoteCount';
              submissionId: string;
              count: number;
            }>;
          };
    }>;
    subscriptionInUse?: {
      __typename?: 'PaymentSubscription';
      id: string;
      userId: string;
      status: PaymentSubscriptionStatus;
      stripeSubscriptionId: string;
      currentPeriodStart?: any | null;
      currentPeriodEnd?: any | null;
      cancelAtPeriodEnd: boolean;
      canceledAt?: any | null;
      trialStart?: any | null;
      trialEnd?: any | null;
      maxConcurrentEvents: number;
      createdAt: any;
      updatedAt: any;
      liveEvents: Array<{ __typename?: 'Event'; id: string; name: string }>;
    } | null;
    eventPassRedemptionInUse?: {
      __typename?: 'EventPassRedemption';
      id: string;
      eventPassId: string;
      eventId: string;
      redeemedAt: any;
      description?: string | null;
      expiresAt?: any | null;
    } | null;
  };
};

export type UpdateEventThemeConfigMutationVariables = Exact<{
  eventId: Scalars['String']['input'];
  data: EventThemeConfigUpdateInput;
}>;

export type UpdateEventThemeConfigMutation = {
  __typename?: 'Mutation';
  updateEventThemeConfig: {
    __typename?: 'EventThemeConfig';
    headingFontFamily?: Array<string> | null;
    bodyFontFamily?: Array<string> | null;
    foregroundColor?: string | null;
    backgroundColor?: string | null;
    stageBackgroundImage?: string | null;
    fanBackgroundImage?: string | null;
    qrForegroundColor?: string | null;
    qrBackgroundColor?: string | null;
    qrTextColor?: string | null;
    qrWrapperBackgroundColor?: string | null;
    stageElements?: Array<{
      __typename?: 'ScreenElement';
      id: string;
      type: string;
      name?: string | null;
      imageUrl?: string | null;
      defaultStyles?: any | null;
      engagementStyles?: any | null;
      defaultClassNames?: string | null;
      engagementClassNames?: string | null;
      text?: string | null;
      textType?: string | null;
      fontFamily?: Array<string> | null;
      linkHref?: string | null;
      color?: string | null;
    }> | null;
    fanElements?: Array<{
      __typename?: 'ScreenElement';
      id: string;
      type: string;
      name?: string | null;
      imageUrl?: string | null;
      defaultStyles?: any | null;
      engagementStyles?: any | null;
      defaultClassNames?: string | null;
      engagementClassNames?: string | null;
      text?: string | null;
      textType?: string | null;
      fontFamily?: Array<string> | null;
      linkHref?: string | null;
      color?: string | null;
    }> | null;
  };
};

export type CreatePresignedUrlMutationVariables = Exact<{
  mimeType: Scalars['String']['input'];
}>;

export type CreatePresignedUrlMutation = {
  __typename?: 'Mutation';
  createPresignedUrl: {
    __typename?: 'PresignedUrlResponse';
    url: string;
    key: string;
  };
};

export type DeleteEventMutationVariables = Exact<{
  eventId: Scalars['String']['input'];
}>;

export type DeleteEventMutation = {
  __typename?: 'Mutation';
  deleteEvent: { __typename?: 'Event'; id: string };
};

export type UpdateEventMutationVariables = Exact<{
  eventId: Scalars['String']['input'];
  data: UpdateEventInput;
}>;

export type UpdateEventMutation = {
  __typename?: 'Mutation';
  updateEvent: {
    __typename?: 'Event';
    id: string;
    name: string;
    date?: any | null;
    live: boolean;
    location?: string | null;
    locked: boolean;
    description?: string | null;
    createdAt: any;
    updatedAt: any;
    activeEngagementId?: string | null;
    screenCode?: string | null;
    themeConfig?: {
      __typename?: 'EventThemeConfig';
      headingFontFamily?: Array<string> | null;
      bodyFontFamily?: Array<string> | null;
      foregroundColor?: string | null;
      backgroundColor?: string | null;
      stageBackgroundImage?: string | null;
      fanBackgroundImage?: string | null;
      qrForegroundColor?: string | null;
      qrBackgroundColor?: string | null;
      qrTextColor?: string | null;
      qrWrapperBackgroundColor?: string | null;
      stageElements?: Array<{
        __typename?: 'ScreenElement';
        id: string;
        type: string;
        name?: string | null;
        imageUrl?: string | null;
        defaultStyles?: any | null;
        engagementStyles?: any | null;
        defaultClassNames?: string | null;
        engagementClassNames?: string | null;
        text?: string | null;
        textType?: string | null;
        fontFamily?: Array<string> | null;
        linkHref?: string | null;
        color?: string | null;
      }> | null;
      fanElements?: Array<{
        __typename?: 'ScreenElement';
        id: string;
        type: string;
        name?: string | null;
        imageUrl?: string | null;
        defaultStyles?: any | null;
        engagementStyles?: any | null;
        defaultClassNames?: string | null;
        engagementClassNames?: string | null;
        text?: string | null;
        textType?: string | null;
        fontFamily?: Array<string> | null;
        linkHref?: string | null;
        color?: string | null;
      }> | null;
    } | null;
    activeEngagement?: {
      __typename?: 'Engagement';
      id: string;
      eventId: string;
      createdAt: any;
      updatedAt: any;
      title: string;
      description?: string | null;
      qrCodeCta?: string | null;
      startTime?: any | null;
      order: number;
      endTime?: any | null;
      type: EngagementType;
      data?:
        | { __typename?: 'NowPlayingAdminData'; currentSong?: string | null }
        | {
            __typename?: 'PhotoCarouselAdminData';
            visibleSubmission?: string | null;
            rejectedQueue: Array<string>;
            unapprovedQueue: Array<string>;
            unseenQueue: Array<string>;
            seenQueuePointer: number;
            seenQueue: Array<string>;
          }
        | {
            __typename?: 'RaffleAdminData';
            raffleStatus: RaffleStatus;
            raffleCandidates: Array<string>;
            raffleWinners: Array<string>;
            raffleWinner?: string | null;
            winnerCount: number;
            remainingSubmissionIds: Array<string>;
            lastEliminatedSubmissionId?: string | null;
          }
        | {
            __typename?: 'SlidesAdminData';
            currentSlide: string;
            slidesDisplayOrder: Array<string>;
          }
        | {
            __typename?: 'TriviaAdminData';
            status: TriviaRoundStatus;
            questionIndex: number;
            playedThroughIndex: number;
            reviewing: boolean;
            questionEndsAt?: any | null;
            answeredCount: number;
            playerCount: number;
            correctChoiceId?: string | null;
            correctCount?: number | null;
            revealedQuestionIds: Array<string>;
            tallies: Array<{
              __typename?: 'TriviaTally';
              choiceId: string;
              count: number;
            }>;
            leaderboard: Array<{
              __typename?: 'TriviaLeaderboardRow';
              userId: string;
              name: string;
              score: number;
              rank: number;
              tied: boolean;
            }>;
          }
        | {
            __typename?: 'VoteForAdminData';
            startTime?: any | null;
            endTime?: any | null;
            voteWinners?: Array<string> | null;
            choiceDisplayOrder: Array<string>;
            votes: Array<{
              __typename?: 'VoteCount';
              submissionId: string;
              count: number;
            }>;
          }
        | null;
      config?:
        | {
            __typename?: 'NowPlayingAdminConfig';
            visualizationType: string;
            allowComments: boolean;
            allowedReactions: Array<string>;
          }
        | {
            __typename?: 'PhotoCarouselAdminConfig';
            maxSubmissionsPerUser: number;
            requireApproval: boolean;
            askSharePermission?: boolean | null;
            sharePrompt?: string | null;
            noPhotosMessage?: string | null;
            pollInterval?: number | null;
            predefinedCaptions?: Array<string> | null;
            maxVisiblePhotos: number;
          }
        | {
            __typename?: 'RaffleAdminConfig';
            optionalImageUrl?: string | null;
            claimYourPrize?: string | null;
            ticketFlipDirection: RaffleTicketFlipDirection;
          }
        | {
            __typename?: 'SlidesAdminConfig';
            autoPlay: boolean;
            autoPlayIntervalMs?: number | null;
          }
        | {
            __typename?: 'TriviaAdminConfig';
            instructions?: string | null;
            useQuestionTimer: boolean;
            defaultTimerMs: number;
            questions: Array<{
              __typename?: 'TriviaQuestion';
              id: string;
              text: string;
              correctChoiceId?: string | null;
              timerMs?: number | null;
              choices: Array<{
                __typename?: 'TriviaChoice';
                id: string;
                text: string;
              }>;
            }>;
          }
        | {
            __typename?: 'VoteForAdminConfig';
            votesPerUser: number;
            allowUserSubmissions: boolean;
            maxSubmissionsPerUser: number;
          }
        | null;
      viewConfig:
        | {
            __typename?: 'NowPlayingViewConfig';
            visualizationType: string;
            allowComments: boolean;
            allowedReactions: Array<string>;
          }
        | {
            __typename?: 'PhotoCarouselViewConfig';
            maxSubmissionsPerUser: number;
            askSharePermission?: boolean | null;
            sharePrompt?: string | null;
            noPhotosMessage?: string | null;
            maxVisiblePhotos: number;
          }
        | {
            __typename?: 'RaffleViewConfig';
            optionalImageUrl?: string | null;
            claimYourPrize?: string | null;
            ticketFlipDirection: RaffleTicketFlipDirection;
          }
        | {
            __typename?: 'SlidesViewConfig';
            autoPlay: boolean;
            autoPlayIntervalMs?: number | null;
          }
        | {
            __typename?: 'TriviaViewConfig';
            instructions?: string | null;
            useQuestionTimer: boolean;
            defaultTimerMs: number;
            questions: Array<{
              __typename?: 'TriviaViewQuestion';
              id: string;
              text: string;
              timerMs?: number | null;
              choices: Array<{
                __typename?: 'TriviaChoice';
                id: string;
                text: string;
              }>;
            }>;
          }
        | { __typename?: 'VoteForViewConfig'; votesPerUser: number };
      viewData:
        | { __typename?: 'NowPlayingViewData'; currentSong?: string | null }
        | {
            __typename?: 'PhotoCarouselViewData';
            visibleSubmission?: string | null;
          }
        | {
            __typename?: 'RaffleViewData';
            raffleStatus: RaffleStatus;
            raffleCandidates: Array<string>;
            raffleWinners: Array<string>;
            raffleWinner?: string | null;
            winnerCount: number;
            remainingSubmissionIds: Array<string>;
            lastEliminatedSubmissionId?: string | null;
          }
        | {
            __typename?: 'SlidesViewData';
            currentSlide: string;
            slidesDisplayOrder: Array<string>;
          }
        | {
            __typename?: 'TriviaViewData';
            status: TriviaRoundStatus;
            questionIndex: number;
            questionEndsAt?: any | null;
            answeredCount: number;
            playerCount: number;
            correctChoiceId?: string | null;
            correctCount?: number | null;
            leaderboardOverflow: number;
            tallies: Array<{
              __typename?: 'TriviaTally';
              choiceId: string;
              count: number;
            }>;
            leaderboard: Array<{
              __typename?: 'TriviaLeaderboardRow';
              userId: string;
              name: string;
              score: number;
              rank: number;
              tied: boolean;
            }>;
          }
        | {
            __typename?: 'VoteForViewData';
            voteWinners?: Array<string> | null;
            choiceDisplayOrder: Array<string>;
            votes: Array<{
              __typename?: 'VoteCount';
              submissionId: string;
              count: number;
            }>;
          };
    } | null;
    engagements: Array<{
      __typename?: 'Engagement';
      id: string;
      eventId: string;
      createdAt: any;
      updatedAt: any;
      title: string;
      description?: string | null;
      qrCodeCta?: string | null;
      startTime?: any | null;
      order: number;
      endTime?: any | null;
      type: EngagementType;
      data?:
        | { __typename?: 'NowPlayingAdminData'; currentSong?: string | null }
        | {
            __typename?: 'PhotoCarouselAdminData';
            visibleSubmission?: string | null;
            rejectedQueue: Array<string>;
            unapprovedQueue: Array<string>;
            unseenQueue: Array<string>;
            seenQueuePointer: number;
            seenQueue: Array<string>;
          }
        | {
            __typename?: 'RaffleAdminData';
            raffleStatus: RaffleStatus;
            raffleCandidates: Array<string>;
            raffleWinners: Array<string>;
            raffleWinner?: string | null;
            winnerCount: number;
            remainingSubmissionIds: Array<string>;
            lastEliminatedSubmissionId?: string | null;
          }
        | {
            __typename?: 'SlidesAdminData';
            currentSlide: string;
            slidesDisplayOrder: Array<string>;
          }
        | {
            __typename?: 'TriviaAdminData';
            status: TriviaRoundStatus;
            questionIndex: number;
            playedThroughIndex: number;
            reviewing: boolean;
            questionEndsAt?: any | null;
            answeredCount: number;
            playerCount: number;
            correctChoiceId?: string | null;
            correctCount?: number | null;
            revealedQuestionIds: Array<string>;
            tallies: Array<{
              __typename?: 'TriviaTally';
              choiceId: string;
              count: number;
            }>;
            leaderboard: Array<{
              __typename?: 'TriviaLeaderboardRow';
              userId: string;
              name: string;
              score: number;
              rank: number;
              tied: boolean;
            }>;
          }
        | {
            __typename?: 'VoteForAdminData';
            startTime?: any | null;
            endTime?: any | null;
            voteWinners?: Array<string> | null;
            choiceDisplayOrder: Array<string>;
            votes: Array<{
              __typename?: 'VoteCount';
              submissionId: string;
              count: number;
            }>;
          }
        | null;
      config?:
        | {
            __typename?: 'NowPlayingAdminConfig';
            visualizationType: string;
            allowComments: boolean;
            allowedReactions: Array<string>;
          }
        | {
            __typename?: 'PhotoCarouselAdminConfig';
            maxSubmissionsPerUser: number;
            requireApproval: boolean;
            askSharePermission?: boolean | null;
            sharePrompt?: string | null;
            noPhotosMessage?: string | null;
            pollInterval?: number | null;
            predefinedCaptions?: Array<string> | null;
            maxVisiblePhotos: number;
          }
        | {
            __typename?: 'RaffleAdminConfig';
            optionalImageUrl?: string | null;
            claimYourPrize?: string | null;
            ticketFlipDirection: RaffleTicketFlipDirection;
          }
        | {
            __typename?: 'SlidesAdminConfig';
            autoPlay: boolean;
            autoPlayIntervalMs?: number | null;
          }
        | {
            __typename?: 'TriviaAdminConfig';
            instructions?: string | null;
            useQuestionTimer: boolean;
            defaultTimerMs: number;
            questions: Array<{
              __typename?: 'TriviaQuestion';
              id: string;
              text: string;
              correctChoiceId?: string | null;
              timerMs?: number | null;
              choices: Array<{
                __typename?: 'TriviaChoice';
                id: string;
                text: string;
              }>;
            }>;
          }
        | {
            __typename?: 'VoteForAdminConfig';
            votesPerUser: number;
            allowUserSubmissions: boolean;
            maxSubmissionsPerUser: number;
          }
        | null;
      viewConfig:
        | {
            __typename?: 'NowPlayingViewConfig';
            visualizationType: string;
            allowComments: boolean;
            allowedReactions: Array<string>;
          }
        | {
            __typename?: 'PhotoCarouselViewConfig';
            maxSubmissionsPerUser: number;
            askSharePermission?: boolean | null;
            sharePrompt?: string | null;
            noPhotosMessage?: string | null;
            maxVisiblePhotos: number;
          }
        | {
            __typename?: 'RaffleViewConfig';
            optionalImageUrl?: string | null;
            claimYourPrize?: string | null;
            ticketFlipDirection: RaffleTicketFlipDirection;
          }
        | {
            __typename?: 'SlidesViewConfig';
            autoPlay: boolean;
            autoPlayIntervalMs?: number | null;
          }
        | {
            __typename?: 'TriviaViewConfig';
            instructions?: string | null;
            useQuestionTimer: boolean;
            defaultTimerMs: number;
            questions: Array<{
              __typename?: 'TriviaViewQuestion';
              id: string;
              text: string;
              timerMs?: number | null;
              choices: Array<{
                __typename?: 'TriviaChoice';
                id: string;
                text: string;
              }>;
            }>;
          }
        | { __typename?: 'VoteForViewConfig'; votesPerUser: number };
      viewData:
        | { __typename?: 'NowPlayingViewData'; currentSong?: string | null }
        | {
            __typename?: 'PhotoCarouselViewData';
            visibleSubmission?: string | null;
          }
        | {
            __typename?: 'RaffleViewData';
            raffleStatus: RaffleStatus;
            raffleCandidates: Array<string>;
            raffleWinners: Array<string>;
            raffleWinner?: string | null;
            winnerCount: number;
            remainingSubmissionIds: Array<string>;
            lastEliminatedSubmissionId?: string | null;
          }
        | {
            __typename?: 'SlidesViewData';
            currentSlide: string;
            slidesDisplayOrder: Array<string>;
          }
        | {
            __typename?: 'TriviaViewData';
            status: TriviaRoundStatus;
            questionIndex: number;
            questionEndsAt?: any | null;
            answeredCount: number;
            playerCount: number;
            correctChoiceId?: string | null;
            correctCount?: number | null;
            leaderboardOverflow: number;
            tallies: Array<{
              __typename?: 'TriviaTally';
              choiceId: string;
              count: number;
            }>;
            leaderboard: Array<{
              __typename?: 'TriviaLeaderboardRow';
              userId: string;
              name: string;
              score: number;
              rank: number;
              tied: boolean;
            }>;
          }
        | {
            __typename?: 'VoteForViewData';
            voteWinners?: Array<string> | null;
            choiceDisplayOrder: Array<string>;
            votes: Array<{
              __typename?: 'VoteCount';
              submissionId: string;
              count: number;
            }>;
          };
    }>;
    subscriptionInUse?: {
      __typename?: 'PaymentSubscription';
      id: string;
      userId: string;
      status: PaymentSubscriptionStatus;
      stripeSubscriptionId: string;
      currentPeriodStart?: any | null;
      currentPeriodEnd?: any | null;
      cancelAtPeriodEnd: boolean;
      canceledAt?: any | null;
      trialStart?: any | null;
      trialEnd?: any | null;
      maxConcurrentEvents: number;
      createdAt: any;
      updatedAt: any;
      liveEvents: Array<{ __typename?: 'Event'; id: string; name: string }>;
    } | null;
    eventPassRedemptionInUse?: {
      __typename?: 'EventPassRedemption';
      id: string;
      eventPassId: string;
      eventId: string;
      redeemedAt: any;
      description?: string | null;
      expiresAt?: any | null;
    } | null;
  };
};

export type MoveEngagementMutationVariables = Exact<{
  engagementId: Scalars['String']['input'];
  direction: Scalars['String']['input'];
}>;

export type MoveEngagementMutation = {
  __typename?: 'Mutation';
  moveEngagement: Array<{
    __typename?: 'Engagement';
    id: string;
    eventId: string;
    createdAt: any;
    updatedAt: any;
    title: string;
    description?: string | null;
    qrCodeCta?: string | null;
    startTime?: any | null;
    order: number;
    endTime?: any | null;
    type: EngagementType;
    data?:
      | { __typename?: 'NowPlayingAdminData'; currentSong?: string | null }
      | {
          __typename?: 'PhotoCarouselAdminData';
          visibleSubmission?: string | null;
          rejectedQueue: Array<string>;
          unapprovedQueue: Array<string>;
          unseenQueue: Array<string>;
          seenQueuePointer: number;
          seenQueue: Array<string>;
        }
      | {
          __typename?: 'RaffleAdminData';
          raffleStatus: RaffleStatus;
          raffleCandidates: Array<string>;
          raffleWinners: Array<string>;
          raffleWinner?: string | null;
          winnerCount: number;
          remainingSubmissionIds: Array<string>;
          lastEliminatedSubmissionId?: string | null;
        }
      | {
          __typename?: 'SlidesAdminData';
          currentSlide: string;
          slidesDisplayOrder: Array<string>;
        }
      | {
          __typename?: 'TriviaAdminData';
          status: TriviaRoundStatus;
          questionIndex: number;
          playedThroughIndex: number;
          reviewing: boolean;
          questionEndsAt?: any | null;
          answeredCount: number;
          playerCount: number;
          correctChoiceId?: string | null;
          correctCount?: number | null;
          revealedQuestionIds: Array<string>;
          tallies: Array<{
            __typename?: 'TriviaTally';
            choiceId: string;
            count: number;
          }>;
          leaderboard: Array<{
            __typename?: 'TriviaLeaderboardRow';
            userId: string;
            name: string;
            score: number;
            rank: number;
            tied: boolean;
          }>;
        }
      | {
          __typename?: 'VoteForAdminData';
          startTime?: any | null;
          endTime?: any | null;
          voteWinners?: Array<string> | null;
          choiceDisplayOrder: Array<string>;
          votes: Array<{
            __typename?: 'VoteCount';
            submissionId: string;
            count: number;
          }>;
        }
      | null;
    config?:
      | {
          __typename?: 'NowPlayingAdminConfig';
          visualizationType: string;
          allowComments: boolean;
          allowedReactions: Array<string>;
        }
      | {
          __typename?: 'PhotoCarouselAdminConfig';
          maxSubmissionsPerUser: number;
          requireApproval: boolean;
          askSharePermission?: boolean | null;
          sharePrompt?: string | null;
          noPhotosMessage?: string | null;
          pollInterval?: number | null;
          predefinedCaptions?: Array<string> | null;
          maxVisiblePhotos: number;
        }
      | {
          __typename?: 'RaffleAdminConfig';
          optionalImageUrl?: string | null;
          claimYourPrize?: string | null;
          ticketFlipDirection: RaffleTicketFlipDirection;
        }
      | {
          __typename?: 'SlidesAdminConfig';
          autoPlay: boolean;
          autoPlayIntervalMs?: number | null;
        }
      | {
          __typename?: 'TriviaAdminConfig';
          instructions?: string | null;
          useQuestionTimer: boolean;
          defaultTimerMs: number;
          questions: Array<{
            __typename?: 'TriviaQuestion';
            id: string;
            text: string;
            correctChoiceId?: string | null;
            timerMs?: number | null;
            choices: Array<{
              __typename?: 'TriviaChoice';
              id: string;
              text: string;
            }>;
          }>;
        }
      | {
          __typename?: 'VoteForAdminConfig';
          votesPerUser: number;
          allowUserSubmissions: boolean;
          maxSubmissionsPerUser: number;
        }
      | null;
    viewConfig:
      | {
          __typename?: 'NowPlayingViewConfig';
          visualizationType: string;
          allowComments: boolean;
          allowedReactions: Array<string>;
        }
      | {
          __typename?: 'PhotoCarouselViewConfig';
          maxSubmissionsPerUser: number;
          askSharePermission?: boolean | null;
          sharePrompt?: string | null;
          noPhotosMessage?: string | null;
          maxVisiblePhotos: number;
        }
      | {
          __typename?: 'RaffleViewConfig';
          optionalImageUrl?: string | null;
          claimYourPrize?: string | null;
          ticketFlipDirection: RaffleTicketFlipDirection;
        }
      | {
          __typename?: 'SlidesViewConfig';
          autoPlay: boolean;
          autoPlayIntervalMs?: number | null;
        }
      | {
          __typename?: 'TriviaViewConfig';
          instructions?: string | null;
          useQuestionTimer: boolean;
          defaultTimerMs: number;
          questions: Array<{
            __typename?: 'TriviaViewQuestion';
            id: string;
            text: string;
            timerMs?: number | null;
            choices: Array<{
              __typename?: 'TriviaChoice';
              id: string;
              text: string;
            }>;
          }>;
        }
      | { __typename?: 'VoteForViewConfig'; votesPerUser: number };
    viewData:
      | { __typename?: 'NowPlayingViewData'; currentSong?: string | null }
      | {
          __typename?: 'PhotoCarouselViewData';
          visibleSubmission?: string | null;
        }
      | {
          __typename?: 'RaffleViewData';
          raffleStatus: RaffleStatus;
          raffleCandidates: Array<string>;
          raffleWinners: Array<string>;
          raffleWinner?: string | null;
          winnerCount: number;
          remainingSubmissionIds: Array<string>;
          lastEliminatedSubmissionId?: string | null;
        }
      | {
          __typename?: 'SlidesViewData';
          currentSlide: string;
          slidesDisplayOrder: Array<string>;
        }
      | {
          __typename?: 'TriviaViewData';
          status: TriviaRoundStatus;
          questionIndex: number;
          questionEndsAt?: any | null;
          answeredCount: number;
          playerCount: number;
          correctChoiceId?: string | null;
          correctCount?: number | null;
          leaderboardOverflow: number;
          tallies: Array<{
            __typename?: 'TriviaTally';
            choiceId: string;
            count: number;
          }>;
          leaderboard: Array<{
            __typename?: 'TriviaLeaderboardRow';
            userId: string;
            name: string;
            score: number;
            rank: number;
            tied: boolean;
          }>;
        }
      | {
          __typename?: 'VoteForViewData';
          voteWinners?: Array<string> | null;
          choiceDisplayOrder: Array<string>;
          votes: Array<{
            __typename?: 'VoteCount';
            submissionId: string;
            count: number;
          }>;
        };
  }>;
};

export type GenerateImageMutationVariables = Exact<{
  data: GenerateImageInput;
}>;

export type GenerateImageMutation = {
  __typename?: 'Mutation';
  generateImage: { __typename?: 'GenerateImageResponse'; uri?: string | null };
};

export type UpdateSubmissionMutationVariables = Exact<{
  submissionId: Scalars['String']['input'];
  data: Scalars['Json']['input'];
}>;

export type UpdateSubmissionMutation = {
  __typename?: 'Mutation';
  updateSubmission: {
    __typename?: 'Submission';
    id: string;
    engagementId: string;
    createdAt: any;
    userId?: string | null;
    hidden: boolean;
    possibleBannedDevice: boolean;
    matchedBanCreatedAt?: any | null;
    data:
      | {
          __typename?: 'NowPlayingSubmissionData';
          order: number;
          songAlbumArt?: string | null;
          songTitle?: string | null;
          songArtist?: string | null;
          songNotes?: string | null;
          songLyrics?: string | null;
          visualizationType?: string | null;
          spotifyUrl?: string | null;
        }
      | {
          __typename?: 'PhotoCarouselSubmissionData';
          photoUrl?: string | null;
          caption?: string | null;
          approved?: boolean | null;
          sharingPermissionGranted?: boolean | null;
        }
      | {
          __typename?: 'RaffleSubmissionData';
          name: string;
          optionalImageUrl?: string | null;
        }
      | {
          __typename?: 'SlidesSubmissionData';
          optionalImageUrl?: string | null;
          title: string;
          content: string;
          slideDuration?: number | null;
          imageTilt?: SlideImageTilt | null;
          layout?: SlideLayout | null;
          showQr?: boolean | null;
          background?: {
            __typename?: 'SlideBackground';
            type: SlideBackgroundType;
            color?: string | null;
            imageUrl?: string | null;
          } | null;
          elements?: Array<{
            __typename?: 'SlideElement';
            id: string;
            type: SlideElementType;
            name?: string | null;
            locked?: boolean | null;
            text?: string | null;
            textType?: string | null;
            fontFamily?: Array<string> | null;
            color?: string | null;
            fontSize?: number | null;
            fontWeight?: SlideFontWeight | null;
            textAlign?: SlideTextAlign | null;
            verticalAlign?: SlideVerticalAlign | null;
            imageUrl?: string | null;
            fit?: SlideImageFit | null;
            box?: {
              __typename?: 'SlideBox';
              x: number;
              y: number;
              w: number;
              h: number;
            } | null;
          }> | null;
        }
      | {
          __typename?: 'TriviaSubmissionData';
          questionId?: string | null;
          choiceId?: string | null;
        }
      | {
          __typename?: 'VoteForSubmissionData';
          title: string;
          color: string;
          description: string;
          optionalImageUrl?: string | null;
        };
    user?: { __typename?: 'User'; id: string; name?: string | null } | null;
    reactions?: Array<{
      __typename?: 'Reaction';
      id: string;
      type: string;
      createdAt: any;
    }> | null;
  };
};

export type CreateReactionMutationVariables = Exact<{
  submissionId: Scalars['String']['input'];
  type: Scalars['String']['input'];
  deviceId?: InputMaybe<Scalars['String']['input']>;
  visitorId?: InputMaybe<Scalars['String']['input']>;
}>;

export type CreateReactionMutation = {
  __typename?: 'Mutation';
  createReaction: {
    __typename?: 'Reaction';
    id: string;
    type: string;
    createdAt: any;
    submissionId: string;
  };
};

export type BanUserMutationVariables = Exact<{
  submissionId: Scalars['String']['input'];
  hideExisting: Scalars['Boolean']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
}>;

export type BanUserMutation = {
  __typename?: 'Mutation';
  banUser: {
    __typename?: 'BanPayload';
    hiddenCount: number;
    ban: {
      __typename?: 'Ban';
      id: string;
      userId: string;
      reason?: string | null;
      createdAt: any;
      hiddenCount: number;
      sourceEventId?: string | null;
      sourceEngagementId?: string | null;
      sourceSubmissionId?: string | null;
      sourcePhotoUrl?: string | null;
      user: { __typename?: 'User'; id: string; name?: string | null };
      sourceEvent?: { __typename?: 'Event'; id: string; name: string } | null;
      sourceEngagement?: {
        __typename?: 'Engagement';
        id: string;
        title: string;
      } | null;
    };
  };
};

export type UnbanUserMutationVariables = Exact<{
  banId: Scalars['String']['input'];
  eventId: Scalars['String']['input'];
}>;

export type UnbanUserMutation = {
  __typename?: 'Mutation';
  unbanUser: {
    __typename?: 'UnbanPayload';
    banId: string;
    restoredCount: number;
  };
};

export type DeleteReactionMutationVariables = Exact<{
  reactionId: Scalars['String']['input'];
}>;

export type DeleteReactionMutation = {
  __typename?: 'Mutation';
  deleteReaction: {
    __typename?: 'Reaction';
    id: string;
    type: string;
    createdAt: any;
    submissionId: string;
  };
};

export type CreateEngagementMutationVariables = Exact<{
  eventId: Scalars['String']['input'];
  data: CreateEngagementInput;
}>;

export type CreateEngagementMutation = {
  __typename?: 'Mutation';
  createEngagement: {
    __typename?: 'Engagement';
    id: string;
    eventId: string;
    createdAt: any;
    updatedAt: any;
    title: string;
    description?: string | null;
    qrCodeCta?: string | null;
    startTime?: any | null;
    order: number;
    endTime?: any | null;
    type: EngagementType;
    data?:
      | { __typename?: 'NowPlayingAdminData'; currentSong?: string | null }
      | {
          __typename?: 'PhotoCarouselAdminData';
          visibleSubmission?: string | null;
          rejectedQueue: Array<string>;
          unapprovedQueue: Array<string>;
          unseenQueue: Array<string>;
          seenQueuePointer: number;
          seenQueue: Array<string>;
        }
      | {
          __typename?: 'RaffleAdminData';
          raffleStatus: RaffleStatus;
          raffleCandidates: Array<string>;
          raffleWinners: Array<string>;
          raffleWinner?: string | null;
          winnerCount: number;
          remainingSubmissionIds: Array<string>;
          lastEliminatedSubmissionId?: string | null;
        }
      | {
          __typename?: 'SlidesAdminData';
          currentSlide: string;
          slidesDisplayOrder: Array<string>;
        }
      | {
          __typename?: 'TriviaAdminData';
          status: TriviaRoundStatus;
          questionIndex: number;
          playedThroughIndex: number;
          reviewing: boolean;
          questionEndsAt?: any | null;
          answeredCount: number;
          playerCount: number;
          correctChoiceId?: string | null;
          correctCount?: number | null;
          revealedQuestionIds: Array<string>;
          tallies: Array<{
            __typename?: 'TriviaTally';
            choiceId: string;
            count: number;
          }>;
          leaderboard: Array<{
            __typename?: 'TriviaLeaderboardRow';
            userId: string;
            name: string;
            score: number;
            rank: number;
            tied: boolean;
          }>;
        }
      | {
          __typename?: 'VoteForAdminData';
          startTime?: any | null;
          endTime?: any | null;
          voteWinners?: Array<string> | null;
          choiceDisplayOrder: Array<string>;
          votes: Array<{
            __typename?: 'VoteCount';
            submissionId: string;
            count: number;
          }>;
        }
      | null;
    config?:
      | {
          __typename?: 'NowPlayingAdminConfig';
          visualizationType: string;
          allowComments: boolean;
          allowedReactions: Array<string>;
        }
      | {
          __typename?: 'PhotoCarouselAdminConfig';
          maxSubmissionsPerUser: number;
          requireApproval: boolean;
          askSharePermission?: boolean | null;
          sharePrompt?: string | null;
          noPhotosMessage?: string | null;
          pollInterval?: number | null;
          predefinedCaptions?: Array<string> | null;
          maxVisiblePhotos: number;
        }
      | {
          __typename?: 'RaffleAdminConfig';
          optionalImageUrl?: string | null;
          claimYourPrize?: string | null;
          ticketFlipDirection: RaffleTicketFlipDirection;
        }
      | {
          __typename?: 'SlidesAdminConfig';
          autoPlay: boolean;
          autoPlayIntervalMs?: number | null;
        }
      | {
          __typename?: 'TriviaAdminConfig';
          instructions?: string | null;
          useQuestionTimer: boolean;
          defaultTimerMs: number;
          questions: Array<{
            __typename?: 'TriviaQuestion';
            id: string;
            text: string;
            correctChoiceId?: string | null;
            timerMs?: number | null;
            choices: Array<{
              __typename?: 'TriviaChoice';
              id: string;
              text: string;
            }>;
          }>;
        }
      | {
          __typename?: 'VoteForAdminConfig';
          votesPerUser: number;
          allowUserSubmissions: boolean;
          maxSubmissionsPerUser: number;
        }
      | null;
    viewConfig:
      | {
          __typename?: 'NowPlayingViewConfig';
          visualizationType: string;
          allowComments: boolean;
          allowedReactions: Array<string>;
        }
      | {
          __typename?: 'PhotoCarouselViewConfig';
          maxSubmissionsPerUser: number;
          askSharePermission?: boolean | null;
          sharePrompt?: string | null;
          noPhotosMessage?: string | null;
          maxVisiblePhotos: number;
        }
      | {
          __typename?: 'RaffleViewConfig';
          optionalImageUrl?: string | null;
          claimYourPrize?: string | null;
          ticketFlipDirection: RaffleTicketFlipDirection;
        }
      | {
          __typename?: 'SlidesViewConfig';
          autoPlay: boolean;
          autoPlayIntervalMs?: number | null;
        }
      | {
          __typename?: 'TriviaViewConfig';
          instructions?: string | null;
          useQuestionTimer: boolean;
          defaultTimerMs: number;
          questions: Array<{
            __typename?: 'TriviaViewQuestion';
            id: string;
            text: string;
            timerMs?: number | null;
            choices: Array<{
              __typename?: 'TriviaChoice';
              id: string;
              text: string;
            }>;
          }>;
        }
      | { __typename?: 'VoteForViewConfig'; votesPerUser: number };
    viewData:
      | { __typename?: 'NowPlayingViewData'; currentSong?: string | null }
      | {
          __typename?: 'PhotoCarouselViewData';
          visibleSubmission?: string | null;
        }
      | {
          __typename?: 'RaffleViewData';
          raffleStatus: RaffleStatus;
          raffleCandidates: Array<string>;
          raffleWinners: Array<string>;
          raffleWinner?: string | null;
          winnerCount: number;
          remainingSubmissionIds: Array<string>;
          lastEliminatedSubmissionId?: string | null;
        }
      | {
          __typename?: 'SlidesViewData';
          currentSlide: string;
          slidesDisplayOrder: Array<string>;
        }
      | {
          __typename?: 'TriviaViewData';
          status: TriviaRoundStatus;
          questionIndex: number;
          questionEndsAt?: any | null;
          answeredCount: number;
          playerCount: number;
          correctChoiceId?: string | null;
          correctCount?: number | null;
          leaderboardOverflow: number;
          tallies: Array<{
            __typename?: 'TriviaTally';
            choiceId: string;
            count: number;
          }>;
          leaderboard: Array<{
            __typename?: 'TriviaLeaderboardRow';
            userId: string;
            name: string;
            score: number;
            rank: number;
            tied: boolean;
          }>;
        }
      | {
          __typename?: 'VoteForViewData';
          voteWinners?: Array<string> | null;
          choiceDisplayOrder: Array<string>;
          votes: Array<{
            __typename?: 'VoteCount';
            submissionId: string;
            count: number;
          }>;
        };
  };
};

export type UpdateEngagementMutationVariables = Exact<{
  engagementId: Scalars['String']['input'];
  data: UpdateEngagementInput;
}>;

export type UpdateEngagementMutation = {
  __typename?: 'Mutation';
  updateEngagement: {
    __typename?: 'Engagement';
    id: string;
    eventId: string;
    createdAt: any;
    updatedAt: any;
    title: string;
    description?: string | null;
    qrCodeCta?: string | null;
    startTime?: any | null;
    order: number;
    endTime?: any | null;
    type: EngagementType;
    data?:
      | { __typename?: 'NowPlayingAdminData'; currentSong?: string | null }
      | {
          __typename?: 'PhotoCarouselAdminData';
          visibleSubmission?: string | null;
          rejectedQueue: Array<string>;
          unapprovedQueue: Array<string>;
          unseenQueue: Array<string>;
          seenQueuePointer: number;
          seenQueue: Array<string>;
        }
      | {
          __typename?: 'RaffleAdminData';
          raffleStatus: RaffleStatus;
          raffleCandidates: Array<string>;
          raffleWinners: Array<string>;
          raffleWinner?: string | null;
          winnerCount: number;
          remainingSubmissionIds: Array<string>;
          lastEliminatedSubmissionId?: string | null;
        }
      | {
          __typename?: 'SlidesAdminData';
          currentSlide: string;
          slidesDisplayOrder: Array<string>;
        }
      | {
          __typename?: 'TriviaAdminData';
          status: TriviaRoundStatus;
          questionIndex: number;
          playedThroughIndex: number;
          reviewing: boolean;
          questionEndsAt?: any | null;
          answeredCount: number;
          playerCount: number;
          correctChoiceId?: string | null;
          correctCount?: number | null;
          revealedQuestionIds: Array<string>;
          tallies: Array<{
            __typename?: 'TriviaTally';
            choiceId: string;
            count: number;
          }>;
          leaderboard: Array<{
            __typename?: 'TriviaLeaderboardRow';
            userId: string;
            name: string;
            score: number;
            rank: number;
            tied: boolean;
          }>;
        }
      | {
          __typename?: 'VoteForAdminData';
          startTime?: any | null;
          endTime?: any | null;
          voteWinners?: Array<string> | null;
          choiceDisplayOrder: Array<string>;
          votes: Array<{
            __typename?: 'VoteCount';
            submissionId: string;
            count: number;
          }>;
        }
      | null;
    config?:
      | {
          __typename?: 'NowPlayingAdminConfig';
          visualizationType: string;
          allowComments: boolean;
          allowedReactions: Array<string>;
        }
      | {
          __typename?: 'PhotoCarouselAdminConfig';
          maxSubmissionsPerUser: number;
          requireApproval: boolean;
          askSharePermission?: boolean | null;
          sharePrompt?: string | null;
          noPhotosMessage?: string | null;
          pollInterval?: number | null;
          predefinedCaptions?: Array<string> | null;
          maxVisiblePhotos: number;
        }
      | {
          __typename?: 'RaffleAdminConfig';
          optionalImageUrl?: string | null;
          claimYourPrize?: string | null;
          ticketFlipDirection: RaffleTicketFlipDirection;
        }
      | {
          __typename?: 'SlidesAdminConfig';
          autoPlay: boolean;
          autoPlayIntervalMs?: number | null;
        }
      | {
          __typename?: 'TriviaAdminConfig';
          instructions?: string | null;
          useQuestionTimer: boolean;
          defaultTimerMs: number;
          questions: Array<{
            __typename?: 'TriviaQuestion';
            id: string;
            text: string;
            correctChoiceId?: string | null;
            timerMs?: number | null;
            choices: Array<{
              __typename?: 'TriviaChoice';
              id: string;
              text: string;
            }>;
          }>;
        }
      | {
          __typename?: 'VoteForAdminConfig';
          votesPerUser: number;
          allowUserSubmissions: boolean;
          maxSubmissionsPerUser: number;
        }
      | null;
    viewConfig:
      | {
          __typename?: 'NowPlayingViewConfig';
          visualizationType: string;
          allowComments: boolean;
          allowedReactions: Array<string>;
        }
      | {
          __typename?: 'PhotoCarouselViewConfig';
          maxSubmissionsPerUser: number;
          askSharePermission?: boolean | null;
          sharePrompt?: string | null;
          noPhotosMessage?: string | null;
          maxVisiblePhotos: number;
        }
      | {
          __typename?: 'RaffleViewConfig';
          optionalImageUrl?: string | null;
          claimYourPrize?: string | null;
          ticketFlipDirection: RaffleTicketFlipDirection;
        }
      | {
          __typename?: 'SlidesViewConfig';
          autoPlay: boolean;
          autoPlayIntervalMs?: number | null;
        }
      | {
          __typename?: 'TriviaViewConfig';
          instructions?: string | null;
          useQuestionTimer: boolean;
          defaultTimerMs: number;
          questions: Array<{
            __typename?: 'TriviaViewQuestion';
            id: string;
            text: string;
            timerMs?: number | null;
            choices: Array<{
              __typename?: 'TriviaChoice';
              id: string;
              text: string;
            }>;
          }>;
        }
      | { __typename?: 'VoteForViewConfig'; votesPerUser: number };
    viewData:
      | { __typename?: 'NowPlayingViewData'; currentSong?: string | null }
      | {
          __typename?: 'PhotoCarouselViewData';
          visibleSubmission?: string | null;
        }
      | {
          __typename?: 'RaffleViewData';
          raffleStatus: RaffleStatus;
          raffleCandidates: Array<string>;
          raffleWinners: Array<string>;
          raffleWinner?: string | null;
          winnerCount: number;
          remainingSubmissionIds: Array<string>;
          lastEliminatedSubmissionId?: string | null;
        }
      | {
          __typename?: 'SlidesViewData';
          currentSlide: string;
          slidesDisplayOrder: Array<string>;
        }
      | {
          __typename?: 'TriviaViewData';
          status: TriviaRoundStatus;
          questionIndex: number;
          questionEndsAt?: any | null;
          answeredCount: number;
          playerCount: number;
          correctChoiceId?: string | null;
          correctCount?: number | null;
          leaderboardOverflow: number;
          tallies: Array<{
            __typename?: 'TriviaTally';
            choiceId: string;
            count: number;
          }>;
          leaderboard: Array<{
            __typename?: 'TriviaLeaderboardRow';
            userId: string;
            name: string;
            score: number;
            rank: number;
            tied: boolean;
          }>;
        }
      | {
          __typename?: 'VoteForViewData';
          voteWinners?: Array<string> | null;
          choiceDisplayOrder: Array<string>;
          votes: Array<{
            __typename?: 'VoteCount';
            submissionId: string;
            count: number;
          }>;
        };
  };
};

export type DeleteSubmissionMutationVariables = Exact<{
  submissionId: Scalars['String']['input'];
}>;

export type DeleteSubmissionMutation = {
  __typename?: 'Mutation';
  deleteSubmission: { __typename?: 'Submission'; id: string };
};

export type FanSignupMutationVariables = Exact<{
  data: SignupInput;
}>;

export type FanSignupMutation = {
  __typename?: 'Mutation';
  signup: {
    __typename?: 'User';
    id: string;
    email?: string | null;
    role: Role;
    createdAt: any;
  };
};

export type CreateSubmissionPresignedUrlMutationVariables = Exact<{
  engagementId: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
  deviceId?: InputMaybe<Scalars['String']['input']>;
  visitorId?: InputMaybe<Scalars['String']['input']>;
}>;

export type CreateSubmissionPresignedUrlMutation = {
  __typename?: 'Mutation';
  createSubmissionPresignedUrl: {
    __typename?: 'PresignedUrlResponse';
    url: string;
    key: string;
  };
};

export type DeleteEngagementMutationVariables = Exact<{
  engagementId: Scalars['String']['input'];
}>;

export type DeleteEngagementMutation = {
  __typename?: 'Mutation';
  deleteEngagement: { __typename?: 'Engagement'; id: string };
};

export type CreateEventMutationVariables = Exact<{
  data: CreateEventInput;
}>;

export type CreateEventMutation = {
  __typename?: 'Mutation';
  createEvent: {
    __typename?: 'Event';
    id: string;
    name: string;
    date?: any | null;
    live: boolean;
    location?: string | null;
    locked: boolean;
    description?: string | null;
    createdAt: any;
    updatedAt: any;
    activeEngagementId?: string | null;
    screenCode?: string | null;
    themeConfig?: {
      __typename?: 'EventThemeConfig';
      headingFontFamily?: Array<string> | null;
      bodyFontFamily?: Array<string> | null;
      foregroundColor?: string | null;
      backgroundColor?: string | null;
      stageBackgroundImage?: string | null;
      fanBackgroundImage?: string | null;
      qrForegroundColor?: string | null;
      qrBackgroundColor?: string | null;
      qrTextColor?: string | null;
      qrWrapperBackgroundColor?: string | null;
      stageElements?: Array<{
        __typename?: 'ScreenElement';
        id: string;
        type: string;
        name?: string | null;
        imageUrl?: string | null;
        defaultStyles?: any | null;
        engagementStyles?: any | null;
        defaultClassNames?: string | null;
        engagementClassNames?: string | null;
        text?: string | null;
        textType?: string | null;
        fontFamily?: Array<string> | null;
        linkHref?: string | null;
        color?: string | null;
      }> | null;
      fanElements?: Array<{
        __typename?: 'ScreenElement';
        id: string;
        type: string;
        name?: string | null;
        imageUrl?: string | null;
        defaultStyles?: any | null;
        engagementStyles?: any | null;
        defaultClassNames?: string | null;
        engagementClassNames?: string | null;
        text?: string | null;
        textType?: string | null;
        fontFamily?: Array<string> | null;
        linkHref?: string | null;
        color?: string | null;
      }> | null;
    } | null;
    activeEngagement?: {
      __typename?: 'Engagement';
      id: string;
      eventId: string;
      createdAt: any;
      updatedAt: any;
      title: string;
      description?: string | null;
      qrCodeCta?: string | null;
      startTime?: any | null;
      order: number;
      endTime?: any | null;
      type: EngagementType;
      data?:
        | { __typename?: 'NowPlayingAdminData'; currentSong?: string | null }
        | {
            __typename?: 'PhotoCarouselAdminData';
            visibleSubmission?: string | null;
            rejectedQueue: Array<string>;
            unapprovedQueue: Array<string>;
            unseenQueue: Array<string>;
            seenQueuePointer: number;
            seenQueue: Array<string>;
          }
        | {
            __typename?: 'RaffleAdminData';
            raffleStatus: RaffleStatus;
            raffleCandidates: Array<string>;
            raffleWinners: Array<string>;
            raffleWinner?: string | null;
            winnerCount: number;
            remainingSubmissionIds: Array<string>;
            lastEliminatedSubmissionId?: string | null;
          }
        | {
            __typename?: 'SlidesAdminData';
            currentSlide: string;
            slidesDisplayOrder: Array<string>;
          }
        | {
            __typename?: 'TriviaAdminData';
            status: TriviaRoundStatus;
            questionIndex: number;
            playedThroughIndex: number;
            reviewing: boolean;
            questionEndsAt?: any | null;
            answeredCount: number;
            playerCount: number;
            correctChoiceId?: string | null;
            correctCount?: number | null;
            revealedQuestionIds: Array<string>;
            tallies: Array<{
              __typename?: 'TriviaTally';
              choiceId: string;
              count: number;
            }>;
            leaderboard: Array<{
              __typename?: 'TriviaLeaderboardRow';
              userId: string;
              name: string;
              score: number;
              rank: number;
              tied: boolean;
            }>;
          }
        | {
            __typename?: 'VoteForAdminData';
            startTime?: any | null;
            endTime?: any | null;
            voteWinners?: Array<string> | null;
            choiceDisplayOrder: Array<string>;
            votes: Array<{
              __typename?: 'VoteCount';
              submissionId: string;
              count: number;
            }>;
          }
        | null;
      config?:
        | {
            __typename?: 'NowPlayingAdminConfig';
            visualizationType: string;
            allowComments: boolean;
            allowedReactions: Array<string>;
          }
        | {
            __typename?: 'PhotoCarouselAdminConfig';
            maxSubmissionsPerUser: number;
            requireApproval: boolean;
            askSharePermission?: boolean | null;
            sharePrompt?: string | null;
            noPhotosMessage?: string | null;
            pollInterval?: number | null;
            predefinedCaptions?: Array<string> | null;
            maxVisiblePhotos: number;
          }
        | {
            __typename?: 'RaffleAdminConfig';
            optionalImageUrl?: string | null;
            claimYourPrize?: string | null;
            ticketFlipDirection: RaffleTicketFlipDirection;
          }
        | {
            __typename?: 'SlidesAdminConfig';
            autoPlay: boolean;
            autoPlayIntervalMs?: number | null;
          }
        | {
            __typename?: 'TriviaAdminConfig';
            instructions?: string | null;
            useQuestionTimer: boolean;
            defaultTimerMs: number;
            questions: Array<{
              __typename?: 'TriviaQuestion';
              id: string;
              text: string;
              correctChoiceId?: string | null;
              timerMs?: number | null;
              choices: Array<{
                __typename?: 'TriviaChoice';
                id: string;
                text: string;
              }>;
            }>;
          }
        | {
            __typename?: 'VoteForAdminConfig';
            votesPerUser: number;
            allowUserSubmissions: boolean;
            maxSubmissionsPerUser: number;
          }
        | null;
      viewConfig:
        | {
            __typename?: 'NowPlayingViewConfig';
            visualizationType: string;
            allowComments: boolean;
            allowedReactions: Array<string>;
          }
        | {
            __typename?: 'PhotoCarouselViewConfig';
            maxSubmissionsPerUser: number;
            askSharePermission?: boolean | null;
            sharePrompt?: string | null;
            noPhotosMessage?: string | null;
            maxVisiblePhotos: number;
          }
        | {
            __typename?: 'RaffleViewConfig';
            optionalImageUrl?: string | null;
            claimYourPrize?: string | null;
            ticketFlipDirection: RaffleTicketFlipDirection;
          }
        | {
            __typename?: 'SlidesViewConfig';
            autoPlay: boolean;
            autoPlayIntervalMs?: number | null;
          }
        | {
            __typename?: 'TriviaViewConfig';
            instructions?: string | null;
            useQuestionTimer: boolean;
            defaultTimerMs: number;
            questions: Array<{
              __typename?: 'TriviaViewQuestion';
              id: string;
              text: string;
              timerMs?: number | null;
              choices: Array<{
                __typename?: 'TriviaChoice';
                id: string;
                text: string;
              }>;
            }>;
          }
        | { __typename?: 'VoteForViewConfig'; votesPerUser: number };
      viewData:
        | { __typename?: 'NowPlayingViewData'; currentSong?: string | null }
        | {
            __typename?: 'PhotoCarouselViewData';
            visibleSubmission?: string | null;
          }
        | {
            __typename?: 'RaffleViewData';
            raffleStatus: RaffleStatus;
            raffleCandidates: Array<string>;
            raffleWinners: Array<string>;
            raffleWinner?: string | null;
            winnerCount: number;
            remainingSubmissionIds: Array<string>;
            lastEliminatedSubmissionId?: string | null;
          }
        | {
            __typename?: 'SlidesViewData';
            currentSlide: string;
            slidesDisplayOrder: Array<string>;
          }
        | {
            __typename?: 'TriviaViewData';
            status: TriviaRoundStatus;
            questionIndex: number;
            questionEndsAt?: any | null;
            answeredCount: number;
            playerCount: number;
            correctChoiceId?: string | null;
            correctCount?: number | null;
            leaderboardOverflow: number;
            tallies: Array<{
              __typename?: 'TriviaTally';
              choiceId: string;
              count: number;
            }>;
            leaderboard: Array<{
              __typename?: 'TriviaLeaderboardRow';
              userId: string;
              name: string;
              score: number;
              rank: number;
              tied: boolean;
            }>;
          }
        | {
            __typename?: 'VoteForViewData';
            voteWinners?: Array<string> | null;
            choiceDisplayOrder: Array<string>;
            votes: Array<{
              __typename?: 'VoteCount';
              submissionId: string;
              count: number;
            }>;
          };
    } | null;
    engagements: Array<{
      __typename?: 'Engagement';
      id: string;
      eventId: string;
      createdAt: any;
      updatedAt: any;
      title: string;
      description?: string | null;
      qrCodeCta?: string | null;
      startTime?: any | null;
      order: number;
      endTime?: any | null;
      type: EngagementType;
      data?:
        | { __typename?: 'NowPlayingAdminData'; currentSong?: string | null }
        | {
            __typename?: 'PhotoCarouselAdminData';
            visibleSubmission?: string | null;
            rejectedQueue: Array<string>;
            unapprovedQueue: Array<string>;
            unseenQueue: Array<string>;
            seenQueuePointer: number;
            seenQueue: Array<string>;
          }
        | {
            __typename?: 'RaffleAdminData';
            raffleStatus: RaffleStatus;
            raffleCandidates: Array<string>;
            raffleWinners: Array<string>;
            raffleWinner?: string | null;
            winnerCount: number;
            remainingSubmissionIds: Array<string>;
            lastEliminatedSubmissionId?: string | null;
          }
        | {
            __typename?: 'SlidesAdminData';
            currentSlide: string;
            slidesDisplayOrder: Array<string>;
          }
        | {
            __typename?: 'TriviaAdminData';
            status: TriviaRoundStatus;
            questionIndex: number;
            playedThroughIndex: number;
            reviewing: boolean;
            questionEndsAt?: any | null;
            answeredCount: number;
            playerCount: number;
            correctChoiceId?: string | null;
            correctCount?: number | null;
            revealedQuestionIds: Array<string>;
            tallies: Array<{
              __typename?: 'TriviaTally';
              choiceId: string;
              count: number;
            }>;
            leaderboard: Array<{
              __typename?: 'TriviaLeaderboardRow';
              userId: string;
              name: string;
              score: number;
              rank: number;
              tied: boolean;
            }>;
          }
        | {
            __typename?: 'VoteForAdminData';
            startTime?: any | null;
            endTime?: any | null;
            voteWinners?: Array<string> | null;
            choiceDisplayOrder: Array<string>;
            votes: Array<{
              __typename?: 'VoteCount';
              submissionId: string;
              count: number;
            }>;
          }
        | null;
      config?:
        | {
            __typename?: 'NowPlayingAdminConfig';
            visualizationType: string;
            allowComments: boolean;
            allowedReactions: Array<string>;
          }
        | {
            __typename?: 'PhotoCarouselAdminConfig';
            maxSubmissionsPerUser: number;
            requireApproval: boolean;
            askSharePermission?: boolean | null;
            sharePrompt?: string | null;
            noPhotosMessage?: string | null;
            pollInterval?: number | null;
            predefinedCaptions?: Array<string> | null;
            maxVisiblePhotos: number;
          }
        | {
            __typename?: 'RaffleAdminConfig';
            optionalImageUrl?: string | null;
            claimYourPrize?: string | null;
            ticketFlipDirection: RaffleTicketFlipDirection;
          }
        | {
            __typename?: 'SlidesAdminConfig';
            autoPlay: boolean;
            autoPlayIntervalMs?: number | null;
          }
        | {
            __typename?: 'TriviaAdminConfig';
            instructions?: string | null;
            useQuestionTimer: boolean;
            defaultTimerMs: number;
            questions: Array<{
              __typename?: 'TriviaQuestion';
              id: string;
              text: string;
              correctChoiceId?: string | null;
              timerMs?: number | null;
              choices: Array<{
                __typename?: 'TriviaChoice';
                id: string;
                text: string;
              }>;
            }>;
          }
        | {
            __typename?: 'VoteForAdminConfig';
            votesPerUser: number;
            allowUserSubmissions: boolean;
            maxSubmissionsPerUser: number;
          }
        | null;
      viewConfig:
        | {
            __typename?: 'NowPlayingViewConfig';
            visualizationType: string;
            allowComments: boolean;
            allowedReactions: Array<string>;
          }
        | {
            __typename?: 'PhotoCarouselViewConfig';
            maxSubmissionsPerUser: number;
            askSharePermission?: boolean | null;
            sharePrompt?: string | null;
            noPhotosMessage?: string | null;
            maxVisiblePhotos: number;
          }
        | {
            __typename?: 'RaffleViewConfig';
            optionalImageUrl?: string | null;
            claimYourPrize?: string | null;
            ticketFlipDirection: RaffleTicketFlipDirection;
          }
        | {
            __typename?: 'SlidesViewConfig';
            autoPlay: boolean;
            autoPlayIntervalMs?: number | null;
          }
        | {
            __typename?: 'TriviaViewConfig';
            instructions?: string | null;
            useQuestionTimer: boolean;
            defaultTimerMs: number;
            questions: Array<{
              __typename?: 'TriviaViewQuestion';
              id: string;
              text: string;
              timerMs?: number | null;
              choices: Array<{
                __typename?: 'TriviaChoice';
                id: string;
                text: string;
              }>;
            }>;
          }
        | { __typename?: 'VoteForViewConfig'; votesPerUser: number };
      viewData:
        | { __typename?: 'NowPlayingViewData'; currentSong?: string | null }
        | {
            __typename?: 'PhotoCarouselViewData';
            visibleSubmission?: string | null;
          }
        | {
            __typename?: 'RaffleViewData';
            raffleStatus: RaffleStatus;
            raffleCandidates: Array<string>;
            raffleWinners: Array<string>;
            raffleWinner?: string | null;
            winnerCount: number;
            remainingSubmissionIds: Array<string>;
            lastEliminatedSubmissionId?: string | null;
          }
        | {
            __typename?: 'SlidesViewData';
            currentSlide: string;
            slidesDisplayOrder: Array<string>;
          }
        | {
            __typename?: 'TriviaViewData';
            status: TriviaRoundStatus;
            questionIndex: number;
            questionEndsAt?: any | null;
            answeredCount: number;
            playerCount: number;
            correctChoiceId?: string | null;
            correctCount?: number | null;
            leaderboardOverflow: number;
            tallies: Array<{
              __typename?: 'TriviaTally';
              choiceId: string;
              count: number;
            }>;
            leaderboard: Array<{
              __typename?: 'TriviaLeaderboardRow';
              userId: string;
              name: string;
              score: number;
              rank: number;
              tied: boolean;
            }>;
          }
        | {
            __typename?: 'VoteForViewData';
            voteWinners?: Array<string> | null;
            choiceDisplayOrder: Array<string>;
            votes: Array<{
              __typename?: 'VoteCount';
              submissionId: string;
              count: number;
            }>;
          };
    }>;
    subscriptionInUse?: {
      __typename?: 'PaymentSubscription';
      id: string;
      userId: string;
      status: PaymentSubscriptionStatus;
      stripeSubscriptionId: string;
      currentPeriodStart?: any | null;
      currentPeriodEnd?: any | null;
      cancelAtPeriodEnd: boolean;
      canceledAt?: any | null;
      trialStart?: any | null;
      trialEnd?: any | null;
      maxConcurrentEvents: number;
      createdAt: any;
      updatedAt: any;
      liveEvents: Array<{ __typename?: 'Event'; id: string; name: string }>;
    } | null;
    eventPassRedemptionInUse?: {
      __typename?: 'EventPassRedemption';
      id: string;
      eventPassId: string;
      eventId: string;
      redeemedAt: any;
      description?: string | null;
      expiresAt?: any | null;
    } | null;
  };
};

export type StartMockEngagementMutationVariables = Exact<{
  engagementId: Scalars['String']['input'];
}>;

export type StartMockEngagementMutation = {
  __typename?: 'Mutation';
  startMockEngagement: {
    __typename?: 'StartMockEngagementResponse';
    mockRunId: string;
  };
};

export type StopMockEngagementMutationVariables = Exact<{
  mockRunId: Scalars['String']['input'];
}>;

export type StopMockEngagementMutation = {
  __typename?: 'Mutation';
  stopMockEngagement: boolean;
};

export type ExtendMockEngagementMutationVariables = Exact<{
  mockRunId: Scalars['String']['input'];
}>;

export type ExtendMockEngagementMutation = {
  __typename?: 'Mutation';
  extendMockEngagement: boolean;
};

export type CreateEventPassCheckoutSessionMutationVariables = Exact<{
  data: CreateEventPassCheckoutSessionInput;
}>;

export type CreateEventPassCheckoutSessionMutation = {
  __typename?: 'Mutation';
  createEventPassCheckoutSession: {
    __typename?: 'CreateEventPassCheckoutSessionResponse';
    url: string;
    eventPassId: string;
  };
};

export type RedeemEventPassMutationVariables = Exact<{
  eventPassId: Scalars['String']['input'];
  eventId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
}>;

export type RedeemEventPassMutation = {
  __typename?: 'Mutation';
  redeemEventPass: {
    __typename?: 'RedeemEventPassResponse';
    eventPassRedemption: {
      __typename?: 'EventPassRedemption';
      id: string;
      eventPassId: string;
      eventId: string;
      redeemedAt: any;
      description?: string | null;
      expiresAt?: any | null;
    };
    event: {
      __typename?: 'Event';
      id: string;
      name: string;
      date?: any | null;
      live: boolean;
      location?: string | null;
      locked: boolean;
      description?: string | null;
      createdAt: any;
      updatedAt: any;
      activeEngagementId?: string | null;
      screenCode?: string | null;
      themeConfig?: {
        __typename?: 'EventThemeConfig';
        headingFontFamily?: Array<string> | null;
        bodyFontFamily?: Array<string> | null;
        foregroundColor?: string | null;
        backgroundColor?: string | null;
        stageBackgroundImage?: string | null;
        fanBackgroundImage?: string | null;
        qrForegroundColor?: string | null;
        qrBackgroundColor?: string | null;
        qrTextColor?: string | null;
        qrWrapperBackgroundColor?: string | null;
        stageElements?: Array<{
          __typename?: 'ScreenElement';
          id: string;
          type: string;
          name?: string | null;
          imageUrl?: string | null;
          defaultStyles?: any | null;
          engagementStyles?: any | null;
          defaultClassNames?: string | null;
          engagementClassNames?: string | null;
          text?: string | null;
          textType?: string | null;
          fontFamily?: Array<string> | null;
          linkHref?: string | null;
          color?: string | null;
        }> | null;
        fanElements?: Array<{
          __typename?: 'ScreenElement';
          id: string;
          type: string;
          name?: string | null;
          imageUrl?: string | null;
          defaultStyles?: any | null;
          engagementStyles?: any | null;
          defaultClassNames?: string | null;
          engagementClassNames?: string | null;
          text?: string | null;
          textType?: string | null;
          fontFamily?: Array<string> | null;
          linkHref?: string | null;
          color?: string | null;
        }> | null;
      } | null;
      activeEngagement?: {
        __typename?: 'Engagement';
        id: string;
        eventId: string;
        createdAt: any;
        updatedAt: any;
        title: string;
        description?: string | null;
        qrCodeCta?: string | null;
        startTime?: any | null;
        order: number;
        endTime?: any | null;
        type: EngagementType;
        data?:
          | { __typename?: 'NowPlayingAdminData'; currentSong?: string | null }
          | {
              __typename?: 'PhotoCarouselAdminData';
              visibleSubmission?: string | null;
              rejectedQueue: Array<string>;
              unapprovedQueue: Array<string>;
              unseenQueue: Array<string>;
              seenQueuePointer: number;
              seenQueue: Array<string>;
            }
          | {
              __typename?: 'RaffleAdminData';
              raffleStatus: RaffleStatus;
              raffleCandidates: Array<string>;
              raffleWinners: Array<string>;
              raffleWinner?: string | null;
              winnerCount: number;
              remainingSubmissionIds: Array<string>;
              lastEliminatedSubmissionId?: string | null;
            }
          | {
              __typename?: 'SlidesAdminData';
              currentSlide: string;
              slidesDisplayOrder: Array<string>;
            }
          | {
              __typename?: 'TriviaAdminData';
              status: TriviaRoundStatus;
              questionIndex: number;
              playedThroughIndex: number;
              reviewing: boolean;
              questionEndsAt?: any | null;
              answeredCount: number;
              playerCount: number;
              correctChoiceId?: string | null;
              correctCount?: number | null;
              revealedQuestionIds: Array<string>;
              tallies: Array<{
                __typename?: 'TriviaTally';
                choiceId: string;
                count: number;
              }>;
              leaderboard: Array<{
                __typename?: 'TriviaLeaderboardRow';
                userId: string;
                name: string;
                score: number;
                rank: number;
                tied: boolean;
              }>;
            }
          | {
              __typename?: 'VoteForAdminData';
              startTime?: any | null;
              endTime?: any | null;
              voteWinners?: Array<string> | null;
              choiceDisplayOrder: Array<string>;
              votes: Array<{
                __typename?: 'VoteCount';
                submissionId: string;
                count: number;
              }>;
            }
          | null;
        config?:
          | {
              __typename?: 'NowPlayingAdminConfig';
              visualizationType: string;
              allowComments: boolean;
              allowedReactions: Array<string>;
            }
          | {
              __typename?: 'PhotoCarouselAdminConfig';
              maxSubmissionsPerUser: number;
              requireApproval: boolean;
              askSharePermission?: boolean | null;
              sharePrompt?: string | null;
              noPhotosMessage?: string | null;
              pollInterval?: number | null;
              predefinedCaptions?: Array<string> | null;
              maxVisiblePhotos: number;
            }
          | {
              __typename?: 'RaffleAdminConfig';
              optionalImageUrl?: string | null;
              claimYourPrize?: string | null;
              ticketFlipDirection: RaffleTicketFlipDirection;
            }
          | {
              __typename?: 'SlidesAdminConfig';
              autoPlay: boolean;
              autoPlayIntervalMs?: number | null;
            }
          | {
              __typename?: 'TriviaAdminConfig';
              instructions?: string | null;
              useQuestionTimer: boolean;
              defaultTimerMs: number;
              questions: Array<{
                __typename?: 'TriviaQuestion';
                id: string;
                text: string;
                correctChoiceId?: string | null;
                timerMs?: number | null;
                choices: Array<{
                  __typename?: 'TriviaChoice';
                  id: string;
                  text: string;
                }>;
              }>;
            }
          | {
              __typename?: 'VoteForAdminConfig';
              votesPerUser: number;
              allowUserSubmissions: boolean;
              maxSubmissionsPerUser: number;
            }
          | null;
        viewConfig:
          | {
              __typename?: 'NowPlayingViewConfig';
              visualizationType: string;
              allowComments: boolean;
              allowedReactions: Array<string>;
            }
          | {
              __typename?: 'PhotoCarouselViewConfig';
              maxSubmissionsPerUser: number;
              askSharePermission?: boolean | null;
              sharePrompt?: string | null;
              noPhotosMessage?: string | null;
              maxVisiblePhotos: number;
            }
          | {
              __typename?: 'RaffleViewConfig';
              optionalImageUrl?: string | null;
              claimYourPrize?: string | null;
              ticketFlipDirection: RaffleTicketFlipDirection;
            }
          | {
              __typename?: 'SlidesViewConfig';
              autoPlay: boolean;
              autoPlayIntervalMs?: number | null;
            }
          | {
              __typename?: 'TriviaViewConfig';
              instructions?: string | null;
              useQuestionTimer: boolean;
              defaultTimerMs: number;
              questions: Array<{
                __typename?: 'TriviaViewQuestion';
                id: string;
                text: string;
                timerMs?: number | null;
                choices: Array<{
                  __typename?: 'TriviaChoice';
                  id: string;
                  text: string;
                }>;
              }>;
            }
          | { __typename?: 'VoteForViewConfig'; votesPerUser: number };
        viewData:
          | { __typename?: 'NowPlayingViewData'; currentSong?: string | null }
          | {
              __typename?: 'PhotoCarouselViewData';
              visibleSubmission?: string | null;
            }
          | {
              __typename?: 'RaffleViewData';
              raffleStatus: RaffleStatus;
              raffleCandidates: Array<string>;
              raffleWinners: Array<string>;
              raffleWinner?: string | null;
              winnerCount: number;
              remainingSubmissionIds: Array<string>;
              lastEliminatedSubmissionId?: string | null;
            }
          | {
              __typename?: 'SlidesViewData';
              currentSlide: string;
              slidesDisplayOrder: Array<string>;
            }
          | {
              __typename?: 'TriviaViewData';
              status: TriviaRoundStatus;
              questionIndex: number;
              questionEndsAt?: any | null;
              answeredCount: number;
              playerCount: number;
              correctChoiceId?: string | null;
              correctCount?: number | null;
              leaderboardOverflow: number;
              tallies: Array<{
                __typename?: 'TriviaTally';
                choiceId: string;
                count: number;
              }>;
              leaderboard: Array<{
                __typename?: 'TriviaLeaderboardRow';
                userId: string;
                name: string;
                score: number;
                rank: number;
                tied: boolean;
              }>;
            }
          | {
              __typename?: 'VoteForViewData';
              voteWinners?: Array<string> | null;
              choiceDisplayOrder: Array<string>;
              votes: Array<{
                __typename?: 'VoteCount';
                submissionId: string;
                count: number;
              }>;
            };
      } | null;
      engagements: Array<{
        __typename?: 'Engagement';
        id: string;
        eventId: string;
        createdAt: any;
        updatedAt: any;
        title: string;
        description?: string | null;
        qrCodeCta?: string | null;
        startTime?: any | null;
        order: number;
        endTime?: any | null;
        type: EngagementType;
        data?:
          | { __typename?: 'NowPlayingAdminData'; currentSong?: string | null }
          | {
              __typename?: 'PhotoCarouselAdminData';
              visibleSubmission?: string | null;
              rejectedQueue: Array<string>;
              unapprovedQueue: Array<string>;
              unseenQueue: Array<string>;
              seenQueuePointer: number;
              seenQueue: Array<string>;
            }
          | {
              __typename?: 'RaffleAdminData';
              raffleStatus: RaffleStatus;
              raffleCandidates: Array<string>;
              raffleWinners: Array<string>;
              raffleWinner?: string | null;
              winnerCount: number;
              remainingSubmissionIds: Array<string>;
              lastEliminatedSubmissionId?: string | null;
            }
          | {
              __typename?: 'SlidesAdminData';
              currentSlide: string;
              slidesDisplayOrder: Array<string>;
            }
          | {
              __typename?: 'TriviaAdminData';
              status: TriviaRoundStatus;
              questionIndex: number;
              playedThroughIndex: number;
              reviewing: boolean;
              questionEndsAt?: any | null;
              answeredCount: number;
              playerCount: number;
              correctChoiceId?: string | null;
              correctCount?: number | null;
              revealedQuestionIds: Array<string>;
              tallies: Array<{
                __typename?: 'TriviaTally';
                choiceId: string;
                count: number;
              }>;
              leaderboard: Array<{
                __typename?: 'TriviaLeaderboardRow';
                userId: string;
                name: string;
                score: number;
                rank: number;
                tied: boolean;
              }>;
            }
          | {
              __typename?: 'VoteForAdminData';
              startTime?: any | null;
              endTime?: any | null;
              voteWinners?: Array<string> | null;
              choiceDisplayOrder: Array<string>;
              votes: Array<{
                __typename?: 'VoteCount';
                submissionId: string;
                count: number;
              }>;
            }
          | null;
        config?:
          | {
              __typename?: 'NowPlayingAdminConfig';
              visualizationType: string;
              allowComments: boolean;
              allowedReactions: Array<string>;
            }
          | {
              __typename?: 'PhotoCarouselAdminConfig';
              maxSubmissionsPerUser: number;
              requireApproval: boolean;
              askSharePermission?: boolean | null;
              sharePrompt?: string | null;
              noPhotosMessage?: string | null;
              pollInterval?: number | null;
              predefinedCaptions?: Array<string> | null;
              maxVisiblePhotos: number;
            }
          | {
              __typename?: 'RaffleAdminConfig';
              optionalImageUrl?: string | null;
              claimYourPrize?: string | null;
              ticketFlipDirection: RaffleTicketFlipDirection;
            }
          | {
              __typename?: 'SlidesAdminConfig';
              autoPlay: boolean;
              autoPlayIntervalMs?: number | null;
            }
          | {
              __typename?: 'TriviaAdminConfig';
              instructions?: string | null;
              useQuestionTimer: boolean;
              defaultTimerMs: number;
              questions: Array<{
                __typename?: 'TriviaQuestion';
                id: string;
                text: string;
                correctChoiceId?: string | null;
                timerMs?: number | null;
                choices: Array<{
                  __typename?: 'TriviaChoice';
                  id: string;
                  text: string;
                }>;
              }>;
            }
          | {
              __typename?: 'VoteForAdminConfig';
              votesPerUser: number;
              allowUserSubmissions: boolean;
              maxSubmissionsPerUser: number;
            }
          | null;
        viewConfig:
          | {
              __typename?: 'NowPlayingViewConfig';
              visualizationType: string;
              allowComments: boolean;
              allowedReactions: Array<string>;
            }
          | {
              __typename?: 'PhotoCarouselViewConfig';
              maxSubmissionsPerUser: number;
              askSharePermission?: boolean | null;
              sharePrompt?: string | null;
              noPhotosMessage?: string | null;
              maxVisiblePhotos: number;
            }
          | {
              __typename?: 'RaffleViewConfig';
              optionalImageUrl?: string | null;
              claimYourPrize?: string | null;
              ticketFlipDirection: RaffleTicketFlipDirection;
            }
          | {
              __typename?: 'SlidesViewConfig';
              autoPlay: boolean;
              autoPlayIntervalMs?: number | null;
            }
          | {
              __typename?: 'TriviaViewConfig';
              instructions?: string | null;
              useQuestionTimer: boolean;
              defaultTimerMs: number;
              questions: Array<{
                __typename?: 'TriviaViewQuestion';
                id: string;
                text: string;
                timerMs?: number | null;
                choices: Array<{
                  __typename?: 'TriviaChoice';
                  id: string;
                  text: string;
                }>;
              }>;
            }
          | { __typename?: 'VoteForViewConfig'; votesPerUser: number };
        viewData:
          | { __typename?: 'NowPlayingViewData'; currentSong?: string | null }
          | {
              __typename?: 'PhotoCarouselViewData';
              visibleSubmission?: string | null;
            }
          | {
              __typename?: 'RaffleViewData';
              raffleStatus: RaffleStatus;
              raffleCandidates: Array<string>;
              raffleWinners: Array<string>;
              raffleWinner?: string | null;
              winnerCount: number;
              remainingSubmissionIds: Array<string>;
              lastEliminatedSubmissionId?: string | null;
            }
          | {
              __typename?: 'SlidesViewData';
              currentSlide: string;
              slidesDisplayOrder: Array<string>;
            }
          | {
              __typename?: 'TriviaViewData';
              status: TriviaRoundStatus;
              questionIndex: number;
              questionEndsAt?: any | null;
              answeredCount: number;
              playerCount: number;
              correctChoiceId?: string | null;
              correctCount?: number | null;
              leaderboardOverflow: number;
              tallies: Array<{
                __typename?: 'TriviaTally';
                choiceId: string;
                count: number;
              }>;
              leaderboard: Array<{
                __typename?: 'TriviaLeaderboardRow';
                userId: string;
                name: string;
                score: number;
                rank: number;
                tied: boolean;
              }>;
            }
          | {
              __typename?: 'VoteForViewData';
              voteWinners?: Array<string> | null;
              choiceDisplayOrder: Array<string>;
              votes: Array<{
                __typename?: 'VoteCount';
                submissionId: string;
                count: number;
              }>;
            };
      }>;
      subscriptionInUse?: {
        __typename?: 'PaymentSubscription';
        id: string;
        userId: string;
        status: PaymentSubscriptionStatus;
        stripeSubscriptionId: string;
        currentPeriodStart?: any | null;
        currentPeriodEnd?: any | null;
        cancelAtPeriodEnd: boolean;
        canceledAt?: any | null;
        trialStart?: any | null;
        trialEnd?: any | null;
        maxConcurrentEvents: number;
        createdAt: any;
        updatedAt: any;
        liveEvents: Array<{ __typename?: 'Event'; id: string; name: string }>;
      } | null;
      eventPassRedemptionInUse?: {
        __typename?: 'EventPassRedemption';
        id: string;
        eventPassId: string;
        eventId: string;
        redeemedAt: any;
        description?: string | null;
        expiresAt?: any | null;
      } | null;
    };
  };
};

export type CreateSubscriptionCheckoutSessionMutationVariables = Exact<{
  data: CreateSubscriptionCheckoutSessionInput;
}>;

export type CreateSubscriptionCheckoutSessionMutation = {
  __typename?: 'Mutation';
  createSubscriptionCheckoutSession: {
    __typename?: 'CreateSubscriptionCheckoutSessionResponse';
    url: string;
  };
};

export type GoLiveWithSubscriptionMutationVariables = Exact<{
  eventId: Scalars['String']['input'];
}>;

export type GoLiveWithSubscriptionMutation = {
  __typename?: 'Mutation';
  goLiveWithSubscription: {
    __typename?: 'Event';
    id: string;
    name: string;
    date?: any | null;
    live: boolean;
    location?: string | null;
    locked: boolean;
    description?: string | null;
    createdAt: any;
    updatedAt: any;
    activeEngagementId?: string | null;
    screenCode?: string | null;
    themeConfig?: {
      __typename?: 'EventThemeConfig';
      headingFontFamily?: Array<string> | null;
      bodyFontFamily?: Array<string> | null;
      foregroundColor?: string | null;
      backgroundColor?: string | null;
      stageBackgroundImage?: string | null;
      fanBackgroundImage?: string | null;
      qrForegroundColor?: string | null;
      qrBackgroundColor?: string | null;
      qrTextColor?: string | null;
      qrWrapperBackgroundColor?: string | null;
      stageElements?: Array<{
        __typename?: 'ScreenElement';
        id: string;
        type: string;
        name?: string | null;
        imageUrl?: string | null;
        defaultStyles?: any | null;
        engagementStyles?: any | null;
        defaultClassNames?: string | null;
        engagementClassNames?: string | null;
        text?: string | null;
        textType?: string | null;
        fontFamily?: Array<string> | null;
        linkHref?: string | null;
        color?: string | null;
      }> | null;
      fanElements?: Array<{
        __typename?: 'ScreenElement';
        id: string;
        type: string;
        name?: string | null;
        imageUrl?: string | null;
        defaultStyles?: any | null;
        engagementStyles?: any | null;
        defaultClassNames?: string | null;
        engagementClassNames?: string | null;
        text?: string | null;
        textType?: string | null;
        fontFamily?: Array<string> | null;
        linkHref?: string | null;
        color?: string | null;
      }> | null;
    } | null;
    activeEngagement?: {
      __typename?: 'Engagement';
      id: string;
      eventId: string;
      createdAt: any;
      updatedAt: any;
      title: string;
      description?: string | null;
      qrCodeCta?: string | null;
      startTime?: any | null;
      order: number;
      endTime?: any | null;
      type: EngagementType;
      data?:
        | { __typename?: 'NowPlayingAdminData'; currentSong?: string | null }
        | {
            __typename?: 'PhotoCarouselAdminData';
            visibleSubmission?: string | null;
            rejectedQueue: Array<string>;
            unapprovedQueue: Array<string>;
            unseenQueue: Array<string>;
            seenQueuePointer: number;
            seenQueue: Array<string>;
          }
        | {
            __typename?: 'RaffleAdminData';
            raffleStatus: RaffleStatus;
            raffleCandidates: Array<string>;
            raffleWinners: Array<string>;
            raffleWinner?: string | null;
            winnerCount: number;
            remainingSubmissionIds: Array<string>;
            lastEliminatedSubmissionId?: string | null;
          }
        | {
            __typename?: 'SlidesAdminData';
            currentSlide: string;
            slidesDisplayOrder: Array<string>;
          }
        | {
            __typename?: 'TriviaAdminData';
            status: TriviaRoundStatus;
            questionIndex: number;
            playedThroughIndex: number;
            reviewing: boolean;
            questionEndsAt?: any | null;
            answeredCount: number;
            playerCount: number;
            correctChoiceId?: string | null;
            correctCount?: number | null;
            revealedQuestionIds: Array<string>;
            tallies: Array<{
              __typename?: 'TriviaTally';
              choiceId: string;
              count: number;
            }>;
            leaderboard: Array<{
              __typename?: 'TriviaLeaderboardRow';
              userId: string;
              name: string;
              score: number;
              rank: number;
              tied: boolean;
            }>;
          }
        | {
            __typename?: 'VoteForAdminData';
            startTime?: any | null;
            endTime?: any | null;
            voteWinners?: Array<string> | null;
            choiceDisplayOrder: Array<string>;
            votes: Array<{
              __typename?: 'VoteCount';
              submissionId: string;
              count: number;
            }>;
          }
        | null;
      config?:
        | {
            __typename?: 'NowPlayingAdminConfig';
            visualizationType: string;
            allowComments: boolean;
            allowedReactions: Array<string>;
          }
        | {
            __typename?: 'PhotoCarouselAdminConfig';
            maxSubmissionsPerUser: number;
            requireApproval: boolean;
            askSharePermission?: boolean | null;
            sharePrompt?: string | null;
            noPhotosMessage?: string | null;
            pollInterval?: number | null;
            predefinedCaptions?: Array<string> | null;
            maxVisiblePhotos: number;
          }
        | {
            __typename?: 'RaffleAdminConfig';
            optionalImageUrl?: string | null;
            claimYourPrize?: string | null;
            ticketFlipDirection: RaffleTicketFlipDirection;
          }
        | {
            __typename?: 'SlidesAdminConfig';
            autoPlay: boolean;
            autoPlayIntervalMs?: number | null;
          }
        | {
            __typename?: 'TriviaAdminConfig';
            instructions?: string | null;
            useQuestionTimer: boolean;
            defaultTimerMs: number;
            questions: Array<{
              __typename?: 'TriviaQuestion';
              id: string;
              text: string;
              correctChoiceId?: string | null;
              timerMs?: number | null;
              choices: Array<{
                __typename?: 'TriviaChoice';
                id: string;
                text: string;
              }>;
            }>;
          }
        | {
            __typename?: 'VoteForAdminConfig';
            votesPerUser: number;
            allowUserSubmissions: boolean;
            maxSubmissionsPerUser: number;
          }
        | null;
      viewConfig:
        | {
            __typename?: 'NowPlayingViewConfig';
            visualizationType: string;
            allowComments: boolean;
            allowedReactions: Array<string>;
          }
        | {
            __typename?: 'PhotoCarouselViewConfig';
            maxSubmissionsPerUser: number;
            askSharePermission?: boolean | null;
            sharePrompt?: string | null;
            noPhotosMessage?: string | null;
            maxVisiblePhotos: number;
          }
        | {
            __typename?: 'RaffleViewConfig';
            optionalImageUrl?: string | null;
            claimYourPrize?: string | null;
            ticketFlipDirection: RaffleTicketFlipDirection;
          }
        | {
            __typename?: 'SlidesViewConfig';
            autoPlay: boolean;
            autoPlayIntervalMs?: number | null;
          }
        | {
            __typename?: 'TriviaViewConfig';
            instructions?: string | null;
            useQuestionTimer: boolean;
            defaultTimerMs: number;
            questions: Array<{
              __typename?: 'TriviaViewQuestion';
              id: string;
              text: string;
              timerMs?: number | null;
              choices: Array<{
                __typename?: 'TriviaChoice';
                id: string;
                text: string;
              }>;
            }>;
          }
        | { __typename?: 'VoteForViewConfig'; votesPerUser: number };
      viewData:
        | { __typename?: 'NowPlayingViewData'; currentSong?: string | null }
        | {
            __typename?: 'PhotoCarouselViewData';
            visibleSubmission?: string | null;
          }
        | {
            __typename?: 'RaffleViewData';
            raffleStatus: RaffleStatus;
            raffleCandidates: Array<string>;
            raffleWinners: Array<string>;
            raffleWinner?: string | null;
            winnerCount: number;
            remainingSubmissionIds: Array<string>;
            lastEliminatedSubmissionId?: string | null;
          }
        | {
            __typename?: 'SlidesViewData';
            currentSlide: string;
            slidesDisplayOrder: Array<string>;
          }
        | {
            __typename?: 'TriviaViewData';
            status: TriviaRoundStatus;
            questionIndex: number;
            questionEndsAt?: any | null;
            answeredCount: number;
            playerCount: number;
            correctChoiceId?: string | null;
            correctCount?: number | null;
            leaderboardOverflow: number;
            tallies: Array<{
              __typename?: 'TriviaTally';
              choiceId: string;
              count: number;
            }>;
            leaderboard: Array<{
              __typename?: 'TriviaLeaderboardRow';
              userId: string;
              name: string;
              score: number;
              rank: number;
              tied: boolean;
            }>;
          }
        | {
            __typename?: 'VoteForViewData';
            voteWinners?: Array<string> | null;
            choiceDisplayOrder: Array<string>;
            votes: Array<{
              __typename?: 'VoteCount';
              submissionId: string;
              count: number;
            }>;
          };
    } | null;
    engagements: Array<{
      __typename?: 'Engagement';
      id: string;
      eventId: string;
      createdAt: any;
      updatedAt: any;
      title: string;
      description?: string | null;
      qrCodeCta?: string | null;
      startTime?: any | null;
      order: number;
      endTime?: any | null;
      type: EngagementType;
      data?:
        | { __typename?: 'NowPlayingAdminData'; currentSong?: string | null }
        | {
            __typename?: 'PhotoCarouselAdminData';
            visibleSubmission?: string | null;
            rejectedQueue: Array<string>;
            unapprovedQueue: Array<string>;
            unseenQueue: Array<string>;
            seenQueuePointer: number;
            seenQueue: Array<string>;
          }
        | {
            __typename?: 'RaffleAdminData';
            raffleStatus: RaffleStatus;
            raffleCandidates: Array<string>;
            raffleWinners: Array<string>;
            raffleWinner?: string | null;
            winnerCount: number;
            remainingSubmissionIds: Array<string>;
            lastEliminatedSubmissionId?: string | null;
          }
        | {
            __typename?: 'SlidesAdminData';
            currentSlide: string;
            slidesDisplayOrder: Array<string>;
          }
        | {
            __typename?: 'TriviaAdminData';
            status: TriviaRoundStatus;
            questionIndex: number;
            playedThroughIndex: number;
            reviewing: boolean;
            questionEndsAt?: any | null;
            answeredCount: number;
            playerCount: number;
            correctChoiceId?: string | null;
            correctCount?: number | null;
            revealedQuestionIds: Array<string>;
            tallies: Array<{
              __typename?: 'TriviaTally';
              choiceId: string;
              count: number;
            }>;
            leaderboard: Array<{
              __typename?: 'TriviaLeaderboardRow';
              userId: string;
              name: string;
              score: number;
              rank: number;
              tied: boolean;
            }>;
          }
        | {
            __typename?: 'VoteForAdminData';
            startTime?: any | null;
            endTime?: any | null;
            voteWinners?: Array<string> | null;
            choiceDisplayOrder: Array<string>;
            votes: Array<{
              __typename?: 'VoteCount';
              submissionId: string;
              count: number;
            }>;
          }
        | null;
      config?:
        | {
            __typename?: 'NowPlayingAdminConfig';
            visualizationType: string;
            allowComments: boolean;
            allowedReactions: Array<string>;
          }
        | {
            __typename?: 'PhotoCarouselAdminConfig';
            maxSubmissionsPerUser: number;
            requireApproval: boolean;
            askSharePermission?: boolean | null;
            sharePrompt?: string | null;
            noPhotosMessage?: string | null;
            pollInterval?: number | null;
            predefinedCaptions?: Array<string> | null;
            maxVisiblePhotos: number;
          }
        | {
            __typename?: 'RaffleAdminConfig';
            optionalImageUrl?: string | null;
            claimYourPrize?: string | null;
            ticketFlipDirection: RaffleTicketFlipDirection;
          }
        | {
            __typename?: 'SlidesAdminConfig';
            autoPlay: boolean;
            autoPlayIntervalMs?: number | null;
          }
        | {
            __typename?: 'TriviaAdminConfig';
            instructions?: string | null;
            useQuestionTimer: boolean;
            defaultTimerMs: number;
            questions: Array<{
              __typename?: 'TriviaQuestion';
              id: string;
              text: string;
              correctChoiceId?: string | null;
              timerMs?: number | null;
              choices: Array<{
                __typename?: 'TriviaChoice';
                id: string;
                text: string;
              }>;
            }>;
          }
        | {
            __typename?: 'VoteForAdminConfig';
            votesPerUser: number;
            allowUserSubmissions: boolean;
            maxSubmissionsPerUser: number;
          }
        | null;
      viewConfig:
        | {
            __typename?: 'NowPlayingViewConfig';
            visualizationType: string;
            allowComments: boolean;
            allowedReactions: Array<string>;
          }
        | {
            __typename?: 'PhotoCarouselViewConfig';
            maxSubmissionsPerUser: number;
            askSharePermission?: boolean | null;
            sharePrompt?: string | null;
            noPhotosMessage?: string | null;
            maxVisiblePhotos: number;
          }
        | {
            __typename?: 'RaffleViewConfig';
            optionalImageUrl?: string | null;
            claimYourPrize?: string | null;
            ticketFlipDirection: RaffleTicketFlipDirection;
          }
        | {
            __typename?: 'SlidesViewConfig';
            autoPlay: boolean;
            autoPlayIntervalMs?: number | null;
          }
        | {
            __typename?: 'TriviaViewConfig';
            instructions?: string | null;
            useQuestionTimer: boolean;
            defaultTimerMs: number;
            questions: Array<{
              __typename?: 'TriviaViewQuestion';
              id: string;
              text: string;
              timerMs?: number | null;
              choices: Array<{
                __typename?: 'TriviaChoice';
                id: string;
                text: string;
              }>;
            }>;
          }
        | { __typename?: 'VoteForViewConfig'; votesPerUser: number };
      viewData:
        | { __typename?: 'NowPlayingViewData'; currentSong?: string | null }
        | {
            __typename?: 'PhotoCarouselViewData';
            visibleSubmission?: string | null;
          }
        | {
            __typename?: 'RaffleViewData';
            raffleStatus: RaffleStatus;
            raffleCandidates: Array<string>;
            raffleWinners: Array<string>;
            raffleWinner?: string | null;
            winnerCount: number;
            remainingSubmissionIds: Array<string>;
            lastEliminatedSubmissionId?: string | null;
          }
        | {
            __typename?: 'SlidesViewData';
            currentSlide: string;
            slidesDisplayOrder: Array<string>;
          }
        | {
            __typename?: 'TriviaViewData';
            status: TriviaRoundStatus;
            questionIndex: number;
            questionEndsAt?: any | null;
            answeredCount: number;
            playerCount: number;
            correctChoiceId?: string | null;
            correctCount?: number | null;
            leaderboardOverflow: number;
            tallies: Array<{
              __typename?: 'TriviaTally';
              choiceId: string;
              count: number;
            }>;
            leaderboard: Array<{
              __typename?: 'TriviaLeaderboardRow';
              userId: string;
              name: string;
              score: number;
              rank: number;
              tied: boolean;
            }>;
          }
        | {
            __typename?: 'VoteForViewData';
            voteWinners?: Array<string> | null;
            choiceDisplayOrder: Array<string>;
            votes: Array<{
              __typename?: 'VoteCount';
              submissionId: string;
              count: number;
            }>;
          };
    }>;
    subscriptionInUse?: {
      __typename?: 'PaymentSubscription';
      id: string;
      userId: string;
      status: PaymentSubscriptionStatus;
      stripeSubscriptionId: string;
      currentPeriodStart?: any | null;
      currentPeriodEnd?: any | null;
      cancelAtPeriodEnd: boolean;
      canceledAt?: any | null;
      trialStart?: any | null;
      trialEnd?: any | null;
      maxConcurrentEvents: number;
      createdAt: any;
      updatedAt: any;
      liveEvents: Array<{ __typename?: 'Event'; id: string; name: string }>;
    } | null;
    eventPassRedemptionInUse?: {
      __typename?: 'EventPassRedemption';
      id: string;
      eventPassId: string;
      eventId: string;
      redeemedAt: any;
      description?: string | null;
      expiresAt?: any | null;
    } | null;
  };
};

export type EndLiveSessionMutationVariables = Exact<{
  eventId: Scalars['String']['input'];
}>;

export type EndLiveSessionMutation = {
  __typename?: 'Mutation';
  endLiveSession: {
    __typename?: 'Event';
    id: string;
    name: string;
    date?: any | null;
    live: boolean;
    location?: string | null;
    locked: boolean;
    description?: string | null;
    createdAt: any;
    updatedAt: any;
    activeEngagementId?: string | null;
    screenCode?: string | null;
    themeConfig?: {
      __typename?: 'EventThemeConfig';
      headingFontFamily?: Array<string> | null;
      bodyFontFamily?: Array<string> | null;
      foregroundColor?: string | null;
      backgroundColor?: string | null;
      stageBackgroundImage?: string | null;
      fanBackgroundImage?: string | null;
      qrForegroundColor?: string | null;
      qrBackgroundColor?: string | null;
      qrTextColor?: string | null;
      qrWrapperBackgroundColor?: string | null;
      stageElements?: Array<{
        __typename?: 'ScreenElement';
        id: string;
        type: string;
        name?: string | null;
        imageUrl?: string | null;
        defaultStyles?: any | null;
        engagementStyles?: any | null;
        defaultClassNames?: string | null;
        engagementClassNames?: string | null;
        text?: string | null;
        textType?: string | null;
        fontFamily?: Array<string> | null;
        linkHref?: string | null;
        color?: string | null;
      }> | null;
      fanElements?: Array<{
        __typename?: 'ScreenElement';
        id: string;
        type: string;
        name?: string | null;
        imageUrl?: string | null;
        defaultStyles?: any | null;
        engagementStyles?: any | null;
        defaultClassNames?: string | null;
        engagementClassNames?: string | null;
        text?: string | null;
        textType?: string | null;
        fontFamily?: Array<string> | null;
        linkHref?: string | null;
        color?: string | null;
      }> | null;
    } | null;
    activeEngagement?: {
      __typename?: 'Engagement';
      id: string;
      eventId: string;
      createdAt: any;
      updatedAt: any;
      title: string;
      description?: string | null;
      qrCodeCta?: string | null;
      startTime?: any | null;
      order: number;
      endTime?: any | null;
      type: EngagementType;
      data?:
        | { __typename?: 'NowPlayingAdminData'; currentSong?: string | null }
        | {
            __typename?: 'PhotoCarouselAdminData';
            visibleSubmission?: string | null;
            rejectedQueue: Array<string>;
            unapprovedQueue: Array<string>;
            unseenQueue: Array<string>;
            seenQueuePointer: number;
            seenQueue: Array<string>;
          }
        | {
            __typename?: 'RaffleAdminData';
            raffleStatus: RaffleStatus;
            raffleCandidates: Array<string>;
            raffleWinners: Array<string>;
            raffleWinner?: string | null;
            winnerCount: number;
            remainingSubmissionIds: Array<string>;
            lastEliminatedSubmissionId?: string | null;
          }
        | {
            __typename?: 'SlidesAdminData';
            currentSlide: string;
            slidesDisplayOrder: Array<string>;
          }
        | {
            __typename?: 'TriviaAdminData';
            status: TriviaRoundStatus;
            questionIndex: number;
            playedThroughIndex: number;
            reviewing: boolean;
            questionEndsAt?: any | null;
            answeredCount: number;
            playerCount: number;
            correctChoiceId?: string | null;
            correctCount?: number | null;
            revealedQuestionIds: Array<string>;
            tallies: Array<{
              __typename?: 'TriviaTally';
              choiceId: string;
              count: number;
            }>;
            leaderboard: Array<{
              __typename?: 'TriviaLeaderboardRow';
              userId: string;
              name: string;
              score: number;
              rank: number;
              tied: boolean;
            }>;
          }
        | {
            __typename?: 'VoteForAdminData';
            startTime?: any | null;
            endTime?: any | null;
            voteWinners?: Array<string> | null;
            choiceDisplayOrder: Array<string>;
            votes: Array<{
              __typename?: 'VoteCount';
              submissionId: string;
              count: number;
            }>;
          }
        | null;
      config?:
        | {
            __typename?: 'NowPlayingAdminConfig';
            visualizationType: string;
            allowComments: boolean;
            allowedReactions: Array<string>;
          }
        | {
            __typename?: 'PhotoCarouselAdminConfig';
            maxSubmissionsPerUser: number;
            requireApproval: boolean;
            askSharePermission?: boolean | null;
            sharePrompt?: string | null;
            noPhotosMessage?: string | null;
            pollInterval?: number | null;
            predefinedCaptions?: Array<string> | null;
            maxVisiblePhotos: number;
          }
        | {
            __typename?: 'RaffleAdminConfig';
            optionalImageUrl?: string | null;
            claimYourPrize?: string | null;
            ticketFlipDirection: RaffleTicketFlipDirection;
          }
        | {
            __typename?: 'SlidesAdminConfig';
            autoPlay: boolean;
            autoPlayIntervalMs?: number | null;
          }
        | {
            __typename?: 'TriviaAdminConfig';
            instructions?: string | null;
            useQuestionTimer: boolean;
            defaultTimerMs: number;
            questions: Array<{
              __typename?: 'TriviaQuestion';
              id: string;
              text: string;
              correctChoiceId?: string | null;
              timerMs?: number | null;
              choices: Array<{
                __typename?: 'TriviaChoice';
                id: string;
                text: string;
              }>;
            }>;
          }
        | {
            __typename?: 'VoteForAdminConfig';
            votesPerUser: number;
            allowUserSubmissions: boolean;
            maxSubmissionsPerUser: number;
          }
        | null;
      viewConfig:
        | {
            __typename?: 'NowPlayingViewConfig';
            visualizationType: string;
            allowComments: boolean;
            allowedReactions: Array<string>;
          }
        | {
            __typename?: 'PhotoCarouselViewConfig';
            maxSubmissionsPerUser: number;
            askSharePermission?: boolean | null;
            sharePrompt?: string | null;
            noPhotosMessage?: string | null;
            maxVisiblePhotos: number;
          }
        | {
            __typename?: 'RaffleViewConfig';
            optionalImageUrl?: string | null;
            claimYourPrize?: string | null;
            ticketFlipDirection: RaffleTicketFlipDirection;
          }
        | {
            __typename?: 'SlidesViewConfig';
            autoPlay: boolean;
            autoPlayIntervalMs?: number | null;
          }
        | {
            __typename?: 'TriviaViewConfig';
            instructions?: string | null;
            useQuestionTimer: boolean;
            defaultTimerMs: number;
            questions: Array<{
              __typename?: 'TriviaViewQuestion';
              id: string;
              text: string;
              timerMs?: number | null;
              choices: Array<{
                __typename?: 'TriviaChoice';
                id: string;
                text: string;
              }>;
            }>;
          }
        | { __typename?: 'VoteForViewConfig'; votesPerUser: number };
      viewData:
        | { __typename?: 'NowPlayingViewData'; currentSong?: string | null }
        | {
            __typename?: 'PhotoCarouselViewData';
            visibleSubmission?: string | null;
          }
        | {
            __typename?: 'RaffleViewData';
            raffleStatus: RaffleStatus;
            raffleCandidates: Array<string>;
            raffleWinners: Array<string>;
            raffleWinner?: string | null;
            winnerCount: number;
            remainingSubmissionIds: Array<string>;
            lastEliminatedSubmissionId?: string | null;
          }
        | {
            __typename?: 'SlidesViewData';
            currentSlide: string;
            slidesDisplayOrder: Array<string>;
          }
        | {
            __typename?: 'TriviaViewData';
            status: TriviaRoundStatus;
            questionIndex: number;
            questionEndsAt?: any | null;
            answeredCount: number;
            playerCount: number;
            correctChoiceId?: string | null;
            correctCount?: number | null;
            leaderboardOverflow: number;
            tallies: Array<{
              __typename?: 'TriviaTally';
              choiceId: string;
              count: number;
            }>;
            leaderboard: Array<{
              __typename?: 'TriviaLeaderboardRow';
              userId: string;
              name: string;
              score: number;
              rank: number;
              tied: boolean;
            }>;
          }
        | {
            __typename?: 'VoteForViewData';
            voteWinners?: Array<string> | null;
            choiceDisplayOrder: Array<string>;
            votes: Array<{
              __typename?: 'VoteCount';
              submissionId: string;
              count: number;
            }>;
          };
    } | null;
    engagements: Array<{
      __typename?: 'Engagement';
      id: string;
      eventId: string;
      createdAt: any;
      updatedAt: any;
      title: string;
      description?: string | null;
      qrCodeCta?: string | null;
      startTime?: any | null;
      order: number;
      endTime?: any | null;
      type: EngagementType;
      data?:
        | { __typename?: 'NowPlayingAdminData'; currentSong?: string | null }
        | {
            __typename?: 'PhotoCarouselAdminData';
            visibleSubmission?: string | null;
            rejectedQueue: Array<string>;
            unapprovedQueue: Array<string>;
            unseenQueue: Array<string>;
            seenQueuePointer: number;
            seenQueue: Array<string>;
          }
        | {
            __typename?: 'RaffleAdminData';
            raffleStatus: RaffleStatus;
            raffleCandidates: Array<string>;
            raffleWinners: Array<string>;
            raffleWinner?: string | null;
            winnerCount: number;
            remainingSubmissionIds: Array<string>;
            lastEliminatedSubmissionId?: string | null;
          }
        | {
            __typename?: 'SlidesAdminData';
            currentSlide: string;
            slidesDisplayOrder: Array<string>;
          }
        | {
            __typename?: 'TriviaAdminData';
            status: TriviaRoundStatus;
            questionIndex: number;
            playedThroughIndex: number;
            reviewing: boolean;
            questionEndsAt?: any | null;
            answeredCount: number;
            playerCount: number;
            correctChoiceId?: string | null;
            correctCount?: number | null;
            revealedQuestionIds: Array<string>;
            tallies: Array<{
              __typename?: 'TriviaTally';
              choiceId: string;
              count: number;
            }>;
            leaderboard: Array<{
              __typename?: 'TriviaLeaderboardRow';
              userId: string;
              name: string;
              score: number;
              rank: number;
              tied: boolean;
            }>;
          }
        | {
            __typename?: 'VoteForAdminData';
            startTime?: any | null;
            endTime?: any | null;
            voteWinners?: Array<string> | null;
            choiceDisplayOrder: Array<string>;
            votes: Array<{
              __typename?: 'VoteCount';
              submissionId: string;
              count: number;
            }>;
          }
        | null;
      config?:
        | {
            __typename?: 'NowPlayingAdminConfig';
            visualizationType: string;
            allowComments: boolean;
            allowedReactions: Array<string>;
          }
        | {
            __typename?: 'PhotoCarouselAdminConfig';
            maxSubmissionsPerUser: number;
            requireApproval: boolean;
            askSharePermission?: boolean | null;
            sharePrompt?: string | null;
            noPhotosMessage?: string | null;
            pollInterval?: number | null;
            predefinedCaptions?: Array<string> | null;
            maxVisiblePhotos: number;
          }
        | {
            __typename?: 'RaffleAdminConfig';
            optionalImageUrl?: string | null;
            claimYourPrize?: string | null;
            ticketFlipDirection: RaffleTicketFlipDirection;
          }
        | {
            __typename?: 'SlidesAdminConfig';
            autoPlay: boolean;
            autoPlayIntervalMs?: number | null;
          }
        | {
            __typename?: 'TriviaAdminConfig';
            instructions?: string | null;
            useQuestionTimer: boolean;
            defaultTimerMs: number;
            questions: Array<{
              __typename?: 'TriviaQuestion';
              id: string;
              text: string;
              correctChoiceId?: string | null;
              timerMs?: number | null;
              choices: Array<{
                __typename?: 'TriviaChoice';
                id: string;
                text: string;
              }>;
            }>;
          }
        | {
            __typename?: 'VoteForAdminConfig';
            votesPerUser: number;
            allowUserSubmissions: boolean;
            maxSubmissionsPerUser: number;
          }
        | null;
      viewConfig:
        | {
            __typename?: 'NowPlayingViewConfig';
            visualizationType: string;
            allowComments: boolean;
            allowedReactions: Array<string>;
          }
        | {
            __typename?: 'PhotoCarouselViewConfig';
            maxSubmissionsPerUser: number;
            askSharePermission?: boolean | null;
            sharePrompt?: string | null;
            noPhotosMessage?: string | null;
            maxVisiblePhotos: number;
          }
        | {
            __typename?: 'RaffleViewConfig';
            optionalImageUrl?: string | null;
            claimYourPrize?: string | null;
            ticketFlipDirection: RaffleTicketFlipDirection;
          }
        | {
            __typename?: 'SlidesViewConfig';
            autoPlay: boolean;
            autoPlayIntervalMs?: number | null;
          }
        | {
            __typename?: 'TriviaViewConfig';
            instructions?: string | null;
            useQuestionTimer: boolean;
            defaultTimerMs: number;
            questions: Array<{
              __typename?: 'TriviaViewQuestion';
              id: string;
              text: string;
              timerMs?: number | null;
              choices: Array<{
                __typename?: 'TriviaChoice';
                id: string;
                text: string;
              }>;
            }>;
          }
        | { __typename?: 'VoteForViewConfig'; votesPerUser: number };
      viewData:
        | { __typename?: 'NowPlayingViewData'; currentSong?: string | null }
        | {
            __typename?: 'PhotoCarouselViewData';
            visibleSubmission?: string | null;
          }
        | {
            __typename?: 'RaffleViewData';
            raffleStatus: RaffleStatus;
            raffleCandidates: Array<string>;
            raffleWinners: Array<string>;
            raffleWinner?: string | null;
            winnerCount: number;
            remainingSubmissionIds: Array<string>;
            lastEliminatedSubmissionId?: string | null;
          }
        | {
            __typename?: 'SlidesViewData';
            currentSlide: string;
            slidesDisplayOrder: Array<string>;
          }
        | {
            __typename?: 'TriviaViewData';
            status: TriviaRoundStatus;
            questionIndex: number;
            questionEndsAt?: any | null;
            answeredCount: number;
            playerCount: number;
            correctChoiceId?: string | null;
            correctCount?: number | null;
            leaderboardOverflow: number;
            tallies: Array<{
              __typename?: 'TriviaTally';
              choiceId: string;
              count: number;
            }>;
            leaderboard: Array<{
              __typename?: 'TriviaLeaderboardRow';
              userId: string;
              name: string;
              score: number;
              rank: number;
              tied: boolean;
            }>;
          }
        | {
            __typename?: 'VoteForViewData';
            voteWinners?: Array<string> | null;
            choiceDisplayOrder: Array<string>;
            votes: Array<{
              __typename?: 'VoteCount';
              submissionId: string;
              count: number;
            }>;
          };
    }>;
    subscriptionInUse?: {
      __typename?: 'PaymentSubscription';
      id: string;
      userId: string;
      status: PaymentSubscriptionStatus;
      stripeSubscriptionId: string;
      currentPeriodStart?: any | null;
      currentPeriodEnd?: any | null;
      cancelAtPeriodEnd: boolean;
      canceledAt?: any | null;
      trialStart?: any | null;
      trialEnd?: any | null;
      maxConcurrentEvents: number;
      createdAt: any;
      updatedAt: any;
      liveEvents: Array<{ __typename?: 'Event'; id: string; name: string }>;
    } | null;
    eventPassRedemptionInUse?: {
      __typename?: 'EventPassRedemption';
      id: string;
      eventPassId: string;
      eventId: string;
      redeemedAt: any;
      description?: string | null;
      expiresAt?: any | null;
    } | null;
  };
};

export type CreateScreenTemplateMutationVariables = Exact<{
  data: ScreenTemplateCreateInput;
}>;

export type CreateScreenTemplateMutation = {
  __typename?: 'Mutation';
  createScreenTemplate: {
    __typename?: 'ScreenTemplate';
    id: string;
    name: string;
    description?: string | null;
    createdAt: any;
    updatedAt: any;
    enabled: boolean;
    config?: {
      __typename?: 'EventThemeConfig';
      headingFontFamily?: Array<string> | null;
      bodyFontFamily?: Array<string> | null;
      foregroundColor?: string | null;
      backgroundColor?: string | null;
      stageBackgroundImage?: string | null;
      fanBackgroundImage?: string | null;
      qrForegroundColor?: string | null;
      qrBackgroundColor?: string | null;
      qrTextColor?: string | null;
      qrWrapperBackgroundColor?: string | null;
      stageElements?: Array<{
        __typename?: 'ScreenElement';
        id: string;
        type: string;
        name?: string | null;
        imageUrl?: string | null;
        defaultStyles?: any | null;
        engagementStyles?: any | null;
        defaultClassNames?: string | null;
        engagementClassNames?: string | null;
        text?: string | null;
        textType?: string | null;
        fontFamily?: Array<string> | null;
        linkHref?: string | null;
        color?: string | null;
      }> | null;
      fanElements?: Array<{
        __typename?: 'ScreenElement';
        id: string;
        type: string;
        name?: string | null;
        imageUrl?: string | null;
        defaultStyles?: any | null;
        engagementStyles?: any | null;
        defaultClassNames?: string | null;
        engagementClassNames?: string | null;
        text?: string | null;
        textType?: string | null;
        fontFamily?: Array<string> | null;
        linkHref?: string | null;
        color?: string | null;
      }> | null;
    } | null;
    engagements: Array<{
      __typename?: 'ScreenTemplateEngagementInput';
      data?: any | null;
      description?: string | null;
      config?: any | null;
      endTime?: any | null;
      qrCodeCta?: string | null;
      startTime?: any | null;
      title: string;
      type: EngagementType;
    }>;
  };
};

export type UpdateScreenTemplateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  data: ScreenTemplateUpdateInput;
}>;

export type UpdateScreenTemplateMutation = {
  __typename?: 'Mutation';
  updateScreenTemplate: {
    __typename?: 'ScreenTemplate';
    id: string;
    name: string;
    description?: string | null;
    createdAt: any;
    updatedAt: any;
    enabled: boolean;
    config?: {
      __typename?: 'EventThemeConfig';
      headingFontFamily?: Array<string> | null;
      bodyFontFamily?: Array<string> | null;
      foregroundColor?: string | null;
      backgroundColor?: string | null;
      stageBackgroundImage?: string | null;
      fanBackgroundImage?: string | null;
      qrForegroundColor?: string | null;
      qrBackgroundColor?: string | null;
      qrTextColor?: string | null;
      qrWrapperBackgroundColor?: string | null;
      stageElements?: Array<{
        __typename?: 'ScreenElement';
        id: string;
        type: string;
        name?: string | null;
        imageUrl?: string | null;
        defaultStyles?: any | null;
        engagementStyles?: any | null;
        defaultClassNames?: string | null;
        engagementClassNames?: string | null;
        text?: string | null;
        textType?: string | null;
        fontFamily?: Array<string> | null;
        linkHref?: string | null;
        color?: string | null;
      }> | null;
      fanElements?: Array<{
        __typename?: 'ScreenElement';
        id: string;
        type: string;
        name?: string | null;
        imageUrl?: string | null;
        defaultStyles?: any | null;
        engagementStyles?: any | null;
        defaultClassNames?: string | null;
        engagementClassNames?: string | null;
        text?: string | null;
        textType?: string | null;
        fontFamily?: Array<string> | null;
        linkHref?: string | null;
        color?: string | null;
      }> | null;
    } | null;
    engagements: Array<{
      __typename?: 'ScreenTemplateEngagementInput';
      data?: any | null;
      description?: string | null;
      config?: any | null;
      endTime?: any | null;
      qrCodeCta?: string | null;
      startTime?: any | null;
      title: string;
      type: EngagementType;
    }>;
  };
};

export type DeleteScreenTemplateMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type DeleteScreenTemplateMutation = {
  __typename?: 'Mutation';
  deleteScreenTemplate: { __typename?: 'ScreenTemplate'; id: string };
};

export type CreateCustomerPortalSessionMutationVariables = Exact<{
  [key: string]: never;
}>;

export type CreateCustomerPortalSessionMutation = {
  __typename?: 'Mutation';
  createCustomerPortalSession: {
    __typename?: 'CreateCustomerPortalSessionResponse';
    url: string;
  };
};

export type RequestPasswordResetMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;

export type RequestPasswordResetMutation = {
  __typename?: 'Mutation';
  requestPasswordReset: {
    __typename?: 'RequestPasswordResetResponse';
    success: boolean;
    message: string;
  };
};

export type ResetPasswordMutationVariables = Exact<{
  token: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;

export type ResetPasswordMutation = {
  __typename?: 'Mutation';
  resetPassword: { __typename?: 'ResetPasswordResponse'; success: boolean };
};

export type SetCookieConsentMutationVariables = Exact<{
  preferences: CookiePreferencesInput;
}>;

export type SetCookieConsentMutation = {
  __typename?: 'Mutation';
  setCookieConsent: {
    __typename?: 'SetCookieConsentResponse';
    success: boolean;
    user: {
      __typename?: 'User';
      id: string;
      email?: string | null;
      role: Role;
      createdAt: any;
    };
  };
};

export type SignupForBetaMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;

export type SignupForBetaMutation = {
  __typename?: 'Mutation';
  signupForBeta: { __typename?: 'SignupForBetaResponse'; success: boolean };
};

export type GetEventsQueryVariables = Exact<{ [key: string]: never }>;

export type GetEventsQuery = {
  __typename?: 'Query';
  events: Array<{
    __typename?: 'Event';
    id: string;
    name: string;
    date?: any | null;
    live: boolean;
    location?: string | null;
    locked: boolean;
    description?: string | null;
    createdAt: any;
    updatedAt: any;
    activeEngagementId?: string | null;
    screenCode?: string | null;
    themeConfig?: {
      __typename?: 'EventThemeConfig';
      headingFontFamily?: Array<string> | null;
      bodyFontFamily?: Array<string> | null;
      foregroundColor?: string | null;
      backgroundColor?: string | null;
      stageBackgroundImage?: string | null;
      fanBackgroundImage?: string | null;
      qrForegroundColor?: string | null;
      qrBackgroundColor?: string | null;
      qrTextColor?: string | null;
      qrWrapperBackgroundColor?: string | null;
      stageElements?: Array<{
        __typename?: 'ScreenElement';
        id: string;
        type: string;
        name?: string | null;
        imageUrl?: string | null;
        defaultStyles?: any | null;
        engagementStyles?: any | null;
        defaultClassNames?: string | null;
        engagementClassNames?: string | null;
        text?: string | null;
        textType?: string | null;
        fontFamily?: Array<string> | null;
        linkHref?: string | null;
        color?: string | null;
      }> | null;
      fanElements?: Array<{
        __typename?: 'ScreenElement';
        id: string;
        type: string;
        name?: string | null;
        imageUrl?: string | null;
        defaultStyles?: any | null;
        engagementStyles?: any | null;
        defaultClassNames?: string | null;
        engagementClassNames?: string | null;
        text?: string | null;
        textType?: string | null;
        fontFamily?: Array<string> | null;
        linkHref?: string | null;
        color?: string | null;
      }> | null;
    } | null;
    activeEngagement?: {
      __typename?: 'Engagement';
      id: string;
      eventId: string;
      createdAt: any;
      updatedAt: any;
      title: string;
      description?: string | null;
      qrCodeCta?: string | null;
      startTime?: any | null;
      order: number;
      endTime?: any | null;
      type: EngagementType;
      data?:
        | { __typename?: 'NowPlayingAdminData'; currentSong?: string | null }
        | {
            __typename?: 'PhotoCarouselAdminData';
            visibleSubmission?: string | null;
            rejectedQueue: Array<string>;
            unapprovedQueue: Array<string>;
            unseenQueue: Array<string>;
            seenQueuePointer: number;
            seenQueue: Array<string>;
          }
        | {
            __typename?: 'RaffleAdminData';
            raffleStatus: RaffleStatus;
            raffleCandidates: Array<string>;
            raffleWinners: Array<string>;
            raffleWinner?: string | null;
            winnerCount: number;
            remainingSubmissionIds: Array<string>;
            lastEliminatedSubmissionId?: string | null;
          }
        | {
            __typename?: 'SlidesAdminData';
            currentSlide: string;
            slidesDisplayOrder: Array<string>;
          }
        | {
            __typename?: 'TriviaAdminData';
            status: TriviaRoundStatus;
            questionIndex: number;
            playedThroughIndex: number;
            reviewing: boolean;
            questionEndsAt?: any | null;
            answeredCount: number;
            playerCount: number;
            correctChoiceId?: string | null;
            correctCount?: number | null;
            revealedQuestionIds: Array<string>;
            tallies: Array<{
              __typename?: 'TriviaTally';
              choiceId: string;
              count: number;
            }>;
            leaderboard: Array<{
              __typename?: 'TriviaLeaderboardRow';
              userId: string;
              name: string;
              score: number;
              rank: number;
              tied: boolean;
            }>;
          }
        | {
            __typename?: 'VoteForAdminData';
            startTime?: any | null;
            endTime?: any | null;
            voteWinners?: Array<string> | null;
            choiceDisplayOrder: Array<string>;
            votes: Array<{
              __typename?: 'VoteCount';
              submissionId: string;
              count: number;
            }>;
          }
        | null;
      config?:
        | {
            __typename?: 'NowPlayingAdminConfig';
            visualizationType: string;
            allowComments: boolean;
            allowedReactions: Array<string>;
          }
        | {
            __typename?: 'PhotoCarouselAdminConfig';
            maxSubmissionsPerUser: number;
            requireApproval: boolean;
            askSharePermission?: boolean | null;
            sharePrompt?: string | null;
            noPhotosMessage?: string | null;
            pollInterval?: number | null;
            predefinedCaptions?: Array<string> | null;
            maxVisiblePhotos: number;
          }
        | {
            __typename?: 'RaffleAdminConfig';
            optionalImageUrl?: string | null;
            claimYourPrize?: string | null;
            ticketFlipDirection: RaffleTicketFlipDirection;
          }
        | {
            __typename?: 'SlidesAdminConfig';
            autoPlay: boolean;
            autoPlayIntervalMs?: number | null;
          }
        | {
            __typename?: 'TriviaAdminConfig';
            instructions?: string | null;
            useQuestionTimer: boolean;
            defaultTimerMs: number;
            questions: Array<{
              __typename?: 'TriviaQuestion';
              id: string;
              text: string;
              correctChoiceId?: string | null;
              timerMs?: number | null;
              choices: Array<{
                __typename?: 'TriviaChoice';
                id: string;
                text: string;
              }>;
            }>;
          }
        | {
            __typename?: 'VoteForAdminConfig';
            votesPerUser: number;
            allowUserSubmissions: boolean;
            maxSubmissionsPerUser: number;
          }
        | null;
      viewConfig:
        | {
            __typename?: 'NowPlayingViewConfig';
            visualizationType: string;
            allowComments: boolean;
            allowedReactions: Array<string>;
          }
        | {
            __typename?: 'PhotoCarouselViewConfig';
            maxSubmissionsPerUser: number;
            askSharePermission?: boolean | null;
            sharePrompt?: string | null;
            noPhotosMessage?: string | null;
            maxVisiblePhotos: number;
          }
        | {
            __typename?: 'RaffleViewConfig';
            optionalImageUrl?: string | null;
            claimYourPrize?: string | null;
            ticketFlipDirection: RaffleTicketFlipDirection;
          }
        | {
            __typename?: 'SlidesViewConfig';
            autoPlay: boolean;
            autoPlayIntervalMs?: number | null;
          }
        | {
            __typename?: 'TriviaViewConfig';
            instructions?: string | null;
            useQuestionTimer: boolean;
            defaultTimerMs: number;
            questions: Array<{
              __typename?: 'TriviaViewQuestion';
              id: string;
              text: string;
              timerMs?: number | null;
              choices: Array<{
                __typename?: 'TriviaChoice';
                id: string;
                text: string;
              }>;
            }>;
          }
        | { __typename?: 'VoteForViewConfig'; votesPerUser: number };
      viewData:
        | { __typename?: 'NowPlayingViewData'; currentSong?: string | null }
        | {
            __typename?: 'PhotoCarouselViewData';
            visibleSubmission?: string | null;
          }
        | {
            __typename?: 'RaffleViewData';
            raffleStatus: RaffleStatus;
            raffleCandidates: Array<string>;
            raffleWinners: Array<string>;
            raffleWinner?: string | null;
            winnerCount: number;
            remainingSubmissionIds: Array<string>;
            lastEliminatedSubmissionId?: string | null;
          }
        | {
            __typename?: 'SlidesViewData';
            currentSlide: string;
            slidesDisplayOrder: Array<string>;
          }
        | {
            __typename?: 'TriviaViewData';
            status: TriviaRoundStatus;
            questionIndex: number;
            questionEndsAt?: any | null;
            answeredCount: number;
            playerCount: number;
            correctChoiceId?: string | null;
            correctCount?: number | null;
            leaderboardOverflow: number;
            tallies: Array<{
              __typename?: 'TriviaTally';
              choiceId: string;
              count: number;
            }>;
            leaderboard: Array<{
              __typename?: 'TriviaLeaderboardRow';
              userId: string;
              name: string;
              score: number;
              rank: number;
              tied: boolean;
            }>;
          }
        | {
            __typename?: 'VoteForViewData';
            voteWinners?: Array<string> | null;
            choiceDisplayOrder: Array<string>;
            votes: Array<{
              __typename?: 'VoteCount';
              submissionId: string;
              count: number;
            }>;
          };
    } | null;
    engagements: Array<{
      __typename?: 'Engagement';
      id: string;
      eventId: string;
      createdAt: any;
      updatedAt: any;
      title: string;
      description?: string | null;
      qrCodeCta?: string | null;
      startTime?: any | null;
      order: number;
      endTime?: any | null;
      type: EngagementType;
      data?:
        | { __typename?: 'NowPlayingAdminData'; currentSong?: string | null }
        | {
            __typename?: 'PhotoCarouselAdminData';
            visibleSubmission?: string | null;
            rejectedQueue: Array<string>;
            unapprovedQueue: Array<string>;
            unseenQueue: Array<string>;
            seenQueuePointer: number;
            seenQueue: Array<string>;
          }
        | {
            __typename?: 'RaffleAdminData';
            raffleStatus: RaffleStatus;
            raffleCandidates: Array<string>;
            raffleWinners: Array<string>;
            raffleWinner?: string | null;
            winnerCount: number;
            remainingSubmissionIds: Array<string>;
            lastEliminatedSubmissionId?: string | null;
          }
        | {
            __typename?: 'SlidesAdminData';
            currentSlide: string;
            slidesDisplayOrder: Array<string>;
          }
        | {
            __typename?: 'TriviaAdminData';
            status: TriviaRoundStatus;
            questionIndex: number;
            playedThroughIndex: number;
            reviewing: boolean;
            questionEndsAt?: any | null;
            answeredCount: number;
            playerCount: number;
            correctChoiceId?: string | null;
            correctCount?: number | null;
            revealedQuestionIds: Array<string>;
            tallies: Array<{
              __typename?: 'TriviaTally';
              choiceId: string;
              count: number;
            }>;
            leaderboard: Array<{
              __typename?: 'TriviaLeaderboardRow';
              userId: string;
              name: string;
              score: number;
              rank: number;
              tied: boolean;
            }>;
          }
        | {
            __typename?: 'VoteForAdminData';
            startTime?: any | null;
            endTime?: any | null;
            voteWinners?: Array<string> | null;
            choiceDisplayOrder: Array<string>;
            votes: Array<{
              __typename?: 'VoteCount';
              submissionId: string;
              count: number;
            }>;
          }
        | null;
      config?:
        | {
            __typename?: 'NowPlayingAdminConfig';
            visualizationType: string;
            allowComments: boolean;
            allowedReactions: Array<string>;
          }
        | {
            __typename?: 'PhotoCarouselAdminConfig';
            maxSubmissionsPerUser: number;
            requireApproval: boolean;
            askSharePermission?: boolean | null;
            sharePrompt?: string | null;
            noPhotosMessage?: string | null;
            pollInterval?: number | null;
            predefinedCaptions?: Array<string> | null;
            maxVisiblePhotos: number;
          }
        | {
            __typename?: 'RaffleAdminConfig';
            optionalImageUrl?: string | null;
            claimYourPrize?: string | null;
            ticketFlipDirection: RaffleTicketFlipDirection;
          }
        | {
            __typename?: 'SlidesAdminConfig';
            autoPlay: boolean;
            autoPlayIntervalMs?: number | null;
          }
        | {
            __typename?: 'TriviaAdminConfig';
            instructions?: string | null;
            useQuestionTimer: boolean;
            defaultTimerMs: number;
            questions: Array<{
              __typename?: 'TriviaQuestion';
              id: string;
              text: string;
              correctChoiceId?: string | null;
              timerMs?: number | null;
              choices: Array<{
                __typename?: 'TriviaChoice';
                id: string;
                text: string;
              }>;
            }>;
          }
        | {
            __typename?: 'VoteForAdminConfig';
            votesPerUser: number;
            allowUserSubmissions: boolean;
            maxSubmissionsPerUser: number;
          }
        | null;
      viewConfig:
        | {
            __typename?: 'NowPlayingViewConfig';
            visualizationType: string;
            allowComments: boolean;
            allowedReactions: Array<string>;
          }
        | {
            __typename?: 'PhotoCarouselViewConfig';
            maxSubmissionsPerUser: number;
            askSharePermission?: boolean | null;
            sharePrompt?: string | null;
            noPhotosMessage?: string | null;
            maxVisiblePhotos: number;
          }
        | {
            __typename?: 'RaffleViewConfig';
            optionalImageUrl?: string | null;
            claimYourPrize?: string | null;
            ticketFlipDirection: RaffleTicketFlipDirection;
          }
        | {
            __typename?: 'SlidesViewConfig';
            autoPlay: boolean;
            autoPlayIntervalMs?: number | null;
          }
        | {
            __typename?: 'TriviaViewConfig';
            instructions?: string | null;
            useQuestionTimer: boolean;
            defaultTimerMs: number;
            questions: Array<{
              __typename?: 'TriviaViewQuestion';
              id: string;
              text: string;
              timerMs?: number | null;
              choices: Array<{
                __typename?: 'TriviaChoice';
                id: string;
                text: string;
              }>;
            }>;
          }
        | { __typename?: 'VoteForViewConfig'; votesPerUser: number };
      viewData:
        | { __typename?: 'NowPlayingViewData'; currentSong?: string | null }
        | {
            __typename?: 'PhotoCarouselViewData';
            visibleSubmission?: string | null;
          }
        | {
            __typename?: 'RaffleViewData';
            raffleStatus: RaffleStatus;
            raffleCandidates: Array<string>;
            raffleWinners: Array<string>;
            raffleWinner?: string | null;
            winnerCount: number;
            remainingSubmissionIds: Array<string>;
            lastEliminatedSubmissionId?: string | null;
          }
        | {
            __typename?: 'SlidesViewData';
            currentSlide: string;
            slidesDisplayOrder: Array<string>;
          }
        | {
            __typename?: 'TriviaViewData';
            status: TriviaRoundStatus;
            questionIndex: number;
            questionEndsAt?: any | null;
            answeredCount: number;
            playerCount: number;
            correctChoiceId?: string | null;
            correctCount?: number | null;
            leaderboardOverflow: number;
            tallies: Array<{
              __typename?: 'TriviaTally';
              choiceId: string;
              count: number;
            }>;
            leaderboard: Array<{
              __typename?: 'TriviaLeaderboardRow';
              userId: string;
              name: string;
              score: number;
              rank: number;
              tied: boolean;
            }>;
          }
        | {
            __typename?: 'VoteForViewData';
            voteWinners?: Array<string> | null;
            choiceDisplayOrder: Array<string>;
            votes: Array<{
              __typename?: 'VoteCount';
              submissionId: string;
              count: number;
            }>;
          };
    }>;
    subscriptionInUse?: {
      __typename?: 'PaymentSubscription';
      id: string;
      userId: string;
      status: PaymentSubscriptionStatus;
      stripeSubscriptionId: string;
      currentPeriodStart?: any | null;
      currentPeriodEnd?: any | null;
      cancelAtPeriodEnd: boolean;
      canceledAt?: any | null;
      trialStart?: any | null;
      trialEnd?: any | null;
      maxConcurrentEvents: number;
      createdAt: any;
      updatedAt: any;
      liveEvents: Array<{ __typename?: 'Event'; id: string; name: string }>;
    } | null;
    eventPassRedemptionInUse?: {
      __typename?: 'EventPassRedemption';
      id: string;
      eventPassId: string;
      eventId: string;
      redeemedAt: any;
      description?: string | null;
      expiresAt?: any | null;
    } | null;
  }>;
};

export type GetEventQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type GetEventQuery = {
  __typename?: 'Query';
  event?: {
    __typename?: 'Event';
    id: string;
    name: string;
    date?: any | null;
    live: boolean;
    location?: string | null;
    locked: boolean;
    description?: string | null;
    createdAt: any;
    updatedAt: any;
    activeEngagementId?: string | null;
    screenCode?: string | null;
    themeConfig?: {
      __typename?: 'EventThemeConfig';
      headingFontFamily?: Array<string> | null;
      bodyFontFamily?: Array<string> | null;
      foregroundColor?: string | null;
      backgroundColor?: string | null;
      stageBackgroundImage?: string | null;
      fanBackgroundImage?: string | null;
      qrForegroundColor?: string | null;
      qrBackgroundColor?: string | null;
      qrTextColor?: string | null;
      qrWrapperBackgroundColor?: string | null;
      stageElements?: Array<{
        __typename?: 'ScreenElement';
        id: string;
        type: string;
        name?: string | null;
        imageUrl?: string | null;
        defaultStyles?: any | null;
        engagementStyles?: any | null;
        defaultClassNames?: string | null;
        engagementClassNames?: string | null;
        text?: string | null;
        textType?: string | null;
        fontFamily?: Array<string> | null;
        linkHref?: string | null;
        color?: string | null;
      }> | null;
      fanElements?: Array<{
        __typename?: 'ScreenElement';
        id: string;
        type: string;
        name?: string | null;
        imageUrl?: string | null;
        defaultStyles?: any | null;
        engagementStyles?: any | null;
        defaultClassNames?: string | null;
        engagementClassNames?: string | null;
        text?: string | null;
        textType?: string | null;
        fontFamily?: Array<string> | null;
        linkHref?: string | null;
        color?: string | null;
      }> | null;
    } | null;
    activeEngagement?: {
      __typename?: 'Engagement';
      id: string;
      eventId: string;
      createdAt: any;
      updatedAt: any;
      title: string;
      description?: string | null;
      qrCodeCta?: string | null;
      startTime?: any | null;
      order: number;
      endTime?: any | null;
      type: EngagementType;
      data?:
        | { __typename?: 'NowPlayingAdminData'; currentSong?: string | null }
        | {
            __typename?: 'PhotoCarouselAdminData';
            visibleSubmission?: string | null;
            rejectedQueue: Array<string>;
            unapprovedQueue: Array<string>;
            unseenQueue: Array<string>;
            seenQueuePointer: number;
            seenQueue: Array<string>;
          }
        | {
            __typename?: 'RaffleAdminData';
            raffleStatus: RaffleStatus;
            raffleCandidates: Array<string>;
            raffleWinners: Array<string>;
            raffleWinner?: string | null;
            winnerCount: number;
            remainingSubmissionIds: Array<string>;
            lastEliminatedSubmissionId?: string | null;
          }
        | {
            __typename?: 'SlidesAdminData';
            currentSlide: string;
            slidesDisplayOrder: Array<string>;
          }
        | {
            __typename?: 'TriviaAdminData';
            status: TriviaRoundStatus;
            questionIndex: number;
            playedThroughIndex: number;
            reviewing: boolean;
            questionEndsAt?: any | null;
            answeredCount: number;
            playerCount: number;
            correctChoiceId?: string | null;
            correctCount?: number | null;
            revealedQuestionIds: Array<string>;
            tallies: Array<{
              __typename?: 'TriviaTally';
              choiceId: string;
              count: number;
            }>;
            leaderboard: Array<{
              __typename?: 'TriviaLeaderboardRow';
              userId: string;
              name: string;
              score: number;
              rank: number;
              tied: boolean;
            }>;
          }
        | {
            __typename?: 'VoteForAdminData';
            startTime?: any | null;
            endTime?: any | null;
            voteWinners?: Array<string> | null;
            choiceDisplayOrder: Array<string>;
            votes: Array<{
              __typename?: 'VoteCount';
              submissionId: string;
              count: number;
            }>;
          }
        | null;
      config?:
        | {
            __typename?: 'NowPlayingAdminConfig';
            visualizationType: string;
            allowComments: boolean;
            allowedReactions: Array<string>;
          }
        | {
            __typename?: 'PhotoCarouselAdminConfig';
            maxSubmissionsPerUser: number;
            requireApproval: boolean;
            askSharePermission?: boolean | null;
            sharePrompt?: string | null;
            noPhotosMessage?: string | null;
            pollInterval?: number | null;
            predefinedCaptions?: Array<string> | null;
            maxVisiblePhotos: number;
          }
        | {
            __typename?: 'RaffleAdminConfig';
            optionalImageUrl?: string | null;
            claimYourPrize?: string | null;
            ticketFlipDirection: RaffleTicketFlipDirection;
          }
        | {
            __typename?: 'SlidesAdminConfig';
            autoPlay: boolean;
            autoPlayIntervalMs?: number | null;
          }
        | {
            __typename?: 'TriviaAdminConfig';
            instructions?: string | null;
            useQuestionTimer: boolean;
            defaultTimerMs: number;
            questions: Array<{
              __typename?: 'TriviaQuestion';
              id: string;
              text: string;
              correctChoiceId?: string | null;
              timerMs?: number | null;
              choices: Array<{
                __typename?: 'TriviaChoice';
                id: string;
                text: string;
              }>;
            }>;
          }
        | {
            __typename?: 'VoteForAdminConfig';
            votesPerUser: number;
            allowUserSubmissions: boolean;
            maxSubmissionsPerUser: number;
          }
        | null;
      viewConfig:
        | {
            __typename?: 'NowPlayingViewConfig';
            visualizationType: string;
            allowComments: boolean;
            allowedReactions: Array<string>;
          }
        | {
            __typename?: 'PhotoCarouselViewConfig';
            maxSubmissionsPerUser: number;
            askSharePermission?: boolean | null;
            sharePrompt?: string | null;
            noPhotosMessage?: string | null;
            maxVisiblePhotos: number;
          }
        | {
            __typename?: 'RaffleViewConfig';
            optionalImageUrl?: string | null;
            claimYourPrize?: string | null;
            ticketFlipDirection: RaffleTicketFlipDirection;
          }
        | {
            __typename?: 'SlidesViewConfig';
            autoPlay: boolean;
            autoPlayIntervalMs?: number | null;
          }
        | {
            __typename?: 'TriviaViewConfig';
            instructions?: string | null;
            useQuestionTimer: boolean;
            defaultTimerMs: number;
            questions: Array<{
              __typename?: 'TriviaViewQuestion';
              id: string;
              text: string;
              timerMs?: number | null;
              choices: Array<{
                __typename?: 'TriviaChoice';
                id: string;
                text: string;
              }>;
            }>;
          }
        | { __typename?: 'VoteForViewConfig'; votesPerUser: number };
      viewData:
        | { __typename?: 'NowPlayingViewData'; currentSong?: string | null }
        | {
            __typename?: 'PhotoCarouselViewData';
            visibleSubmission?: string | null;
          }
        | {
            __typename?: 'RaffleViewData';
            raffleStatus: RaffleStatus;
            raffleCandidates: Array<string>;
            raffleWinners: Array<string>;
            raffleWinner?: string | null;
            winnerCount: number;
            remainingSubmissionIds: Array<string>;
            lastEliminatedSubmissionId?: string | null;
          }
        | {
            __typename?: 'SlidesViewData';
            currentSlide: string;
            slidesDisplayOrder: Array<string>;
          }
        | {
            __typename?: 'TriviaViewData';
            status: TriviaRoundStatus;
            questionIndex: number;
            questionEndsAt?: any | null;
            answeredCount: number;
            playerCount: number;
            correctChoiceId?: string | null;
            correctCount?: number | null;
            leaderboardOverflow: number;
            tallies: Array<{
              __typename?: 'TriviaTally';
              choiceId: string;
              count: number;
            }>;
            leaderboard: Array<{
              __typename?: 'TriviaLeaderboardRow';
              userId: string;
              name: string;
              score: number;
              rank: number;
              tied: boolean;
            }>;
          }
        | {
            __typename?: 'VoteForViewData';
            voteWinners?: Array<string> | null;
            choiceDisplayOrder: Array<string>;
            votes: Array<{
              __typename?: 'VoteCount';
              submissionId: string;
              count: number;
            }>;
          };
    } | null;
    engagements: Array<{
      __typename?: 'Engagement';
      id: string;
      eventId: string;
      createdAt: any;
      updatedAt: any;
      title: string;
      description?: string | null;
      qrCodeCta?: string | null;
      startTime?: any | null;
      order: number;
      endTime?: any | null;
      type: EngagementType;
      data?:
        | { __typename?: 'NowPlayingAdminData'; currentSong?: string | null }
        | {
            __typename?: 'PhotoCarouselAdminData';
            visibleSubmission?: string | null;
            rejectedQueue: Array<string>;
            unapprovedQueue: Array<string>;
            unseenQueue: Array<string>;
            seenQueuePointer: number;
            seenQueue: Array<string>;
          }
        | {
            __typename?: 'RaffleAdminData';
            raffleStatus: RaffleStatus;
            raffleCandidates: Array<string>;
            raffleWinners: Array<string>;
            raffleWinner?: string | null;
            winnerCount: number;
            remainingSubmissionIds: Array<string>;
            lastEliminatedSubmissionId?: string | null;
          }
        | {
            __typename?: 'SlidesAdminData';
            currentSlide: string;
            slidesDisplayOrder: Array<string>;
          }
        | {
            __typename?: 'TriviaAdminData';
            status: TriviaRoundStatus;
            questionIndex: number;
            playedThroughIndex: number;
            reviewing: boolean;
            questionEndsAt?: any | null;
            answeredCount: number;
            playerCount: number;
            correctChoiceId?: string | null;
            correctCount?: number | null;
            revealedQuestionIds: Array<string>;
            tallies: Array<{
              __typename?: 'TriviaTally';
              choiceId: string;
              count: number;
            }>;
            leaderboard: Array<{
              __typename?: 'TriviaLeaderboardRow';
              userId: string;
              name: string;
              score: number;
              rank: number;
              tied: boolean;
            }>;
          }
        | {
            __typename?: 'VoteForAdminData';
            startTime?: any | null;
            endTime?: any | null;
            voteWinners?: Array<string> | null;
            choiceDisplayOrder: Array<string>;
            votes: Array<{
              __typename?: 'VoteCount';
              submissionId: string;
              count: number;
            }>;
          }
        | null;
      config?:
        | {
            __typename?: 'NowPlayingAdminConfig';
            visualizationType: string;
            allowComments: boolean;
            allowedReactions: Array<string>;
          }
        | {
            __typename?: 'PhotoCarouselAdminConfig';
            maxSubmissionsPerUser: number;
            requireApproval: boolean;
            askSharePermission?: boolean | null;
            sharePrompt?: string | null;
            noPhotosMessage?: string | null;
            pollInterval?: number | null;
            predefinedCaptions?: Array<string> | null;
            maxVisiblePhotos: number;
          }
        | {
            __typename?: 'RaffleAdminConfig';
            optionalImageUrl?: string | null;
            claimYourPrize?: string | null;
            ticketFlipDirection: RaffleTicketFlipDirection;
          }
        | {
            __typename?: 'SlidesAdminConfig';
            autoPlay: boolean;
            autoPlayIntervalMs?: number | null;
          }
        | {
            __typename?: 'TriviaAdminConfig';
            instructions?: string | null;
            useQuestionTimer: boolean;
            defaultTimerMs: number;
            questions: Array<{
              __typename?: 'TriviaQuestion';
              id: string;
              text: string;
              correctChoiceId?: string | null;
              timerMs?: number | null;
              choices: Array<{
                __typename?: 'TriviaChoice';
                id: string;
                text: string;
              }>;
            }>;
          }
        | {
            __typename?: 'VoteForAdminConfig';
            votesPerUser: number;
            allowUserSubmissions: boolean;
            maxSubmissionsPerUser: number;
          }
        | null;
      viewConfig:
        | {
            __typename?: 'NowPlayingViewConfig';
            visualizationType: string;
            allowComments: boolean;
            allowedReactions: Array<string>;
          }
        | {
            __typename?: 'PhotoCarouselViewConfig';
            maxSubmissionsPerUser: number;
            askSharePermission?: boolean | null;
            sharePrompt?: string | null;
            noPhotosMessage?: string | null;
            maxVisiblePhotos: number;
          }
        | {
            __typename?: 'RaffleViewConfig';
            optionalImageUrl?: string | null;
            claimYourPrize?: string | null;
            ticketFlipDirection: RaffleTicketFlipDirection;
          }
        | {
            __typename?: 'SlidesViewConfig';
            autoPlay: boolean;
            autoPlayIntervalMs?: number | null;
          }
        | {
            __typename?: 'TriviaViewConfig';
            instructions?: string | null;
            useQuestionTimer: boolean;
            defaultTimerMs: number;
            questions: Array<{
              __typename?: 'TriviaViewQuestion';
              id: string;
              text: string;
              timerMs?: number | null;
              choices: Array<{
                __typename?: 'TriviaChoice';
                id: string;
                text: string;
              }>;
            }>;
          }
        | { __typename?: 'VoteForViewConfig'; votesPerUser: number };
      viewData:
        | { __typename?: 'NowPlayingViewData'; currentSong?: string | null }
        | {
            __typename?: 'PhotoCarouselViewData';
            visibleSubmission?: string | null;
          }
        | {
            __typename?: 'RaffleViewData';
            raffleStatus: RaffleStatus;
            raffleCandidates: Array<string>;
            raffleWinners: Array<string>;
            raffleWinner?: string | null;
            winnerCount: number;
            remainingSubmissionIds: Array<string>;
            lastEliminatedSubmissionId?: string | null;
          }
        | {
            __typename?: 'SlidesViewData';
            currentSlide: string;
            slidesDisplayOrder: Array<string>;
          }
        | {
            __typename?: 'TriviaViewData';
            status: TriviaRoundStatus;
            questionIndex: number;
            questionEndsAt?: any | null;
            answeredCount: number;
            playerCount: number;
            correctChoiceId?: string | null;
            correctCount?: number | null;
            leaderboardOverflow: number;
            tallies: Array<{
              __typename?: 'TriviaTally';
              choiceId: string;
              count: number;
            }>;
            leaderboard: Array<{
              __typename?: 'TriviaLeaderboardRow';
              userId: string;
              name: string;
              score: number;
              rank: number;
              tied: boolean;
            }>;
          }
        | {
            __typename?: 'VoteForViewData';
            voteWinners?: Array<string> | null;
            choiceDisplayOrder: Array<string>;
            votes: Array<{
              __typename?: 'VoteCount';
              submissionId: string;
              count: number;
            }>;
          };
    }>;
    subscriptionInUse?: {
      __typename?: 'PaymentSubscription';
      id: string;
      userId: string;
      status: PaymentSubscriptionStatus;
      stripeSubscriptionId: string;
      currentPeriodStart?: any | null;
      currentPeriodEnd?: any | null;
      cancelAtPeriodEnd: boolean;
      canceledAt?: any | null;
      trialStart?: any | null;
      trialEnd?: any | null;
      maxConcurrentEvents: number;
      createdAt: any;
      updatedAt: any;
      liveEvents: Array<{ __typename?: 'Event'; id: string; name: string }>;
    } | null;
    eventPassRedemptionInUse?: {
      __typename?: 'EventPassRedemption';
      id: string;
      eventPassId: string;
      eventId: string;
      redeemedAt: any;
      description?: string | null;
      expiresAt?: any | null;
    } | null;
  } | null;
};

export type GetUsersQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<UserFilter>;
}>;

export type GetUsersQuery = {
  __typename?: 'Query';
  users: {
    __typename?: 'UserConnection';
    totalCount: number;
    edges: Array<{
      __typename?: 'UserEdge';
      cursor: string;
      node: {
        __typename?: 'User';
        id: string;
        email?: string | null;
        role: Role;
        name?: string | null;
        username?: string | null;
        lastLogin?: any | null;
        googleId?: string | null;
        stripeCustomerId?: string | null;
        createdAt: any;
      };
    }>;
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor?: string | null;
      endCursor?: string | null;
    };
  };
};

export type StageGetEventsQueryVariables = Exact<{ [key: string]: never }>;

export type StageGetEventsQuery = {
  __typename?: 'Query';
  events: Array<{
    __typename?: 'Event';
    id: string;
    name: string;
    live: boolean;
    description?: string | null;
    date?: any | null;
    location?: string | null;
    themeConfig?: {
      __typename?: 'EventThemeConfig';
      headingFontFamily?: Array<string> | null;
      bodyFontFamily?: Array<string> | null;
      foregroundColor?: string | null;
      backgroundColor?: string | null;
      stageBackgroundImage?: string | null;
      fanBackgroundImage?: string | null;
      qrForegroundColor?: string | null;
      qrBackgroundColor?: string | null;
      qrTextColor?: string | null;
      qrWrapperBackgroundColor?: string | null;
      stageElements?: Array<{
        __typename?: 'ScreenElement';
        id: string;
        type: string;
        name?: string | null;
        imageUrl?: string | null;
        defaultStyles?: any | null;
        engagementStyles?: any | null;
        defaultClassNames?: string | null;
        engagementClassNames?: string | null;
        text?: string | null;
        textType?: string | null;
        fontFamily?: Array<string> | null;
        linkHref?: string | null;
        color?: string | null;
      }> | null;
      fanElements?: Array<{
        __typename?: 'ScreenElement';
        id: string;
        type: string;
        name?: string | null;
        imageUrl?: string | null;
        defaultStyles?: any | null;
        engagementStyles?: any | null;
        defaultClassNames?: string | null;
        engagementClassNames?: string | null;
        text?: string | null;
        textType?: string | null;
        fontFamily?: Array<string> | null;
        linkHref?: string | null;
        color?: string | null;
      }> | null;
    } | null;
    activeEngagement?: {
      __typename?: 'Engagement';
      id: string;
      createdAt: any;
      updatedAt: any;
      title: string;
      qrCodeCta?: string | null;
      description?: string | null;
      startTime?: any | null;
      endTime?: any | null;
      type: EngagementType;
      order: number;
      viewConfig:
        | {
            __typename?: 'NowPlayingViewConfig';
            visualizationType: string;
            allowComments: boolean;
            allowedReactions: Array<string>;
          }
        | {
            __typename?: 'PhotoCarouselViewConfig';
            maxSubmissionsPerUser: number;
            askSharePermission?: boolean | null;
            sharePrompt?: string | null;
            noPhotosMessage?: string | null;
            maxVisiblePhotos: number;
          }
        | {
            __typename?: 'RaffleViewConfig';
            optionalImageUrl?: string | null;
            claimYourPrize?: string | null;
            ticketFlipDirection: RaffleTicketFlipDirection;
          }
        | {
            __typename?: 'SlidesViewConfig';
            autoPlay: boolean;
            autoPlayIntervalMs?: number | null;
          }
        | {
            __typename?: 'TriviaViewConfig';
            instructions?: string | null;
            useQuestionTimer: boolean;
            defaultTimerMs: number;
            questions: Array<{
              __typename?: 'TriviaViewQuestion';
              id: string;
              text: string;
              timerMs?: number | null;
              choices: Array<{
                __typename?: 'TriviaChoice';
                id: string;
                text: string;
              }>;
            }>;
          }
        | { __typename?: 'VoteForViewConfig'; votesPerUser: number };
      viewData:
        | { __typename?: 'NowPlayingViewData'; currentSong?: string | null }
        | {
            __typename?: 'PhotoCarouselViewData';
            visibleSubmission?: string | null;
          }
        | {
            __typename?: 'RaffleViewData';
            raffleStatus: RaffleStatus;
            raffleCandidates: Array<string>;
            raffleWinners: Array<string>;
            raffleWinner?: string | null;
            winnerCount: number;
            remainingSubmissionIds: Array<string>;
            lastEliminatedSubmissionId?: string | null;
          }
        | {
            __typename?: 'SlidesViewData';
            currentSlide: string;
            slidesDisplayOrder: Array<string>;
          }
        | {
            __typename?: 'TriviaViewData';
            status: TriviaRoundStatus;
            questionIndex: number;
            questionEndsAt?: any | null;
            answeredCount: number;
            playerCount: number;
            correctChoiceId?: string | null;
            correctCount?: number | null;
            leaderboardOverflow: number;
            tallies: Array<{
              __typename?: 'TriviaTally';
              choiceId: string;
              count: number;
            }>;
            leaderboard: Array<{
              __typename?: 'TriviaLeaderboardRow';
              userId: string;
              name: string;
              score: number;
              rank: number;
              tied: boolean;
            }>;
          }
        | {
            __typename?: 'VoteForViewData';
            voteWinners?: Array<string> | null;
            choiceDisplayOrder: Array<string>;
            votes: Array<{
              __typename?: 'VoteCount';
              submissionId: string;
              count: number;
            }>;
          };
    } | null;
  }>;
};

export type GetEngagementQueryVariables = Exact<{
  engagementId: Scalars['String']['input'];
}>;

export type GetEngagementQuery = {
  __typename?: 'Query';
  engagement?: {
    __typename?: 'Engagement';
    id: string;
    eventId: string;
    createdAt: any;
    updatedAt: any;
    title: string;
    description?: string | null;
    qrCodeCta?: string | null;
    startTime?: any | null;
    order: number;
    endTime?: any | null;
    type: EngagementType;
    data?:
      | { __typename?: 'NowPlayingAdminData'; currentSong?: string | null }
      | {
          __typename?: 'PhotoCarouselAdminData';
          visibleSubmission?: string | null;
          rejectedQueue: Array<string>;
          unapprovedQueue: Array<string>;
          unseenQueue: Array<string>;
          seenQueuePointer: number;
          seenQueue: Array<string>;
        }
      | {
          __typename?: 'RaffleAdminData';
          raffleStatus: RaffleStatus;
          raffleCandidates: Array<string>;
          raffleWinners: Array<string>;
          raffleWinner?: string | null;
          winnerCount: number;
          remainingSubmissionIds: Array<string>;
          lastEliminatedSubmissionId?: string | null;
        }
      | {
          __typename?: 'SlidesAdminData';
          currentSlide: string;
          slidesDisplayOrder: Array<string>;
        }
      | {
          __typename?: 'TriviaAdminData';
          status: TriviaRoundStatus;
          questionIndex: number;
          playedThroughIndex: number;
          reviewing: boolean;
          questionEndsAt?: any | null;
          answeredCount: number;
          playerCount: number;
          correctChoiceId?: string | null;
          correctCount?: number | null;
          revealedQuestionIds: Array<string>;
          tallies: Array<{
            __typename?: 'TriviaTally';
            choiceId: string;
            count: number;
          }>;
          leaderboard: Array<{
            __typename?: 'TriviaLeaderboardRow';
            userId: string;
            name: string;
            score: number;
            rank: number;
            tied: boolean;
          }>;
        }
      | {
          __typename?: 'VoteForAdminData';
          startTime?: any | null;
          endTime?: any | null;
          voteWinners?: Array<string> | null;
          choiceDisplayOrder: Array<string>;
          votes: Array<{
            __typename?: 'VoteCount';
            submissionId: string;
            count: number;
          }>;
        }
      | null;
    config?:
      | {
          __typename?: 'NowPlayingAdminConfig';
          visualizationType: string;
          allowComments: boolean;
          allowedReactions: Array<string>;
        }
      | {
          __typename?: 'PhotoCarouselAdminConfig';
          maxSubmissionsPerUser: number;
          requireApproval: boolean;
          askSharePermission?: boolean | null;
          sharePrompt?: string | null;
          noPhotosMessage?: string | null;
          pollInterval?: number | null;
          predefinedCaptions?: Array<string> | null;
          maxVisiblePhotos: number;
        }
      | {
          __typename?: 'RaffleAdminConfig';
          optionalImageUrl?: string | null;
          claimYourPrize?: string | null;
          ticketFlipDirection: RaffleTicketFlipDirection;
        }
      | {
          __typename?: 'SlidesAdminConfig';
          autoPlay: boolean;
          autoPlayIntervalMs?: number | null;
        }
      | {
          __typename?: 'TriviaAdminConfig';
          instructions?: string | null;
          useQuestionTimer: boolean;
          defaultTimerMs: number;
          questions: Array<{
            __typename?: 'TriviaQuestion';
            id: string;
            text: string;
            correctChoiceId?: string | null;
            timerMs?: number | null;
            choices: Array<{
              __typename?: 'TriviaChoice';
              id: string;
              text: string;
            }>;
          }>;
        }
      | {
          __typename?: 'VoteForAdminConfig';
          votesPerUser: number;
          allowUserSubmissions: boolean;
          maxSubmissionsPerUser: number;
        }
      | null;
    viewConfig:
      | {
          __typename?: 'NowPlayingViewConfig';
          visualizationType: string;
          allowComments: boolean;
          allowedReactions: Array<string>;
        }
      | {
          __typename?: 'PhotoCarouselViewConfig';
          maxSubmissionsPerUser: number;
          askSharePermission?: boolean | null;
          sharePrompt?: string | null;
          noPhotosMessage?: string | null;
          maxVisiblePhotos: number;
        }
      | {
          __typename?: 'RaffleViewConfig';
          optionalImageUrl?: string | null;
          claimYourPrize?: string | null;
          ticketFlipDirection: RaffleTicketFlipDirection;
        }
      | {
          __typename?: 'SlidesViewConfig';
          autoPlay: boolean;
          autoPlayIntervalMs?: number | null;
        }
      | {
          __typename?: 'TriviaViewConfig';
          instructions?: string | null;
          useQuestionTimer: boolean;
          defaultTimerMs: number;
          questions: Array<{
            __typename?: 'TriviaViewQuestion';
            id: string;
            text: string;
            timerMs?: number | null;
            choices: Array<{
              __typename?: 'TriviaChoice';
              id: string;
              text: string;
            }>;
          }>;
        }
      | { __typename?: 'VoteForViewConfig'; votesPerUser: number };
    viewData:
      | { __typename?: 'NowPlayingViewData'; currentSong?: string | null }
      | {
          __typename?: 'PhotoCarouselViewData';
          visibleSubmission?: string | null;
        }
      | {
          __typename?: 'RaffleViewData';
          raffleStatus: RaffleStatus;
          raffleCandidates: Array<string>;
          raffleWinners: Array<string>;
          raffleWinner?: string | null;
          winnerCount: number;
          remainingSubmissionIds: Array<string>;
          lastEliminatedSubmissionId?: string | null;
        }
      | {
          __typename?: 'SlidesViewData';
          currentSlide: string;
          slidesDisplayOrder: Array<string>;
        }
      | {
          __typename?: 'TriviaViewData';
          status: TriviaRoundStatus;
          questionIndex: number;
          questionEndsAt?: any | null;
          answeredCount: number;
          playerCount: number;
          correctChoiceId?: string | null;
          correctCount?: number | null;
          leaderboardOverflow: number;
          tallies: Array<{
            __typename?: 'TriviaTally';
            choiceId: string;
            count: number;
          }>;
          leaderboard: Array<{
            __typename?: 'TriviaLeaderboardRow';
            userId: string;
            name: string;
            score: number;
            rank: number;
            tied: boolean;
          }>;
        }
      | {
          __typename?: 'VoteForViewData';
          voteWinners?: Array<string> | null;
          choiceDisplayOrder: Array<string>;
          votes: Array<{
            __typename?: 'VoteCount';
            submissionId: string;
            count: number;
          }>;
        };
  } | null;
};

export type GetStageEngagementQueryVariables = Exact<{
  engagementId: Scalars['String']['input'];
}>;

export type GetStageEngagementQuery = {
  __typename?: 'Query';
  engagement?: {
    __typename?: 'Engagement';
    id: string;
    createdAt: any;
    updatedAt: any;
    title: string;
    qrCodeCta?: string | null;
    description?: string | null;
    startTime?: any | null;
    endTime?: any | null;
    type: EngagementType;
    order: number;
    viewConfig:
      | {
          __typename?: 'NowPlayingViewConfig';
          visualizationType: string;
          allowComments: boolean;
          allowedReactions: Array<string>;
        }
      | {
          __typename?: 'PhotoCarouselViewConfig';
          maxSubmissionsPerUser: number;
          askSharePermission?: boolean | null;
          sharePrompt?: string | null;
          noPhotosMessage?: string | null;
          maxVisiblePhotos: number;
        }
      | {
          __typename?: 'RaffleViewConfig';
          optionalImageUrl?: string | null;
          claimYourPrize?: string | null;
          ticketFlipDirection: RaffleTicketFlipDirection;
        }
      | {
          __typename?: 'SlidesViewConfig';
          autoPlay: boolean;
          autoPlayIntervalMs?: number | null;
        }
      | {
          __typename?: 'TriviaViewConfig';
          instructions?: string | null;
          useQuestionTimer: boolean;
          defaultTimerMs: number;
          questions: Array<{
            __typename?: 'TriviaViewQuestion';
            id: string;
            text: string;
            timerMs?: number | null;
            choices: Array<{
              __typename?: 'TriviaChoice';
              id: string;
              text: string;
            }>;
          }>;
        }
      | { __typename?: 'VoteForViewConfig'; votesPerUser: number };
    viewData:
      | { __typename?: 'NowPlayingViewData'; currentSong?: string | null }
      | {
          __typename?: 'PhotoCarouselViewData';
          visibleSubmission?: string | null;
        }
      | {
          __typename?: 'RaffleViewData';
          raffleStatus: RaffleStatus;
          raffleCandidates: Array<string>;
          raffleWinners: Array<string>;
          raffleWinner?: string | null;
          winnerCount: number;
          remainingSubmissionIds: Array<string>;
          lastEliminatedSubmissionId?: string | null;
        }
      | {
          __typename?: 'SlidesViewData';
          currentSlide: string;
          slidesDisplayOrder: Array<string>;
        }
      | {
          __typename?: 'TriviaViewData';
          status: TriviaRoundStatus;
          questionIndex: number;
          questionEndsAt?: any | null;
          answeredCount: number;
          playerCount: number;
          correctChoiceId?: string | null;
          correctCount?: number | null;
          leaderboardOverflow: number;
          tallies: Array<{
            __typename?: 'TriviaTally';
            choiceId: string;
            count: number;
          }>;
          leaderboard: Array<{
            __typename?: 'TriviaLeaderboardRow';
            userId: string;
            name: string;
            score: number;
            rank: number;
            tied: boolean;
          }>;
        }
      | {
          __typename?: 'VoteForViewData';
          voteWinners?: Array<string> | null;
          choiceDisplayOrder: Array<string>;
          votes: Array<{
            __typename?: 'VoteCount';
            submissionId: string;
            count: number;
          }>;
        };
  } | null;
};

export type GetFanEngagementQueryVariables = Exact<{
  engagementId: Scalars['String']['input'];
}>;

export type GetFanEngagementQuery = {
  __typename?: 'Query';
  engagement?: {
    __typename?: 'Engagement';
    id: string;
    createdAt: any;
    updatedAt: any;
    title: string;
    description?: string | null;
    startTime?: any | null;
    endTime?: any | null;
    type: EngagementType;
    order: number;
    viewConfig:
      | {
          __typename?: 'NowPlayingViewConfig';
          visualizationType: string;
          allowComments: boolean;
          allowedReactions: Array<string>;
        }
      | {
          __typename?: 'PhotoCarouselViewConfig';
          maxSubmissionsPerUser: number;
          askSharePermission?: boolean | null;
          sharePrompt?: string | null;
          noPhotosMessage?: string | null;
          maxVisiblePhotos: number;
        }
      | {
          __typename?: 'RaffleViewConfig';
          optionalImageUrl?: string | null;
          claimYourPrize?: string | null;
          ticketFlipDirection: RaffleTicketFlipDirection;
        }
      | {
          __typename?: 'SlidesViewConfig';
          autoPlay: boolean;
          autoPlayIntervalMs?: number | null;
        }
      | {
          __typename?: 'TriviaViewConfig';
          instructions?: string | null;
          useQuestionTimer: boolean;
          defaultTimerMs: number;
          questions: Array<{
            __typename?: 'TriviaViewQuestion';
            id: string;
            text: string;
            timerMs?: number | null;
            choices: Array<{
              __typename?: 'TriviaChoice';
              id: string;
              text: string;
            }>;
          }>;
        }
      | { __typename?: 'VoteForViewConfig'; votesPerUser: number };
    viewData:
      | { __typename?: 'NowPlayingViewData'; currentSong?: string | null }
      | {
          __typename?: 'PhotoCarouselViewData';
          visibleSubmission?: string | null;
        }
      | {
          __typename?: 'RaffleViewData';
          raffleStatus: RaffleStatus;
          raffleCandidates: Array<string>;
          raffleWinners: Array<string>;
          raffleWinner?: string | null;
          winnerCount: number;
          remainingSubmissionIds: Array<string>;
          lastEliminatedSubmissionId?: string | null;
        }
      | {
          __typename?: 'SlidesViewData';
          currentSlide: string;
          slidesDisplayOrder: Array<string>;
        }
      | {
          __typename?: 'TriviaViewData';
          status: TriviaRoundStatus;
          questionIndex: number;
          questionEndsAt?: any | null;
          answeredCount: number;
          playerCount: number;
          correctChoiceId?: string | null;
          correctCount?: number | null;
          leaderboardOverflow: number;
          tallies: Array<{
            __typename?: 'TriviaTally';
            choiceId: string;
            count: number;
          }>;
          leaderboard: Array<{
            __typename?: 'TriviaLeaderboardRow';
            userId: string;
            name: string;
            score: number;
            rank: number;
            tied: boolean;
          }>;
        }
      | {
          __typename?: 'VoteForViewData';
          voteWinners?: Array<string> | null;
          choiceDisplayOrder: Array<string>;
          votes: Array<{
            __typename?: 'VoteCount';
            submissionId: string;
            count: number;
          }>;
        };
  } | null;
};

export type GetEngagementSubmissionsByUserQueryVariables = Exact<{
  engagementId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}>;

export type GetEngagementSubmissionsByUserQuery = {
  __typename?: 'Query';
  engagementSubmissionsByUser: Array<{
    __typename?: 'Submission';
    id: string;
    engagementId: string;
    createdAt: any;
    userId?: string | null;
    hidden: boolean;
    possibleBannedDevice: boolean;
    matchedBanCreatedAt?: any | null;
    data:
      | {
          __typename?: 'NowPlayingSubmissionData';
          order: number;
          songAlbumArt?: string | null;
          songTitle?: string | null;
          songArtist?: string | null;
          songNotes?: string | null;
          songLyrics?: string | null;
          visualizationType?: string | null;
          spotifyUrl?: string | null;
        }
      | {
          __typename?: 'PhotoCarouselSubmissionData';
          photoUrl?: string | null;
          caption?: string | null;
          approved?: boolean | null;
          sharingPermissionGranted?: boolean | null;
        }
      | {
          __typename?: 'RaffleSubmissionData';
          name: string;
          optionalImageUrl?: string | null;
        }
      | {
          __typename?: 'SlidesSubmissionData';
          optionalImageUrl?: string | null;
          title: string;
          content: string;
          slideDuration?: number | null;
          imageTilt?: SlideImageTilt | null;
          layout?: SlideLayout | null;
          showQr?: boolean | null;
          background?: {
            __typename?: 'SlideBackground';
            type: SlideBackgroundType;
            color?: string | null;
            imageUrl?: string | null;
          } | null;
          elements?: Array<{
            __typename?: 'SlideElement';
            id: string;
            type: SlideElementType;
            name?: string | null;
            locked?: boolean | null;
            text?: string | null;
            textType?: string | null;
            fontFamily?: Array<string> | null;
            color?: string | null;
            fontSize?: number | null;
            fontWeight?: SlideFontWeight | null;
            textAlign?: SlideTextAlign | null;
            verticalAlign?: SlideVerticalAlign | null;
            imageUrl?: string | null;
            fit?: SlideImageFit | null;
            box?: {
              __typename?: 'SlideBox';
              x: number;
              y: number;
              w: number;
              h: number;
            } | null;
          }> | null;
        }
      | {
          __typename?: 'TriviaSubmissionData';
          questionId?: string | null;
          choiceId?: string | null;
        }
      | {
          __typename?: 'VoteForSubmissionData';
          title: string;
          color: string;
          description: string;
          optionalImageUrl?: string | null;
        };
    user?: { __typename?: 'User'; id: string; name?: string | null } | null;
    reactions?: Array<{
      __typename?: 'Reaction';
      id: string;
      type: string;
      createdAt: any;
    }> | null;
  }>;
};

export type GetSubmissionQueryVariables = Exact<{
  submissionId: Scalars['String']['input'];
}>;

export type GetSubmissionQuery = {
  __typename?: 'Query';
  submission?: {
    __typename?: 'Submission';
    id: string;
    engagementId: string;
    createdAt: any;
    userId?: string | null;
    hidden: boolean;
    possibleBannedDevice: boolean;
    matchedBanCreatedAt?: any | null;
    data:
      | {
          __typename?: 'NowPlayingSubmissionData';
          order: number;
          songAlbumArt?: string | null;
          songTitle?: string | null;
          songArtist?: string | null;
          songNotes?: string | null;
          songLyrics?: string | null;
          visualizationType?: string | null;
          spotifyUrl?: string | null;
        }
      | {
          __typename?: 'PhotoCarouselSubmissionData';
          photoUrl?: string | null;
          caption?: string | null;
          approved?: boolean | null;
          sharingPermissionGranted?: boolean | null;
        }
      | {
          __typename?: 'RaffleSubmissionData';
          name: string;
          optionalImageUrl?: string | null;
        }
      | {
          __typename?: 'SlidesSubmissionData';
          optionalImageUrl?: string | null;
          title: string;
          content: string;
          slideDuration?: number | null;
          imageTilt?: SlideImageTilt | null;
          layout?: SlideLayout | null;
          showQr?: boolean | null;
          background?: {
            __typename?: 'SlideBackground';
            type: SlideBackgroundType;
            color?: string | null;
            imageUrl?: string | null;
          } | null;
          elements?: Array<{
            __typename?: 'SlideElement';
            id: string;
            type: SlideElementType;
            name?: string | null;
            locked?: boolean | null;
            text?: string | null;
            textType?: string | null;
            fontFamily?: Array<string> | null;
            color?: string | null;
            fontSize?: number | null;
            fontWeight?: SlideFontWeight | null;
            textAlign?: SlideTextAlign | null;
            verticalAlign?: SlideVerticalAlign | null;
            imageUrl?: string | null;
            fit?: SlideImageFit | null;
            box?: {
              __typename?: 'SlideBox';
              x: number;
              y: number;
              w: number;
              h: number;
            } | null;
          }> | null;
        }
      | {
          __typename?: 'TriviaSubmissionData';
          questionId?: string | null;
          choiceId?: string | null;
        }
      | {
          __typename?: 'VoteForSubmissionData';
          title: string;
          color: string;
          description: string;
          optionalImageUrl?: string | null;
        };
    user?: { __typename?: 'User'; id: string; name?: string | null } | null;
    reactions?: Array<{
      __typename?: 'Reaction';
      id: string;
      type: string;
      createdAt: any;
    }> | null;
  } | null;
};

export type GetSubmissionsQueryVariables = Exact<{
  engagementId: Scalars['String']['input'];
}>;

export type GetSubmissionsQuery = {
  __typename?: 'Query';
  submissions: Array<{
    __typename?: 'Submission';
    id: string;
    engagementId: string;
    createdAt: any;
    userId?: string | null;
    hidden: boolean;
    possibleBannedDevice: boolean;
    matchedBanCreatedAt?: any | null;
    data:
      | {
          __typename?: 'NowPlayingSubmissionData';
          order: number;
          songAlbumArt?: string | null;
          songTitle?: string | null;
          songArtist?: string | null;
          songNotes?: string | null;
          songLyrics?: string | null;
          visualizationType?: string | null;
          spotifyUrl?: string | null;
        }
      | {
          __typename?: 'PhotoCarouselSubmissionData';
          photoUrl?: string | null;
          caption?: string | null;
          approved?: boolean | null;
          sharingPermissionGranted?: boolean | null;
        }
      | {
          __typename?: 'RaffleSubmissionData';
          name: string;
          optionalImageUrl?: string | null;
        }
      | {
          __typename?: 'SlidesSubmissionData';
          optionalImageUrl?: string | null;
          title: string;
          content: string;
          slideDuration?: number | null;
          imageTilt?: SlideImageTilt | null;
          layout?: SlideLayout | null;
          showQr?: boolean | null;
          background?: {
            __typename?: 'SlideBackground';
            type: SlideBackgroundType;
            color?: string | null;
            imageUrl?: string | null;
          } | null;
          elements?: Array<{
            __typename?: 'SlideElement';
            id: string;
            type: SlideElementType;
            name?: string | null;
            locked?: boolean | null;
            text?: string | null;
            textType?: string | null;
            fontFamily?: Array<string> | null;
            color?: string | null;
            fontSize?: number | null;
            fontWeight?: SlideFontWeight | null;
            textAlign?: SlideTextAlign | null;
            verticalAlign?: SlideVerticalAlign | null;
            imageUrl?: string | null;
            fit?: SlideImageFit | null;
            box?: {
              __typename?: 'SlideBox';
              x: number;
              y: number;
              w: number;
              h: number;
            } | null;
          }> | null;
        }
      | {
          __typename?: 'TriviaSubmissionData';
          questionId?: string | null;
          choiceId?: string | null;
        }
      | {
          __typename?: 'VoteForSubmissionData';
          title: string;
          color: string;
          description: string;
          optionalImageUrl?: string | null;
        };
    user?: { __typename?: 'User'; id: string; name?: string | null } | null;
    reactions?: Array<{
      __typename?: 'Reaction';
      id: string;
      type: string;
      createdAt: any;
    }> | null;
  }>;
};

export type ValidateGoogleFontQueryVariables = Exact<{
  fontName: Scalars['String']['input'];
}>;

export type ValidateGoogleFontQuery = {
  __typename?: 'Query';
  validateGoogleFont: boolean;
};

export type StageGetActiveEngagementQueryVariables = Exact<{
  eventId: Scalars['String']['input'];
}>;

export type StageGetActiveEngagementQuery = {
  __typename?: 'Query';
  activeEventEngagement?: {
    __typename?: 'Engagement';
    id: string;
    createdAt: any;
    updatedAt: any;
    title: string;
    qrCodeCta?: string | null;
    description?: string | null;
    startTime?: any | null;
    endTime?: any | null;
    type: EngagementType;
    order: number;
    viewConfig:
      | {
          __typename?: 'NowPlayingViewConfig';
          visualizationType: string;
          allowComments: boolean;
          allowedReactions: Array<string>;
        }
      | {
          __typename?: 'PhotoCarouselViewConfig';
          maxSubmissionsPerUser: number;
          askSharePermission?: boolean | null;
          sharePrompt?: string | null;
          noPhotosMessage?: string | null;
          maxVisiblePhotos: number;
        }
      | {
          __typename?: 'RaffleViewConfig';
          optionalImageUrl?: string | null;
          claimYourPrize?: string | null;
          ticketFlipDirection: RaffleTicketFlipDirection;
        }
      | {
          __typename?: 'SlidesViewConfig';
          autoPlay: boolean;
          autoPlayIntervalMs?: number | null;
        }
      | {
          __typename?: 'TriviaViewConfig';
          instructions?: string | null;
          useQuestionTimer: boolean;
          defaultTimerMs: number;
          questions: Array<{
            __typename?: 'TriviaViewQuestion';
            id: string;
            text: string;
            timerMs?: number | null;
            choices: Array<{
              __typename?: 'TriviaChoice';
              id: string;
              text: string;
            }>;
          }>;
        }
      | { __typename?: 'VoteForViewConfig'; votesPerUser: number };
    viewData:
      | { __typename?: 'NowPlayingViewData'; currentSong?: string | null }
      | {
          __typename?: 'PhotoCarouselViewData';
          visibleSubmission?: string | null;
        }
      | {
          __typename?: 'RaffleViewData';
          raffleStatus: RaffleStatus;
          raffleCandidates: Array<string>;
          raffleWinners: Array<string>;
          raffleWinner?: string | null;
          winnerCount: number;
          remainingSubmissionIds: Array<string>;
          lastEliminatedSubmissionId?: string | null;
        }
      | {
          __typename?: 'SlidesViewData';
          currentSlide: string;
          slidesDisplayOrder: Array<string>;
        }
      | {
          __typename?: 'TriviaViewData';
          status: TriviaRoundStatus;
          questionIndex: number;
          questionEndsAt?: any | null;
          answeredCount: number;
          playerCount: number;
          correctChoiceId?: string | null;
          correctCount?: number | null;
          leaderboardOverflow: number;
          tallies: Array<{
            __typename?: 'TriviaTally';
            choiceId: string;
            count: number;
          }>;
          leaderboard: Array<{
            __typename?: 'TriviaLeaderboardRow';
            userId: string;
            name: string;
            score: number;
            rank: number;
            tied: boolean;
          }>;
        }
      | {
          __typename?: 'VoteForViewData';
          voteWinners?: Array<string> | null;
          choiceDisplayOrder: Array<string>;
          votes: Array<{
            __typename?: 'VoteCount';
            submissionId: string;
            count: number;
          }>;
        };
  } | null;
};

export type FanGetSubmissionsQueryVariables = Exact<{
  engagementId: Scalars['String']['input'];
}>;

export type FanGetSubmissionsQuery = {
  __typename?: 'Query';
  submissions: Array<{
    __typename?: 'Submission';
    id: string;
    createdAt: any;
    engagementId: string;
    hidden: boolean;
    possibleBannedDevice: boolean;
    data:
      | {
          __typename?: 'NowPlayingSubmissionData';
          order: number;
          songAlbumArt?: string | null;
          songTitle?: string | null;
          songArtist?: string | null;
          songNotes?: string | null;
          songLyrics?: string | null;
          visualizationType?: string | null;
          spotifyUrl?: string | null;
        }
      | {
          __typename?: 'PhotoCarouselSubmissionData';
          photoUrl?: string | null;
          caption?: string | null;
          approved?: boolean | null;
          sharingPermissionGranted?: boolean | null;
        }
      | {
          __typename?: 'RaffleSubmissionData';
          name: string;
          optionalImageUrl?: string | null;
        }
      | {
          __typename?: 'SlidesSubmissionData';
          optionalImageUrl?: string | null;
          title: string;
          content: string;
          slideDuration?: number | null;
          imageTilt?: SlideImageTilt | null;
          layout?: SlideLayout | null;
          showQr?: boolean | null;
          background?: {
            __typename?: 'SlideBackground';
            type: SlideBackgroundType;
            color?: string | null;
            imageUrl?: string | null;
          } | null;
          elements?: Array<{
            __typename?: 'SlideElement';
            id: string;
            type: SlideElementType;
            name?: string | null;
            locked?: boolean | null;
            text?: string | null;
            textType?: string | null;
            fontFamily?: Array<string> | null;
            color?: string | null;
            fontSize?: number | null;
            fontWeight?: SlideFontWeight | null;
            textAlign?: SlideTextAlign | null;
            verticalAlign?: SlideVerticalAlign | null;
            imageUrl?: string | null;
            fit?: SlideImageFit | null;
            box?: {
              __typename?: 'SlideBox';
              x: number;
              y: number;
              w: number;
              h: number;
            } | null;
          }> | null;
        }
      | {
          __typename?: 'TriviaSubmissionData';
          questionId?: string | null;
          choiceId?: string | null;
        }
      | {
          __typename?: 'VoteForSubmissionData';
          title: string;
          color: string;
          description: string;
          optionalImageUrl?: string | null;
        };
    reactions?: Array<{
      __typename?: 'Reaction';
      id: string;
      type: string;
      createdAt: any;
      submissionId: string;
    }> | null;
  }>;
};

export type FanGetSubmissionQueryVariables = Exact<{
  submissionId: Scalars['String']['input'];
}>;

export type FanGetSubmissionQuery = {
  __typename?: 'Query';
  submission?: {
    __typename?: 'Submission';
    id: string;
    createdAt: any;
    engagementId: string;
    hidden: boolean;
    possibleBannedDevice: boolean;
    data:
      | {
          __typename?: 'NowPlayingSubmissionData';
          order: number;
          songAlbumArt?: string | null;
          songTitle?: string | null;
          songArtist?: string | null;
          songNotes?: string | null;
          songLyrics?: string | null;
          visualizationType?: string | null;
          spotifyUrl?: string | null;
        }
      | {
          __typename?: 'PhotoCarouselSubmissionData';
          photoUrl?: string | null;
          caption?: string | null;
          approved?: boolean | null;
          sharingPermissionGranted?: boolean | null;
        }
      | {
          __typename?: 'RaffleSubmissionData';
          name: string;
          optionalImageUrl?: string | null;
        }
      | {
          __typename?: 'SlidesSubmissionData';
          optionalImageUrl?: string | null;
          title: string;
          content: string;
          slideDuration?: number | null;
          imageTilt?: SlideImageTilt | null;
          layout?: SlideLayout | null;
          showQr?: boolean | null;
          background?: {
            __typename?: 'SlideBackground';
            type: SlideBackgroundType;
            color?: string | null;
            imageUrl?: string | null;
          } | null;
          elements?: Array<{
            __typename?: 'SlideElement';
            id: string;
            type: SlideElementType;
            name?: string | null;
            locked?: boolean | null;
            text?: string | null;
            textType?: string | null;
            fontFamily?: Array<string> | null;
            color?: string | null;
            fontSize?: number | null;
            fontWeight?: SlideFontWeight | null;
            textAlign?: SlideTextAlign | null;
            verticalAlign?: SlideVerticalAlign | null;
            imageUrl?: string | null;
            fit?: SlideImageFit | null;
            box?: {
              __typename?: 'SlideBox';
              x: number;
              y: number;
              w: number;
              h: number;
            } | null;
          }> | null;
        }
      | {
          __typename?: 'TriviaSubmissionData';
          questionId?: string | null;
          choiceId?: string | null;
        }
      | {
          __typename?: 'VoteForSubmissionData';
          title: string;
          color: string;
          description: string;
          optionalImageUrl?: string | null;
        };
    reactions?: Array<{
      __typename?: 'Reaction';
      id: string;
      type: string;
      createdAt: any;
      submissionId: string;
    }> | null;
  } | null;
};

export type FanGetEngagementReactionsQueryVariables = Exact<{
  engagementId: Scalars['String']['input'];
}>;

export type FanGetEngagementReactionsQuery = {
  __typename?: 'Query';
  engagementReactions: Array<{
    __typename?: 'Reaction';
    id: string;
    type: string;
    createdAt: any;
    submissionId: string;
  }>;
};

export type CanCreateSubmissionQueryVariables = Exact<{
  engagementId: Scalars['String']['input'];
  deviceId?: InputMaybe<Scalars['String']['input']>;
  visitorId?: InputMaybe<Scalars['String']['input']>;
}>;

export type CanCreateSubmissionQuery = {
  __typename?: 'Query';
  canCreateSubmission: boolean;
};

export type DeviceAccessQueryVariables = Exact<{
  engagementId: Scalars['String']['input'];
  deviceId?: InputMaybe<Scalars['String']['input']>;
  visitorId?: InputMaybe<Scalars['String']['input']>;
}>;

export type DeviceAccessQuery = {
  __typename?: 'Query';
  deviceAccess: {
    __typename?: 'DeviceAccess';
    allowed: boolean;
    message?: string | null;
  };
};

export type GetBansQueryVariables = Exact<{
  eventId: Scalars['String']['input'];
}>;

export type GetBansQuery = {
  __typename?: 'Query';
  banCount: number;
  bans: Array<{
    __typename?: 'Ban';
    id: string;
    userId: string;
    reason?: string | null;
    createdAt: any;
    hiddenCount: number;
    sourceEventId?: string | null;
    sourceEngagementId?: string | null;
    sourceSubmissionId?: string | null;
    sourcePhotoUrl?: string | null;
    user: { __typename?: 'User'; id: string; name?: string | null };
    sourceEvent?: { __typename?: 'Event'; id: string; name: string } | null;
    sourceEngagement?: {
      __typename?: 'Engagement';
      id: string;
      title: string;
    } | null;
  }>;
};

export type StageGetSubmissionsQueryVariables = Exact<{
  engagementId: Scalars['String']['input'];
}>;

export type StageGetSubmissionsQuery = {
  __typename?: 'Query';
  submissions: Array<{
    __typename?: 'Submission';
    id: string;
    createdAt: any;
    engagementId: string;
    hidden: boolean;
    possibleBannedDevice: boolean;
    matchedBanCreatedAt?: any | null;
    userId?: string | null;
    data:
      | {
          __typename?: 'NowPlayingSubmissionData';
          order: number;
          songAlbumArt?: string | null;
          songTitle?: string | null;
          songArtist?: string | null;
          songNotes?: string | null;
          songLyrics?: string | null;
          visualizationType?: string | null;
          spotifyUrl?: string | null;
        }
      | {
          __typename?: 'PhotoCarouselSubmissionData';
          photoUrl?: string | null;
          caption?: string | null;
          approved?: boolean | null;
          sharingPermissionGranted?: boolean | null;
        }
      | {
          __typename?: 'RaffleSubmissionData';
          name: string;
          optionalImageUrl?: string | null;
        }
      | {
          __typename?: 'SlidesSubmissionData';
          optionalImageUrl?: string | null;
          title: string;
          content: string;
          slideDuration?: number | null;
          imageTilt?: SlideImageTilt | null;
          layout?: SlideLayout | null;
          showQr?: boolean | null;
          background?: {
            __typename?: 'SlideBackground';
            type: SlideBackgroundType;
            color?: string | null;
            imageUrl?: string | null;
          } | null;
          elements?: Array<{
            __typename?: 'SlideElement';
            id: string;
            type: SlideElementType;
            name?: string | null;
            locked?: boolean | null;
            text?: string | null;
            textType?: string | null;
            fontFamily?: Array<string> | null;
            color?: string | null;
            fontSize?: number | null;
            fontWeight?: SlideFontWeight | null;
            textAlign?: SlideTextAlign | null;
            verticalAlign?: SlideVerticalAlign | null;
            imageUrl?: string | null;
            fit?: SlideImageFit | null;
            box?: {
              __typename?: 'SlideBox';
              x: number;
              y: number;
              w: number;
              h: number;
            } | null;
          }> | null;
        }
      | {
          __typename?: 'TriviaSubmissionData';
          questionId?: string | null;
          choiceId?: string | null;
        }
      | {
          __typename?: 'VoteForSubmissionData';
          title: string;
          color: string;
          description: string;
          optionalImageUrl?: string | null;
        };
    reactions?: Array<{
      __typename?: 'Reaction';
      id: string;
      type: string;
      createdAt: any;
    }> | null;
  }>;
};

export type StageGetSubmissionQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type StageGetSubmissionQuery = {
  __typename?: 'Query';
  submission?: {
    __typename?: 'Submission';
    id: string;
    createdAt: any;
    engagementId: string;
    hidden: boolean;
    possibleBannedDevice: boolean;
    matchedBanCreatedAt?: any | null;
    userId?: string | null;
    data:
      | {
          __typename?: 'NowPlayingSubmissionData';
          order: number;
          songAlbumArt?: string | null;
          songTitle?: string | null;
          songArtist?: string | null;
          songNotes?: string | null;
          songLyrics?: string | null;
          visualizationType?: string | null;
          spotifyUrl?: string | null;
        }
      | {
          __typename?: 'PhotoCarouselSubmissionData';
          photoUrl?: string | null;
          caption?: string | null;
          approved?: boolean | null;
          sharingPermissionGranted?: boolean | null;
        }
      | {
          __typename?: 'RaffleSubmissionData';
          name: string;
          optionalImageUrl?: string | null;
        }
      | {
          __typename?: 'SlidesSubmissionData';
          optionalImageUrl?: string | null;
          title: string;
          content: string;
          slideDuration?: number | null;
          imageTilt?: SlideImageTilt | null;
          layout?: SlideLayout | null;
          showQr?: boolean | null;
          background?: {
            __typename?: 'SlideBackground';
            type: SlideBackgroundType;
            color?: string | null;
            imageUrl?: string | null;
          } | null;
          elements?: Array<{
            __typename?: 'SlideElement';
            id: string;
            type: SlideElementType;
            name?: string | null;
            locked?: boolean | null;
            text?: string | null;
            textType?: string | null;
            fontFamily?: Array<string> | null;
            color?: string | null;
            fontSize?: number | null;
            fontWeight?: SlideFontWeight | null;
            textAlign?: SlideTextAlign | null;
            verticalAlign?: SlideVerticalAlign | null;
            imageUrl?: string | null;
            fit?: SlideImageFit | null;
            box?: {
              __typename?: 'SlideBox';
              x: number;
              y: number;
              w: number;
              h: number;
            } | null;
          }> | null;
        }
      | {
          __typename?: 'TriviaSubmissionData';
          questionId?: string | null;
          choiceId?: string | null;
        }
      | {
          __typename?: 'VoteForSubmissionData';
          title: string;
          color: string;
          description: string;
          optionalImageUrl?: string | null;
        };
    reactions?: Array<{
      __typename?: 'Reaction';
      id: string;
      type: string;
      createdAt: any;
    }> | null;
  } | null;
};

export type GetEngagementsQueryVariables = Exact<{
  eventId: Scalars['String']['input'];
}>;

export type GetEngagementsQuery = {
  __typename?: 'Query';
  engagements: Array<{
    __typename?: 'Engagement';
    id: string;
    eventId: string;
    createdAt: any;
    updatedAt: any;
    title: string;
    description?: string | null;
    qrCodeCta?: string | null;
    startTime?: any | null;
    order: number;
    endTime?: any | null;
    type: EngagementType;
    data?:
      | { __typename?: 'NowPlayingAdminData'; currentSong?: string | null }
      | {
          __typename?: 'PhotoCarouselAdminData';
          visibleSubmission?: string | null;
          rejectedQueue: Array<string>;
          unapprovedQueue: Array<string>;
          unseenQueue: Array<string>;
          seenQueuePointer: number;
          seenQueue: Array<string>;
        }
      | {
          __typename?: 'RaffleAdminData';
          raffleStatus: RaffleStatus;
          raffleCandidates: Array<string>;
          raffleWinners: Array<string>;
          raffleWinner?: string | null;
          winnerCount: number;
          remainingSubmissionIds: Array<string>;
          lastEliminatedSubmissionId?: string | null;
        }
      | {
          __typename?: 'SlidesAdminData';
          currentSlide: string;
          slidesDisplayOrder: Array<string>;
        }
      | {
          __typename?: 'TriviaAdminData';
          status: TriviaRoundStatus;
          questionIndex: number;
          playedThroughIndex: number;
          reviewing: boolean;
          questionEndsAt?: any | null;
          answeredCount: number;
          playerCount: number;
          correctChoiceId?: string | null;
          correctCount?: number | null;
          revealedQuestionIds: Array<string>;
          tallies: Array<{
            __typename?: 'TriviaTally';
            choiceId: string;
            count: number;
          }>;
          leaderboard: Array<{
            __typename?: 'TriviaLeaderboardRow';
            userId: string;
            name: string;
            score: number;
            rank: number;
            tied: boolean;
          }>;
        }
      | {
          __typename?: 'VoteForAdminData';
          startTime?: any | null;
          endTime?: any | null;
          voteWinners?: Array<string> | null;
          choiceDisplayOrder: Array<string>;
          votes: Array<{
            __typename?: 'VoteCount';
            submissionId: string;
            count: number;
          }>;
        }
      | null;
    config?:
      | {
          __typename?: 'NowPlayingAdminConfig';
          visualizationType: string;
          allowComments: boolean;
          allowedReactions: Array<string>;
        }
      | {
          __typename?: 'PhotoCarouselAdminConfig';
          maxSubmissionsPerUser: number;
          requireApproval: boolean;
          askSharePermission?: boolean | null;
          sharePrompt?: string | null;
          noPhotosMessage?: string | null;
          pollInterval?: number | null;
          predefinedCaptions?: Array<string> | null;
          maxVisiblePhotos: number;
        }
      | {
          __typename?: 'RaffleAdminConfig';
          optionalImageUrl?: string | null;
          claimYourPrize?: string | null;
          ticketFlipDirection: RaffleTicketFlipDirection;
        }
      | {
          __typename?: 'SlidesAdminConfig';
          autoPlay: boolean;
          autoPlayIntervalMs?: number | null;
        }
      | {
          __typename?: 'TriviaAdminConfig';
          instructions?: string | null;
          useQuestionTimer: boolean;
          defaultTimerMs: number;
          questions: Array<{
            __typename?: 'TriviaQuestion';
            id: string;
            text: string;
            correctChoiceId?: string | null;
            timerMs?: number | null;
            choices: Array<{
              __typename?: 'TriviaChoice';
              id: string;
              text: string;
            }>;
          }>;
        }
      | {
          __typename?: 'VoteForAdminConfig';
          votesPerUser: number;
          allowUserSubmissions: boolean;
          maxSubmissionsPerUser: number;
        }
      | null;
    viewConfig:
      | {
          __typename?: 'NowPlayingViewConfig';
          visualizationType: string;
          allowComments: boolean;
          allowedReactions: Array<string>;
        }
      | {
          __typename?: 'PhotoCarouselViewConfig';
          maxSubmissionsPerUser: number;
          askSharePermission?: boolean | null;
          sharePrompt?: string | null;
          noPhotosMessage?: string | null;
          maxVisiblePhotos: number;
        }
      | {
          __typename?: 'RaffleViewConfig';
          optionalImageUrl?: string | null;
          claimYourPrize?: string | null;
          ticketFlipDirection: RaffleTicketFlipDirection;
        }
      | {
          __typename?: 'SlidesViewConfig';
          autoPlay: boolean;
          autoPlayIntervalMs?: number | null;
        }
      | {
          __typename?: 'TriviaViewConfig';
          instructions?: string | null;
          useQuestionTimer: boolean;
          defaultTimerMs: number;
          questions: Array<{
            __typename?: 'TriviaViewQuestion';
            id: string;
            text: string;
            timerMs?: number | null;
            choices: Array<{
              __typename?: 'TriviaChoice';
              id: string;
              text: string;
            }>;
          }>;
        }
      | { __typename?: 'VoteForViewConfig'; votesPerUser: number };
    viewData:
      | { __typename?: 'NowPlayingViewData'; currentSong?: string | null }
      | {
          __typename?: 'PhotoCarouselViewData';
          visibleSubmission?: string | null;
        }
      | {
          __typename?: 'RaffleViewData';
          raffleStatus: RaffleStatus;
          raffleCandidates: Array<string>;
          raffleWinners: Array<string>;
          raffleWinner?: string | null;
          winnerCount: number;
          remainingSubmissionIds: Array<string>;
          lastEliminatedSubmissionId?: string | null;
        }
      | {
          __typename?: 'SlidesViewData';
          currentSlide: string;
          slidesDisplayOrder: Array<string>;
        }
      | {
          __typename?: 'TriviaViewData';
          status: TriviaRoundStatus;
          questionIndex: number;
          questionEndsAt?: any | null;
          answeredCount: number;
          playerCount: number;
          correctChoiceId?: string | null;
          correctCount?: number | null;
          leaderboardOverflow: number;
          tallies: Array<{
            __typename?: 'TriviaTally';
            choiceId: string;
            count: number;
          }>;
          leaderboard: Array<{
            __typename?: 'TriviaLeaderboardRow';
            userId: string;
            name: string;
            score: number;
            rank: number;
            tied: boolean;
          }>;
        }
      | {
          __typename?: 'VoteForViewData';
          voteWinners?: Array<string> | null;
          choiceDisplayOrder: Array<string>;
          votes: Array<{
            __typename?: 'VoteCount';
            submissionId: string;
            count: number;
          }>;
        };
  }>;
};

export type FanGetEventQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type FanGetEventQuery = {
  __typename?: 'Query';
  event?: {
    __typename?: 'Event';
    id: string;
    name: string;
    live: boolean;
    description?: string | null;
    date?: any | null;
    location?: string | null;
    themeConfig?: {
      __typename?: 'EventThemeConfig';
      headingFontFamily?: Array<string> | null;
      bodyFontFamily?: Array<string> | null;
      foregroundColor?: string | null;
      backgroundColor?: string | null;
      stageBackgroundImage?: string | null;
      fanBackgroundImage?: string | null;
      qrForegroundColor?: string | null;
      qrBackgroundColor?: string | null;
      qrTextColor?: string | null;
      qrWrapperBackgroundColor?: string | null;
      stageElements?: Array<{
        __typename?: 'ScreenElement';
        id: string;
        type: string;
        name?: string | null;
        imageUrl?: string | null;
        defaultStyles?: any | null;
        engagementStyles?: any | null;
        defaultClassNames?: string | null;
        engagementClassNames?: string | null;
        text?: string | null;
        textType?: string | null;
        fontFamily?: Array<string> | null;
        linkHref?: string | null;
        color?: string | null;
      }> | null;
      fanElements?: Array<{
        __typename?: 'ScreenElement';
        id: string;
        type: string;
        name?: string | null;
        imageUrl?: string | null;
        defaultStyles?: any | null;
        engagementStyles?: any | null;
        defaultClassNames?: string | null;
        engagementClassNames?: string | null;
        text?: string | null;
        textType?: string | null;
        fontFamily?: Array<string> | null;
        linkHref?: string | null;
        color?: string | null;
      }> | null;
    } | null;
    activeEngagement?: {
      __typename?: 'Engagement';
      id: string;
      createdAt: any;
      updatedAt: any;
      title: string;
      description?: string | null;
      startTime?: any | null;
      endTime?: any | null;
      type: EngagementType;
      order: number;
      viewConfig:
        | {
            __typename?: 'NowPlayingViewConfig';
            visualizationType: string;
            allowComments: boolean;
            allowedReactions: Array<string>;
          }
        | {
            __typename?: 'PhotoCarouselViewConfig';
            maxSubmissionsPerUser: number;
            askSharePermission?: boolean | null;
            sharePrompt?: string | null;
            noPhotosMessage?: string | null;
            maxVisiblePhotos: number;
          }
        | {
            __typename?: 'RaffleViewConfig';
            optionalImageUrl?: string | null;
            claimYourPrize?: string | null;
            ticketFlipDirection: RaffleTicketFlipDirection;
          }
        | {
            __typename?: 'SlidesViewConfig';
            autoPlay: boolean;
            autoPlayIntervalMs?: number | null;
          }
        | {
            __typename?: 'TriviaViewConfig';
            instructions?: string | null;
            useQuestionTimer: boolean;
            defaultTimerMs: number;
            questions: Array<{
              __typename?: 'TriviaViewQuestion';
              id: string;
              text: string;
              timerMs?: number | null;
              choices: Array<{
                __typename?: 'TriviaChoice';
                id: string;
                text: string;
              }>;
            }>;
          }
        | { __typename?: 'VoteForViewConfig'; votesPerUser: number };
      viewData:
        | { __typename?: 'NowPlayingViewData'; currentSong?: string | null }
        | {
            __typename?: 'PhotoCarouselViewData';
            visibleSubmission?: string | null;
          }
        | {
            __typename?: 'RaffleViewData';
            raffleStatus: RaffleStatus;
            raffleCandidates: Array<string>;
            raffleWinners: Array<string>;
            raffleWinner?: string | null;
            winnerCount: number;
            remainingSubmissionIds: Array<string>;
            lastEliminatedSubmissionId?: string | null;
          }
        | {
            __typename?: 'SlidesViewData';
            currentSlide: string;
            slidesDisplayOrder: Array<string>;
          }
        | {
            __typename?: 'TriviaViewData';
            status: TriviaRoundStatus;
            questionIndex: number;
            questionEndsAt?: any | null;
            answeredCount: number;
            playerCount: number;
            correctChoiceId?: string | null;
            correctCount?: number | null;
            leaderboardOverflow: number;
            tallies: Array<{
              __typename?: 'TriviaTally';
              choiceId: string;
              count: number;
            }>;
            leaderboard: Array<{
              __typename?: 'TriviaLeaderboardRow';
              userId: string;
              name: string;
              score: number;
              rank: number;
              tied: boolean;
            }>;
          }
        | {
            __typename?: 'VoteForViewData';
            voteWinners?: Array<string> | null;
            choiceDisplayOrder: Array<string>;
            votes: Array<{
              __typename?: 'VoteCount';
              submissionId: string;
              count: number;
            }>;
          };
    } | null;
  } | null;
};

export type StageGetEventQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type StageGetEventQuery = {
  __typename?: 'Query';
  event?: {
    __typename?: 'Event';
    id: string;
    name: string;
    live: boolean;
    description?: string | null;
    date?: any | null;
    location?: string | null;
    themeConfig?: {
      __typename?: 'EventThemeConfig';
      headingFontFamily?: Array<string> | null;
      bodyFontFamily?: Array<string> | null;
      foregroundColor?: string | null;
      backgroundColor?: string | null;
      stageBackgroundImage?: string | null;
      fanBackgroundImage?: string | null;
      qrForegroundColor?: string | null;
      qrBackgroundColor?: string | null;
      qrTextColor?: string | null;
      qrWrapperBackgroundColor?: string | null;
      stageElements?: Array<{
        __typename?: 'ScreenElement';
        id: string;
        type: string;
        name?: string | null;
        imageUrl?: string | null;
        defaultStyles?: any | null;
        engagementStyles?: any | null;
        defaultClassNames?: string | null;
        engagementClassNames?: string | null;
        text?: string | null;
        textType?: string | null;
        fontFamily?: Array<string> | null;
        linkHref?: string | null;
        color?: string | null;
      }> | null;
      fanElements?: Array<{
        __typename?: 'ScreenElement';
        id: string;
        type: string;
        name?: string | null;
        imageUrl?: string | null;
        defaultStyles?: any | null;
        engagementStyles?: any | null;
        defaultClassNames?: string | null;
        engagementClassNames?: string | null;
        text?: string | null;
        textType?: string | null;
        fontFamily?: Array<string> | null;
        linkHref?: string | null;
        color?: string | null;
      }> | null;
    } | null;
    activeEngagement?: {
      __typename?: 'Engagement';
      id: string;
      createdAt: any;
      updatedAt: any;
      title: string;
      qrCodeCta?: string | null;
      description?: string | null;
      startTime?: any | null;
      endTime?: any | null;
      type: EngagementType;
      order: number;
      viewConfig:
        | {
            __typename?: 'NowPlayingViewConfig';
            visualizationType: string;
            allowComments: boolean;
            allowedReactions: Array<string>;
          }
        | {
            __typename?: 'PhotoCarouselViewConfig';
            maxSubmissionsPerUser: number;
            askSharePermission?: boolean | null;
            sharePrompt?: string | null;
            noPhotosMessage?: string | null;
            maxVisiblePhotos: number;
          }
        | {
            __typename?: 'RaffleViewConfig';
            optionalImageUrl?: string | null;
            claimYourPrize?: string | null;
            ticketFlipDirection: RaffleTicketFlipDirection;
          }
        | {
            __typename?: 'SlidesViewConfig';
            autoPlay: boolean;
            autoPlayIntervalMs?: number | null;
          }
        | {
            __typename?: 'TriviaViewConfig';
            instructions?: string | null;
            useQuestionTimer: boolean;
            defaultTimerMs: number;
            questions: Array<{
              __typename?: 'TriviaViewQuestion';
              id: string;
              text: string;
              timerMs?: number | null;
              choices: Array<{
                __typename?: 'TriviaChoice';
                id: string;
                text: string;
              }>;
            }>;
          }
        | { __typename?: 'VoteForViewConfig'; votesPerUser: number };
      viewData:
        | { __typename?: 'NowPlayingViewData'; currentSong?: string | null }
        | {
            __typename?: 'PhotoCarouselViewData';
            visibleSubmission?: string | null;
          }
        | {
            __typename?: 'RaffleViewData';
            raffleStatus: RaffleStatus;
            raffleCandidates: Array<string>;
            raffleWinners: Array<string>;
            raffleWinner?: string | null;
            winnerCount: number;
            remainingSubmissionIds: Array<string>;
            lastEliminatedSubmissionId?: string | null;
          }
        | {
            __typename?: 'SlidesViewData';
            currentSlide: string;
            slidesDisplayOrder: Array<string>;
          }
        | {
            __typename?: 'TriviaViewData';
            status: TriviaRoundStatus;
            questionIndex: number;
            questionEndsAt?: any | null;
            answeredCount: number;
            playerCount: number;
            correctChoiceId?: string | null;
            correctCount?: number | null;
            leaderboardOverflow: number;
            tallies: Array<{
              __typename?: 'TriviaTally';
              choiceId: string;
              count: number;
            }>;
            leaderboard: Array<{
              __typename?: 'TriviaLeaderboardRow';
              userId: string;
              name: string;
              score: number;
              rank: number;
              tied: boolean;
            }>;
          }
        | {
            __typename?: 'VoteForViewData';
            voteWinners?: Array<string> | null;
            choiceDisplayOrder: Array<string>;
            votes: Array<{
              __typename?: 'VoteCount';
              submissionId: string;
              count: number;
            }>;
          };
    } | null;
  } | null;
};

export type RandomNameQueryVariables = Exact<{ [key: string]: never }>;

export type RandomNameQuery = { __typename?: 'Query'; randomName: string };

export type WhoamiQueryVariables = Exact<{ [key: string]: never }>;

export type WhoamiQuery = {
  __typename?: 'Query';
  whoami?: {
    __typename?: 'User';
    id: string;
    name?: string | null;
    username?: string | null;
    lastLogin?: any | null;
    email?: string | null;
    role: Role;
    createdAt: any;
    cookieConsent?: {
      __typename?: 'CookiePreferences';
      functional: boolean;
      analytics: boolean;
      marketing: boolean;
      consentDate?: string | null;
    } | null;
  } | null;
};

export type GetFullAccountInfoQueryVariables = Exact<{ [key: string]: never }>;

export type GetFullAccountInfoQuery = {
  __typename?: 'Query';
  whoami?: {
    __typename?: 'User';
    id: string;
    email?: string | null;
    role: Role;
    name?: string | null;
    username?: string | null;
    lastLogin?: any | null;
    googleId?: string | null;
    stripeCustomerId?: string | null;
    createdAt: any;
  } | null;
  mySubscription?: {
    __typename?: 'PaymentSubscription';
    id: string;
    userId: string;
    status: PaymentSubscriptionStatus;
    stripeSubscriptionId: string;
    currentPeriodStart?: any | null;
    currentPeriodEnd?: any | null;
    cancelAtPeriodEnd: boolean;
    canceledAt?: any | null;
    trialStart?: any | null;
    trialEnd?: any | null;
    maxConcurrentEvents: number;
    createdAt: any;
    updatedAt: any;
    liveEvents: Array<{ __typename?: 'Event'; id: string; name: string }>;
  } | null;
  myEventPasses: Array<{
    __typename?: 'EventPass';
    id: string;
    userId: string;
    status: EventPassStatus;
    stripeCheckoutSessionId?: string | null;
    stripeChargeId?: string | null;
    amountPaid?: number | null;
    currency?: string | null;
    createdAt: any;
    updatedAt: any;
    expiresAt?: any | null;
    redemptions: Array<{
      __typename?: 'EventPassRedemption';
      id: string;
      eventPassId: string;
      eventId: string;
      redeemedAt: any;
      description?: string | null;
      expiresAt?: any | null;
    }>;
  }>;
};

export type CanMakeEventLiveQueryVariables = Exact<{
  eventId: Scalars['String']['input'];
}>;

export type CanMakeEventLiveQuery = {
  __typename?: 'Query';
  canMakeEventLive: {
    __typename?: 'CanMakeEventLiveResponse';
    withEventPass: boolean;
    withSubscription: boolean;
    liveCount: number;
  };
};

export type MyPurchasesQueryVariables = Exact<{ [key: string]: never }>;

export type MyPurchasesQuery = {
  __typename?: 'Query';
  mySubscription?: {
    __typename?: 'PaymentSubscription';
    id: string;
    userId: string;
    status: PaymentSubscriptionStatus;
    stripeSubscriptionId: string;
    currentPeriodStart?: any | null;
    currentPeriodEnd?: any | null;
    cancelAtPeriodEnd: boolean;
    canceledAt?: any | null;
    trialStart?: any | null;
    trialEnd?: any | null;
    maxConcurrentEvents: number;
    createdAt: any;
    updatedAt: any;
    liveEvents: Array<{ __typename?: 'Event'; id: string; name: string }>;
  } | null;
  myEventPasses: Array<{
    __typename?: 'EventPass';
    id: string;
    userId: string;
    status: EventPassStatus;
    stripeCheckoutSessionId?: string | null;
    stripeChargeId?: string | null;
    amountPaid?: number | null;
    currency?: string | null;
    createdAt: any;
    updatedAt: any;
    expiresAt?: any | null;
    redemptions: Array<{
      __typename?: 'EventPassRedemption';
      id: string;
      eventPassId: string;
      eventId: string;
      redeemedAt: any;
      description?: string | null;
      expiresAt?: any | null;
    }>;
  }>;
  pricing: { __typename?: 'Pricing'; eventPass: number; subscription: number };
};

export type GetScreenTemplatesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetScreenTemplatesQuery = {
  __typename?: 'Query';
  screenTemplates: Array<{
    __typename?: 'ScreenTemplate';
    id: string;
    name: string;
    description?: string | null;
    createdAt: any;
    updatedAt: any;
    enabled: boolean;
    config?: {
      __typename?: 'EventThemeConfig';
      headingFontFamily?: Array<string> | null;
      bodyFontFamily?: Array<string> | null;
      foregroundColor?: string | null;
      backgroundColor?: string | null;
      stageBackgroundImage?: string | null;
      fanBackgroundImage?: string | null;
      qrForegroundColor?: string | null;
      qrBackgroundColor?: string | null;
      qrTextColor?: string | null;
      qrWrapperBackgroundColor?: string | null;
      stageElements?: Array<{
        __typename?: 'ScreenElement';
        id: string;
        type: string;
        name?: string | null;
        imageUrl?: string | null;
        defaultStyles?: any | null;
        engagementStyles?: any | null;
        defaultClassNames?: string | null;
        engagementClassNames?: string | null;
        text?: string | null;
        textType?: string | null;
        fontFamily?: Array<string> | null;
        linkHref?: string | null;
        color?: string | null;
      }> | null;
      fanElements?: Array<{
        __typename?: 'ScreenElement';
        id: string;
        type: string;
        name?: string | null;
        imageUrl?: string | null;
        defaultStyles?: any | null;
        engagementStyles?: any | null;
        defaultClassNames?: string | null;
        engagementClassNames?: string | null;
        text?: string | null;
        textType?: string | null;
        fontFamily?: Array<string> | null;
        linkHref?: string | null;
        color?: string | null;
      }> | null;
    } | null;
    engagements: Array<{
      __typename?: 'ScreenTemplateEngagementInput';
      data?: any | null;
      description?: string | null;
      config?: any | null;
      endTime?: any | null;
      qrCodeCta?: string | null;
      startTime?: any | null;
      title: string;
      type: EngagementType;
    }>;
  }>;
};

export type GetPricingQueryVariables = Exact<{ [key: string]: never }>;

export type GetPricingQuery = {
  __typename?: 'Query';
  pricing: { __typename?: 'Pricing'; eventPass: number; subscription: number };
};

export type GetPrivacyPolicyQueryVariables = Exact<{ [key: string]: never }>;

export type GetPrivacyPolicyQuery = {
  __typename?: 'Query';
  privacyPolicy: string;
};

export type GetTermsOfUseQueryVariables = Exact<{ [key: string]: never }>;

export type GetTermsOfUseQuery = { __typename?: 'Query'; termsOfUse: string };

export type FeatureFlagsQueryVariables = Exact<{ [key: string]: never }>;

export type FeatureFlagsQuery = {
  __typename?: 'Query';
  featureFlags: {
    __typename?: 'FeatureFlags';
    googleAuth: boolean;
    eventPassPromoCode: string;
    subscriptionPromoCode: string;
    monetizationEnabled: boolean;
    bansEnabled: boolean;
  };
};

export type GetEventIdByCodeQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;

export type GetEventIdByCodeQuery = {
  __typename?: 'Query';
  eventByCode: {
    __typename?: 'EventByCodeResponse';
    success: boolean;
    eventId?: string | null;
  };
};

export type BetaSignupsQueryVariables = Exact<{ [key: string]: never }>;

export type BetaSignupsQuery = {
  __typename?: 'Query';
  betaSignups: Array<{
    __typename?: 'BetaSignup';
    id: string;
    email: string;
    createdAt: any;
  }>;
};

export type OnActiveEngagementChangedSubscriptionVariables = Exact<{
  eventId: Scalars['String']['input'];
}>;

export type OnActiveEngagementChangedSubscription = {
  __typename?: 'Subscription';
  activeEngagementChanged?: {
    __typename?: 'ActiveEngagementChangedPayload';
    activeEngagement?: {
      __typename?: 'Engagement';
      id: string;
      createdAt: any;
      updatedAt: any;
      title: string;
      qrCodeCta?: string | null;
      description?: string | null;
      startTime?: any | null;
      endTime?: any | null;
      type: EngagementType;
      order: number;
      viewConfig:
        | {
            __typename?: 'NowPlayingViewConfig';
            visualizationType: string;
            allowComments: boolean;
            allowedReactions: Array<string>;
          }
        | {
            __typename?: 'PhotoCarouselViewConfig';
            maxSubmissionsPerUser: number;
            askSharePermission?: boolean | null;
            sharePrompt?: string | null;
            noPhotosMessage?: string | null;
            maxVisiblePhotos: number;
          }
        | {
            __typename?: 'RaffleViewConfig';
            optionalImageUrl?: string | null;
            claimYourPrize?: string | null;
            ticketFlipDirection: RaffleTicketFlipDirection;
          }
        | {
            __typename?: 'SlidesViewConfig';
            autoPlay: boolean;
            autoPlayIntervalMs?: number | null;
          }
        | {
            __typename?: 'TriviaViewConfig';
            instructions?: string | null;
            useQuestionTimer: boolean;
            defaultTimerMs: number;
            questions: Array<{
              __typename?: 'TriviaViewQuestion';
              id: string;
              text: string;
              timerMs?: number | null;
              choices: Array<{
                __typename?: 'TriviaChoice';
                id: string;
                text: string;
              }>;
            }>;
          }
        | { __typename?: 'VoteForViewConfig'; votesPerUser: number };
      viewData:
        | { __typename?: 'NowPlayingViewData'; currentSong?: string | null }
        | {
            __typename?: 'PhotoCarouselViewData';
            visibleSubmission?: string | null;
          }
        | {
            __typename?: 'RaffleViewData';
            raffleStatus: RaffleStatus;
            raffleCandidates: Array<string>;
            raffleWinners: Array<string>;
            raffleWinner?: string | null;
            winnerCount: number;
            remainingSubmissionIds: Array<string>;
            lastEliminatedSubmissionId?: string | null;
          }
        | {
            __typename?: 'SlidesViewData';
            currentSlide: string;
            slidesDisplayOrder: Array<string>;
          }
        | {
            __typename?: 'TriviaViewData';
            status: TriviaRoundStatus;
            questionIndex: number;
            questionEndsAt?: any | null;
            answeredCount: number;
            playerCount: number;
            correctChoiceId?: string | null;
            correctCount?: number | null;
            leaderboardOverflow: number;
            tallies: Array<{
              __typename?: 'TriviaTally';
              choiceId: string;
              count: number;
            }>;
            leaderboard: Array<{
              __typename?: 'TriviaLeaderboardRow';
              userId: string;
              name: string;
              score: number;
              rank: number;
              tied: boolean;
            }>;
          }
        | {
            __typename?: 'VoteForViewData';
            voteWinners?: Array<string> | null;
            choiceDisplayOrder: Array<string>;
            votes: Array<{
              __typename?: 'VoteCount';
              submissionId: string;
              count: number;
            }>;
          };
    } | null;
  } | null;
};

export type OnEngagementChangedSubscriptionVariables = Exact<{
  engagementId: Scalars['String']['input'];
}>;

export type OnEngagementChangedSubscription = {
  __typename?: 'Subscription';
  engagementChanged?: {
    __typename?: 'EngagementChangedPayload';
    engagement: {
      __typename?: 'Engagement';
      id: string;
      eventId: string;
      createdAt: any;
      updatedAt: any;
      title: string;
      description?: string | null;
      qrCodeCta?: string | null;
      startTime?: any | null;
      order: number;
      endTime?: any | null;
      type: EngagementType;
      viewConfig:
        | {
            __typename?: 'NowPlayingViewConfig';
            visualizationType: string;
            allowComments: boolean;
            allowedReactions: Array<string>;
          }
        | {
            __typename?: 'PhotoCarouselViewConfig';
            maxSubmissionsPerUser: number;
            askSharePermission?: boolean | null;
            sharePrompt?: string | null;
            noPhotosMessage?: string | null;
            maxVisiblePhotos: number;
          }
        | { __typename?: 'RaffleViewConfig' }
        | {
            __typename?: 'SlidesViewConfig';
            autoPlay: boolean;
            autoPlayIntervalMs?: number | null;
          }
        | { __typename?: 'TriviaViewConfig' }
        | { __typename?: 'VoteForViewConfig'; votesPerUser: number };
      viewData:
        | { __typename?: 'NowPlayingViewData'; currentSong?: string | null }
        | {
            __typename?: 'PhotoCarouselViewData';
            visibleSubmission?: string | null;
          }
        | { __typename?: 'RaffleViewData' }
        | {
            __typename?: 'SlidesViewData';
            currentSlide: string;
            slidesDisplayOrder: Array<string>;
          }
        | { __typename?: 'TriviaViewData' }
        | {
            __typename?: 'VoteForViewData';
            voteWinners?: Array<string> | null;
            choiceDisplayOrder: Array<string>;
            votes: Array<{
              __typename?: 'VoteCount';
              submissionId: string;
              count: number;
            }>;
          };
    };
  } | null;
};

export type OnMockEngagementChangedSubscriptionVariables = Exact<{
  engagementId: Scalars['String']['input'];
}>;

export type OnMockEngagementChangedSubscription = {
  __typename?: 'Subscription';
  mockEngagementChanged?: {
    __typename?: 'EngagementChangedPayload';
    engagement: {
      __typename?: 'Engagement';
      id: string;
      eventId: string;
      createdAt: any;
      updatedAt: any;
      title: string;
      description?: string | null;
      qrCodeCta?: string | null;
      startTime?: any | null;
      order: number;
      endTime?: any | null;
      type: EngagementType;
      viewConfig:
        | {
            __typename?: 'NowPlayingViewConfig';
            visualizationType: string;
            allowComments: boolean;
            allowedReactions: Array<string>;
          }
        | {
            __typename?: 'PhotoCarouselViewConfig';
            maxSubmissionsPerUser: number;
            askSharePermission?: boolean | null;
            sharePrompt?: string | null;
            noPhotosMessage?: string | null;
            maxVisiblePhotos: number;
          }
        | { __typename?: 'RaffleViewConfig' }
        | {
            __typename?: 'SlidesViewConfig';
            autoPlay: boolean;
            autoPlayIntervalMs?: number | null;
          }
        | { __typename?: 'TriviaViewConfig' }
        | { __typename?: 'VoteForViewConfig'; votesPerUser: number };
      viewData:
        | { __typename?: 'NowPlayingViewData'; currentSong?: string | null }
        | {
            __typename?: 'PhotoCarouselViewData';
            visibleSubmission?: string | null;
          }
        | { __typename?: 'RaffleViewData' }
        | {
            __typename?: 'SlidesViewData';
            currentSlide: string;
            slidesDisplayOrder: Array<string>;
          }
        | { __typename?: 'TriviaViewData' }
        | {
            __typename?: 'VoteForViewData';
            voteWinners?: Array<string> | null;
            choiceDisplayOrder: Array<string>;
            votes: Array<{
              __typename?: 'VoteCount';
              submissionId: string;
              count: number;
            }>;
          };
    };
  } | null;
};

export type OnStageEngagementSubmissionsChangedSubscriptionVariables = Exact<{
  engagementId: Scalars['String']['input'];
}>;

export type OnStageEngagementSubmissionsChangedSubscription = {
  __typename?: 'Subscription';
  engagementSubmissionsChanged?: {
    __typename?: 'EngagementSubmissionsChangedPayload';
    submissions: Array<{
      __typename?: 'Submission';
      id: string;
      createdAt: any;
      engagementId: string;
      hidden: boolean;
      possibleBannedDevice: boolean;
      matchedBanCreatedAt?: any | null;
      userId?: string | null;
      data:
        | {
            __typename?: 'NowPlayingSubmissionData';
            order: number;
            songAlbumArt?: string | null;
            songTitle?: string | null;
            songArtist?: string | null;
            songNotes?: string | null;
            songLyrics?: string | null;
            visualizationType?: string | null;
            spotifyUrl?: string | null;
          }
        | {
            __typename?: 'PhotoCarouselSubmissionData';
            photoUrl?: string | null;
            caption?: string | null;
            approved?: boolean | null;
            sharingPermissionGranted?: boolean | null;
          }
        | {
            __typename?: 'RaffleSubmissionData';
            name: string;
            optionalImageUrl?: string | null;
          }
        | {
            __typename?: 'SlidesSubmissionData';
            optionalImageUrl?: string | null;
            title: string;
            content: string;
            slideDuration?: number | null;
            imageTilt?: SlideImageTilt | null;
            layout?: SlideLayout | null;
            showQr?: boolean | null;
            background?: {
              __typename?: 'SlideBackground';
              type: SlideBackgroundType;
              color?: string | null;
              imageUrl?: string | null;
            } | null;
            elements?: Array<{
              __typename?: 'SlideElement';
              id: string;
              type: SlideElementType;
              name?: string | null;
              locked?: boolean | null;
              text?: string | null;
              textType?: string | null;
              fontFamily?: Array<string> | null;
              color?: string | null;
              fontSize?: number | null;
              fontWeight?: SlideFontWeight | null;
              textAlign?: SlideTextAlign | null;
              verticalAlign?: SlideVerticalAlign | null;
              imageUrl?: string | null;
              fit?: SlideImageFit | null;
              box?: {
                __typename?: 'SlideBox';
                x: number;
                y: number;
                w: number;
                h: number;
              } | null;
            }> | null;
          }
        | {
            __typename?: 'TriviaSubmissionData';
            questionId?: string | null;
            choiceId?: string | null;
          }
        | {
            __typename?: 'VoteForSubmissionData';
            title: string;
            color: string;
            description: string;
            optionalImageUrl?: string | null;
          };
      reactions?: Array<{
        __typename?: 'Reaction';
        id: string;
        type: string;
        createdAt: any;
      }> | null;
    }>;
  } | null;
};

export type OnFanEngagementSubmissionsChangedSubscriptionVariables = Exact<{
  engagementId: Scalars['String']['input'];
}>;

export type OnFanEngagementSubmissionsChangedSubscription = {
  __typename?: 'Subscription';
  engagementSubmissionsChanged?: {
    __typename?: 'EngagementSubmissionsChangedPayload';
    submissions: Array<{
      __typename?: 'Submission';
      id: string;
      createdAt: any;
      engagementId: string;
      hidden: boolean;
      possibleBannedDevice: boolean;
      data:
        | {
            __typename?: 'NowPlayingSubmissionData';
            order: number;
            songAlbumArt?: string | null;
            songTitle?: string | null;
            songArtist?: string | null;
            songNotes?: string | null;
            songLyrics?: string | null;
            visualizationType?: string | null;
            spotifyUrl?: string | null;
          }
        | {
            __typename?: 'PhotoCarouselSubmissionData';
            photoUrl?: string | null;
            caption?: string | null;
            approved?: boolean | null;
            sharingPermissionGranted?: boolean | null;
          }
        | {
            __typename?: 'RaffleSubmissionData';
            name: string;
            optionalImageUrl?: string | null;
          }
        | {
            __typename?: 'SlidesSubmissionData';
            optionalImageUrl?: string | null;
            title: string;
            content: string;
            slideDuration?: number | null;
            imageTilt?: SlideImageTilt | null;
            layout?: SlideLayout | null;
            showQr?: boolean | null;
            background?: {
              __typename?: 'SlideBackground';
              type: SlideBackgroundType;
              color?: string | null;
              imageUrl?: string | null;
            } | null;
            elements?: Array<{
              __typename?: 'SlideElement';
              id: string;
              type: SlideElementType;
              name?: string | null;
              locked?: boolean | null;
              text?: string | null;
              textType?: string | null;
              fontFamily?: Array<string> | null;
              color?: string | null;
              fontSize?: number | null;
              fontWeight?: SlideFontWeight | null;
              textAlign?: SlideTextAlign | null;
              verticalAlign?: SlideVerticalAlign | null;
              imageUrl?: string | null;
              fit?: SlideImageFit | null;
              box?: {
                __typename?: 'SlideBox';
                x: number;
                y: number;
                w: number;
                h: number;
              } | null;
            }> | null;
          }
        | {
            __typename?: 'TriviaSubmissionData';
            questionId?: string | null;
            choiceId?: string | null;
          }
        | {
            __typename?: 'VoteForSubmissionData';
            title: string;
            color: string;
            description: string;
            optionalImageUrl?: string | null;
          };
      reactions?: Array<{
        __typename?: 'Reaction';
        id: string;
        type: string;
        createdAt: any;
        submissionId: string;
      }> | null;
    }>;
  } | null;
};

export type OnMockStageEngagementSubmissionsChangedSubscriptionVariables =
  Exact<{
    engagementId: Scalars['String']['input'];
  }>;

export type OnMockStageEngagementSubmissionsChangedSubscription = {
  __typename?: 'Subscription';
  mockEngagementSubmissionsChanged?: {
    __typename?: 'EngagementSubmissionsChangedPayload';
    submissions: Array<{
      __typename?: 'Submission';
      id: string;
      createdAt: any;
      engagementId: string;
      hidden: boolean;
      possibleBannedDevice: boolean;
      matchedBanCreatedAt?: any | null;
      userId?: string | null;
      data:
        | {
            __typename?: 'NowPlayingSubmissionData';
            order: number;
            songAlbumArt?: string | null;
            songTitle?: string | null;
            songArtist?: string | null;
            songNotes?: string | null;
            songLyrics?: string | null;
            visualizationType?: string | null;
            spotifyUrl?: string | null;
          }
        | {
            __typename?: 'PhotoCarouselSubmissionData';
            photoUrl?: string | null;
            caption?: string | null;
            approved?: boolean | null;
            sharingPermissionGranted?: boolean | null;
          }
        | {
            __typename?: 'RaffleSubmissionData';
            name: string;
            optionalImageUrl?: string | null;
          }
        | {
            __typename?: 'SlidesSubmissionData';
            optionalImageUrl?: string | null;
            title: string;
            content: string;
            slideDuration?: number | null;
            imageTilt?: SlideImageTilt | null;
            layout?: SlideLayout | null;
            showQr?: boolean | null;
            background?: {
              __typename?: 'SlideBackground';
              type: SlideBackgroundType;
              color?: string | null;
              imageUrl?: string | null;
            } | null;
            elements?: Array<{
              __typename?: 'SlideElement';
              id: string;
              type: SlideElementType;
              name?: string | null;
              locked?: boolean | null;
              text?: string | null;
              textType?: string | null;
              fontFamily?: Array<string> | null;
              color?: string | null;
              fontSize?: number | null;
              fontWeight?: SlideFontWeight | null;
              textAlign?: SlideTextAlign | null;
              verticalAlign?: SlideVerticalAlign | null;
              imageUrl?: string | null;
              fit?: SlideImageFit | null;
              box?: {
                __typename?: 'SlideBox';
                x: number;
                y: number;
                w: number;
                h: number;
              } | null;
            }> | null;
          }
        | {
            __typename?: 'TriviaSubmissionData';
            questionId?: string | null;
            choiceId?: string | null;
          }
        | {
            __typename?: 'VoteForSubmissionData';
            title: string;
            color: string;
            description: string;
            optionalImageUrl?: string | null;
          };
      reactions?: Array<{
        __typename?: 'Reaction';
        id: string;
        type: string;
        createdAt: any;
      }> | null;
    }>;
  } | null;
};

export type OnMockFanEngagementSubmissionsChangedSubscriptionVariables = Exact<{
  engagementId: Scalars['String']['input'];
}>;

export type OnMockFanEngagementSubmissionsChangedSubscription = {
  __typename?: 'Subscription';
  mockEngagementSubmissionsChanged?: {
    __typename?: 'EngagementSubmissionsChangedPayload';
    submissions: Array<{
      __typename?: 'Submission';
      id: string;
      createdAt: any;
      engagementId: string;
      hidden: boolean;
      possibleBannedDevice: boolean;
      data:
        | {
            __typename?: 'NowPlayingSubmissionData';
            order: number;
            songAlbumArt?: string | null;
            songTitle?: string | null;
            songArtist?: string | null;
            songNotes?: string | null;
            songLyrics?: string | null;
            visualizationType?: string | null;
            spotifyUrl?: string | null;
          }
        | {
            __typename?: 'PhotoCarouselSubmissionData';
            photoUrl?: string | null;
            caption?: string | null;
            approved?: boolean | null;
            sharingPermissionGranted?: boolean | null;
          }
        | {
            __typename?: 'RaffleSubmissionData';
            name: string;
            optionalImageUrl?: string | null;
          }
        | {
            __typename?: 'SlidesSubmissionData';
            optionalImageUrl?: string | null;
            title: string;
            content: string;
            slideDuration?: number | null;
            imageTilt?: SlideImageTilt | null;
            layout?: SlideLayout | null;
            showQr?: boolean | null;
            background?: {
              __typename?: 'SlideBackground';
              type: SlideBackgroundType;
              color?: string | null;
              imageUrl?: string | null;
            } | null;
            elements?: Array<{
              __typename?: 'SlideElement';
              id: string;
              type: SlideElementType;
              name?: string | null;
              locked?: boolean | null;
              text?: string | null;
              textType?: string | null;
              fontFamily?: Array<string> | null;
              color?: string | null;
              fontSize?: number | null;
              fontWeight?: SlideFontWeight | null;
              textAlign?: SlideTextAlign | null;
              verticalAlign?: SlideVerticalAlign | null;
              imageUrl?: string | null;
              fit?: SlideImageFit | null;
              box?: {
                __typename?: 'SlideBox';
                x: number;
                y: number;
                w: number;
                h: number;
              } | null;
            }> | null;
          }
        | {
            __typename?: 'TriviaSubmissionData';
            questionId?: string | null;
            choiceId?: string | null;
          }
        | {
            __typename?: 'VoteForSubmissionData';
            title: string;
            color: string;
            description: string;
            optionalImageUrl?: string | null;
          };
      reactions?: Array<{
        __typename?: 'Reaction';
        id: string;
        type: string;
        createdAt: any;
        submissionId: string;
      }> | null;
    }>;
  } | null;
};

export type OnReactionsCreatedSubscriptionVariables = Exact<{
  submissionId: Scalars['String']['input'];
}>;

export type OnReactionsCreatedSubscription = {
  __typename?: 'Subscription';
  reactionsCreated?: {
    __typename?: 'ReactionsCreatedPayload';
    reactions: Array<{
      __typename?: 'Reaction';
      id: string;
      type: string;
      createdAt: any;
    }>;
  } | null;
};

export type OnSubmissionCreatedSubscriptionVariables = Exact<{
  engagementId: Scalars['String']['input'];
}>;

export type OnSubmissionCreatedSubscription = {
  __typename?: 'Subscription';
  submissionCreated?: {
    __typename?: 'SubmissionCreatedPayload';
    submission: {
      __typename?: 'Submission';
      id: string;
      engagementId: string;
      createdAt: any;
      userId?: string | null;
      hidden: boolean;
      possibleBannedDevice: boolean;
      matchedBanCreatedAt?: any | null;
      data:
        | {
            __typename?: 'NowPlayingSubmissionData';
            order: number;
            songAlbumArt?: string | null;
            songTitle?: string | null;
            songArtist?: string | null;
            songNotes?: string | null;
            songLyrics?: string | null;
            visualizationType?: string | null;
            spotifyUrl?: string | null;
          }
        | {
            __typename?: 'PhotoCarouselSubmissionData';
            photoUrl?: string | null;
            caption?: string | null;
            approved?: boolean | null;
            sharingPermissionGranted?: boolean | null;
          }
        | {
            __typename?: 'RaffleSubmissionData';
            name: string;
            optionalImageUrl?: string | null;
          }
        | {
            __typename?: 'SlidesSubmissionData';
            optionalImageUrl?: string | null;
            title: string;
            content: string;
            slideDuration?: number | null;
            imageTilt?: SlideImageTilt | null;
            layout?: SlideLayout | null;
            showQr?: boolean | null;
            background?: {
              __typename?: 'SlideBackground';
              type: SlideBackgroundType;
              color?: string | null;
              imageUrl?: string | null;
            } | null;
            elements?: Array<{
              __typename?: 'SlideElement';
              id: string;
              type: SlideElementType;
              name?: string | null;
              locked?: boolean | null;
              text?: string | null;
              textType?: string | null;
              fontFamily?: Array<string> | null;
              color?: string | null;
              fontSize?: number | null;
              fontWeight?: SlideFontWeight | null;
              textAlign?: SlideTextAlign | null;
              verticalAlign?: SlideVerticalAlign | null;
              imageUrl?: string | null;
              fit?: SlideImageFit | null;
              box?: {
                __typename?: 'SlideBox';
                x: number;
                y: number;
                w: number;
                h: number;
              } | null;
            }> | null;
          }
        | {
            __typename?: 'TriviaSubmissionData';
            questionId?: string | null;
            choiceId?: string | null;
          }
        | {
            __typename?: 'VoteForSubmissionData';
            title: string;
            color: string;
            description: string;
            optionalImageUrl?: string | null;
          };
      user?: { __typename?: 'User'; id: string; name?: string | null } | null;
      reactions?: Array<{
        __typename?: 'Reaction';
        id: string;
        type: string;
        createdAt: any;
      }> | null;
    };
  } | null;
};

export type OnSubmissionDeletedSubscriptionVariables = Exact<{
  engagementId: Scalars['String']['input'];
}>;

export type OnSubmissionDeletedSubscription = {
  __typename?: 'Subscription';
  submissionDeleted?: {
    __typename?: 'SubmissionDeletedPayload';
    submissionId: string;
  } | null;
};

export type OnMockReactionsCreatedSubscriptionVariables = Exact<{
  submissionId: Scalars['String']['input'];
}>;

export type OnMockReactionsCreatedSubscription = {
  __typename?: 'Subscription';
  mockReactionsCreated?: {
    __typename?: 'ReactionsCreatedPayload';
    reactions: Array<{
      __typename?: 'Reaction';
      id: string;
      type: string;
      createdAt: any;
    }>;
  } | null;
};

export type OnMockSubmissionCreatedSubscriptionVariables = Exact<{
  engagementId: Scalars['String']['input'];
}>;

export type OnMockSubmissionCreatedSubscription = {
  __typename?: 'Subscription';
  mockSubmissionCreated?: {
    __typename?: 'SubmissionCreatedPayload';
    submission: {
      __typename?: 'Submission';
      id: string;
      engagementId: string;
      createdAt: any;
      userId?: string | null;
      hidden: boolean;
      possibleBannedDevice: boolean;
      matchedBanCreatedAt?: any | null;
      data:
        | {
            __typename?: 'NowPlayingSubmissionData';
            order: number;
            songAlbumArt?: string | null;
            songTitle?: string | null;
            songArtist?: string | null;
            songNotes?: string | null;
            songLyrics?: string | null;
            visualizationType?: string | null;
            spotifyUrl?: string | null;
          }
        | {
            __typename?: 'PhotoCarouselSubmissionData';
            photoUrl?: string | null;
            caption?: string | null;
            approved?: boolean | null;
            sharingPermissionGranted?: boolean | null;
          }
        | {
            __typename?: 'RaffleSubmissionData';
            name: string;
            optionalImageUrl?: string | null;
          }
        | {
            __typename?: 'SlidesSubmissionData';
            optionalImageUrl?: string | null;
            title: string;
            content: string;
            slideDuration?: number | null;
            imageTilt?: SlideImageTilt | null;
            layout?: SlideLayout | null;
            showQr?: boolean | null;
            background?: {
              __typename?: 'SlideBackground';
              type: SlideBackgroundType;
              color?: string | null;
              imageUrl?: string | null;
            } | null;
            elements?: Array<{
              __typename?: 'SlideElement';
              id: string;
              type: SlideElementType;
              name?: string | null;
              locked?: boolean | null;
              text?: string | null;
              textType?: string | null;
              fontFamily?: Array<string> | null;
              color?: string | null;
              fontSize?: number | null;
              fontWeight?: SlideFontWeight | null;
              textAlign?: SlideTextAlign | null;
              verticalAlign?: SlideVerticalAlign | null;
              imageUrl?: string | null;
              fit?: SlideImageFit | null;
              box?: {
                __typename?: 'SlideBox';
                x: number;
                y: number;
                w: number;
                h: number;
              } | null;
            }> | null;
          }
        | {
            __typename?: 'TriviaSubmissionData';
            questionId?: string | null;
            choiceId?: string | null;
          }
        | {
            __typename?: 'VoteForSubmissionData';
            title: string;
            color: string;
            description: string;
            optionalImageUrl?: string | null;
          };
      user?: { __typename?: 'User'; id: string; name?: string | null } | null;
      reactions?: Array<{
        __typename?: 'Reaction';
        id: string;
        type: string;
        createdAt: any;
      }> | null;
    };
  } | null;
};

export type OnMockSubmissionDeletedSubscriptionVariables = Exact<{
  engagementId: Scalars['String']['input'];
}>;

export type OnMockSubmissionDeletedSubscription = {
  __typename?: 'Subscription';
  mockSubmissionDeleted?: {
    __typename?: 'SubmissionDeletedPayload';
    submissionId: string;
  } | null;
};

export const TriviaMyAnswerFieldsFragmentDoc = gql`
  fragment TriviaMyAnswerFields on TriviaMyAnswer {
    questionId
    choiceId
  }
`;
export const PhotoCarouselSubmissionFieldsFragmentDoc = gql`
  fragment PhotoCarouselSubmissionFields on PhotoCarouselSubmissionData {
    photoUrl
    caption
    approved
    sharingPermissionGranted
  }
`;
export const VoteForSubmissionFieldsFragmentDoc = gql`
  fragment VoteForSubmissionFields on VoteForSubmissionData {
    title
    color
    description
    optionalImageUrl
  }
`;
export const SlidesSubmissionFieldsFragmentDoc = gql`
  fragment SlidesSubmissionFields on SlidesSubmissionData {
    optionalImageUrl
    title
    content
    slideDuration
    imageTilt
    layout
    showQr
    background {
      type
      color
      imageUrl
    }
    elements {
      id
      type
      name
      locked
      box {
        x
        y
        w
        h
      }
      text
      textType
      fontFamily
      color
      fontSize
      fontWeight
      textAlign
      verticalAlign
      imageUrl
      fit
    }
  }
`;
export const NowPlayingSubmissionFieldsFragmentDoc = gql`
  fragment NowPlayingSubmissionFields on NowPlayingSubmissionData {
    order
    songAlbumArt
    songTitle
    songArtist
    songNotes
    songLyrics
    visualizationType
    spotifyUrl
  }
`;
export const RaffleSubmissionFieldsFragmentDoc = gql`
  fragment RaffleSubmissionFields on RaffleSubmissionData {
    name
    optionalImageUrl
  }
`;
export const TriviaSubmissionFieldsFragmentDoc = gql`
  fragment TriviaSubmissionFields on TriviaSubmissionData {
    questionId
    choiceId
  }
`;
export const FullSubmissionFragmentDoc = gql`
  fragment FullSubmission on Submission {
    id
    engagementId
    data {
      ...PhotoCarouselSubmissionFields
      ...VoteForSubmissionFields
      ...SlidesSubmissionFields
      ...NowPlayingSubmissionFields
      ...RaffleSubmissionFields
      ...TriviaSubmissionFields
    }
    createdAt
    userId
    hidden
    possibleBannedDevice
    matchedBanCreatedAt
    user {
      id
      name
    }
    reactions {
      id
      type
      createdAt
    }
  }
  ${PhotoCarouselSubmissionFieldsFragmentDoc}
  ${VoteForSubmissionFieldsFragmentDoc}
  ${SlidesSubmissionFieldsFragmentDoc}
  ${NowPlayingSubmissionFieldsFragmentDoc}
  ${RaffleSubmissionFieldsFragmentDoc}
  ${TriviaSubmissionFieldsFragmentDoc}
`;
export const BanFieldsFragmentDoc = gql`
  fragment BanFields on Ban {
    id
    userId
    reason
    createdAt
    hiddenCount
    sourceEventId
    sourceEngagementId
    sourceSubmissionId
    sourcePhotoUrl
    user {
      id
      name
    }
    sourceEvent {
      id
      name
    }
    sourceEngagement {
      id
      title
    }
  }
`;
export const FanReactionFragmentDoc = gql`
  fragment FanReaction on Reaction {
    id
    type
    createdAt
    submissionId
  }
`;
export const FanSubmissionFragmentDoc = gql`
  fragment FanSubmission on Submission {
    id
    createdAt
    engagementId
    hidden
    possibleBannedDevice
    data {
      ...PhotoCarouselSubmissionFields
      ...VoteForSubmissionFields
      ...SlidesSubmissionFields
      ...NowPlayingSubmissionFields
      ...RaffleSubmissionFields
      ...TriviaSubmissionFields
    }
    reactions {
      ...FanReaction
    }
  }
  ${PhotoCarouselSubmissionFieldsFragmentDoc}
  ${VoteForSubmissionFieldsFragmentDoc}
  ${SlidesSubmissionFieldsFragmentDoc}
  ${NowPlayingSubmissionFieldsFragmentDoc}
  ${RaffleSubmissionFieldsFragmentDoc}
  ${TriviaSubmissionFieldsFragmentDoc}
  ${FanReactionFragmentDoc}
`;
export const StageReactionFragmentDoc = gql`
  fragment StageReaction on Reaction {
    id
    type
    createdAt
  }
`;
export const StageSubmissionFragmentDoc = gql`
  fragment StageSubmission on Submission {
    id
    createdAt
    engagementId
    hidden
    possibleBannedDevice
    matchedBanCreatedAt
    userId
    data {
      ...PhotoCarouselSubmissionFields
      ...VoteForSubmissionFields
      ...SlidesSubmissionFields
      ...NowPlayingSubmissionFields
      ...RaffleSubmissionFields
      ...TriviaSubmissionFields
    }
    reactions {
      ...StageReaction
    }
  }
  ${PhotoCarouselSubmissionFieldsFragmentDoc}
  ${VoteForSubmissionFieldsFragmentDoc}
  ${SlidesSubmissionFieldsFragmentDoc}
  ${NowPlayingSubmissionFieldsFragmentDoc}
  ${RaffleSubmissionFieldsFragmentDoc}
  ${TriviaSubmissionFieldsFragmentDoc}
  ${StageReactionFragmentDoc}
`;
export const ScreenElementFragmentDoc = gql`
  fragment ScreenElement on ScreenElement {
    id
    type
    name
    imageUrl
    defaultStyles
    engagementStyles
    defaultClassNames
    engagementClassNames
    text
    textType
    fontFamily
    linkHref
    color
  }
`;
export const EventThemeConfigFragmentDoc = gql`
  fragment EventThemeConfig on EventThemeConfig {
    headingFontFamily
    bodyFontFamily
    foregroundColor
    backgroundColor
    stageBackgroundImage
    fanBackgroundImage
    qrForegroundColor
    qrBackgroundColor
    qrTextColor
    qrWrapperBackgroundColor
    stageElements {
      ...ScreenElement
    }
    fanElements {
      ...ScreenElement
    }
  }
  ${ScreenElementFragmentDoc}
`;
export const PhotoCarouselAdminDataFieldsFragmentDoc = gql`
  fragment PhotoCarouselAdminDataFields on PhotoCarouselAdminData {
    visibleSubmission
    rejectedQueue
    unapprovedQueue
    unseenQueue
    seenQueuePointer
    seenQueue
  }
`;
export const VoteForAdminDataFieldsFragmentDoc = gql`
  fragment VoteForAdminDataFields on VoteForAdminData {
    votes {
      submissionId
      count
    }
    startTime
    endTime
    voteWinners
    choiceDisplayOrder
  }
`;
export const SlidesAdminDataFieldsFragmentDoc = gql`
  fragment SlidesAdminDataFields on SlidesAdminData {
    currentSlide
    slidesDisplayOrder
  }
`;
export const NowPlayingAdminDataFieldsFragmentDoc = gql`
  fragment NowPlayingAdminDataFields on NowPlayingAdminData {
    currentSong
  }
`;
export const RaffleAdminDataFieldsFragmentDoc = gql`
  fragment RaffleAdminDataFields on RaffleAdminData {
    raffleStatus
    raffleCandidates
    raffleWinners
    raffleWinner
    winnerCount
    remainingSubmissionIds
    lastEliminatedSubmissionId
  }
`;
export const TriviaTallyFieldsFragmentDoc = gql`
  fragment TriviaTallyFields on TriviaTally {
    choiceId
    count
  }
`;
export const TriviaLeaderboardRowFieldsFragmentDoc = gql`
  fragment TriviaLeaderboardRowFields on TriviaLeaderboardRow {
    userId
    name
    score
    rank
    tied
  }
`;
export const TriviaAdminDataFieldsFragmentDoc = gql`
  fragment TriviaAdminDataFields on TriviaAdminData {
    status
    questionIndex
    playedThroughIndex
    reviewing
    questionEndsAt
    answeredCount
    playerCount
    correctChoiceId
    correctCount
    revealedQuestionIds
    skipRevealedQuestionIds
    skipped
    tallies {
      ...TriviaTallyFields
    }
    leaderboard {
      ...TriviaLeaderboardRowFields
    }
  }
  ${TriviaTallyFieldsFragmentDoc}
  ${TriviaLeaderboardRowFieldsFragmentDoc}
`;
export const PhotoCarouselAdminConfigFieldsFragmentDoc = gql`
  fragment PhotoCarouselAdminConfigFields on PhotoCarouselAdminConfig {
    maxSubmissionsPerUser
    requireApproval
    askSharePermission
    sharePrompt
    noPhotosMessage
    pollInterval
    predefinedCaptions
    maxVisiblePhotos
  }
`;
export const VoteForAdminConfigFieldsFragmentDoc = gql`
  fragment VoteForAdminConfigFields on VoteForAdminConfig {
    votesPerUser
    allowUserSubmissions
    maxSubmissionsPerUser
  }
`;
export const SlidesAdminConfigFieldsFragmentDoc = gql`
  fragment SlidesAdminConfigFields on SlidesAdminConfig {
    autoPlay
    autoPlayIntervalMs
  }
`;
export const NowPlayingAdminConfigFieldsFragmentDoc = gql`
  fragment NowPlayingAdminConfigFields on NowPlayingAdminConfig {
    visualizationType
    allowComments
    allowedReactions
  }
`;
export const RaffleAdminConfigFieldsFragmentDoc = gql`
  fragment RaffleAdminConfigFields on RaffleAdminConfig {
    optionalImageUrl
    claimYourPrize
    ticketFlipDirection
  }
`;
export const TriviaChoiceFieldsFragmentDoc = gql`
  fragment TriviaChoiceFields on TriviaChoice {
    id
    text
  }
`;
export const TriviaQuestionFieldsFragmentDoc = gql`
  fragment TriviaQuestionFields on TriviaQuestion {
    id
    text
    correctChoiceId
    timerMs
    choices {
      ...TriviaChoiceFields
    }
  }
  ${TriviaChoiceFieldsFragmentDoc}
`;
export const TriviaAdminConfigFieldsFragmentDoc = gql`
  fragment TriviaAdminConfigFields on TriviaAdminConfig {
    instructions
    useQuestionTimer
    defaultTimerMs
    questions {
      ...TriviaQuestionFields
    }
  }
  ${TriviaQuestionFieldsFragmentDoc}
`;
export const PhotoCarouselViewConfigFieldsFragmentDoc = gql`
  fragment PhotoCarouselViewConfigFields on PhotoCarouselViewConfig {
    maxSubmissionsPerUser
    askSharePermission
    sharePrompt
    noPhotosMessage
    maxVisiblePhotos
  }
`;
export const VoteForViewConfigFieldsFragmentDoc = gql`
  fragment VoteForViewConfigFields on VoteForViewConfig {
    votesPerUser
  }
`;
export const SlidesViewConfigFieldsFragmentDoc = gql`
  fragment SlidesViewConfigFields on SlidesViewConfig {
    autoPlay
    autoPlayIntervalMs
  }
`;
export const NowPlayingViewConfigFieldsFragmentDoc = gql`
  fragment NowPlayingViewConfigFields on NowPlayingViewConfig {
    visualizationType
    allowComments
    allowedReactions
  }
`;
export const RaffleViewConfigFieldsFragmentDoc = gql`
  fragment RaffleViewConfigFields on RaffleViewConfig {
    optionalImageUrl
    claimYourPrize
    ticketFlipDirection
  }
`;
export const TriviaViewQuestionFieldsFragmentDoc = gql`
  fragment TriviaViewQuestionFields on TriviaViewQuestion {
    id
    text
    timerMs
    choices {
      ...TriviaChoiceFields
    }
  }
  ${TriviaChoiceFieldsFragmentDoc}
`;
export const TriviaViewConfigFieldsFragmentDoc = gql`
  fragment TriviaViewConfigFields on TriviaViewConfig {
    instructions
    useQuestionTimer
    defaultTimerMs
    questions {
      ...TriviaViewQuestionFields
    }
  }
  ${TriviaViewQuestionFieldsFragmentDoc}
`;
export const PhotoCarouselViewDataFieldsFragmentDoc = gql`
  fragment PhotoCarouselViewDataFields on PhotoCarouselViewData {
    visibleSubmission
  }
`;
export const VoteForViewDataFieldsFragmentDoc = gql`
  fragment VoteForViewDataFields on VoteForViewData {
    votes {
      submissionId
      count
    }
    voteWinners
    choiceDisplayOrder
  }
`;
export const SlidesViewDataFieldsFragmentDoc = gql`
  fragment SlidesViewDataFields on SlidesViewData {
    currentSlide
    slidesDisplayOrder
  }
`;
export const NowPlayingViewDataFieldsFragmentDoc = gql`
  fragment NowPlayingViewDataFields on NowPlayingViewData {
    currentSong
  }
`;
export const RaffleViewDataFieldsFragmentDoc = gql`
  fragment RaffleViewDataFields on RaffleViewData {
    raffleStatus
    raffleCandidates
    raffleWinners
    raffleWinner
    winnerCount
    remainingSubmissionIds
    lastEliminatedSubmissionId
  }
`;
export const TriviaViewDataFieldsFragmentDoc = gql`
  fragment TriviaViewDataFields on TriviaViewData {
    status
    questionIndex
    questionEndsAt
    answeredCount
    playerCount
    correctChoiceId
    correctCount
    leaderboardOverflow
    skipped
    tallies {
      ...TriviaTallyFields
    }
    leaderboard {
      ...TriviaLeaderboardRowFields
    }
  }
  ${TriviaTallyFieldsFragmentDoc}
  ${TriviaLeaderboardRowFieldsFragmentDoc}
`;
export const FullEngagementFragmentDoc = gql`
  fragment FullEngagement on Engagement {
    id
    eventId
    createdAt
    updatedAt
    title
    description
    qrCodeCta
    startTime
    order
    endTime
    type
    data {
      ...PhotoCarouselAdminDataFields
      ...VoteForAdminDataFields
      ...SlidesAdminDataFields
      ...NowPlayingAdminDataFields
      ...RaffleAdminDataFields
      ...TriviaAdminDataFields
    }
    config {
      ...PhotoCarouselAdminConfigFields
      ...VoteForAdminConfigFields
      ...SlidesAdminConfigFields
      ...NowPlayingAdminConfigFields
      ...RaffleAdminConfigFields
      ...TriviaAdminConfigFields
    }
    viewConfig {
      ...PhotoCarouselViewConfigFields
      ...VoteForViewConfigFields
      ...SlidesViewConfigFields
      ...NowPlayingViewConfigFields
      ...RaffleViewConfigFields
      ...TriviaViewConfigFields
    }
    viewData {
      ...PhotoCarouselViewDataFields
      ...VoteForViewDataFields
      ...SlidesViewDataFields
      ...NowPlayingViewDataFields
      ...RaffleViewDataFields
      ...TriviaViewDataFields
    }
    order
  }
  ${PhotoCarouselAdminDataFieldsFragmentDoc}
  ${VoteForAdminDataFieldsFragmentDoc}
  ${SlidesAdminDataFieldsFragmentDoc}
  ${NowPlayingAdminDataFieldsFragmentDoc}
  ${RaffleAdminDataFieldsFragmentDoc}
  ${TriviaAdminDataFieldsFragmentDoc}
  ${PhotoCarouselAdminConfigFieldsFragmentDoc}
  ${VoteForAdminConfigFieldsFragmentDoc}
  ${SlidesAdminConfigFieldsFragmentDoc}
  ${NowPlayingAdminConfigFieldsFragmentDoc}
  ${RaffleAdminConfigFieldsFragmentDoc}
  ${TriviaAdminConfigFieldsFragmentDoc}
  ${PhotoCarouselViewConfigFieldsFragmentDoc}
  ${VoteForViewConfigFieldsFragmentDoc}
  ${SlidesViewConfigFieldsFragmentDoc}
  ${NowPlayingViewConfigFieldsFragmentDoc}
  ${RaffleViewConfigFieldsFragmentDoc}
  ${TriviaViewConfigFieldsFragmentDoc}
  ${PhotoCarouselViewDataFieldsFragmentDoc}
  ${VoteForViewDataFieldsFragmentDoc}
  ${SlidesViewDataFieldsFragmentDoc}
  ${NowPlayingViewDataFieldsFragmentDoc}
  ${RaffleViewDataFieldsFragmentDoc}
  ${TriviaViewDataFieldsFragmentDoc}
`;
export const PaymentSubscriptionFragmentDoc = gql`
  fragment PaymentSubscription on PaymentSubscription {
    id
    userId
    status
    stripeSubscriptionId
    currentPeriodStart
    currentPeriodEnd
    cancelAtPeriodEnd
    canceledAt
    trialStart
    trialEnd
    maxConcurrentEvents
    createdAt
    updatedAt
    liveEvents {
      id
      name
    }
  }
`;
export const EventPassRedemptionFragmentDoc = gql`
  fragment EventPassRedemption on EventPassRedemption {
    id
    eventPassId
    eventId
    redeemedAt
    description
    expiresAt
  }
`;
export const FullEventFragmentDoc = gql`
  fragment FullEvent on Event {
    id
    name
    date
    live
    location
    locked
    description
    createdAt
    updatedAt
    themeConfig {
      ...EventThemeConfig
    }
    activeEngagement {
      ...FullEngagement
    }
    activeEngagementId
    engagements {
      ...FullEngagement
    }
    subscriptionInUse {
      ...PaymentSubscription
    }
    eventPassRedemptionInUse {
      ...EventPassRedemption
    }
    screenCode
  }
  ${EventThemeConfigFragmentDoc}
  ${FullEngagementFragmentDoc}
  ${PaymentSubscriptionFragmentDoc}
  ${EventPassRedemptionFragmentDoc}
`;
export const FanEngagementFragmentDoc = gql`
  fragment FanEngagement on Engagement {
    id
    createdAt
    updatedAt
    title
    description
    startTime
    endTime
    viewConfig {
      ...PhotoCarouselViewConfigFields
      ...VoteForViewConfigFields
      ...SlidesViewConfigFields
      ...NowPlayingViewConfigFields
      ...RaffleViewConfigFields
      ...TriviaViewConfigFields
    }
    viewData {
      ...PhotoCarouselViewDataFields
      ...VoteForViewDataFields
      ...SlidesViewDataFields
      ...NowPlayingViewDataFields
      ...RaffleViewDataFields
      ...TriviaViewDataFields
    }
    type
    order
  }
  ${PhotoCarouselViewConfigFieldsFragmentDoc}
  ${VoteForViewConfigFieldsFragmentDoc}
  ${SlidesViewConfigFieldsFragmentDoc}
  ${NowPlayingViewConfigFieldsFragmentDoc}
  ${RaffleViewConfigFieldsFragmentDoc}
  ${TriviaViewConfigFieldsFragmentDoc}
  ${PhotoCarouselViewDataFieldsFragmentDoc}
  ${VoteForViewDataFieldsFragmentDoc}
  ${SlidesViewDataFieldsFragmentDoc}
  ${NowPlayingViewDataFieldsFragmentDoc}
  ${RaffleViewDataFieldsFragmentDoc}
  ${TriviaViewDataFieldsFragmentDoc}
`;
export const FanEventFragmentDoc = gql`
  fragment FanEvent on Event {
    id
    name
    live
    description
    date
    location
    themeConfig {
      ...EventThemeConfig
    }
    activeEngagement {
      ...FanEngagement
    }
  }
  ${EventThemeConfigFragmentDoc}
  ${FanEngagementFragmentDoc}
`;
export const ScreenTemplateEngagementInputFragmentDoc = gql`
  fragment ScreenTemplateEngagementInput on ScreenTemplateEngagementInput {
    data
    description
    config
    endTime
    qrCodeCta
    startTime
    title
    type
  }
`;
export const ScreenTemplateFragmentDoc = gql`
  fragment ScreenTemplate on ScreenTemplate {
    id
    name
    description
    config {
      ...EventThemeConfig
    }
    engagements {
      ...ScreenTemplateEngagementInput
    }
    createdAt
    updatedAt
    enabled
  }
  ${EventThemeConfigFragmentDoc}
  ${ScreenTemplateEngagementInputFragmentDoc}
`;
export const StageEngagementFragmentDoc = gql`
  fragment StageEngagement on Engagement {
    id
    createdAt
    updatedAt
    title
    qrCodeCta
    description
    startTime
    endTime
    viewConfig {
      ...PhotoCarouselViewConfigFields
      ...VoteForViewConfigFields
      ...SlidesViewConfigFields
      ...NowPlayingViewConfigFields
      ...RaffleViewConfigFields
      ...TriviaViewConfigFields
    }
    viewData {
      ...PhotoCarouselViewDataFields
      ...VoteForViewDataFields
      ...SlidesViewDataFields
      ...NowPlayingViewDataFields
      ...RaffleViewDataFields
      ...TriviaViewDataFields
    }
    type
    order
  }
  ${PhotoCarouselViewConfigFieldsFragmentDoc}
  ${VoteForViewConfigFieldsFragmentDoc}
  ${SlidesViewConfigFieldsFragmentDoc}
  ${NowPlayingViewConfigFieldsFragmentDoc}
  ${RaffleViewConfigFieldsFragmentDoc}
  ${TriviaViewConfigFieldsFragmentDoc}
  ${PhotoCarouselViewDataFieldsFragmentDoc}
  ${VoteForViewDataFieldsFragmentDoc}
  ${SlidesViewDataFieldsFragmentDoc}
  ${NowPlayingViewDataFieldsFragmentDoc}
  ${RaffleViewDataFieldsFragmentDoc}
  ${TriviaViewDataFieldsFragmentDoc}
`;
export const StageEventFragmentDoc = gql`
  fragment StageEvent on Event {
    id
    name
    live
    description
    date
    location
    themeConfig {
      ...EventThemeConfig
    }
    activeEngagement {
      ...StageEngagement
    }
  }
  ${EventThemeConfigFragmentDoc}
  ${StageEngagementFragmentDoc}
`;
export const FullUserFragmentDoc = gql`
  fragment FullUser on User {
    id
    email
    role
    name
    username
    lastLogin
    googleId
    stripeCustomerId
    createdAt
  }
`;
export const UserFragmentDoc = gql`
  fragment User on User {
    id
    email
    role
    createdAt
  }
`;
export const EventPassFragmentDoc = gql`
  fragment EventPass on EventPass {
    id
    userId
    status
    stripeCheckoutSessionId
    stripeChargeId
    amountPaid
    currency
    createdAt
    updatedAt
    expiresAt
    redemptions {
      id
      eventPassId
      eventId
      redeemedAt
      description
      expiresAt
    }
  }
`;
export const CookiePreferencesFragmentDoc = gql`
  fragment CookiePreferences on CookiePreferences {
    functional
    analytics
    marketing
    consentDate
  }
`;
export const PhotoCarouselDownloadDocument = gql`
  query photoCarouselDownload($engagementId: String!) {
    photoCarouselDownload(engagementId: $engagementId) {
      success
      message
      downloadUrl
    }
  }
`;

/**
 * __usePhotoCarouselDownloadQuery__
 *
 * To run a query within a React component, call `usePhotoCarouselDownloadQuery` and pass it any options that fit your needs.
 * When your component renders, `usePhotoCarouselDownloadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePhotoCarouselDownloadQuery({
 *   variables: {
 *      engagementId: // value for 'engagementId'
 *   },
 * });
 */
export function usePhotoCarouselDownloadQuery(
  baseOptions: Apollo.QueryHookOptions<
    PhotoCarouselDownloadQuery,
    PhotoCarouselDownloadQueryVariables
  > &
    (
      | { variables: PhotoCarouselDownloadQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PhotoCarouselDownloadQuery,
    PhotoCarouselDownloadQueryVariables
  >(PhotoCarouselDownloadDocument, options);
}
export function usePhotoCarouselDownloadLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PhotoCarouselDownloadQuery,
    PhotoCarouselDownloadQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PhotoCarouselDownloadQuery,
    PhotoCarouselDownloadQueryVariables
  >(PhotoCarouselDownloadDocument, options);
}
export function usePhotoCarouselDownloadSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PhotoCarouselDownloadQuery,
        PhotoCarouselDownloadQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PhotoCarouselDownloadQuery,
    PhotoCarouselDownloadQueryVariables
  >(PhotoCarouselDownloadDocument, options);
}
export type PhotoCarouselDownloadQueryHookResult = ReturnType<
  typeof usePhotoCarouselDownloadQuery
>;
export type PhotoCarouselDownloadLazyQueryHookResult = ReturnType<
  typeof usePhotoCarouselDownloadLazyQuery
>;
export type PhotoCarouselDownloadSuspenseQueryHookResult = ReturnType<
  typeof usePhotoCarouselDownloadSuspenseQuery
>;
export type PhotoCarouselDownloadQueryResult = Apollo.QueryResult<
  PhotoCarouselDownloadQuery,
  PhotoCarouselDownloadQueryVariables
>;
export const PhotoCarouselRandomCaptionDocument = gql`
  query photoCarouselRandomCaption($engagementId: String!) {
    photoCarouselRandomCaption(engagementId: $engagementId)
  }
`;

/**
 * __usePhotoCarouselRandomCaptionQuery__
 *
 * To run a query within a React component, call `usePhotoCarouselRandomCaptionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePhotoCarouselRandomCaptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePhotoCarouselRandomCaptionQuery({
 *   variables: {
 *      engagementId: // value for 'engagementId'
 *   },
 * });
 */
export function usePhotoCarouselRandomCaptionQuery(
  baseOptions: Apollo.QueryHookOptions<
    PhotoCarouselRandomCaptionQuery,
    PhotoCarouselRandomCaptionQueryVariables
  > &
    (
      | { variables: PhotoCarouselRandomCaptionQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PhotoCarouselRandomCaptionQuery,
    PhotoCarouselRandomCaptionQueryVariables
  >(PhotoCarouselRandomCaptionDocument, options);
}
export function usePhotoCarouselRandomCaptionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PhotoCarouselRandomCaptionQuery,
    PhotoCarouselRandomCaptionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PhotoCarouselRandomCaptionQuery,
    PhotoCarouselRandomCaptionQueryVariables
  >(PhotoCarouselRandomCaptionDocument, options);
}
export function usePhotoCarouselRandomCaptionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PhotoCarouselRandomCaptionQuery,
        PhotoCarouselRandomCaptionQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PhotoCarouselRandomCaptionQuery,
    PhotoCarouselRandomCaptionQueryVariables
  >(PhotoCarouselRandomCaptionDocument, options);
}
export type PhotoCarouselRandomCaptionQueryHookResult = ReturnType<
  typeof usePhotoCarouselRandomCaptionQuery
>;
export type PhotoCarouselRandomCaptionLazyQueryHookResult = ReturnType<
  typeof usePhotoCarouselRandomCaptionLazyQuery
>;
export type PhotoCarouselRandomCaptionSuspenseQueryHookResult = ReturnType<
  typeof usePhotoCarouselRandomCaptionSuspenseQuery
>;
export type PhotoCarouselRandomCaptionQueryResult = Apollo.QueryResult<
  PhotoCarouselRandomCaptionQuery,
  PhotoCarouselRandomCaptionQueryVariables
>;
export const RaffleCloseDocument = gql`
  mutation raffleClose($engagementId: String!) {
    raffleClose(engagementId: $engagementId) {
      ...FullEngagement
    }
  }
  ${FullEngagementFragmentDoc}
`;
export type RaffleCloseMutationFn = Apollo.MutationFunction<
  RaffleCloseMutation,
  RaffleCloseMutationVariables
>;

/**
 * __useRaffleCloseMutation__
 *
 * To run a mutation, you first call `useRaffleCloseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRaffleCloseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [raffleCloseMutation, { data, loading, error }] = useRaffleCloseMutation({
 *   variables: {
 *      engagementId: // value for 'engagementId'
 *   },
 * });
 */
export function useRaffleCloseMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RaffleCloseMutation,
    RaffleCloseMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RaffleCloseMutation, RaffleCloseMutationVariables>(
    RaffleCloseDocument,
    options,
  );
}
export type RaffleCloseMutationHookResult = ReturnType<
  typeof useRaffleCloseMutation
>;
export type RaffleCloseMutationResult =
  Apollo.MutationResult<RaffleCloseMutation>;
export type RaffleCloseMutationOptions = Apollo.BaseMutationOptions<
  RaffleCloseMutation,
  RaffleCloseMutationVariables
>;
export const RaffleReopenDocument = gql`
  mutation raffleReopen($engagementId: String!) {
    raffleReopen(engagementId: $engagementId) {
      ...FullEngagement
    }
  }
  ${FullEngagementFragmentDoc}
`;
export type RaffleReopenMutationFn = Apollo.MutationFunction<
  RaffleReopenMutation,
  RaffleReopenMutationVariables
>;

/**
 * __useRaffleReopenMutation__
 *
 * To run a mutation, you first call `useRaffleReopenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRaffleReopenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [raffleReopenMutation, { data, loading, error }] = useRaffleReopenMutation({
 *   variables: {
 *      engagementId: // value for 'engagementId'
 *   },
 * });
 */
export function useRaffleReopenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RaffleReopenMutation,
    RaffleReopenMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RaffleReopenMutation,
    RaffleReopenMutationVariables
  >(RaffleReopenDocument, options);
}
export type RaffleReopenMutationHookResult = ReturnType<
  typeof useRaffleReopenMutation
>;
export type RaffleReopenMutationResult =
  Apollo.MutationResult<RaffleReopenMutation>;
export type RaffleReopenMutationOptions = Apollo.BaseMutationOptions<
  RaffleReopenMutation,
  RaffleReopenMutationVariables
>;
export const RaffleBeginDrawingDocument = gql`
  mutation raffleBeginDrawing($engagementId: String!, $winnerCount: Int!) {
    raffleBeginDrawing(engagementId: $engagementId, winnerCount: $winnerCount) {
      ...FullEngagement
    }
  }
  ${FullEngagementFragmentDoc}
`;
export type RaffleBeginDrawingMutationFn = Apollo.MutationFunction<
  RaffleBeginDrawingMutation,
  RaffleBeginDrawingMutationVariables
>;

/**
 * __useRaffleBeginDrawingMutation__
 *
 * To run a mutation, you first call `useRaffleBeginDrawingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRaffleBeginDrawingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [raffleBeginDrawingMutation, { data, loading, error }] = useRaffleBeginDrawingMutation({
 *   variables: {
 *      engagementId: // value for 'engagementId'
 *      winnerCount: // value for 'winnerCount'
 *   },
 * });
 */
export function useRaffleBeginDrawingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RaffleBeginDrawingMutation,
    RaffleBeginDrawingMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RaffleBeginDrawingMutation,
    RaffleBeginDrawingMutationVariables
  >(RaffleBeginDrawingDocument, options);
}
export type RaffleBeginDrawingMutationHookResult = ReturnType<
  typeof useRaffleBeginDrawingMutation
>;
export type RaffleBeginDrawingMutationResult =
  Apollo.MutationResult<RaffleBeginDrawingMutation>;
export type RaffleBeginDrawingMutationOptions = Apollo.BaseMutationOptions<
  RaffleBeginDrawingMutation,
  RaffleBeginDrawingMutationVariables
>;
export const RaffleResetDocument = gql`
  mutation raffleReset($engagementId: String!) {
    raffleReset(engagementId: $engagementId) {
      ...FullEngagement
    }
  }
  ${FullEngagementFragmentDoc}
`;
export type RaffleResetMutationFn = Apollo.MutationFunction<
  RaffleResetMutation,
  RaffleResetMutationVariables
>;

/**
 * __useRaffleResetMutation__
 *
 * To run a mutation, you first call `useRaffleResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRaffleResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [raffleResetMutation, { data, loading, error }] = useRaffleResetMutation({
 *   variables: {
 *      engagementId: // value for 'engagementId'
 *   },
 * });
 */
export function useRaffleResetMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RaffleResetMutation,
    RaffleResetMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RaffleResetMutation, RaffleResetMutationVariables>(
    RaffleResetDocument,
    options,
  );
}
export type RaffleResetMutationHookResult = ReturnType<
  typeof useRaffleResetMutation
>;
export type RaffleResetMutationResult =
  Apollo.MutationResult<RaffleResetMutation>;
export type RaffleResetMutationOptions = Apollo.BaseMutationOptions<
  RaffleResetMutation,
  RaffleResetMutationVariables
>;
export const RaffleRestartDrawingDocument = gql`
  mutation raffleRestartDrawing($engagementId: String!) {
    raffleRestartDrawing(engagementId: $engagementId) {
      ...FullEngagement
    }
  }
  ${FullEngagementFragmentDoc}
`;
export type RaffleRestartDrawingMutationFn = Apollo.MutationFunction<
  RaffleRestartDrawingMutation,
  RaffleRestartDrawingMutationVariables
>;

/**
 * __useRaffleRestartDrawingMutation__
 *
 * To run a mutation, you first call `useRaffleRestartDrawingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRaffleRestartDrawingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [raffleRestartDrawingMutation, { data, loading, error }] = useRaffleRestartDrawingMutation({
 *   variables: {
 *      engagementId: // value for 'engagementId'
 *   },
 * });
 */
export function useRaffleRestartDrawingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RaffleRestartDrawingMutation,
    RaffleRestartDrawingMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RaffleRestartDrawingMutation,
    RaffleRestartDrawingMutationVariables
  >(RaffleRestartDrawingDocument, options);
}
export type RaffleRestartDrawingMutationHookResult = ReturnType<
  typeof useRaffleRestartDrawingMutation
>;
export type RaffleRestartDrawingMutationResult =
  Apollo.MutationResult<RaffleRestartDrawingMutation>;
export type RaffleRestartDrawingMutationOptions = Apollo.BaseMutationOptions<
  RaffleRestartDrawingMutation,
  RaffleRestartDrawingMutationVariables
>;
export const RaffleWiggleTicketDocument = gql`
  mutation raffleWiggleTicket($engagementId: String!, $submissionId: String!) {
    raffleWiggleTicket(engagementId: $engagementId, submissionId: $submissionId)
  }
`;
export type RaffleWiggleTicketMutationFn = Apollo.MutationFunction<
  RaffleWiggleTicketMutation,
  RaffleWiggleTicketMutationVariables
>;

/**
 * __useRaffleWiggleTicketMutation__
 *
 * To run a mutation, you first call `useRaffleWiggleTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRaffleWiggleTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [raffleWiggleTicketMutation, { data, loading, error }] = useRaffleWiggleTicketMutation({
 *   variables: {
 *      engagementId: // value for 'engagementId'
 *      submissionId: // value for 'submissionId'
 *   },
 * });
 */
export function useRaffleWiggleTicketMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RaffleWiggleTicketMutation,
    RaffleWiggleTicketMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RaffleWiggleTicketMutation,
    RaffleWiggleTicketMutationVariables
  >(RaffleWiggleTicketDocument, options);
}
export type RaffleWiggleTicketMutationHookResult = ReturnType<
  typeof useRaffleWiggleTicketMutation
>;
export type RaffleWiggleTicketMutationResult =
  Apollo.MutationResult<RaffleWiggleTicketMutation>;
export type RaffleWiggleTicketMutationOptions = Apollo.BaseMutationOptions<
  RaffleWiggleTicketMutation,
  RaffleWiggleTicketMutationVariables
>;
export const RaffleTicketWiggledDocument = gql`
  subscription raffleTicketWiggled($engagementId: String!) {
    raffleTicketWiggled(engagementId: $engagementId) {
      engagementId
      submissionId
    }
  }
`;

/**
 * __useRaffleTicketWiggledSubscription__
 *
 * To run a query within a React component, call `useRaffleTicketWiggledSubscription` and pass it any options that fit your needs.
 * When your component renders, `useRaffleTicketWiggledSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRaffleTicketWiggledSubscription({
 *   variables: {
 *      engagementId: // value for 'engagementId'
 *   },
 * });
 */
export function useRaffleTicketWiggledSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    RaffleTicketWiggledSubscription,
    RaffleTicketWiggledSubscriptionVariables
  > &
    (
      | { variables: RaffleTicketWiggledSubscriptionVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    RaffleTicketWiggledSubscription,
    RaffleTicketWiggledSubscriptionVariables
  >(RaffleTicketWiggledDocument, options);
}
export type RaffleTicketWiggledSubscriptionHookResult = ReturnType<
  typeof useRaffleTicketWiggledSubscription
>;
export type RaffleTicketWiggledSubscriptionResult =
  Apollo.SubscriptionResult<RaffleTicketWiggledSubscription>;
export const MockRaffleTicketWiggledDocument = gql`
  subscription mockRaffleTicketWiggled($engagementId: String!) {
    mockRaffleTicketWiggled(engagementId: $engagementId) {
      engagementId
      submissionId
    }
  }
`;

/**
 * __useMockRaffleTicketWiggledSubscription__
 *
 * To run a query within a React component, call `useMockRaffleTicketWiggledSubscription` and pass it any options that fit your needs.
 * When your component renders, `useMockRaffleTicketWiggledSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMockRaffleTicketWiggledSubscription({
 *   variables: {
 *      engagementId: // value for 'engagementId'
 *   },
 * });
 */
export function useMockRaffleTicketWiggledSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    MockRaffleTicketWiggledSubscription,
    MockRaffleTicketWiggledSubscriptionVariables
  > &
    (
      | {
          variables: MockRaffleTicketWiggledSubscriptionVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    MockRaffleTicketWiggledSubscription,
    MockRaffleTicketWiggledSubscriptionVariables
  >(MockRaffleTicketWiggledDocument, options);
}
export type MockRaffleTicketWiggledSubscriptionHookResult = ReturnType<
  typeof useMockRaffleTicketWiggledSubscription
>;
export type MockRaffleTicketWiggledSubscriptionResult =
  Apollo.SubscriptionResult<MockRaffleTicketWiggledSubscription>;
export const TriviaMyAnswersDocument = gql`
  query triviaMyAnswers($engagementId: String!) {
    triviaMyAnswers(engagementId: $engagementId) {
      answers {
        ...TriviaMyAnswerFields
      }
      scored {
        questionId
        correctChoiceId
      }
      score
      rank
    }
  }
  ${TriviaMyAnswerFieldsFragmentDoc}
`;

/**
 * __useTriviaMyAnswersQuery__
 *
 * To run a query within a React component, call `useTriviaMyAnswersQuery` and pass it any options that fit your needs.
 * When your component renders, `useTriviaMyAnswersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTriviaMyAnswersQuery({
 *   variables: {
 *      engagementId: // value for 'engagementId'
 *   },
 * });
 */
export function useTriviaMyAnswersQuery(
  baseOptions: Apollo.QueryHookOptions<
    TriviaMyAnswersQuery,
    TriviaMyAnswersQueryVariables
  > &
    (
      | { variables: TriviaMyAnswersQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TriviaMyAnswersQuery, TriviaMyAnswersQueryVariables>(
    TriviaMyAnswersDocument,
    options,
  );
}
export function useTriviaMyAnswersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TriviaMyAnswersQuery,
    TriviaMyAnswersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    TriviaMyAnswersQuery,
    TriviaMyAnswersQueryVariables
  >(TriviaMyAnswersDocument, options);
}
export function useTriviaMyAnswersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TriviaMyAnswersQuery,
        TriviaMyAnswersQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    TriviaMyAnswersQuery,
    TriviaMyAnswersQueryVariables
  >(TriviaMyAnswersDocument, options);
}
export type TriviaMyAnswersQueryHookResult = ReturnType<
  typeof useTriviaMyAnswersQuery
>;
export type TriviaMyAnswersLazyQueryHookResult = ReturnType<
  typeof useTriviaMyAnswersLazyQuery
>;
export type TriviaMyAnswersSuspenseQueryHookResult = ReturnType<
  typeof useTriviaMyAnswersSuspenseQuery
>;
export type TriviaMyAnswersQueryResult = Apollo.QueryResult<
  TriviaMyAnswersQuery,
  TriviaMyAnswersQueryVariables
>;
export const TriviaStartRoundDocument = gql`
  mutation triviaStartRound($engagementId: String!) {
    triviaStartRound(engagementId: $engagementId) {
      ...FullEngagement
    }
  }
  ${FullEngagementFragmentDoc}
`;
export type TriviaStartRoundMutationFn = Apollo.MutationFunction<
  TriviaStartRoundMutation,
  TriviaStartRoundMutationVariables
>;

/**
 * __useTriviaStartRoundMutation__
 *
 * To run a mutation, you first call `useTriviaStartRoundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriviaStartRoundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triviaStartRoundMutation, { data, loading, error }] = useTriviaStartRoundMutation({
 *   variables: {
 *      engagementId: // value for 'engagementId'
 *   },
 * });
 */
export function useTriviaStartRoundMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TriviaStartRoundMutation,
    TriviaStartRoundMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TriviaStartRoundMutation,
    TriviaStartRoundMutationVariables
  >(TriviaStartRoundDocument, options);
}
export type TriviaStartRoundMutationHookResult = ReturnType<
  typeof useTriviaStartRoundMutation
>;
export type TriviaStartRoundMutationResult =
  Apollo.MutationResult<TriviaStartRoundMutation>;
export type TriviaStartRoundMutationOptions = Apollo.BaseMutationOptions<
  TriviaStartRoundMutation,
  TriviaStartRoundMutationVariables
>;
export const TriviaCloseAnswersDocument = gql`
  mutation triviaCloseAnswers($engagementId: String!) {
    triviaCloseAnswers(engagementId: $engagementId) {
      ...FullEngagement
    }
  }
  ${FullEngagementFragmentDoc}
`;
export type TriviaCloseAnswersMutationFn = Apollo.MutationFunction<
  TriviaCloseAnswersMutation,
  TriviaCloseAnswersMutationVariables
>;

/**
 * __useTriviaCloseAnswersMutation__
 *
 * To run a mutation, you first call `useTriviaCloseAnswersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriviaCloseAnswersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triviaCloseAnswersMutation, { data, loading, error }] = useTriviaCloseAnswersMutation({
 *   variables: {
 *      engagementId: // value for 'engagementId'
 *   },
 * });
 */
export function useTriviaCloseAnswersMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TriviaCloseAnswersMutation,
    TriviaCloseAnswersMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TriviaCloseAnswersMutation,
    TriviaCloseAnswersMutationVariables
  >(TriviaCloseAnswersDocument, options);
}
export type TriviaCloseAnswersMutationHookResult = ReturnType<
  typeof useTriviaCloseAnswersMutation
>;
export type TriviaCloseAnswersMutationResult =
  Apollo.MutationResult<TriviaCloseAnswersMutation>;
export type TriviaCloseAnswersMutationOptions = Apollo.BaseMutationOptions<
  TriviaCloseAnswersMutation,
  TriviaCloseAnswersMutationVariables
>;
export const TriviaRevealDocument = gql`
  mutation triviaReveal($engagementId: String!) {
    triviaReveal(engagementId: $engagementId) {
      ...FullEngagement
    }
  }
  ${FullEngagementFragmentDoc}
`;
export type TriviaRevealMutationFn = Apollo.MutationFunction<
  TriviaRevealMutation,
  TriviaRevealMutationVariables
>;

/**
 * __useTriviaRevealMutation__
 *
 * To run a mutation, you first call `useTriviaRevealMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriviaRevealMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triviaRevealMutation, { data, loading, error }] = useTriviaRevealMutation({
 *   variables: {
 *      engagementId: // value for 'engagementId'
 *   },
 * });
 */
export function useTriviaRevealMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TriviaRevealMutation,
    TriviaRevealMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TriviaRevealMutation,
    TriviaRevealMutationVariables
  >(TriviaRevealDocument, options);
}
export type TriviaRevealMutationHookResult = ReturnType<
  typeof useTriviaRevealMutation
>;
export type TriviaRevealMutationResult =
  Apollo.MutationResult<TriviaRevealMutation>;
export type TriviaRevealMutationOptions = Apollo.BaseMutationOptions<
  TriviaRevealMutation,
  TriviaRevealMutationVariables
>;
export const TriviaNextQuestionDocument = gql`
  mutation triviaNextQuestion($engagementId: String!) {
    triviaNextQuestion(engagementId: $engagementId) {
      ...FullEngagement
    }
  }
  ${FullEngagementFragmentDoc}
`;
export type TriviaNextQuestionMutationFn = Apollo.MutationFunction<
  TriviaNextQuestionMutation,
  TriviaNextQuestionMutationVariables
>;

/**
 * __useTriviaNextQuestionMutation__
 *
 * To run a mutation, you first call `useTriviaNextQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriviaNextQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triviaNextQuestionMutation, { data, loading, error }] = useTriviaNextQuestionMutation({
 *   variables: {
 *      engagementId: // value for 'engagementId'
 *   },
 * });
 */
export function useTriviaNextQuestionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TriviaNextQuestionMutation,
    TriviaNextQuestionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TriviaNextQuestionMutation,
    TriviaNextQuestionMutationVariables
  >(TriviaNextQuestionDocument, options);
}
export type TriviaNextQuestionMutationHookResult = ReturnType<
  typeof useTriviaNextQuestionMutation
>;
export type TriviaNextQuestionMutationResult =
  Apollo.MutationResult<TriviaNextQuestionMutation>;
export type TriviaNextQuestionMutationOptions = Apollo.BaseMutationOptions<
  TriviaNextQuestionMutation,
  TriviaNextQuestionMutationVariables
>;
export const TriviaSkipRevealDocument = gql`
  mutation triviaSkipReveal($engagementId: String!) {
    triviaSkipReveal(engagementId: $engagementId) {
      ...FullEngagement
    }
  }
  ${FullEngagementFragmentDoc}
`;
export type TriviaSkipRevealMutationFn = Apollo.MutationFunction<
  TriviaSkipRevealMutation,
  TriviaSkipRevealMutationVariables
>;

/**
 * __useTriviaSkipRevealMutation__
 *
 * To run a mutation, you first call `useTriviaSkipRevealMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriviaSkipRevealMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triviaSkipRevealMutation, { data, loading, error }] = useTriviaSkipRevealMutation({
 *   variables: {
 *      engagementId: // value for 'engagementId'
 *   },
 * });
 */
export function useTriviaSkipRevealMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TriviaSkipRevealMutation,
    TriviaSkipRevealMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TriviaSkipRevealMutation,
    TriviaSkipRevealMutationVariables
  >(TriviaSkipRevealDocument, options);
}
export type TriviaSkipRevealMutationHookResult = ReturnType<
  typeof useTriviaSkipRevealMutation
>;
export type TriviaSkipRevealMutationResult =
  Apollo.MutationResult<TriviaSkipRevealMutation>;
export type TriviaSkipRevealMutationOptions = Apollo.BaseMutationOptions<
  TriviaSkipRevealMutation,
  TriviaSkipRevealMutationVariables
>;
export const TriviaPreviousDocument = gql`
  mutation triviaPrevious($engagementId: String!) {
    triviaPrevious(engagementId: $engagementId) {
      ...FullEngagement
    }
  }
  ${FullEngagementFragmentDoc}
`;
export type TriviaPreviousMutationFn = Apollo.MutationFunction<
  TriviaPreviousMutation,
  TriviaPreviousMutationVariables
>;

/**
 * __useTriviaPreviousMutation__
 *
 * To run a mutation, you first call `useTriviaPreviousMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriviaPreviousMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triviaPreviousMutation, { data, loading, error }] = useTriviaPreviousMutation({
 *   variables: {
 *      engagementId: // value for 'engagementId'
 *   },
 * });
 */
export function useTriviaPreviousMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TriviaPreviousMutation,
    TriviaPreviousMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TriviaPreviousMutation,
    TriviaPreviousMutationVariables
  >(TriviaPreviousDocument, options);
}
export type TriviaPreviousMutationHookResult = ReturnType<
  typeof useTriviaPreviousMutation
>;
export type TriviaPreviousMutationResult =
  Apollo.MutationResult<TriviaPreviousMutation>;
export type TriviaPreviousMutationOptions = Apollo.BaseMutationOptions<
  TriviaPreviousMutation,
  TriviaPreviousMutationVariables
>;
export const TriviaResetDocument = gql`
  mutation triviaReset($engagementId: String!) {
    triviaReset(engagementId: $engagementId) {
      ...FullEngagement
    }
  }
  ${FullEngagementFragmentDoc}
`;
export type TriviaResetMutationFn = Apollo.MutationFunction<
  TriviaResetMutation,
  TriviaResetMutationVariables
>;

/**
 * __useTriviaResetMutation__
 *
 * To run a mutation, you first call `useTriviaResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriviaResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triviaResetMutation, { data, loading, error }] = useTriviaResetMutation({
 *   variables: {
 *      engagementId: // value for 'engagementId'
 *   },
 * });
 */
export function useTriviaResetMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TriviaResetMutation,
    TriviaResetMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TriviaResetMutation, TriviaResetMutationVariables>(
    TriviaResetDocument,
    options,
  );
}
export type TriviaResetMutationHookResult = ReturnType<
  typeof useTriviaResetMutation
>;
export type TriviaResetMutationResult =
  Apollo.MutationResult<TriviaResetMutation>;
export type TriviaResetMutationOptions = Apollo.BaseMutationOptions<
  TriviaResetMutation,
  TriviaResetMutationVariables
>;
export const TriviaExtendTimerDocument = gql`
  mutation triviaExtendTimer($engagementId: String!) {
    triviaExtendTimer(engagementId: $engagementId) {
      ...FullEngagement
    }
  }
  ${FullEngagementFragmentDoc}
`;
export type TriviaExtendTimerMutationFn = Apollo.MutationFunction<
  TriviaExtendTimerMutation,
  TriviaExtendTimerMutationVariables
>;

/**
 * __useTriviaExtendTimerMutation__
 *
 * To run a mutation, you first call `useTriviaExtendTimerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriviaExtendTimerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triviaExtendTimerMutation, { data, loading, error }] = useTriviaExtendTimerMutation({
 *   variables: {
 *      engagementId: // value for 'engagementId'
 *   },
 * });
 */
export function useTriviaExtendTimerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TriviaExtendTimerMutation,
    TriviaExtendTimerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TriviaExtendTimerMutation,
    TriviaExtendTimerMutationVariables
  >(TriviaExtendTimerDocument, options);
}
export type TriviaExtendTimerMutationHookResult = ReturnType<
  typeof useTriviaExtendTimerMutation
>;
export type TriviaExtendTimerMutationResult =
  Apollo.MutationResult<TriviaExtendTimerMutation>;
export type TriviaExtendTimerMutationOptions = Apollo.BaseMutationOptions<
  TriviaExtendTimerMutation,
  TriviaExtendTimerMutationVariables
>;
export const TriviaJoinDocument = gql`
  mutation triviaJoin($engagementId: String!) {
    triviaJoin(engagementId: $engagementId) {
      ...FanEngagement
    }
  }
  ${FanEngagementFragmentDoc}
`;
export type TriviaJoinMutationFn = Apollo.MutationFunction<
  TriviaJoinMutation,
  TriviaJoinMutationVariables
>;

/**
 * __useTriviaJoinMutation__
 *
 * To run a mutation, you first call `useTriviaJoinMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriviaJoinMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triviaJoinMutation, { data, loading, error }] = useTriviaJoinMutation({
 *   variables: {
 *      engagementId: // value for 'engagementId'
 *   },
 * });
 */
export function useTriviaJoinMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TriviaJoinMutation,
    TriviaJoinMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TriviaJoinMutation, TriviaJoinMutationVariables>(
    TriviaJoinDocument,
    options,
  );
}
export type TriviaJoinMutationHookResult = ReturnType<
  typeof useTriviaJoinMutation
>;
export type TriviaJoinMutationResult =
  Apollo.MutationResult<TriviaJoinMutation>;
export type TriviaJoinMutationOptions = Apollo.BaseMutationOptions<
  TriviaJoinMutation,
  TriviaJoinMutationVariables
>;
export const TriviaSubmitAnswerDocument = gql`
  mutation triviaSubmitAnswer(
    $engagementId: String!
    $questionId: String!
    $choiceId: String!
  ) {
    triviaSubmitAnswer(
      engagementId: $engagementId
      questionId: $questionId
      choiceId: $choiceId
    ) {
      ...TriviaMyAnswerFields
    }
  }
  ${TriviaMyAnswerFieldsFragmentDoc}
`;
export type TriviaSubmitAnswerMutationFn = Apollo.MutationFunction<
  TriviaSubmitAnswerMutation,
  TriviaSubmitAnswerMutationVariables
>;

/**
 * __useTriviaSubmitAnswerMutation__
 *
 * To run a mutation, you first call `useTriviaSubmitAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriviaSubmitAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triviaSubmitAnswerMutation, { data, loading, error }] = useTriviaSubmitAnswerMutation({
 *   variables: {
 *      engagementId: // value for 'engagementId'
 *      questionId: // value for 'questionId'
 *      choiceId: // value for 'choiceId'
 *   },
 * });
 */
export function useTriviaSubmitAnswerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TriviaSubmitAnswerMutation,
    TriviaSubmitAnswerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TriviaSubmitAnswerMutation,
    TriviaSubmitAnswerMutationVariables
  >(TriviaSubmitAnswerDocument, options);
}
export type TriviaSubmitAnswerMutationHookResult = ReturnType<
  typeof useTriviaSubmitAnswerMutation
>;
export type TriviaSubmitAnswerMutationResult =
  Apollo.MutationResult<TriviaSubmitAnswerMutation>;
export type TriviaSubmitAnswerMutationOptions = Apollo.BaseMutationOptions<
  TriviaSubmitAnswerMutation,
  TriviaSubmitAnswerMutationVariables
>;
export const VoteForResetVotesDocument = gql`
  mutation voteForResetVotes($engagementId: String!) {
    voteForResetVotes(engagementId: $engagementId) {
      ...FullEngagement
    }
  }
  ${FullEngagementFragmentDoc}
`;
export type VoteForResetVotesMutationFn = Apollo.MutationFunction<
  VoteForResetVotesMutation,
  VoteForResetVotesMutationVariables
>;

/**
 * __useVoteForResetVotesMutation__
 *
 * To run a mutation, you first call `useVoteForResetVotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVoteForResetVotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [voteForResetVotesMutation, { data, loading, error }] = useVoteForResetVotesMutation({
 *   variables: {
 *      engagementId: // value for 'engagementId'
 *   },
 * });
 */
export function useVoteForResetVotesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    VoteForResetVotesMutation,
    VoteForResetVotesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    VoteForResetVotesMutation,
    VoteForResetVotesMutationVariables
  >(VoteForResetVotesDocument, options);
}
export type VoteForResetVotesMutationHookResult = ReturnType<
  typeof useVoteForResetVotesMutation
>;
export type VoteForResetVotesMutationResult =
  Apollo.MutationResult<VoteForResetVotesMutation>;
export type VoteForResetVotesMutationOptions = Apollo.BaseMutationOptions<
  VoteForResetVotesMutation,
  VoteForResetVotesMutationVariables
>;
export const VoteForDeclareWinnersDocument = gql`
  mutation voteForDeclareWinners($engagementId: String!) {
    voteForDeclareWinners(engagementId: $engagementId) {
      ...FullEngagement
    }
  }
  ${FullEngagementFragmentDoc}
`;
export type VoteForDeclareWinnersMutationFn = Apollo.MutationFunction<
  VoteForDeclareWinnersMutation,
  VoteForDeclareWinnersMutationVariables
>;

/**
 * __useVoteForDeclareWinnersMutation__
 *
 * To run a mutation, you first call `useVoteForDeclareWinnersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVoteForDeclareWinnersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [voteForDeclareWinnersMutation, { data, loading, error }] = useVoteForDeclareWinnersMutation({
 *   variables: {
 *      engagementId: // value for 'engagementId'
 *   },
 * });
 */
export function useVoteForDeclareWinnersMutation(
  baseOptions?: Apollo.MutationHookOptions<
    VoteForDeclareWinnersMutation,
    VoteForDeclareWinnersMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    VoteForDeclareWinnersMutation,
    VoteForDeclareWinnersMutationVariables
  >(VoteForDeclareWinnersDocument, options);
}
export type VoteForDeclareWinnersMutationHookResult = ReturnType<
  typeof useVoteForDeclareWinnersMutation
>;
export type VoteForDeclareWinnersMutationResult =
  Apollo.MutationResult<VoteForDeclareWinnersMutation>;
export type VoteForDeclareWinnersMutationOptions = Apollo.BaseMutationOptions<
  VoteForDeclareWinnersMutation,
  VoteForDeclareWinnersMutationVariables
>;
export const VoteForUndeclareWinnersDocument = gql`
  mutation voteForUndeclareWinners($engagementId: String!) {
    voteForUndeclareWinners(engagementId: $engagementId) {
      ...FullEngagement
    }
  }
  ${FullEngagementFragmentDoc}
`;
export type VoteForUndeclareWinnersMutationFn = Apollo.MutationFunction<
  VoteForUndeclareWinnersMutation,
  VoteForUndeclareWinnersMutationVariables
>;

/**
 * __useVoteForUndeclareWinnersMutation__
 *
 * To run a mutation, you first call `useVoteForUndeclareWinnersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVoteForUndeclareWinnersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [voteForUndeclareWinnersMutation, { data, loading, error }] = useVoteForUndeclareWinnersMutation({
 *   variables: {
 *      engagementId: // value for 'engagementId'
 *   },
 * });
 */
export function useVoteForUndeclareWinnersMutation(
  baseOptions?: Apollo.MutationHookOptions<
    VoteForUndeclareWinnersMutation,
    VoteForUndeclareWinnersMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    VoteForUndeclareWinnersMutation,
    VoteForUndeclareWinnersMutationVariables
  >(VoteForUndeclareWinnersDocument, options);
}
export type VoteForUndeclareWinnersMutationHookResult = ReturnType<
  typeof useVoteForUndeclareWinnersMutation
>;
export type VoteForUndeclareWinnersMutationResult =
  Apollo.MutationResult<VoteForUndeclareWinnersMutation>;
export type VoteForUndeclareWinnersMutationOptions = Apollo.BaseMutationOptions<
  VoteForUndeclareWinnersMutation,
  VoteForUndeclareWinnersMutationVariables
>;
export const VoteForVotesResetDocument = gql`
  subscription voteForVotesReset($engagementId: String!) {
    voteForVotesReset(engagementId: $engagementId) {
      engagement {
        ...FullEngagement
      }
    }
  }
  ${FullEngagementFragmentDoc}
`;

/**
 * __useVoteForVotesResetSubscription__
 *
 * To run a query within a React component, call `useVoteForVotesResetSubscription` and pass it any options that fit your needs.
 * When your component renders, `useVoteForVotesResetSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVoteForVotesResetSubscription({
 *   variables: {
 *      engagementId: // value for 'engagementId'
 *   },
 * });
 */
export function useVoteForVotesResetSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    VoteForVotesResetSubscription,
    VoteForVotesResetSubscriptionVariables
  > &
    (
      | { variables: VoteForVotesResetSubscriptionVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    VoteForVotesResetSubscription,
    VoteForVotesResetSubscriptionVariables
  >(VoteForVotesResetDocument, options);
}
export type VoteForVotesResetSubscriptionHookResult = ReturnType<
  typeof useVoteForVotesResetSubscription
>;
export type VoteForVotesResetSubscriptionResult =
  Apollo.SubscriptionResult<VoteForVotesResetSubscription>;
export const MockVoteForVotesResetDocument = gql`
  subscription mockVoteForVotesReset($engagementId: String!) {
    mockVoteForVotesReset(engagementId: $engagementId) {
      engagement {
        ...FullEngagement
      }
    }
  }
  ${FullEngagementFragmentDoc}
`;

/**
 * __useMockVoteForVotesResetSubscription__
 *
 * To run a query within a React component, call `useMockVoteForVotesResetSubscription` and pass it any options that fit your needs.
 * When your component renders, `useMockVoteForVotesResetSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMockVoteForVotesResetSubscription({
 *   variables: {
 *      engagementId: // value for 'engagementId'
 *   },
 * });
 */
export function useMockVoteForVotesResetSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    MockVoteForVotesResetSubscription,
    MockVoteForVotesResetSubscriptionVariables
  > &
    (
      | {
          variables: MockVoteForVotesResetSubscriptionVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    MockVoteForVotesResetSubscription,
    MockVoteForVotesResetSubscriptionVariables
  >(MockVoteForVotesResetDocument, options);
}
export type MockVoteForVotesResetSubscriptionHookResult = ReturnType<
  typeof useMockVoteForVotesResetSubscription
>;
export type MockVoteForVotesResetSubscriptionResult =
  Apollo.SubscriptionResult<MockVoteForVotesResetSubscription>;
export const CreateSubmissionDocument = gql`
  mutation createSubmission(
    $engagementId: String!
    $data: Json!
    $deviceId: String
    $visitorId: String
  ) {
    createSubmission(
      engagementId: $engagementId
      data: $data
      deviceId: $deviceId
      visitorId: $visitorId
    ) {
      ...FanSubmission
    }
  }
  ${FanSubmissionFragmentDoc}
`;
export type CreateSubmissionMutationFn = Apollo.MutationFunction<
  CreateSubmissionMutation,
  CreateSubmissionMutationVariables
>;

/**
 * __useCreateSubmissionMutation__
 *
 * To run a mutation, you first call `useCreateSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubmissionMutation, { data, loading, error }] = useCreateSubmissionMutation({
 *   variables: {
 *      engagementId: // value for 'engagementId'
 *      data: // value for 'data'
 *      deviceId: // value for 'deviceId'
 *      visitorId: // value for 'visitorId'
 *   },
 * });
 */
export function useCreateSubmissionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateSubmissionMutation,
    CreateSubmissionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateSubmissionMutation,
    CreateSubmissionMutationVariables
  >(CreateSubmissionDocument, options);
}
export type CreateSubmissionMutationHookResult = ReturnType<
  typeof useCreateSubmissionMutation
>;
export type CreateSubmissionMutationResult =
  Apollo.MutationResult<CreateSubmissionMutation>;
export type CreateSubmissionMutationOptions = Apollo.BaseMutationOptions<
  CreateSubmissionMutation,
  CreateSubmissionMutationVariables
>;
export const ChangeEventActiveEngagementDocument = gql`
  mutation changeEventActiveEngagement(
    $eventId: String!
    $engagementId: String
  ) {
    changeEventActiveEngagement(
      eventId: $eventId
      engagementId: $engagementId
    ) {
      ...FullEvent
    }
  }
  ${FullEventFragmentDoc}
`;
export type ChangeEventActiveEngagementMutationFn = Apollo.MutationFunction<
  ChangeEventActiveEngagementMutation,
  ChangeEventActiveEngagementMutationVariables
>;

/**
 * __useChangeEventActiveEngagementMutation__
 *
 * To run a mutation, you first call `useChangeEventActiveEngagementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeEventActiveEngagementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeEventActiveEngagementMutation, { data, loading, error }] = useChangeEventActiveEngagementMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      engagementId: // value for 'engagementId'
 *   },
 * });
 */
export function useChangeEventActiveEngagementMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ChangeEventActiveEngagementMutation,
    ChangeEventActiveEngagementMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ChangeEventActiveEngagementMutation,
    ChangeEventActiveEngagementMutationVariables
  >(ChangeEventActiveEngagementDocument, options);
}
export type ChangeEventActiveEngagementMutationHookResult = ReturnType<
  typeof useChangeEventActiveEngagementMutation
>;
export type ChangeEventActiveEngagementMutationResult =
  Apollo.MutationResult<ChangeEventActiveEngagementMutation>;
export type ChangeEventActiveEngagementMutationOptions =
  Apollo.BaseMutationOptions<
    ChangeEventActiveEngagementMutation,
    ChangeEventActiveEngagementMutationVariables
  >;
export const UpdateEventThemeConfigDocument = gql`
  mutation updateEventThemeConfig(
    $eventId: String!
    $data: EventThemeConfigUpdateInput!
  ) {
    updateEventThemeConfig(eventId: $eventId, data: $data) {
      ...EventThemeConfig
    }
  }
  ${EventThemeConfigFragmentDoc}
`;
export type UpdateEventThemeConfigMutationFn = Apollo.MutationFunction<
  UpdateEventThemeConfigMutation,
  UpdateEventThemeConfigMutationVariables
>;

/**
 * __useUpdateEventThemeConfigMutation__
 *
 * To run a mutation, you first call `useUpdateEventThemeConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventThemeConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventThemeConfigMutation, { data, loading, error }] = useUpdateEventThemeConfigMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateEventThemeConfigMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateEventThemeConfigMutation,
    UpdateEventThemeConfigMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateEventThemeConfigMutation,
    UpdateEventThemeConfigMutationVariables
  >(UpdateEventThemeConfigDocument, options);
}
export type UpdateEventThemeConfigMutationHookResult = ReturnType<
  typeof useUpdateEventThemeConfigMutation
>;
export type UpdateEventThemeConfigMutationResult =
  Apollo.MutationResult<UpdateEventThemeConfigMutation>;
export type UpdateEventThemeConfigMutationOptions = Apollo.BaseMutationOptions<
  UpdateEventThemeConfigMutation,
  UpdateEventThemeConfigMutationVariables
>;
export const CreatePresignedUrlDocument = gql`
  mutation createPresignedUrl($mimeType: String!) {
    createPresignedUrl(mimeType: $mimeType) {
      url
      key
    }
  }
`;
export type CreatePresignedUrlMutationFn = Apollo.MutationFunction<
  CreatePresignedUrlMutation,
  CreatePresignedUrlMutationVariables
>;

/**
 * __useCreatePresignedUrlMutation__
 *
 * To run a mutation, you first call `useCreatePresignedUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePresignedUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPresignedUrlMutation, { data, loading, error }] = useCreatePresignedUrlMutation({
 *   variables: {
 *      mimeType: // value for 'mimeType'
 *   },
 * });
 */
export function useCreatePresignedUrlMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreatePresignedUrlMutation,
    CreatePresignedUrlMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreatePresignedUrlMutation,
    CreatePresignedUrlMutationVariables
  >(CreatePresignedUrlDocument, options);
}
export type CreatePresignedUrlMutationHookResult = ReturnType<
  typeof useCreatePresignedUrlMutation
>;
export type CreatePresignedUrlMutationResult =
  Apollo.MutationResult<CreatePresignedUrlMutation>;
export type CreatePresignedUrlMutationOptions = Apollo.BaseMutationOptions<
  CreatePresignedUrlMutation,
  CreatePresignedUrlMutationVariables
>;
export const DeleteEventDocument = gql`
  mutation deleteEvent($eventId: String!) {
    deleteEvent(eventId: $eventId) {
      id
    }
  }
`;
export type DeleteEventMutationFn = Apollo.MutationFunction<
  DeleteEventMutation,
  DeleteEventMutationVariables
>;

/**
 * __useDeleteEventMutation__
 *
 * To run a mutation, you first call `useDeleteEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEventMutation, { data, loading, error }] = useDeleteEventMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useDeleteEventMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteEventMutation,
    DeleteEventMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteEventMutation, DeleteEventMutationVariables>(
    DeleteEventDocument,
    options,
  );
}
export type DeleteEventMutationHookResult = ReturnType<
  typeof useDeleteEventMutation
>;
export type DeleteEventMutationResult =
  Apollo.MutationResult<DeleteEventMutation>;
export type DeleteEventMutationOptions = Apollo.BaseMutationOptions<
  DeleteEventMutation,
  DeleteEventMutationVariables
>;
export const UpdateEventDocument = gql`
  mutation updateEvent($eventId: String!, $data: UpdateEventInput!) {
    updateEvent(eventId: $eventId, data: $data) {
      ...FullEvent
    }
  }
  ${FullEventFragmentDoc}
`;
export type UpdateEventMutationFn = Apollo.MutationFunction<
  UpdateEventMutation,
  UpdateEventMutationVariables
>;

/**
 * __useUpdateEventMutation__
 *
 * To run a mutation, you first call `useUpdateEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventMutation, { data, loading, error }] = useUpdateEventMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateEventMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateEventMutation,
    UpdateEventMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateEventMutation, UpdateEventMutationVariables>(
    UpdateEventDocument,
    options,
  );
}
export type UpdateEventMutationHookResult = ReturnType<
  typeof useUpdateEventMutation
>;
export type UpdateEventMutationResult =
  Apollo.MutationResult<UpdateEventMutation>;
export type UpdateEventMutationOptions = Apollo.BaseMutationOptions<
  UpdateEventMutation,
  UpdateEventMutationVariables
>;
export const MoveEngagementDocument = gql`
  mutation moveEngagement($engagementId: String!, $direction: String!) {
    moveEngagement(engagementId: $engagementId, direction: $direction) {
      ...FullEngagement
    }
  }
  ${FullEngagementFragmentDoc}
`;
export type MoveEngagementMutationFn = Apollo.MutationFunction<
  MoveEngagementMutation,
  MoveEngagementMutationVariables
>;

/**
 * __useMoveEngagementMutation__
 *
 * To run a mutation, you first call `useMoveEngagementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveEngagementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveEngagementMutation, { data, loading, error }] = useMoveEngagementMutation({
 *   variables: {
 *      engagementId: // value for 'engagementId'
 *      direction: // value for 'direction'
 *   },
 * });
 */
export function useMoveEngagementMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MoveEngagementMutation,
    MoveEngagementMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    MoveEngagementMutation,
    MoveEngagementMutationVariables
  >(MoveEngagementDocument, options);
}
export type MoveEngagementMutationHookResult = ReturnType<
  typeof useMoveEngagementMutation
>;
export type MoveEngagementMutationResult =
  Apollo.MutationResult<MoveEngagementMutation>;
export type MoveEngagementMutationOptions = Apollo.BaseMutationOptions<
  MoveEngagementMutation,
  MoveEngagementMutationVariables
>;
export const GenerateImageDocument = gql`
  mutation generateImage($data: GenerateImageInput!) {
    generateImage(data: $data) {
      uri
    }
  }
`;
export type GenerateImageMutationFn = Apollo.MutationFunction<
  GenerateImageMutation,
  GenerateImageMutationVariables
>;

/**
 * __useGenerateImageMutation__
 *
 * To run a mutation, you first call `useGenerateImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateImageMutation, { data, loading, error }] = useGenerateImageMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGenerateImageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GenerateImageMutation,
    GenerateImageMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    GenerateImageMutation,
    GenerateImageMutationVariables
  >(GenerateImageDocument, options);
}
export type GenerateImageMutationHookResult = ReturnType<
  typeof useGenerateImageMutation
>;
export type GenerateImageMutationResult =
  Apollo.MutationResult<GenerateImageMutation>;
export type GenerateImageMutationOptions = Apollo.BaseMutationOptions<
  GenerateImageMutation,
  GenerateImageMutationVariables
>;
export const UpdateSubmissionDocument = gql`
  mutation updateSubmission($submissionId: String!, $data: Json!) {
    updateSubmission(submissionId: $submissionId, data: $data) {
      ...FullSubmission
    }
  }
  ${FullSubmissionFragmentDoc}
`;
export type UpdateSubmissionMutationFn = Apollo.MutationFunction<
  UpdateSubmissionMutation,
  UpdateSubmissionMutationVariables
>;

/**
 * __useUpdateSubmissionMutation__
 *
 * To run a mutation, you first call `useUpdateSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubmissionMutation, { data, loading, error }] = useUpdateSubmissionMutation({
 *   variables: {
 *      submissionId: // value for 'submissionId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateSubmissionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateSubmissionMutation,
    UpdateSubmissionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateSubmissionMutation,
    UpdateSubmissionMutationVariables
  >(UpdateSubmissionDocument, options);
}
export type UpdateSubmissionMutationHookResult = ReturnType<
  typeof useUpdateSubmissionMutation
>;
export type UpdateSubmissionMutationResult =
  Apollo.MutationResult<UpdateSubmissionMutation>;
export type UpdateSubmissionMutationOptions = Apollo.BaseMutationOptions<
  UpdateSubmissionMutation,
  UpdateSubmissionMutationVariables
>;
export const CreateReactionDocument = gql`
  mutation createReaction(
    $submissionId: String!
    $type: String!
    $deviceId: String
    $visitorId: String
  ) {
    createReaction(
      submissionId: $submissionId
      type: $type
      deviceId: $deviceId
      visitorId: $visitorId
    ) {
      ...FanReaction
    }
  }
  ${FanReactionFragmentDoc}
`;
export type CreateReactionMutationFn = Apollo.MutationFunction<
  CreateReactionMutation,
  CreateReactionMutationVariables
>;

/**
 * __useCreateReactionMutation__
 *
 * To run a mutation, you first call `useCreateReactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReactionMutation, { data, loading, error }] = useCreateReactionMutation({
 *   variables: {
 *      submissionId: // value for 'submissionId'
 *      type: // value for 'type'
 *      deviceId: // value for 'deviceId'
 *      visitorId: // value for 'visitorId'
 *   },
 * });
 */
export function useCreateReactionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateReactionMutation,
    CreateReactionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateReactionMutation,
    CreateReactionMutationVariables
  >(CreateReactionDocument, options);
}
export type CreateReactionMutationHookResult = ReturnType<
  typeof useCreateReactionMutation
>;
export type CreateReactionMutationResult =
  Apollo.MutationResult<CreateReactionMutation>;
export type CreateReactionMutationOptions = Apollo.BaseMutationOptions<
  CreateReactionMutation,
  CreateReactionMutationVariables
>;
export const BanUserDocument = gql`
  mutation banUser(
    $submissionId: String!
    $hideExisting: Boolean!
    $reason: String
  ) {
    banUser(
      submissionId: $submissionId
      hideExisting: $hideExisting
      reason: $reason
    ) {
      hiddenCount
      ban {
        ...BanFields
      }
    }
  }
  ${BanFieldsFragmentDoc}
`;
export type BanUserMutationFn = Apollo.MutationFunction<
  BanUserMutation,
  BanUserMutationVariables
>;

/**
 * __useBanUserMutation__
 *
 * To run a mutation, you first call `useBanUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBanUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [banUserMutation, { data, loading, error }] = useBanUserMutation({
 *   variables: {
 *      submissionId: // value for 'submissionId'
 *      hideExisting: // value for 'hideExisting'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useBanUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BanUserMutation,
    BanUserMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<BanUserMutation, BanUserMutationVariables>(
    BanUserDocument,
    options,
  );
}
export type BanUserMutationHookResult = ReturnType<typeof useBanUserMutation>;
export type BanUserMutationResult = Apollo.MutationResult<BanUserMutation>;
export type BanUserMutationOptions = Apollo.BaseMutationOptions<
  BanUserMutation,
  BanUserMutationVariables
>;
export const UnbanUserDocument = gql`
  mutation unbanUser($banId: String!, $eventId: String!) {
    unbanUser(banId: $banId, eventId: $eventId) {
      banId
      restoredCount
    }
  }
`;
export type UnbanUserMutationFn = Apollo.MutationFunction<
  UnbanUserMutation,
  UnbanUserMutationVariables
>;

/**
 * __useUnbanUserMutation__
 *
 * To run a mutation, you first call `useUnbanUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnbanUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unbanUserMutation, { data, loading, error }] = useUnbanUserMutation({
 *   variables: {
 *      banId: // value for 'banId'
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useUnbanUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UnbanUserMutation,
    UnbanUserMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UnbanUserMutation, UnbanUserMutationVariables>(
    UnbanUserDocument,
    options,
  );
}
export type UnbanUserMutationHookResult = ReturnType<
  typeof useUnbanUserMutation
>;
export type UnbanUserMutationResult = Apollo.MutationResult<UnbanUserMutation>;
export type UnbanUserMutationOptions = Apollo.BaseMutationOptions<
  UnbanUserMutation,
  UnbanUserMutationVariables
>;
export const DeleteReactionDocument = gql`
  mutation deleteReaction($reactionId: String!) {
    deleteReaction(reactionId: $reactionId) {
      ...FanReaction
    }
  }
  ${FanReactionFragmentDoc}
`;
export type DeleteReactionMutationFn = Apollo.MutationFunction<
  DeleteReactionMutation,
  DeleteReactionMutationVariables
>;

/**
 * __useDeleteReactionMutation__
 *
 * To run a mutation, you first call `useDeleteReactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReactionMutation, { data, loading, error }] = useDeleteReactionMutation({
 *   variables: {
 *      reactionId: // value for 'reactionId'
 *   },
 * });
 */
export function useDeleteReactionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteReactionMutation,
    DeleteReactionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteReactionMutation,
    DeleteReactionMutationVariables
  >(DeleteReactionDocument, options);
}
export type DeleteReactionMutationHookResult = ReturnType<
  typeof useDeleteReactionMutation
>;
export type DeleteReactionMutationResult =
  Apollo.MutationResult<DeleteReactionMutation>;
export type DeleteReactionMutationOptions = Apollo.BaseMutationOptions<
  DeleteReactionMutation,
  DeleteReactionMutationVariables
>;
export const CreateEngagementDocument = gql`
  mutation createEngagement($eventId: String!, $data: CreateEngagementInput!) {
    createEngagement(eventId: $eventId, data: $data) {
      ...FullEngagement
    }
  }
  ${FullEngagementFragmentDoc}
`;
export type CreateEngagementMutationFn = Apollo.MutationFunction<
  CreateEngagementMutation,
  CreateEngagementMutationVariables
>;

/**
 * __useCreateEngagementMutation__
 *
 * To run a mutation, you first call `useCreateEngagementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEngagementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEngagementMutation, { data, loading, error }] = useCreateEngagementMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateEngagementMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateEngagementMutation,
    CreateEngagementMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateEngagementMutation,
    CreateEngagementMutationVariables
  >(CreateEngagementDocument, options);
}
export type CreateEngagementMutationHookResult = ReturnType<
  typeof useCreateEngagementMutation
>;
export type CreateEngagementMutationResult =
  Apollo.MutationResult<CreateEngagementMutation>;
export type CreateEngagementMutationOptions = Apollo.BaseMutationOptions<
  CreateEngagementMutation,
  CreateEngagementMutationVariables
>;
export const UpdateEngagementDocument = gql`
  mutation updateEngagement(
    $engagementId: String!
    $data: UpdateEngagementInput!
  ) {
    updateEngagement(engagementId: $engagementId, data: $data) {
      ...FullEngagement
    }
  }
  ${FullEngagementFragmentDoc}
`;
export type UpdateEngagementMutationFn = Apollo.MutationFunction<
  UpdateEngagementMutation,
  UpdateEngagementMutationVariables
>;

/**
 * __useUpdateEngagementMutation__
 *
 * To run a mutation, you first call `useUpdateEngagementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEngagementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEngagementMutation, { data, loading, error }] = useUpdateEngagementMutation({
 *   variables: {
 *      engagementId: // value for 'engagementId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateEngagementMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateEngagementMutation,
    UpdateEngagementMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateEngagementMutation,
    UpdateEngagementMutationVariables
  >(UpdateEngagementDocument, options);
}
export type UpdateEngagementMutationHookResult = ReturnType<
  typeof useUpdateEngagementMutation
>;
export type UpdateEngagementMutationResult =
  Apollo.MutationResult<UpdateEngagementMutation>;
export type UpdateEngagementMutationOptions = Apollo.BaseMutationOptions<
  UpdateEngagementMutation,
  UpdateEngagementMutationVariables
>;
export const DeleteSubmissionDocument = gql`
  mutation deleteSubmission($submissionId: String!) {
    deleteSubmission(submissionId: $submissionId) {
      id
    }
  }
`;
export type DeleteSubmissionMutationFn = Apollo.MutationFunction<
  DeleteSubmissionMutation,
  DeleteSubmissionMutationVariables
>;

/**
 * __useDeleteSubmissionMutation__
 *
 * To run a mutation, you first call `useDeleteSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSubmissionMutation, { data, loading, error }] = useDeleteSubmissionMutation({
 *   variables: {
 *      submissionId: // value for 'submissionId'
 *   },
 * });
 */
export function useDeleteSubmissionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteSubmissionMutation,
    DeleteSubmissionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteSubmissionMutation,
    DeleteSubmissionMutationVariables
  >(DeleteSubmissionDocument, options);
}
export type DeleteSubmissionMutationHookResult = ReturnType<
  typeof useDeleteSubmissionMutation
>;
export type DeleteSubmissionMutationResult =
  Apollo.MutationResult<DeleteSubmissionMutation>;
export type DeleteSubmissionMutationOptions = Apollo.BaseMutationOptions<
  DeleteSubmissionMutation,
  DeleteSubmissionMutationVariables
>;
export const FanSignupDocument = gql`
  mutation fanSignup($data: SignupInput!) {
    signup(data: $data) {
      ...User
    }
  }
  ${UserFragmentDoc}
`;
export type FanSignupMutationFn = Apollo.MutationFunction<
  FanSignupMutation,
  FanSignupMutationVariables
>;

/**
 * __useFanSignupMutation__
 *
 * To run a mutation, you first call `useFanSignupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFanSignupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fanSignupMutation, { data, loading, error }] = useFanSignupMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useFanSignupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    FanSignupMutation,
    FanSignupMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<FanSignupMutation, FanSignupMutationVariables>(
    FanSignupDocument,
    options,
  );
}
export type FanSignupMutationHookResult = ReturnType<
  typeof useFanSignupMutation
>;
export type FanSignupMutationResult = Apollo.MutationResult<FanSignupMutation>;
export type FanSignupMutationOptions = Apollo.BaseMutationOptions<
  FanSignupMutation,
  FanSignupMutationVariables
>;
export const CreateSubmissionPresignedUrlDocument = gql`
  mutation createSubmissionPresignedUrl(
    $engagementId: String!
    $mimeType: String!
    $deviceId: String
    $visitorId: String
  ) {
    createSubmissionPresignedUrl(
      engagementId: $engagementId
      mimeType: $mimeType
      deviceId: $deviceId
      visitorId: $visitorId
    ) {
      url
      key
    }
  }
`;
export type CreateSubmissionPresignedUrlMutationFn = Apollo.MutationFunction<
  CreateSubmissionPresignedUrlMutation,
  CreateSubmissionPresignedUrlMutationVariables
>;

/**
 * __useCreateSubmissionPresignedUrlMutation__
 *
 * To run a mutation, you first call `useCreateSubmissionPresignedUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubmissionPresignedUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubmissionPresignedUrlMutation, { data, loading, error }] = useCreateSubmissionPresignedUrlMutation({
 *   variables: {
 *      engagementId: // value for 'engagementId'
 *      mimeType: // value for 'mimeType'
 *      deviceId: // value for 'deviceId'
 *      visitorId: // value for 'visitorId'
 *   },
 * });
 */
export function useCreateSubmissionPresignedUrlMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateSubmissionPresignedUrlMutation,
    CreateSubmissionPresignedUrlMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateSubmissionPresignedUrlMutation,
    CreateSubmissionPresignedUrlMutationVariables
  >(CreateSubmissionPresignedUrlDocument, options);
}
export type CreateSubmissionPresignedUrlMutationHookResult = ReturnType<
  typeof useCreateSubmissionPresignedUrlMutation
>;
export type CreateSubmissionPresignedUrlMutationResult =
  Apollo.MutationResult<CreateSubmissionPresignedUrlMutation>;
export type CreateSubmissionPresignedUrlMutationOptions =
  Apollo.BaseMutationOptions<
    CreateSubmissionPresignedUrlMutation,
    CreateSubmissionPresignedUrlMutationVariables
  >;
export const DeleteEngagementDocument = gql`
  mutation deleteEngagement($engagementId: String!) {
    deleteEngagement(engagementId: $engagementId) {
      id
    }
  }
`;
export type DeleteEngagementMutationFn = Apollo.MutationFunction<
  DeleteEngagementMutation,
  DeleteEngagementMutationVariables
>;

/**
 * __useDeleteEngagementMutation__
 *
 * To run a mutation, you first call `useDeleteEngagementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEngagementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEngagementMutation, { data, loading, error }] = useDeleteEngagementMutation({
 *   variables: {
 *      engagementId: // value for 'engagementId'
 *   },
 * });
 */
export function useDeleteEngagementMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteEngagementMutation,
    DeleteEngagementMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteEngagementMutation,
    DeleteEngagementMutationVariables
  >(DeleteEngagementDocument, options);
}
export type DeleteEngagementMutationHookResult = ReturnType<
  typeof useDeleteEngagementMutation
>;
export type DeleteEngagementMutationResult =
  Apollo.MutationResult<DeleteEngagementMutation>;
export type DeleteEngagementMutationOptions = Apollo.BaseMutationOptions<
  DeleteEngagementMutation,
  DeleteEngagementMutationVariables
>;
export const CreateEventDocument = gql`
  mutation createEvent($data: CreateEventInput!) {
    createEvent(data: $data) {
      ...FullEvent
    }
  }
  ${FullEventFragmentDoc}
`;
export type CreateEventMutationFn = Apollo.MutationFunction<
  CreateEventMutation,
  CreateEventMutationVariables
>;

/**
 * __useCreateEventMutation__
 *
 * To run a mutation, you first call `useCreateEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventMutation, { data, loading, error }] = useCreateEventMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateEventMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateEventMutation,
    CreateEventMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateEventMutation, CreateEventMutationVariables>(
    CreateEventDocument,
    options,
  );
}
export type CreateEventMutationHookResult = ReturnType<
  typeof useCreateEventMutation
>;
export type CreateEventMutationResult =
  Apollo.MutationResult<CreateEventMutation>;
export type CreateEventMutationOptions = Apollo.BaseMutationOptions<
  CreateEventMutation,
  CreateEventMutationVariables
>;
export const StartMockEngagementDocument = gql`
  mutation startMockEngagement($engagementId: String!) {
    startMockEngagement(engagementId: $engagementId) {
      mockRunId
    }
  }
`;
export type StartMockEngagementMutationFn = Apollo.MutationFunction<
  StartMockEngagementMutation,
  StartMockEngagementMutationVariables
>;

/**
 * __useStartMockEngagementMutation__
 *
 * To run a mutation, you first call `useStartMockEngagementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartMockEngagementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startMockEngagementMutation, { data, loading, error }] = useStartMockEngagementMutation({
 *   variables: {
 *      engagementId: // value for 'engagementId'
 *   },
 * });
 */
export function useStartMockEngagementMutation(
  baseOptions?: Apollo.MutationHookOptions<
    StartMockEngagementMutation,
    StartMockEngagementMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    StartMockEngagementMutation,
    StartMockEngagementMutationVariables
  >(StartMockEngagementDocument, options);
}
export type StartMockEngagementMutationHookResult = ReturnType<
  typeof useStartMockEngagementMutation
>;
export type StartMockEngagementMutationResult =
  Apollo.MutationResult<StartMockEngagementMutation>;
export type StartMockEngagementMutationOptions = Apollo.BaseMutationOptions<
  StartMockEngagementMutation,
  StartMockEngagementMutationVariables
>;
export const StopMockEngagementDocument = gql`
  mutation stopMockEngagement($mockRunId: String!) {
    stopMockEngagement(mockRunId: $mockRunId)
  }
`;
export type StopMockEngagementMutationFn = Apollo.MutationFunction<
  StopMockEngagementMutation,
  StopMockEngagementMutationVariables
>;

/**
 * __useStopMockEngagementMutation__
 *
 * To run a mutation, you first call `useStopMockEngagementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopMockEngagementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopMockEngagementMutation, { data, loading, error }] = useStopMockEngagementMutation({
 *   variables: {
 *      mockRunId: // value for 'mockRunId'
 *   },
 * });
 */
export function useStopMockEngagementMutation(
  baseOptions?: Apollo.MutationHookOptions<
    StopMockEngagementMutation,
    StopMockEngagementMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    StopMockEngagementMutation,
    StopMockEngagementMutationVariables
  >(StopMockEngagementDocument, options);
}
export type StopMockEngagementMutationHookResult = ReturnType<
  typeof useStopMockEngagementMutation
>;
export type StopMockEngagementMutationResult =
  Apollo.MutationResult<StopMockEngagementMutation>;
export type StopMockEngagementMutationOptions = Apollo.BaseMutationOptions<
  StopMockEngagementMutation,
  StopMockEngagementMutationVariables
>;
export const ExtendMockEngagementDocument = gql`
  mutation extendMockEngagement($mockRunId: String!) {
    extendMockEngagement(mockRunId: $mockRunId)
  }
`;
export type ExtendMockEngagementMutationFn = Apollo.MutationFunction<
  ExtendMockEngagementMutation,
  ExtendMockEngagementMutationVariables
>;

/**
 * __useExtendMockEngagementMutation__
 *
 * To run a mutation, you first call `useExtendMockEngagementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExtendMockEngagementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [extendMockEngagementMutation, { data, loading, error }] = useExtendMockEngagementMutation({
 *   variables: {
 *      mockRunId: // value for 'mockRunId'
 *   },
 * });
 */
export function useExtendMockEngagementMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ExtendMockEngagementMutation,
    ExtendMockEngagementMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ExtendMockEngagementMutation,
    ExtendMockEngagementMutationVariables
  >(ExtendMockEngagementDocument, options);
}
export type ExtendMockEngagementMutationHookResult = ReturnType<
  typeof useExtendMockEngagementMutation
>;
export type ExtendMockEngagementMutationResult =
  Apollo.MutationResult<ExtendMockEngagementMutation>;
export type ExtendMockEngagementMutationOptions = Apollo.BaseMutationOptions<
  ExtendMockEngagementMutation,
  ExtendMockEngagementMutationVariables
>;
export const CreateEventPassCheckoutSessionDocument = gql`
  mutation createEventPassCheckoutSession(
    $data: CreateEventPassCheckoutSessionInput!
  ) {
    createEventPassCheckoutSession(data: $data) {
      url
      eventPassId
    }
  }
`;
export type CreateEventPassCheckoutSessionMutationFn = Apollo.MutationFunction<
  CreateEventPassCheckoutSessionMutation,
  CreateEventPassCheckoutSessionMutationVariables
>;

/**
 * __useCreateEventPassCheckoutSessionMutation__
 *
 * To run a mutation, you first call `useCreateEventPassCheckoutSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventPassCheckoutSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventPassCheckoutSessionMutation, { data, loading, error }] = useCreateEventPassCheckoutSessionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateEventPassCheckoutSessionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateEventPassCheckoutSessionMutation,
    CreateEventPassCheckoutSessionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateEventPassCheckoutSessionMutation,
    CreateEventPassCheckoutSessionMutationVariables
  >(CreateEventPassCheckoutSessionDocument, options);
}
export type CreateEventPassCheckoutSessionMutationHookResult = ReturnType<
  typeof useCreateEventPassCheckoutSessionMutation
>;
export type CreateEventPassCheckoutSessionMutationResult =
  Apollo.MutationResult<CreateEventPassCheckoutSessionMutation>;
export type CreateEventPassCheckoutSessionMutationOptions =
  Apollo.BaseMutationOptions<
    CreateEventPassCheckoutSessionMutation,
    CreateEventPassCheckoutSessionMutationVariables
  >;
export const RedeemEventPassDocument = gql`
  mutation redeemEventPass(
    $eventPassId: String!
    $eventId: String!
    $description: String
  ) {
    redeemEventPass(
      eventPassId: $eventPassId
      eventId: $eventId
      description: $description
    ) {
      eventPassRedemption {
        ...EventPassRedemption
      }
      event {
        ...FullEvent
      }
    }
  }
  ${EventPassRedemptionFragmentDoc}
  ${FullEventFragmentDoc}
`;
export type RedeemEventPassMutationFn = Apollo.MutationFunction<
  RedeemEventPassMutation,
  RedeemEventPassMutationVariables
>;

/**
 * __useRedeemEventPassMutation__
 *
 * To run a mutation, you first call `useRedeemEventPassMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRedeemEventPassMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [redeemEventPassMutation, { data, loading, error }] = useRedeemEventPassMutation({
 *   variables: {
 *      eventPassId: // value for 'eventPassId'
 *      eventId: // value for 'eventId'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useRedeemEventPassMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RedeemEventPassMutation,
    RedeemEventPassMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RedeemEventPassMutation,
    RedeemEventPassMutationVariables
  >(RedeemEventPassDocument, options);
}
export type RedeemEventPassMutationHookResult = ReturnType<
  typeof useRedeemEventPassMutation
>;
export type RedeemEventPassMutationResult =
  Apollo.MutationResult<RedeemEventPassMutation>;
export type RedeemEventPassMutationOptions = Apollo.BaseMutationOptions<
  RedeemEventPassMutation,
  RedeemEventPassMutationVariables
>;
export const CreateSubscriptionCheckoutSessionDocument = gql`
  mutation createSubscriptionCheckoutSession(
    $data: CreateSubscriptionCheckoutSessionInput!
  ) {
    createSubscriptionCheckoutSession(data: $data) {
      url
    }
  }
`;
export type CreateSubscriptionCheckoutSessionMutationFn =
  Apollo.MutationFunction<
    CreateSubscriptionCheckoutSessionMutation,
    CreateSubscriptionCheckoutSessionMutationVariables
  >;

/**
 * __useCreateSubscriptionCheckoutSessionMutation__
 *
 * To run a mutation, you first call `useCreateSubscriptionCheckoutSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubscriptionCheckoutSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubscriptionCheckoutSessionMutation, { data, loading, error }] = useCreateSubscriptionCheckoutSessionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateSubscriptionCheckoutSessionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateSubscriptionCheckoutSessionMutation,
    CreateSubscriptionCheckoutSessionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateSubscriptionCheckoutSessionMutation,
    CreateSubscriptionCheckoutSessionMutationVariables
  >(CreateSubscriptionCheckoutSessionDocument, options);
}
export type CreateSubscriptionCheckoutSessionMutationHookResult = ReturnType<
  typeof useCreateSubscriptionCheckoutSessionMutation
>;
export type CreateSubscriptionCheckoutSessionMutationResult =
  Apollo.MutationResult<CreateSubscriptionCheckoutSessionMutation>;
export type CreateSubscriptionCheckoutSessionMutationOptions =
  Apollo.BaseMutationOptions<
    CreateSubscriptionCheckoutSessionMutation,
    CreateSubscriptionCheckoutSessionMutationVariables
  >;
export const GoLiveWithSubscriptionDocument = gql`
  mutation goLiveWithSubscription($eventId: String!) {
    goLiveWithSubscription(eventId: $eventId) {
      ...FullEvent
    }
  }
  ${FullEventFragmentDoc}
`;
export type GoLiveWithSubscriptionMutationFn = Apollo.MutationFunction<
  GoLiveWithSubscriptionMutation,
  GoLiveWithSubscriptionMutationVariables
>;

/**
 * __useGoLiveWithSubscriptionMutation__
 *
 * To run a mutation, you first call `useGoLiveWithSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGoLiveWithSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [goLiveWithSubscriptionMutation, { data, loading, error }] = useGoLiveWithSubscriptionMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGoLiveWithSubscriptionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GoLiveWithSubscriptionMutation,
    GoLiveWithSubscriptionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    GoLiveWithSubscriptionMutation,
    GoLiveWithSubscriptionMutationVariables
  >(GoLiveWithSubscriptionDocument, options);
}
export type GoLiveWithSubscriptionMutationHookResult = ReturnType<
  typeof useGoLiveWithSubscriptionMutation
>;
export type GoLiveWithSubscriptionMutationResult =
  Apollo.MutationResult<GoLiveWithSubscriptionMutation>;
export type GoLiveWithSubscriptionMutationOptions = Apollo.BaseMutationOptions<
  GoLiveWithSubscriptionMutation,
  GoLiveWithSubscriptionMutationVariables
>;
export const EndLiveSessionDocument = gql`
  mutation endLiveSession($eventId: String!) {
    endLiveSession(eventId: $eventId) {
      ...FullEvent
    }
  }
  ${FullEventFragmentDoc}
`;
export type EndLiveSessionMutationFn = Apollo.MutationFunction<
  EndLiveSessionMutation,
  EndLiveSessionMutationVariables
>;

/**
 * __useEndLiveSessionMutation__
 *
 * To run a mutation, you first call `useEndLiveSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEndLiveSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [endLiveSessionMutation, { data, loading, error }] = useEndLiveSessionMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useEndLiveSessionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EndLiveSessionMutation,
    EndLiveSessionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    EndLiveSessionMutation,
    EndLiveSessionMutationVariables
  >(EndLiveSessionDocument, options);
}
export type EndLiveSessionMutationHookResult = ReturnType<
  typeof useEndLiveSessionMutation
>;
export type EndLiveSessionMutationResult =
  Apollo.MutationResult<EndLiveSessionMutation>;
export type EndLiveSessionMutationOptions = Apollo.BaseMutationOptions<
  EndLiveSessionMutation,
  EndLiveSessionMutationVariables
>;
export const CreateScreenTemplateDocument = gql`
  mutation createScreenTemplate($data: ScreenTemplateCreateInput!) {
    createScreenTemplate(data: $data) {
      ...ScreenTemplate
    }
  }
  ${ScreenTemplateFragmentDoc}
`;
export type CreateScreenTemplateMutationFn = Apollo.MutationFunction<
  CreateScreenTemplateMutation,
  CreateScreenTemplateMutationVariables
>;

/**
 * __useCreateScreenTemplateMutation__
 *
 * To run a mutation, you first call `useCreateScreenTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateScreenTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createScreenTemplateMutation, { data, loading, error }] = useCreateScreenTemplateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateScreenTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateScreenTemplateMutation,
    CreateScreenTemplateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateScreenTemplateMutation,
    CreateScreenTemplateMutationVariables
  >(CreateScreenTemplateDocument, options);
}
export type CreateScreenTemplateMutationHookResult = ReturnType<
  typeof useCreateScreenTemplateMutation
>;
export type CreateScreenTemplateMutationResult =
  Apollo.MutationResult<CreateScreenTemplateMutation>;
export type CreateScreenTemplateMutationOptions = Apollo.BaseMutationOptions<
  CreateScreenTemplateMutation,
  CreateScreenTemplateMutationVariables
>;
export const UpdateScreenTemplateDocument = gql`
  mutation updateScreenTemplate(
    $id: String!
    $data: ScreenTemplateUpdateInput!
  ) {
    updateScreenTemplate(id: $id, data: $data) {
      ...ScreenTemplate
    }
  }
  ${ScreenTemplateFragmentDoc}
`;
export type UpdateScreenTemplateMutationFn = Apollo.MutationFunction<
  UpdateScreenTemplateMutation,
  UpdateScreenTemplateMutationVariables
>;

/**
 * __useUpdateScreenTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateScreenTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScreenTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScreenTemplateMutation, { data, loading, error }] = useUpdateScreenTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateScreenTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateScreenTemplateMutation,
    UpdateScreenTemplateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateScreenTemplateMutation,
    UpdateScreenTemplateMutationVariables
  >(UpdateScreenTemplateDocument, options);
}
export type UpdateScreenTemplateMutationHookResult = ReturnType<
  typeof useUpdateScreenTemplateMutation
>;
export type UpdateScreenTemplateMutationResult =
  Apollo.MutationResult<UpdateScreenTemplateMutation>;
export type UpdateScreenTemplateMutationOptions = Apollo.BaseMutationOptions<
  UpdateScreenTemplateMutation,
  UpdateScreenTemplateMutationVariables
>;
export const DeleteScreenTemplateDocument = gql`
  mutation deleteScreenTemplate($id: String!) {
    deleteScreenTemplate(id: $id) {
      id
    }
  }
`;
export type DeleteScreenTemplateMutationFn = Apollo.MutationFunction<
  DeleteScreenTemplateMutation,
  DeleteScreenTemplateMutationVariables
>;

/**
 * __useDeleteScreenTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteScreenTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteScreenTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteScreenTemplateMutation, { data, loading, error }] = useDeleteScreenTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteScreenTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteScreenTemplateMutation,
    DeleteScreenTemplateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteScreenTemplateMutation,
    DeleteScreenTemplateMutationVariables
  >(DeleteScreenTemplateDocument, options);
}
export type DeleteScreenTemplateMutationHookResult = ReturnType<
  typeof useDeleteScreenTemplateMutation
>;
export type DeleteScreenTemplateMutationResult =
  Apollo.MutationResult<DeleteScreenTemplateMutation>;
export type DeleteScreenTemplateMutationOptions = Apollo.BaseMutationOptions<
  DeleteScreenTemplateMutation,
  DeleteScreenTemplateMutationVariables
>;
export const CreateCustomerPortalSessionDocument = gql`
  mutation createCustomerPortalSession {
    createCustomerPortalSession {
      url
    }
  }
`;
export type CreateCustomerPortalSessionMutationFn = Apollo.MutationFunction<
  CreateCustomerPortalSessionMutation,
  CreateCustomerPortalSessionMutationVariables
>;

/**
 * __useCreateCustomerPortalSessionMutation__
 *
 * To run a mutation, you first call `useCreateCustomerPortalSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerPortalSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerPortalSessionMutation, { data, loading, error }] = useCreateCustomerPortalSessionMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateCustomerPortalSessionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCustomerPortalSessionMutation,
    CreateCustomerPortalSessionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateCustomerPortalSessionMutation,
    CreateCustomerPortalSessionMutationVariables
  >(CreateCustomerPortalSessionDocument, options);
}
export type CreateCustomerPortalSessionMutationHookResult = ReturnType<
  typeof useCreateCustomerPortalSessionMutation
>;
export type CreateCustomerPortalSessionMutationResult =
  Apollo.MutationResult<CreateCustomerPortalSessionMutation>;
export type CreateCustomerPortalSessionMutationOptions =
  Apollo.BaseMutationOptions<
    CreateCustomerPortalSessionMutation,
    CreateCustomerPortalSessionMutationVariables
  >;
export const RequestPasswordResetDocument = gql`
  mutation requestPasswordReset($email: String!) {
    requestPasswordReset(email: $email) {
      success
      message
    }
  }
`;
export type RequestPasswordResetMutationFn = Apollo.MutationFunction<
  RequestPasswordResetMutation,
  RequestPasswordResetMutationVariables
>;

/**
 * __useRequestPasswordResetMutation__
 *
 * To run a mutation, you first call `useRequestPasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestPasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestPasswordResetMutation, { data, loading, error }] = useRequestPasswordResetMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useRequestPasswordResetMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RequestPasswordResetMutation,
    RequestPasswordResetMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RequestPasswordResetMutation,
    RequestPasswordResetMutationVariables
  >(RequestPasswordResetDocument, options);
}
export type RequestPasswordResetMutationHookResult = ReturnType<
  typeof useRequestPasswordResetMutation
>;
export type RequestPasswordResetMutationResult =
  Apollo.MutationResult<RequestPasswordResetMutation>;
export type RequestPasswordResetMutationOptions = Apollo.BaseMutationOptions<
  RequestPasswordResetMutation,
  RequestPasswordResetMutationVariables
>;
export const ResetPasswordDocument = gql`
  mutation resetPassword($token: String!, $password: String!) {
    resetPassword(token: $token, password: $password) {
      success
    }
  }
`;
export type ResetPasswordMutationFn = Apollo.MutationFunction<
  ResetPasswordMutation,
  ResetPasswordMutationVariables
>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      token: // value for 'token'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useResetPasswordMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResetPasswordMutation,
    ResetPasswordMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ResetPasswordMutation,
    ResetPasswordMutationVariables
  >(ResetPasswordDocument, options);
}
export type ResetPasswordMutationHookResult = ReturnType<
  typeof useResetPasswordMutation
>;
export type ResetPasswordMutationResult =
  Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<
  ResetPasswordMutation,
  ResetPasswordMutationVariables
>;
export const SetCookieConsentDocument = gql`
  mutation setCookieConsent($preferences: CookiePreferencesInput!) {
    setCookieConsent(preferences: $preferences) {
      user {
        ...User
      }
      success
    }
  }
  ${UserFragmentDoc}
`;
export type SetCookieConsentMutationFn = Apollo.MutationFunction<
  SetCookieConsentMutation,
  SetCookieConsentMutationVariables
>;

/**
 * __useSetCookieConsentMutation__
 *
 * To run a mutation, you first call `useSetCookieConsentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCookieConsentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCookieConsentMutation, { data, loading, error }] = useSetCookieConsentMutation({
 *   variables: {
 *      preferences: // value for 'preferences'
 *   },
 * });
 */
export function useSetCookieConsentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetCookieConsentMutation,
    SetCookieConsentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetCookieConsentMutation,
    SetCookieConsentMutationVariables
  >(SetCookieConsentDocument, options);
}
export type SetCookieConsentMutationHookResult = ReturnType<
  typeof useSetCookieConsentMutation
>;
export type SetCookieConsentMutationResult =
  Apollo.MutationResult<SetCookieConsentMutation>;
export type SetCookieConsentMutationOptions = Apollo.BaseMutationOptions<
  SetCookieConsentMutation,
  SetCookieConsentMutationVariables
>;
export const SignupForBetaDocument = gql`
  mutation signupForBeta($email: String!) {
    signupForBeta(email: $email) {
      success
    }
  }
`;
export type SignupForBetaMutationFn = Apollo.MutationFunction<
  SignupForBetaMutation,
  SignupForBetaMutationVariables
>;

/**
 * __useSignupForBetaMutation__
 *
 * To run a mutation, you first call `useSignupForBetaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignupForBetaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signupForBetaMutation, { data, loading, error }] = useSignupForBetaMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSignupForBetaMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SignupForBetaMutation,
    SignupForBetaMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SignupForBetaMutation,
    SignupForBetaMutationVariables
  >(SignupForBetaDocument, options);
}
export type SignupForBetaMutationHookResult = ReturnType<
  typeof useSignupForBetaMutation
>;
export type SignupForBetaMutationResult =
  Apollo.MutationResult<SignupForBetaMutation>;
export type SignupForBetaMutationOptions = Apollo.BaseMutationOptions<
  SignupForBetaMutation,
  SignupForBetaMutationVariables
>;
export const GetEventsDocument = gql`
  query getEvents {
    events {
      ...FullEvent
    }
  }
  ${FullEventFragmentDoc}
`;

/**
 * __useGetEventsQuery__
 *
 * To run a query within a React component, call `useGetEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEventsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetEventsQuery,
    GetEventsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetEventsQuery, GetEventsQueryVariables>(
    GetEventsDocument,
    options,
  );
}
export function useGetEventsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEventsQuery,
    GetEventsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetEventsQuery, GetEventsQueryVariables>(
    GetEventsDocument,
    options,
  );
}
export function useGetEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetEventsQuery, GetEventsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetEventsQuery, GetEventsQueryVariables>(
    GetEventsDocument,
    options,
  );
}
export type GetEventsQueryHookResult = ReturnType<typeof useGetEventsQuery>;
export type GetEventsLazyQueryHookResult = ReturnType<
  typeof useGetEventsLazyQuery
>;
export type GetEventsSuspenseQueryHookResult = ReturnType<
  typeof useGetEventsSuspenseQuery
>;
export type GetEventsQueryResult = Apollo.QueryResult<
  GetEventsQuery,
  GetEventsQueryVariables
>;
export const GetEventDocument = gql`
  query getEvent($id: String!) {
    event(id: $id) {
      ...FullEvent
    }
  }
  ${FullEventFragmentDoc}
`;

/**
 * __useGetEventQuery__
 *
 * To run a query within a React component, call `useGetEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEventQuery(
  baseOptions: Apollo.QueryHookOptions<GetEventQuery, GetEventQueryVariables> &
    ({ variables: GetEventQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetEventQuery, GetEventQueryVariables>(
    GetEventDocument,
    options,
  );
}
export function useGetEventLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEventQuery,
    GetEventQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetEventQuery, GetEventQueryVariables>(
    GetEventDocument,
    options,
  );
}
export function useGetEventSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetEventQuery, GetEventQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetEventQuery, GetEventQueryVariables>(
    GetEventDocument,
    options,
  );
}
export type GetEventQueryHookResult = ReturnType<typeof useGetEventQuery>;
export type GetEventLazyQueryHookResult = ReturnType<
  typeof useGetEventLazyQuery
>;
export type GetEventSuspenseQueryHookResult = ReturnType<
  typeof useGetEventSuspenseQuery
>;
export type GetEventQueryResult = Apollo.QueryResult<
  GetEventQuery,
  GetEventQueryVariables
>;
export const GetUsersDocument = gql`
  query getUsers($first: Int, $after: String, $filter: UserFilter) {
    users(first: $first, after: $after, filter: $filter) {
      edges {
        node {
          ...FullUser
        }
        cursor
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
  ${FullUserFragmentDoc}
`;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetUsersQuery(
  baseOptions?: Apollo.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUsersQuery, GetUsersQueryVariables>(
    GetUsersDocument,
    options,
  );
}
export function useGetUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUsersQuery,
    GetUsersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(
    GetUsersDocument,
    options,
  );
}
export function useGetUsersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetUsersQuery, GetUsersQueryVariables>(
    GetUsersDocument,
    options,
  );
}
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<
  typeof useGetUsersLazyQuery
>;
export type GetUsersSuspenseQueryHookResult = ReturnType<
  typeof useGetUsersSuspenseQuery
>;
export type GetUsersQueryResult = Apollo.QueryResult<
  GetUsersQuery,
  GetUsersQueryVariables
>;
export const StageGetEventsDocument = gql`
  query stageGetEvents {
    events {
      ...StageEvent
    }
  }
  ${StageEventFragmentDoc}
`;

/**
 * __useStageGetEventsQuery__
 *
 * To run a query within a React component, call `useStageGetEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStageGetEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStageGetEventsQuery({
 *   variables: {
 *   },
 * });
 */
export function useStageGetEventsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    StageGetEventsQuery,
    StageGetEventsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<StageGetEventsQuery, StageGetEventsQueryVariables>(
    StageGetEventsDocument,
    options,
  );
}
export function useStageGetEventsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    StageGetEventsQuery,
    StageGetEventsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<StageGetEventsQuery, StageGetEventsQueryVariables>(
    StageGetEventsDocument,
    options,
  );
}
export function useStageGetEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        StageGetEventsQuery,
        StageGetEventsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    StageGetEventsQuery,
    StageGetEventsQueryVariables
  >(StageGetEventsDocument, options);
}
export type StageGetEventsQueryHookResult = ReturnType<
  typeof useStageGetEventsQuery
>;
export type StageGetEventsLazyQueryHookResult = ReturnType<
  typeof useStageGetEventsLazyQuery
>;
export type StageGetEventsSuspenseQueryHookResult = ReturnType<
  typeof useStageGetEventsSuspenseQuery
>;
export type StageGetEventsQueryResult = Apollo.QueryResult<
  StageGetEventsQuery,
  StageGetEventsQueryVariables
>;
export const GetEngagementDocument = gql`
  query getEngagement($engagementId: String!) {
    engagement(id: $engagementId) {
      ...FullEngagement
    }
  }
  ${FullEngagementFragmentDoc}
`;

/**
 * __useGetEngagementQuery__
 *
 * To run a query within a React component, call `useGetEngagementQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEngagementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEngagementQuery({
 *   variables: {
 *      engagementId: // value for 'engagementId'
 *   },
 * });
 */
export function useGetEngagementQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetEngagementQuery,
    GetEngagementQueryVariables
  > &
    (
      | { variables: GetEngagementQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetEngagementQuery, GetEngagementQueryVariables>(
    GetEngagementDocument,
    options,
  );
}
export function useGetEngagementLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEngagementQuery,
    GetEngagementQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetEngagementQuery, GetEngagementQueryVariables>(
    GetEngagementDocument,
    options,
  );
}
export function useGetEngagementSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEngagementQuery,
        GetEngagementQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetEngagementQuery,
    GetEngagementQueryVariables
  >(GetEngagementDocument, options);
}
export type GetEngagementQueryHookResult = ReturnType<
  typeof useGetEngagementQuery
>;
export type GetEngagementLazyQueryHookResult = ReturnType<
  typeof useGetEngagementLazyQuery
>;
export type GetEngagementSuspenseQueryHookResult = ReturnType<
  typeof useGetEngagementSuspenseQuery
>;
export type GetEngagementQueryResult = Apollo.QueryResult<
  GetEngagementQuery,
  GetEngagementQueryVariables
>;
export const GetStageEngagementDocument = gql`
  query getStageEngagement($engagementId: String!) {
    engagement(id: $engagementId) {
      ...StageEngagement
    }
  }
  ${StageEngagementFragmentDoc}
`;

/**
 * __useGetStageEngagementQuery__
 *
 * To run a query within a React component, call `useGetStageEngagementQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStageEngagementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStageEngagementQuery({
 *   variables: {
 *      engagementId: // value for 'engagementId'
 *   },
 * });
 */
export function useGetStageEngagementQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetStageEngagementQuery,
    GetStageEngagementQueryVariables
  > &
    (
      | { variables: GetStageEngagementQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetStageEngagementQuery,
    GetStageEngagementQueryVariables
  >(GetStageEngagementDocument, options);
}
export function useGetStageEngagementLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetStageEngagementQuery,
    GetStageEngagementQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetStageEngagementQuery,
    GetStageEngagementQueryVariables
  >(GetStageEngagementDocument, options);
}
export function useGetStageEngagementSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetStageEngagementQuery,
        GetStageEngagementQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetStageEngagementQuery,
    GetStageEngagementQueryVariables
  >(GetStageEngagementDocument, options);
}
export type GetStageEngagementQueryHookResult = ReturnType<
  typeof useGetStageEngagementQuery
>;
export type GetStageEngagementLazyQueryHookResult = ReturnType<
  typeof useGetStageEngagementLazyQuery
>;
export type GetStageEngagementSuspenseQueryHookResult = ReturnType<
  typeof useGetStageEngagementSuspenseQuery
>;
export type GetStageEngagementQueryResult = Apollo.QueryResult<
  GetStageEngagementQuery,
  GetStageEngagementQueryVariables
>;
export const GetFanEngagementDocument = gql`
  query getFanEngagement($engagementId: String!) {
    engagement(id: $engagementId) {
      ...FanEngagement
    }
  }
  ${FanEngagementFragmentDoc}
`;

/**
 * __useGetFanEngagementQuery__
 *
 * To run a query within a React component, call `useGetFanEngagementQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFanEngagementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFanEngagementQuery({
 *   variables: {
 *      engagementId: // value for 'engagementId'
 *   },
 * });
 */
export function useGetFanEngagementQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetFanEngagementQuery,
    GetFanEngagementQueryVariables
  > &
    (
      | { variables: GetFanEngagementQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetFanEngagementQuery, GetFanEngagementQueryVariables>(
    GetFanEngagementDocument,
    options,
  );
}
export function useGetFanEngagementLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFanEngagementQuery,
    GetFanEngagementQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetFanEngagementQuery,
    GetFanEngagementQueryVariables
  >(GetFanEngagementDocument, options);
}
export function useGetFanEngagementSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetFanEngagementQuery,
        GetFanEngagementQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetFanEngagementQuery,
    GetFanEngagementQueryVariables
  >(GetFanEngagementDocument, options);
}
export type GetFanEngagementQueryHookResult = ReturnType<
  typeof useGetFanEngagementQuery
>;
export type GetFanEngagementLazyQueryHookResult = ReturnType<
  typeof useGetFanEngagementLazyQuery
>;
export type GetFanEngagementSuspenseQueryHookResult = ReturnType<
  typeof useGetFanEngagementSuspenseQuery
>;
export type GetFanEngagementQueryResult = Apollo.QueryResult<
  GetFanEngagementQuery,
  GetFanEngagementQueryVariables
>;
export const GetEngagementSubmissionsByUserDocument = gql`
  query getEngagementSubmissionsByUser(
    $engagementId: String!
    $userId: String!
  ) {
    engagementSubmissionsByUser(engagementId: $engagementId, userId: $userId) {
      ...FullSubmission
    }
  }
  ${FullSubmissionFragmentDoc}
`;

/**
 * __useGetEngagementSubmissionsByUserQuery__
 *
 * To run a query within a React component, call `useGetEngagementSubmissionsByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEngagementSubmissionsByUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEngagementSubmissionsByUserQuery({
 *   variables: {
 *      engagementId: // value for 'engagementId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetEngagementSubmissionsByUserQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetEngagementSubmissionsByUserQuery,
    GetEngagementSubmissionsByUserQueryVariables
  > &
    (
      | {
          variables: GetEngagementSubmissionsByUserQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetEngagementSubmissionsByUserQuery,
    GetEngagementSubmissionsByUserQueryVariables
  >(GetEngagementSubmissionsByUserDocument, options);
}
export function useGetEngagementSubmissionsByUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEngagementSubmissionsByUserQuery,
    GetEngagementSubmissionsByUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetEngagementSubmissionsByUserQuery,
    GetEngagementSubmissionsByUserQueryVariables
  >(GetEngagementSubmissionsByUserDocument, options);
}
export function useGetEngagementSubmissionsByUserSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEngagementSubmissionsByUserQuery,
        GetEngagementSubmissionsByUserQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetEngagementSubmissionsByUserQuery,
    GetEngagementSubmissionsByUserQueryVariables
  >(GetEngagementSubmissionsByUserDocument, options);
}
export type GetEngagementSubmissionsByUserQueryHookResult = ReturnType<
  typeof useGetEngagementSubmissionsByUserQuery
>;
export type GetEngagementSubmissionsByUserLazyQueryHookResult = ReturnType<
  typeof useGetEngagementSubmissionsByUserLazyQuery
>;
export type GetEngagementSubmissionsByUserSuspenseQueryHookResult = ReturnType<
  typeof useGetEngagementSubmissionsByUserSuspenseQuery
>;
export type GetEngagementSubmissionsByUserQueryResult = Apollo.QueryResult<
  GetEngagementSubmissionsByUserQuery,
  GetEngagementSubmissionsByUserQueryVariables
>;
export const GetSubmissionDocument = gql`
  query getSubmission($submissionId: String!) {
    submission(id: $submissionId) {
      ...FullSubmission
    }
  }
  ${FullSubmissionFragmentDoc}
`;

/**
 * __useGetSubmissionQuery__
 *
 * To run a query within a React component, call `useGetSubmissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubmissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubmissionQuery({
 *   variables: {
 *      submissionId: // value for 'submissionId'
 *   },
 * });
 */
export function useGetSubmissionQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSubmissionQuery,
    GetSubmissionQueryVariables
  > &
    (
      | { variables: GetSubmissionQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSubmissionQuery, GetSubmissionQueryVariables>(
    GetSubmissionDocument,
    options,
  );
}
export function useGetSubmissionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSubmissionQuery,
    GetSubmissionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSubmissionQuery, GetSubmissionQueryVariables>(
    GetSubmissionDocument,
    options,
  );
}
export function useGetSubmissionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetSubmissionQuery,
        GetSubmissionQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetSubmissionQuery,
    GetSubmissionQueryVariables
  >(GetSubmissionDocument, options);
}
export type GetSubmissionQueryHookResult = ReturnType<
  typeof useGetSubmissionQuery
>;
export type GetSubmissionLazyQueryHookResult = ReturnType<
  typeof useGetSubmissionLazyQuery
>;
export type GetSubmissionSuspenseQueryHookResult = ReturnType<
  typeof useGetSubmissionSuspenseQuery
>;
export type GetSubmissionQueryResult = Apollo.QueryResult<
  GetSubmissionQuery,
  GetSubmissionQueryVariables
>;
export const GetSubmissionsDocument = gql`
  query getSubmissions($engagementId: String!) {
    submissions(engagementId: $engagementId) {
      ...FullSubmission
    }
  }
  ${FullSubmissionFragmentDoc}
`;

/**
 * __useGetSubmissionsQuery__
 *
 * To run a query within a React component, call `useGetSubmissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubmissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubmissionsQuery({
 *   variables: {
 *      engagementId: // value for 'engagementId'
 *   },
 * });
 */
export function useGetSubmissionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSubmissionsQuery,
    GetSubmissionsQueryVariables
  > &
    (
      | { variables: GetSubmissionsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSubmissionsQuery, GetSubmissionsQueryVariables>(
    GetSubmissionsDocument,
    options,
  );
}
export function useGetSubmissionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSubmissionsQuery,
    GetSubmissionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSubmissionsQuery, GetSubmissionsQueryVariables>(
    GetSubmissionsDocument,
    options,
  );
}
export function useGetSubmissionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetSubmissionsQuery,
        GetSubmissionsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetSubmissionsQuery,
    GetSubmissionsQueryVariables
  >(GetSubmissionsDocument, options);
}
export type GetSubmissionsQueryHookResult = ReturnType<
  typeof useGetSubmissionsQuery
>;
export type GetSubmissionsLazyQueryHookResult = ReturnType<
  typeof useGetSubmissionsLazyQuery
>;
export type GetSubmissionsSuspenseQueryHookResult = ReturnType<
  typeof useGetSubmissionsSuspenseQuery
>;
export type GetSubmissionsQueryResult = Apollo.QueryResult<
  GetSubmissionsQuery,
  GetSubmissionsQueryVariables
>;
export const ValidateGoogleFontDocument = gql`
  query validateGoogleFont($fontName: String!) {
    validateGoogleFont(fontName: $fontName)
  }
`;

/**
 * __useValidateGoogleFontQuery__
 *
 * To run a query within a React component, call `useValidateGoogleFontQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateGoogleFontQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateGoogleFontQuery({
 *   variables: {
 *      fontName: // value for 'fontName'
 *   },
 * });
 */
export function useValidateGoogleFontQuery(
  baseOptions: Apollo.QueryHookOptions<
    ValidateGoogleFontQuery,
    ValidateGoogleFontQueryVariables
  > &
    (
      | { variables: ValidateGoogleFontQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ValidateGoogleFontQuery,
    ValidateGoogleFontQueryVariables
  >(ValidateGoogleFontDocument, options);
}
export function useValidateGoogleFontLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ValidateGoogleFontQuery,
    ValidateGoogleFontQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ValidateGoogleFontQuery,
    ValidateGoogleFontQueryVariables
  >(ValidateGoogleFontDocument, options);
}
export function useValidateGoogleFontSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ValidateGoogleFontQuery,
        ValidateGoogleFontQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ValidateGoogleFontQuery,
    ValidateGoogleFontQueryVariables
  >(ValidateGoogleFontDocument, options);
}
export type ValidateGoogleFontQueryHookResult = ReturnType<
  typeof useValidateGoogleFontQuery
>;
export type ValidateGoogleFontLazyQueryHookResult = ReturnType<
  typeof useValidateGoogleFontLazyQuery
>;
export type ValidateGoogleFontSuspenseQueryHookResult = ReturnType<
  typeof useValidateGoogleFontSuspenseQuery
>;
export type ValidateGoogleFontQueryResult = Apollo.QueryResult<
  ValidateGoogleFontQuery,
  ValidateGoogleFontQueryVariables
>;
export const StageGetActiveEngagementDocument = gql`
  query stageGetActiveEngagement($eventId: String!) {
    activeEventEngagement(eventId: $eventId) {
      ...StageEngagement
    }
  }
  ${StageEngagementFragmentDoc}
`;

/**
 * __useStageGetActiveEngagementQuery__
 *
 * To run a query within a React component, call `useStageGetActiveEngagementQuery` and pass it any options that fit your needs.
 * When your component renders, `useStageGetActiveEngagementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStageGetActiveEngagementQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useStageGetActiveEngagementQuery(
  baseOptions: Apollo.QueryHookOptions<
    StageGetActiveEngagementQuery,
    StageGetActiveEngagementQueryVariables
  > &
    (
      | { variables: StageGetActiveEngagementQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    StageGetActiveEngagementQuery,
    StageGetActiveEngagementQueryVariables
  >(StageGetActiveEngagementDocument, options);
}
export function useStageGetActiveEngagementLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    StageGetActiveEngagementQuery,
    StageGetActiveEngagementQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    StageGetActiveEngagementQuery,
    StageGetActiveEngagementQueryVariables
  >(StageGetActiveEngagementDocument, options);
}
export function useStageGetActiveEngagementSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        StageGetActiveEngagementQuery,
        StageGetActiveEngagementQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    StageGetActiveEngagementQuery,
    StageGetActiveEngagementQueryVariables
  >(StageGetActiveEngagementDocument, options);
}
export type StageGetActiveEngagementQueryHookResult = ReturnType<
  typeof useStageGetActiveEngagementQuery
>;
export type StageGetActiveEngagementLazyQueryHookResult = ReturnType<
  typeof useStageGetActiveEngagementLazyQuery
>;
export type StageGetActiveEngagementSuspenseQueryHookResult = ReturnType<
  typeof useStageGetActiveEngagementSuspenseQuery
>;
export type StageGetActiveEngagementQueryResult = Apollo.QueryResult<
  StageGetActiveEngagementQuery,
  StageGetActiveEngagementQueryVariables
>;
export const FanGetSubmissionsDocument = gql`
  query fanGetSubmissions($engagementId: String!) {
    submissions(engagementId: $engagementId) {
      ...FanSubmission
    }
  }
  ${FanSubmissionFragmentDoc}
`;

/**
 * __useFanGetSubmissionsQuery__
 *
 * To run a query within a React component, call `useFanGetSubmissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFanGetSubmissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFanGetSubmissionsQuery({
 *   variables: {
 *      engagementId: // value for 'engagementId'
 *   },
 * });
 */
export function useFanGetSubmissionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    FanGetSubmissionsQuery,
    FanGetSubmissionsQueryVariables
  > &
    (
      | { variables: FanGetSubmissionsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    FanGetSubmissionsQuery,
    FanGetSubmissionsQueryVariables
  >(FanGetSubmissionsDocument, options);
}
export function useFanGetSubmissionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FanGetSubmissionsQuery,
    FanGetSubmissionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FanGetSubmissionsQuery,
    FanGetSubmissionsQueryVariables
  >(FanGetSubmissionsDocument, options);
}
export function useFanGetSubmissionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FanGetSubmissionsQuery,
        FanGetSubmissionsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    FanGetSubmissionsQuery,
    FanGetSubmissionsQueryVariables
  >(FanGetSubmissionsDocument, options);
}
export type FanGetSubmissionsQueryHookResult = ReturnType<
  typeof useFanGetSubmissionsQuery
>;
export type FanGetSubmissionsLazyQueryHookResult = ReturnType<
  typeof useFanGetSubmissionsLazyQuery
>;
export type FanGetSubmissionsSuspenseQueryHookResult = ReturnType<
  typeof useFanGetSubmissionsSuspenseQuery
>;
export type FanGetSubmissionsQueryResult = Apollo.QueryResult<
  FanGetSubmissionsQuery,
  FanGetSubmissionsQueryVariables
>;
export const FanGetSubmissionDocument = gql`
  query fanGetSubmission($submissionId: String!) {
    submission(id: $submissionId) {
      ...FanSubmission
    }
  }
  ${FanSubmissionFragmentDoc}
`;

/**
 * __useFanGetSubmissionQuery__
 *
 * To run a query within a React component, call `useFanGetSubmissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useFanGetSubmissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFanGetSubmissionQuery({
 *   variables: {
 *      submissionId: // value for 'submissionId'
 *   },
 * });
 */
export function useFanGetSubmissionQuery(
  baseOptions: Apollo.QueryHookOptions<
    FanGetSubmissionQuery,
    FanGetSubmissionQueryVariables
  > &
    (
      | { variables: FanGetSubmissionQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<FanGetSubmissionQuery, FanGetSubmissionQueryVariables>(
    FanGetSubmissionDocument,
    options,
  );
}
export function useFanGetSubmissionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FanGetSubmissionQuery,
    FanGetSubmissionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FanGetSubmissionQuery,
    FanGetSubmissionQueryVariables
  >(FanGetSubmissionDocument, options);
}
export function useFanGetSubmissionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FanGetSubmissionQuery,
        FanGetSubmissionQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    FanGetSubmissionQuery,
    FanGetSubmissionQueryVariables
  >(FanGetSubmissionDocument, options);
}
export type FanGetSubmissionQueryHookResult = ReturnType<
  typeof useFanGetSubmissionQuery
>;
export type FanGetSubmissionLazyQueryHookResult = ReturnType<
  typeof useFanGetSubmissionLazyQuery
>;
export type FanGetSubmissionSuspenseQueryHookResult = ReturnType<
  typeof useFanGetSubmissionSuspenseQuery
>;
export type FanGetSubmissionQueryResult = Apollo.QueryResult<
  FanGetSubmissionQuery,
  FanGetSubmissionQueryVariables
>;
export const FanGetEngagementReactionsDocument = gql`
  query fanGetEngagementReactions($engagementId: String!) {
    engagementReactions(engagementId: $engagementId) {
      ...FanReaction
    }
  }
  ${FanReactionFragmentDoc}
`;

/**
 * __useFanGetEngagementReactionsQuery__
 *
 * To run a query within a React component, call `useFanGetEngagementReactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFanGetEngagementReactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFanGetEngagementReactionsQuery({
 *   variables: {
 *      engagementId: // value for 'engagementId'
 *   },
 * });
 */
export function useFanGetEngagementReactionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    FanGetEngagementReactionsQuery,
    FanGetEngagementReactionsQueryVariables
  > &
    (
      | { variables: FanGetEngagementReactionsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    FanGetEngagementReactionsQuery,
    FanGetEngagementReactionsQueryVariables
  >(FanGetEngagementReactionsDocument, options);
}
export function useFanGetEngagementReactionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FanGetEngagementReactionsQuery,
    FanGetEngagementReactionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FanGetEngagementReactionsQuery,
    FanGetEngagementReactionsQueryVariables
  >(FanGetEngagementReactionsDocument, options);
}
export function useFanGetEngagementReactionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FanGetEngagementReactionsQuery,
        FanGetEngagementReactionsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    FanGetEngagementReactionsQuery,
    FanGetEngagementReactionsQueryVariables
  >(FanGetEngagementReactionsDocument, options);
}
export type FanGetEngagementReactionsQueryHookResult = ReturnType<
  typeof useFanGetEngagementReactionsQuery
>;
export type FanGetEngagementReactionsLazyQueryHookResult = ReturnType<
  typeof useFanGetEngagementReactionsLazyQuery
>;
export type FanGetEngagementReactionsSuspenseQueryHookResult = ReturnType<
  typeof useFanGetEngagementReactionsSuspenseQuery
>;
export type FanGetEngagementReactionsQueryResult = Apollo.QueryResult<
  FanGetEngagementReactionsQuery,
  FanGetEngagementReactionsQueryVariables
>;
export const CanCreateSubmissionDocument = gql`
  query canCreateSubmission(
    $engagementId: String!
    $deviceId: String
    $visitorId: String
  ) {
    canCreateSubmission(
      engagementId: $engagementId
      deviceId: $deviceId
      visitorId: $visitorId
    )
  }
`;

/**
 * __useCanCreateSubmissionQuery__
 *
 * To run a query within a React component, call `useCanCreateSubmissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCanCreateSubmissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCanCreateSubmissionQuery({
 *   variables: {
 *      engagementId: // value for 'engagementId'
 *      deviceId: // value for 'deviceId'
 *      visitorId: // value for 'visitorId'
 *   },
 * });
 */
export function useCanCreateSubmissionQuery(
  baseOptions: Apollo.QueryHookOptions<
    CanCreateSubmissionQuery,
    CanCreateSubmissionQueryVariables
  > &
    (
      | { variables: CanCreateSubmissionQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CanCreateSubmissionQuery,
    CanCreateSubmissionQueryVariables
  >(CanCreateSubmissionDocument, options);
}
export function useCanCreateSubmissionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CanCreateSubmissionQuery,
    CanCreateSubmissionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CanCreateSubmissionQuery,
    CanCreateSubmissionQueryVariables
  >(CanCreateSubmissionDocument, options);
}
export function useCanCreateSubmissionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CanCreateSubmissionQuery,
        CanCreateSubmissionQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CanCreateSubmissionQuery,
    CanCreateSubmissionQueryVariables
  >(CanCreateSubmissionDocument, options);
}
export type CanCreateSubmissionQueryHookResult = ReturnType<
  typeof useCanCreateSubmissionQuery
>;
export type CanCreateSubmissionLazyQueryHookResult = ReturnType<
  typeof useCanCreateSubmissionLazyQuery
>;
export type CanCreateSubmissionSuspenseQueryHookResult = ReturnType<
  typeof useCanCreateSubmissionSuspenseQuery
>;
export type CanCreateSubmissionQueryResult = Apollo.QueryResult<
  CanCreateSubmissionQuery,
  CanCreateSubmissionQueryVariables
>;
export const DeviceAccessDocument = gql`
  query deviceAccess(
    $engagementId: String!
    $deviceId: String
    $visitorId: String
  ) {
    deviceAccess(
      engagementId: $engagementId
      deviceId: $deviceId
      visitorId: $visitorId
    ) {
      allowed
      message
    }
  }
`;

/**
 * __useDeviceAccessQuery__
 *
 * To run a query within a React component, call `useDeviceAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeviceAccessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeviceAccessQuery({
 *   variables: {
 *      engagementId: // value for 'engagementId'
 *      deviceId: // value for 'deviceId'
 *      visitorId: // value for 'visitorId'
 *   },
 * });
 */
export function useDeviceAccessQuery(
  baseOptions: Apollo.QueryHookOptions<
    DeviceAccessQuery,
    DeviceAccessQueryVariables
  > &
    (
      | { variables: DeviceAccessQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DeviceAccessQuery, DeviceAccessQueryVariables>(
    DeviceAccessDocument,
    options,
  );
}
export function useDeviceAccessLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DeviceAccessQuery,
    DeviceAccessQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<DeviceAccessQuery, DeviceAccessQueryVariables>(
    DeviceAccessDocument,
    options,
  );
}
export function useDeviceAccessSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DeviceAccessQuery,
        DeviceAccessQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<DeviceAccessQuery, DeviceAccessQueryVariables>(
    DeviceAccessDocument,
    options,
  );
}
export type DeviceAccessQueryHookResult = ReturnType<
  typeof useDeviceAccessQuery
>;
export type DeviceAccessLazyQueryHookResult = ReturnType<
  typeof useDeviceAccessLazyQuery
>;
export type DeviceAccessSuspenseQueryHookResult = ReturnType<
  typeof useDeviceAccessSuspenseQuery
>;
export type DeviceAccessQueryResult = Apollo.QueryResult<
  DeviceAccessQuery,
  DeviceAccessQueryVariables
>;
export const GetBansDocument = gql`
  query getBans($eventId: String!) {
    bans(eventId: $eventId) {
      ...BanFields
    }
    banCount(eventId: $eventId)
  }
  ${BanFieldsFragmentDoc}
`;

/**
 * __useGetBansQuery__
 *
 * To run a query within a React component, call `useGetBansQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBansQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetBansQuery(
  baseOptions: Apollo.QueryHookOptions<GetBansQuery, GetBansQueryVariables> &
    ({ variables: GetBansQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetBansQuery, GetBansQueryVariables>(
    GetBansDocument,
    options,
  );
}
export function useGetBansLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetBansQuery,
    GetBansQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetBansQuery, GetBansQueryVariables>(
    GetBansDocument,
    options,
  );
}
export function useGetBansSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetBansQuery, GetBansQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetBansQuery, GetBansQueryVariables>(
    GetBansDocument,
    options,
  );
}
export type GetBansQueryHookResult = ReturnType<typeof useGetBansQuery>;
export type GetBansLazyQueryHookResult = ReturnType<typeof useGetBansLazyQuery>;
export type GetBansSuspenseQueryHookResult = ReturnType<
  typeof useGetBansSuspenseQuery
>;
export type GetBansQueryResult = Apollo.QueryResult<
  GetBansQuery,
  GetBansQueryVariables
>;
export const StageGetSubmissionsDocument = gql`
  query stageGetSubmissions($engagementId: String!) {
    submissions(engagementId: $engagementId) {
      ...StageSubmission
    }
  }
  ${StageSubmissionFragmentDoc}
`;

/**
 * __useStageGetSubmissionsQuery__
 *
 * To run a query within a React component, call `useStageGetSubmissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStageGetSubmissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStageGetSubmissionsQuery({
 *   variables: {
 *      engagementId: // value for 'engagementId'
 *   },
 * });
 */
export function useStageGetSubmissionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    StageGetSubmissionsQuery,
    StageGetSubmissionsQueryVariables
  > &
    (
      | { variables: StageGetSubmissionsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    StageGetSubmissionsQuery,
    StageGetSubmissionsQueryVariables
  >(StageGetSubmissionsDocument, options);
}
export function useStageGetSubmissionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    StageGetSubmissionsQuery,
    StageGetSubmissionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    StageGetSubmissionsQuery,
    StageGetSubmissionsQueryVariables
  >(StageGetSubmissionsDocument, options);
}
export function useStageGetSubmissionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        StageGetSubmissionsQuery,
        StageGetSubmissionsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    StageGetSubmissionsQuery,
    StageGetSubmissionsQueryVariables
  >(StageGetSubmissionsDocument, options);
}
export type StageGetSubmissionsQueryHookResult = ReturnType<
  typeof useStageGetSubmissionsQuery
>;
export type StageGetSubmissionsLazyQueryHookResult = ReturnType<
  typeof useStageGetSubmissionsLazyQuery
>;
export type StageGetSubmissionsSuspenseQueryHookResult = ReturnType<
  typeof useStageGetSubmissionsSuspenseQuery
>;
export type StageGetSubmissionsQueryResult = Apollo.QueryResult<
  StageGetSubmissionsQuery,
  StageGetSubmissionsQueryVariables
>;
export const StageGetSubmissionDocument = gql`
  query stageGetSubmission($id: String!) {
    submission(id: $id) {
      ...StageSubmission
    }
  }
  ${StageSubmissionFragmentDoc}
`;

/**
 * __useStageGetSubmissionQuery__
 *
 * To run a query within a React component, call `useStageGetSubmissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useStageGetSubmissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStageGetSubmissionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStageGetSubmissionQuery(
  baseOptions: Apollo.QueryHookOptions<
    StageGetSubmissionQuery,
    StageGetSubmissionQueryVariables
  > &
    (
      | { variables: StageGetSubmissionQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    StageGetSubmissionQuery,
    StageGetSubmissionQueryVariables
  >(StageGetSubmissionDocument, options);
}
export function useStageGetSubmissionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    StageGetSubmissionQuery,
    StageGetSubmissionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    StageGetSubmissionQuery,
    StageGetSubmissionQueryVariables
  >(StageGetSubmissionDocument, options);
}
export function useStageGetSubmissionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        StageGetSubmissionQuery,
        StageGetSubmissionQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    StageGetSubmissionQuery,
    StageGetSubmissionQueryVariables
  >(StageGetSubmissionDocument, options);
}
export type StageGetSubmissionQueryHookResult = ReturnType<
  typeof useStageGetSubmissionQuery
>;
export type StageGetSubmissionLazyQueryHookResult = ReturnType<
  typeof useStageGetSubmissionLazyQuery
>;
export type StageGetSubmissionSuspenseQueryHookResult = ReturnType<
  typeof useStageGetSubmissionSuspenseQuery
>;
export type StageGetSubmissionQueryResult = Apollo.QueryResult<
  StageGetSubmissionQuery,
  StageGetSubmissionQueryVariables
>;
export const GetEngagementsDocument = gql`
  query getEngagements($eventId: String!) {
    engagements(eventId: $eventId) {
      ...FullEngagement
    }
  }
  ${FullEngagementFragmentDoc}
`;

/**
 * __useGetEngagementsQuery__
 *
 * To run a query within a React component, call `useGetEngagementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEngagementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEngagementsQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetEngagementsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetEngagementsQuery,
    GetEngagementsQueryVariables
  > &
    (
      | { variables: GetEngagementsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetEngagementsQuery, GetEngagementsQueryVariables>(
    GetEngagementsDocument,
    options,
  );
}
export function useGetEngagementsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEngagementsQuery,
    GetEngagementsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetEngagementsQuery, GetEngagementsQueryVariables>(
    GetEngagementsDocument,
    options,
  );
}
export function useGetEngagementsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEngagementsQuery,
        GetEngagementsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetEngagementsQuery,
    GetEngagementsQueryVariables
  >(GetEngagementsDocument, options);
}
export type GetEngagementsQueryHookResult = ReturnType<
  typeof useGetEngagementsQuery
>;
export type GetEngagementsLazyQueryHookResult = ReturnType<
  typeof useGetEngagementsLazyQuery
>;
export type GetEngagementsSuspenseQueryHookResult = ReturnType<
  typeof useGetEngagementsSuspenseQuery
>;
export type GetEngagementsQueryResult = Apollo.QueryResult<
  GetEngagementsQuery,
  GetEngagementsQueryVariables
>;
export const FanGetEventDocument = gql`
  query fanGetEvent($id: String!) {
    event(id: $id) {
      ...FanEvent
    }
  }
  ${FanEventFragmentDoc}
`;

/**
 * __useFanGetEventQuery__
 *
 * To run a query within a React component, call `useFanGetEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useFanGetEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFanGetEventQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFanGetEventQuery(
  baseOptions: Apollo.QueryHookOptions<
    FanGetEventQuery,
    FanGetEventQueryVariables
  > &
    (
      | { variables: FanGetEventQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<FanGetEventQuery, FanGetEventQueryVariables>(
    FanGetEventDocument,
    options,
  );
}
export function useFanGetEventLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FanGetEventQuery,
    FanGetEventQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<FanGetEventQuery, FanGetEventQueryVariables>(
    FanGetEventDocument,
    options,
  );
}
export function useFanGetEventSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FanGetEventQuery,
        FanGetEventQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<FanGetEventQuery, FanGetEventQueryVariables>(
    FanGetEventDocument,
    options,
  );
}
export type FanGetEventQueryHookResult = ReturnType<typeof useFanGetEventQuery>;
export type FanGetEventLazyQueryHookResult = ReturnType<
  typeof useFanGetEventLazyQuery
>;
export type FanGetEventSuspenseQueryHookResult = ReturnType<
  typeof useFanGetEventSuspenseQuery
>;
export type FanGetEventQueryResult = Apollo.QueryResult<
  FanGetEventQuery,
  FanGetEventQueryVariables
>;
export const StageGetEventDocument = gql`
  query stageGetEvent($id: String!) {
    event(id: $id) {
      ...StageEvent
    }
  }
  ${StageEventFragmentDoc}
`;

/**
 * __useStageGetEventQuery__
 *
 * To run a query within a React component, call `useStageGetEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useStageGetEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStageGetEventQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStageGetEventQuery(
  baseOptions: Apollo.QueryHookOptions<
    StageGetEventQuery,
    StageGetEventQueryVariables
  > &
    (
      | { variables: StageGetEventQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<StageGetEventQuery, StageGetEventQueryVariables>(
    StageGetEventDocument,
    options,
  );
}
export function useStageGetEventLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    StageGetEventQuery,
    StageGetEventQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<StageGetEventQuery, StageGetEventQueryVariables>(
    StageGetEventDocument,
    options,
  );
}
export function useStageGetEventSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        StageGetEventQuery,
        StageGetEventQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    StageGetEventQuery,
    StageGetEventQueryVariables
  >(StageGetEventDocument, options);
}
export type StageGetEventQueryHookResult = ReturnType<
  typeof useStageGetEventQuery
>;
export type StageGetEventLazyQueryHookResult = ReturnType<
  typeof useStageGetEventLazyQuery
>;
export type StageGetEventSuspenseQueryHookResult = ReturnType<
  typeof useStageGetEventSuspenseQuery
>;
export type StageGetEventQueryResult = Apollo.QueryResult<
  StageGetEventQuery,
  StageGetEventQueryVariables
>;
export const RandomNameDocument = gql`
  query randomName {
    randomName
  }
`;

/**
 * __useRandomNameQuery__
 *
 * To run a query within a React component, call `useRandomNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useRandomNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRandomNameQuery({
 *   variables: {
 *   },
 * });
 */
export function useRandomNameQuery(
  baseOptions?: Apollo.QueryHookOptions<
    RandomNameQuery,
    RandomNameQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RandomNameQuery, RandomNameQueryVariables>(
    RandomNameDocument,
    options,
  );
}
export function useRandomNameLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RandomNameQuery,
    RandomNameQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RandomNameQuery, RandomNameQueryVariables>(
    RandomNameDocument,
    options,
  );
}
export function useRandomNameSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RandomNameQuery,
        RandomNameQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<RandomNameQuery, RandomNameQueryVariables>(
    RandomNameDocument,
    options,
  );
}
export type RandomNameQueryHookResult = ReturnType<typeof useRandomNameQuery>;
export type RandomNameLazyQueryHookResult = ReturnType<
  typeof useRandomNameLazyQuery
>;
export type RandomNameSuspenseQueryHookResult = ReturnType<
  typeof useRandomNameSuspenseQuery
>;
export type RandomNameQueryResult = Apollo.QueryResult<
  RandomNameQuery,
  RandomNameQueryVariables
>;
export const WhoamiDocument = gql`
  query whoami {
    whoami {
      id
      name
      username
      lastLogin
      email
      role
      createdAt
      cookieConsent {
        ...CookiePreferences
      }
    }
  }
  ${CookiePreferencesFragmentDoc}
`;

/**
 * __useWhoamiQuery__
 *
 * To run a query within a React component, call `useWhoamiQuery` and pass it any options that fit your needs.
 * When your component renders, `useWhoamiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWhoamiQuery({
 *   variables: {
 *   },
 * });
 */
export function useWhoamiQuery(
  baseOptions?: Apollo.QueryHookOptions<WhoamiQuery, WhoamiQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<WhoamiQuery, WhoamiQueryVariables>(
    WhoamiDocument,
    options,
  );
}
export function useWhoamiLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<WhoamiQuery, WhoamiQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<WhoamiQuery, WhoamiQueryVariables>(
    WhoamiDocument,
    options,
  );
}
export function useWhoamiSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<WhoamiQuery, WhoamiQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<WhoamiQuery, WhoamiQueryVariables>(
    WhoamiDocument,
    options,
  );
}
export type WhoamiQueryHookResult = ReturnType<typeof useWhoamiQuery>;
export type WhoamiLazyQueryHookResult = ReturnType<typeof useWhoamiLazyQuery>;
export type WhoamiSuspenseQueryHookResult = ReturnType<
  typeof useWhoamiSuspenseQuery
>;
export type WhoamiQueryResult = Apollo.QueryResult<
  WhoamiQuery,
  WhoamiQueryVariables
>;
export const GetFullAccountInfoDocument = gql`
  query getFullAccountInfo {
    whoami {
      ...FullUser
    }
    mySubscription {
      ...PaymentSubscription
    }
    myEventPasses {
      ...EventPass
    }
  }
  ${FullUserFragmentDoc}
  ${PaymentSubscriptionFragmentDoc}
  ${EventPassFragmentDoc}
`;

/**
 * __useGetFullAccountInfoQuery__
 *
 * To run a query within a React component, call `useGetFullAccountInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFullAccountInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFullAccountInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFullAccountInfoQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetFullAccountInfoQuery,
    GetFullAccountInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetFullAccountInfoQuery,
    GetFullAccountInfoQueryVariables
  >(GetFullAccountInfoDocument, options);
}
export function useGetFullAccountInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFullAccountInfoQuery,
    GetFullAccountInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetFullAccountInfoQuery,
    GetFullAccountInfoQueryVariables
  >(GetFullAccountInfoDocument, options);
}
export function useGetFullAccountInfoSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetFullAccountInfoQuery,
        GetFullAccountInfoQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetFullAccountInfoQuery,
    GetFullAccountInfoQueryVariables
  >(GetFullAccountInfoDocument, options);
}
export type GetFullAccountInfoQueryHookResult = ReturnType<
  typeof useGetFullAccountInfoQuery
>;
export type GetFullAccountInfoLazyQueryHookResult = ReturnType<
  typeof useGetFullAccountInfoLazyQuery
>;
export type GetFullAccountInfoSuspenseQueryHookResult = ReturnType<
  typeof useGetFullAccountInfoSuspenseQuery
>;
export type GetFullAccountInfoQueryResult = Apollo.QueryResult<
  GetFullAccountInfoQuery,
  GetFullAccountInfoQueryVariables
>;
export const CanMakeEventLiveDocument = gql`
  query canMakeEventLive($eventId: String!) {
    canMakeEventLive(eventId: $eventId) {
      withEventPass
      withSubscription
      liveCount
    }
  }
`;

/**
 * __useCanMakeEventLiveQuery__
 *
 * To run a query within a React component, call `useCanMakeEventLiveQuery` and pass it any options that fit your needs.
 * When your component renders, `useCanMakeEventLiveQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCanMakeEventLiveQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useCanMakeEventLiveQuery(
  baseOptions: Apollo.QueryHookOptions<
    CanMakeEventLiveQuery,
    CanMakeEventLiveQueryVariables
  > &
    (
      | { variables: CanMakeEventLiveQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CanMakeEventLiveQuery, CanMakeEventLiveQueryVariables>(
    CanMakeEventLiveDocument,
    options,
  );
}
export function useCanMakeEventLiveLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CanMakeEventLiveQuery,
    CanMakeEventLiveQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CanMakeEventLiveQuery,
    CanMakeEventLiveQueryVariables
  >(CanMakeEventLiveDocument, options);
}
export function useCanMakeEventLiveSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CanMakeEventLiveQuery,
        CanMakeEventLiveQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CanMakeEventLiveQuery,
    CanMakeEventLiveQueryVariables
  >(CanMakeEventLiveDocument, options);
}
export type CanMakeEventLiveQueryHookResult = ReturnType<
  typeof useCanMakeEventLiveQuery
>;
export type CanMakeEventLiveLazyQueryHookResult = ReturnType<
  typeof useCanMakeEventLiveLazyQuery
>;
export type CanMakeEventLiveSuspenseQueryHookResult = ReturnType<
  typeof useCanMakeEventLiveSuspenseQuery
>;
export type CanMakeEventLiveQueryResult = Apollo.QueryResult<
  CanMakeEventLiveQuery,
  CanMakeEventLiveQueryVariables
>;
export const MyPurchasesDocument = gql`
  query myPurchases {
    mySubscription {
      ...PaymentSubscription
    }
    myEventPasses {
      ...EventPass
    }
    pricing {
      eventPass
      subscription
    }
  }
  ${PaymentSubscriptionFragmentDoc}
  ${EventPassFragmentDoc}
`;

/**
 * __useMyPurchasesQuery__
 *
 * To run a query within a React component, call `useMyPurchasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyPurchasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyPurchasesQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyPurchasesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    MyPurchasesQuery,
    MyPurchasesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MyPurchasesQuery, MyPurchasesQueryVariables>(
    MyPurchasesDocument,
    options,
  );
}
export function useMyPurchasesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MyPurchasesQuery,
    MyPurchasesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MyPurchasesQuery, MyPurchasesQueryVariables>(
    MyPurchasesDocument,
    options,
  );
}
export function useMyPurchasesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MyPurchasesQuery,
        MyPurchasesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<MyPurchasesQuery, MyPurchasesQueryVariables>(
    MyPurchasesDocument,
    options,
  );
}
export type MyPurchasesQueryHookResult = ReturnType<typeof useMyPurchasesQuery>;
export type MyPurchasesLazyQueryHookResult = ReturnType<
  typeof useMyPurchasesLazyQuery
>;
export type MyPurchasesSuspenseQueryHookResult = ReturnType<
  typeof useMyPurchasesSuspenseQuery
>;
export type MyPurchasesQueryResult = Apollo.QueryResult<
  MyPurchasesQuery,
  MyPurchasesQueryVariables
>;
export const GetScreenTemplatesDocument = gql`
  query getScreenTemplates($search: String) {
    screenTemplates(search: $search) {
      ...ScreenTemplate
    }
  }
  ${ScreenTemplateFragmentDoc}
`;

/**
 * __useGetScreenTemplatesQuery__
 *
 * To run a query within a React component, call `useGetScreenTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScreenTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScreenTemplatesQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetScreenTemplatesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetScreenTemplatesQuery,
    GetScreenTemplatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetScreenTemplatesQuery,
    GetScreenTemplatesQueryVariables
  >(GetScreenTemplatesDocument, options);
}
export function useGetScreenTemplatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetScreenTemplatesQuery,
    GetScreenTemplatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetScreenTemplatesQuery,
    GetScreenTemplatesQueryVariables
  >(GetScreenTemplatesDocument, options);
}
export function useGetScreenTemplatesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetScreenTemplatesQuery,
        GetScreenTemplatesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetScreenTemplatesQuery,
    GetScreenTemplatesQueryVariables
  >(GetScreenTemplatesDocument, options);
}
export type GetScreenTemplatesQueryHookResult = ReturnType<
  typeof useGetScreenTemplatesQuery
>;
export type GetScreenTemplatesLazyQueryHookResult = ReturnType<
  typeof useGetScreenTemplatesLazyQuery
>;
export type GetScreenTemplatesSuspenseQueryHookResult = ReturnType<
  typeof useGetScreenTemplatesSuspenseQuery
>;
export type GetScreenTemplatesQueryResult = Apollo.QueryResult<
  GetScreenTemplatesQuery,
  GetScreenTemplatesQueryVariables
>;
export const GetPricingDocument = gql`
  query getPricing {
    pricing {
      eventPass
      subscription
    }
  }
`;

/**
 * __useGetPricingQuery__
 *
 * To run a query within a React component, call `useGetPricingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPricingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPricingQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPricingQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetPricingQuery,
    GetPricingQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPricingQuery, GetPricingQueryVariables>(
    GetPricingDocument,
    options,
  );
}
export function useGetPricingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPricingQuery,
    GetPricingQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPricingQuery, GetPricingQueryVariables>(
    GetPricingDocument,
    options,
  );
}
export function useGetPricingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPricingQuery,
        GetPricingQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetPricingQuery, GetPricingQueryVariables>(
    GetPricingDocument,
    options,
  );
}
export type GetPricingQueryHookResult = ReturnType<typeof useGetPricingQuery>;
export type GetPricingLazyQueryHookResult = ReturnType<
  typeof useGetPricingLazyQuery
>;
export type GetPricingSuspenseQueryHookResult = ReturnType<
  typeof useGetPricingSuspenseQuery
>;
export type GetPricingQueryResult = Apollo.QueryResult<
  GetPricingQuery,
  GetPricingQueryVariables
>;
export const GetPrivacyPolicyDocument = gql`
  query getPrivacyPolicy {
    privacyPolicy
  }
`;

/**
 * __useGetPrivacyPolicyQuery__
 *
 * To run a query within a React component, call `useGetPrivacyPolicyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPrivacyPolicyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPrivacyPolicyQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPrivacyPolicyQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetPrivacyPolicyQuery,
    GetPrivacyPolicyQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPrivacyPolicyQuery, GetPrivacyPolicyQueryVariables>(
    GetPrivacyPolicyDocument,
    options,
  );
}
export function useGetPrivacyPolicyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPrivacyPolicyQuery,
    GetPrivacyPolicyQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPrivacyPolicyQuery,
    GetPrivacyPolicyQueryVariables
  >(GetPrivacyPolicyDocument, options);
}
export function useGetPrivacyPolicySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPrivacyPolicyQuery,
        GetPrivacyPolicyQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetPrivacyPolicyQuery,
    GetPrivacyPolicyQueryVariables
  >(GetPrivacyPolicyDocument, options);
}
export type GetPrivacyPolicyQueryHookResult = ReturnType<
  typeof useGetPrivacyPolicyQuery
>;
export type GetPrivacyPolicyLazyQueryHookResult = ReturnType<
  typeof useGetPrivacyPolicyLazyQuery
>;
export type GetPrivacyPolicySuspenseQueryHookResult = ReturnType<
  typeof useGetPrivacyPolicySuspenseQuery
>;
export type GetPrivacyPolicyQueryResult = Apollo.QueryResult<
  GetPrivacyPolicyQuery,
  GetPrivacyPolicyQueryVariables
>;
export const GetTermsOfUseDocument = gql`
  query getTermsOfUse {
    termsOfUse
  }
`;

/**
 * __useGetTermsOfUseQuery__
 *
 * To run a query within a React component, call `useGetTermsOfUseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTermsOfUseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTermsOfUseQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTermsOfUseQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetTermsOfUseQuery,
    GetTermsOfUseQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTermsOfUseQuery, GetTermsOfUseQueryVariables>(
    GetTermsOfUseDocument,
    options,
  );
}
export function useGetTermsOfUseLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTermsOfUseQuery,
    GetTermsOfUseQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTermsOfUseQuery, GetTermsOfUseQueryVariables>(
    GetTermsOfUseDocument,
    options,
  );
}
export function useGetTermsOfUseSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetTermsOfUseQuery,
        GetTermsOfUseQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetTermsOfUseQuery,
    GetTermsOfUseQueryVariables
  >(GetTermsOfUseDocument, options);
}
export type GetTermsOfUseQueryHookResult = ReturnType<
  typeof useGetTermsOfUseQuery
>;
export type GetTermsOfUseLazyQueryHookResult = ReturnType<
  typeof useGetTermsOfUseLazyQuery
>;
export type GetTermsOfUseSuspenseQueryHookResult = ReturnType<
  typeof useGetTermsOfUseSuspenseQuery
>;
export type GetTermsOfUseQueryResult = Apollo.QueryResult<
  GetTermsOfUseQuery,
  GetTermsOfUseQueryVariables
>;
export const FeatureFlagsDocument = gql`
  query featureFlags {
    featureFlags {
      googleAuth
      eventPassPromoCode
      subscriptionPromoCode
      monetizationEnabled
      bansEnabled
    }
  }
`;

/**
 * __useFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureFlagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFeatureFlagsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FeatureFlagsQuery,
    FeatureFlagsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<FeatureFlagsQuery, FeatureFlagsQueryVariables>(
    FeatureFlagsDocument,
    options,
  );
}
export function useFeatureFlagsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FeatureFlagsQuery,
    FeatureFlagsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<FeatureFlagsQuery, FeatureFlagsQueryVariables>(
    FeatureFlagsDocument,
    options,
  );
}
export function useFeatureFlagsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FeatureFlagsQuery,
        FeatureFlagsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<FeatureFlagsQuery, FeatureFlagsQueryVariables>(
    FeatureFlagsDocument,
    options,
  );
}
export type FeatureFlagsQueryHookResult = ReturnType<
  typeof useFeatureFlagsQuery
>;
export type FeatureFlagsLazyQueryHookResult = ReturnType<
  typeof useFeatureFlagsLazyQuery
>;
export type FeatureFlagsSuspenseQueryHookResult = ReturnType<
  typeof useFeatureFlagsSuspenseQuery
>;
export type FeatureFlagsQueryResult = Apollo.QueryResult<
  FeatureFlagsQuery,
  FeatureFlagsQueryVariables
>;
export const GetEventIdByCodeDocument = gql`
  query getEventIdByCode($code: String!) {
    eventByCode(code: $code) {
      success
      eventId
    }
  }
`;

/**
 * __useGetEventIdByCodeQuery__
 *
 * To run a query within a React component, call `useGetEventIdByCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventIdByCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventIdByCodeQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useGetEventIdByCodeQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetEventIdByCodeQuery,
    GetEventIdByCodeQueryVariables
  > &
    (
      | { variables: GetEventIdByCodeQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetEventIdByCodeQuery, GetEventIdByCodeQueryVariables>(
    GetEventIdByCodeDocument,
    options,
  );
}
export function useGetEventIdByCodeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEventIdByCodeQuery,
    GetEventIdByCodeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetEventIdByCodeQuery,
    GetEventIdByCodeQueryVariables
  >(GetEventIdByCodeDocument, options);
}
export function useGetEventIdByCodeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEventIdByCodeQuery,
        GetEventIdByCodeQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetEventIdByCodeQuery,
    GetEventIdByCodeQueryVariables
  >(GetEventIdByCodeDocument, options);
}
export type GetEventIdByCodeQueryHookResult = ReturnType<
  typeof useGetEventIdByCodeQuery
>;
export type GetEventIdByCodeLazyQueryHookResult = ReturnType<
  typeof useGetEventIdByCodeLazyQuery
>;
export type GetEventIdByCodeSuspenseQueryHookResult = ReturnType<
  typeof useGetEventIdByCodeSuspenseQuery
>;
export type GetEventIdByCodeQueryResult = Apollo.QueryResult<
  GetEventIdByCodeQuery,
  GetEventIdByCodeQueryVariables
>;
export const BetaSignupsDocument = gql`
  query BetaSignups {
    betaSignups {
      id
      email
      createdAt
    }
  }
`;

/**
 * __useBetaSignupsQuery__
 *
 * To run a query within a React component, call `useBetaSignupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBetaSignupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBetaSignupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useBetaSignupsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BetaSignupsQuery,
    BetaSignupsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<BetaSignupsQuery, BetaSignupsQueryVariables>(
    BetaSignupsDocument,
    options,
  );
}
export function useBetaSignupsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BetaSignupsQuery,
    BetaSignupsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<BetaSignupsQuery, BetaSignupsQueryVariables>(
    BetaSignupsDocument,
    options,
  );
}
export function useBetaSignupsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        BetaSignupsQuery,
        BetaSignupsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<BetaSignupsQuery, BetaSignupsQueryVariables>(
    BetaSignupsDocument,
    options,
  );
}
export type BetaSignupsQueryHookResult = ReturnType<typeof useBetaSignupsQuery>;
export type BetaSignupsLazyQueryHookResult = ReturnType<
  typeof useBetaSignupsLazyQuery
>;
export type BetaSignupsSuspenseQueryHookResult = ReturnType<
  typeof useBetaSignupsSuspenseQuery
>;
export type BetaSignupsQueryResult = Apollo.QueryResult<
  BetaSignupsQuery,
  BetaSignupsQueryVariables
>;
export const OnActiveEngagementChangedDocument = gql`
  subscription OnActiveEngagementChanged($eventId: String!) {
    activeEngagementChanged(eventId: $eventId) {
      activeEngagement {
        ...StageEngagement
      }
    }
  }
  ${StageEngagementFragmentDoc}
`;

/**
 * __useOnActiveEngagementChangedSubscription__
 *
 * To run a query within a React component, call `useOnActiveEngagementChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnActiveEngagementChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnActiveEngagementChangedSubscription({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useOnActiveEngagementChangedSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    OnActiveEngagementChangedSubscription,
    OnActiveEngagementChangedSubscriptionVariables
  > &
    (
      | {
          variables: OnActiveEngagementChangedSubscriptionVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnActiveEngagementChangedSubscription,
    OnActiveEngagementChangedSubscriptionVariables
  >(OnActiveEngagementChangedDocument, options);
}
export type OnActiveEngagementChangedSubscriptionHookResult = ReturnType<
  typeof useOnActiveEngagementChangedSubscription
>;
export type OnActiveEngagementChangedSubscriptionResult =
  Apollo.SubscriptionResult<OnActiveEngagementChangedSubscription>;
export const OnEngagementChangedDocument = gql`
  subscription OnEngagementChanged($engagementId: String!) {
    engagementChanged(engagementId: $engagementId) {
      engagement {
        id
        eventId
        createdAt
        updatedAt
        title
        description
        qrCodeCta
        startTime
        order
        endTime
        type
        viewConfig {
          ...PhotoCarouselViewConfigFields
          ...VoteForViewConfigFields
          ...SlidesViewConfigFields
          ...NowPlayingViewConfigFields
        }
        viewData {
          ...PhotoCarouselViewDataFields
          ...VoteForViewDataFields
          ...SlidesViewDataFields
          ...NowPlayingViewDataFields
        }
      }
    }
  }
  ${PhotoCarouselViewConfigFieldsFragmentDoc}
  ${VoteForViewConfigFieldsFragmentDoc}
  ${SlidesViewConfigFieldsFragmentDoc}
  ${NowPlayingViewConfigFieldsFragmentDoc}
  ${PhotoCarouselViewDataFieldsFragmentDoc}
  ${VoteForViewDataFieldsFragmentDoc}
  ${SlidesViewDataFieldsFragmentDoc}
  ${NowPlayingViewDataFieldsFragmentDoc}
`;

/**
 * __useOnEngagementChangedSubscription__
 *
 * To run a query within a React component, call `useOnEngagementChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnEngagementChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnEngagementChangedSubscription({
 *   variables: {
 *      engagementId: // value for 'engagementId'
 *   },
 * });
 */
export function useOnEngagementChangedSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    OnEngagementChangedSubscription,
    OnEngagementChangedSubscriptionVariables
  > &
    (
      | { variables: OnEngagementChangedSubscriptionVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnEngagementChangedSubscription,
    OnEngagementChangedSubscriptionVariables
  >(OnEngagementChangedDocument, options);
}
export type OnEngagementChangedSubscriptionHookResult = ReturnType<
  typeof useOnEngagementChangedSubscription
>;
export type OnEngagementChangedSubscriptionResult =
  Apollo.SubscriptionResult<OnEngagementChangedSubscription>;
export const OnMockEngagementChangedDocument = gql`
  subscription OnMockEngagementChanged($engagementId: String!) {
    mockEngagementChanged(engagementId: $engagementId) {
      engagement {
        id
        eventId
        createdAt
        updatedAt
        title
        description
        qrCodeCta
        startTime
        order
        endTime
        type
        viewConfig {
          ...PhotoCarouselViewConfigFields
          ...VoteForViewConfigFields
          ...SlidesViewConfigFields
          ...NowPlayingViewConfigFields
        }
        viewData {
          ...PhotoCarouselViewDataFields
          ...VoteForViewDataFields
          ...SlidesViewDataFields
          ...NowPlayingViewDataFields
        }
      }
    }
  }
  ${PhotoCarouselViewConfigFieldsFragmentDoc}
  ${VoteForViewConfigFieldsFragmentDoc}
  ${SlidesViewConfigFieldsFragmentDoc}
  ${NowPlayingViewConfigFieldsFragmentDoc}
  ${PhotoCarouselViewDataFieldsFragmentDoc}
  ${VoteForViewDataFieldsFragmentDoc}
  ${SlidesViewDataFieldsFragmentDoc}
  ${NowPlayingViewDataFieldsFragmentDoc}
`;

/**
 * __useOnMockEngagementChangedSubscription__
 *
 * To run a query within a React component, call `useOnMockEngagementChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnMockEngagementChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnMockEngagementChangedSubscription({
 *   variables: {
 *      engagementId: // value for 'engagementId'
 *   },
 * });
 */
export function useOnMockEngagementChangedSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    OnMockEngagementChangedSubscription,
    OnMockEngagementChangedSubscriptionVariables
  > &
    (
      | {
          variables: OnMockEngagementChangedSubscriptionVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnMockEngagementChangedSubscription,
    OnMockEngagementChangedSubscriptionVariables
  >(OnMockEngagementChangedDocument, options);
}
export type OnMockEngagementChangedSubscriptionHookResult = ReturnType<
  typeof useOnMockEngagementChangedSubscription
>;
export type OnMockEngagementChangedSubscriptionResult =
  Apollo.SubscriptionResult<OnMockEngagementChangedSubscription>;
export const OnStageEngagementSubmissionsChangedDocument = gql`
  subscription OnStageEngagementSubmissionsChanged($engagementId: String!) {
    engagementSubmissionsChanged(engagementId: $engagementId) {
      submissions {
        ...StageSubmission
      }
    }
  }
  ${StageSubmissionFragmentDoc}
`;

/**
 * __useOnStageEngagementSubmissionsChangedSubscription__
 *
 * To run a query within a React component, call `useOnStageEngagementSubmissionsChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnStageEngagementSubmissionsChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnStageEngagementSubmissionsChangedSubscription({
 *   variables: {
 *      engagementId: // value for 'engagementId'
 *   },
 * });
 */
export function useOnStageEngagementSubmissionsChangedSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    OnStageEngagementSubmissionsChangedSubscription,
    OnStageEngagementSubmissionsChangedSubscriptionVariables
  > &
    (
      | {
          variables: OnStageEngagementSubmissionsChangedSubscriptionVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnStageEngagementSubmissionsChangedSubscription,
    OnStageEngagementSubmissionsChangedSubscriptionVariables
  >(OnStageEngagementSubmissionsChangedDocument, options);
}
export type OnStageEngagementSubmissionsChangedSubscriptionHookResult =
  ReturnType<typeof useOnStageEngagementSubmissionsChangedSubscription>;
export type OnStageEngagementSubmissionsChangedSubscriptionResult =
  Apollo.SubscriptionResult<OnStageEngagementSubmissionsChangedSubscription>;
export const OnFanEngagementSubmissionsChangedDocument = gql`
  subscription OnFanEngagementSubmissionsChanged($engagementId: String!) {
    engagementSubmissionsChanged(engagementId: $engagementId) {
      submissions {
        ...FanSubmission
      }
    }
  }
  ${FanSubmissionFragmentDoc}
`;

/**
 * __useOnFanEngagementSubmissionsChangedSubscription__
 *
 * To run a query within a React component, call `useOnFanEngagementSubmissionsChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnFanEngagementSubmissionsChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnFanEngagementSubmissionsChangedSubscription({
 *   variables: {
 *      engagementId: // value for 'engagementId'
 *   },
 * });
 */
export function useOnFanEngagementSubmissionsChangedSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    OnFanEngagementSubmissionsChangedSubscription,
    OnFanEngagementSubmissionsChangedSubscriptionVariables
  > &
    (
      | {
          variables: OnFanEngagementSubmissionsChangedSubscriptionVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnFanEngagementSubmissionsChangedSubscription,
    OnFanEngagementSubmissionsChangedSubscriptionVariables
  >(OnFanEngagementSubmissionsChangedDocument, options);
}
export type OnFanEngagementSubmissionsChangedSubscriptionHookResult =
  ReturnType<typeof useOnFanEngagementSubmissionsChangedSubscription>;
export type OnFanEngagementSubmissionsChangedSubscriptionResult =
  Apollo.SubscriptionResult<OnFanEngagementSubmissionsChangedSubscription>;
export const OnMockStageEngagementSubmissionsChangedDocument = gql`
  subscription OnMockStageEngagementSubmissionsChanged($engagementId: String!) {
    mockEngagementSubmissionsChanged(engagementId: $engagementId) {
      submissions {
        ...StageSubmission
      }
    }
  }
  ${StageSubmissionFragmentDoc}
`;

/**
 * __useOnMockStageEngagementSubmissionsChangedSubscription__
 *
 * To run a query within a React component, call `useOnMockStageEngagementSubmissionsChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnMockStageEngagementSubmissionsChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnMockStageEngagementSubmissionsChangedSubscription({
 *   variables: {
 *      engagementId: // value for 'engagementId'
 *   },
 * });
 */
export function useOnMockStageEngagementSubmissionsChangedSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    OnMockStageEngagementSubmissionsChangedSubscription,
    OnMockStageEngagementSubmissionsChangedSubscriptionVariables
  > &
    (
      | {
          variables: OnMockStageEngagementSubmissionsChangedSubscriptionVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnMockStageEngagementSubmissionsChangedSubscription,
    OnMockStageEngagementSubmissionsChangedSubscriptionVariables
  >(OnMockStageEngagementSubmissionsChangedDocument, options);
}
export type OnMockStageEngagementSubmissionsChangedSubscriptionHookResult =
  ReturnType<typeof useOnMockStageEngagementSubmissionsChangedSubscription>;
export type OnMockStageEngagementSubmissionsChangedSubscriptionResult =
  Apollo.SubscriptionResult<OnMockStageEngagementSubmissionsChangedSubscription>;
export const OnMockFanEngagementSubmissionsChangedDocument = gql`
  subscription OnMockFanEngagementSubmissionsChanged($engagementId: String!) {
    mockEngagementSubmissionsChanged(engagementId: $engagementId) {
      submissions {
        ...FanSubmission
      }
    }
  }
  ${FanSubmissionFragmentDoc}
`;

/**
 * __useOnMockFanEngagementSubmissionsChangedSubscription__
 *
 * To run a query within a React component, call `useOnMockFanEngagementSubmissionsChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnMockFanEngagementSubmissionsChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnMockFanEngagementSubmissionsChangedSubscription({
 *   variables: {
 *      engagementId: // value for 'engagementId'
 *   },
 * });
 */
export function useOnMockFanEngagementSubmissionsChangedSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    OnMockFanEngagementSubmissionsChangedSubscription,
    OnMockFanEngagementSubmissionsChangedSubscriptionVariables
  > &
    (
      | {
          variables: OnMockFanEngagementSubmissionsChangedSubscriptionVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnMockFanEngagementSubmissionsChangedSubscription,
    OnMockFanEngagementSubmissionsChangedSubscriptionVariables
  >(OnMockFanEngagementSubmissionsChangedDocument, options);
}
export type OnMockFanEngagementSubmissionsChangedSubscriptionHookResult =
  ReturnType<typeof useOnMockFanEngagementSubmissionsChangedSubscription>;
export type OnMockFanEngagementSubmissionsChangedSubscriptionResult =
  Apollo.SubscriptionResult<OnMockFanEngagementSubmissionsChangedSubscription>;
export const OnReactionsCreatedDocument = gql`
  subscription OnReactionsCreated($submissionId: String!) {
    reactionsCreated(submissionId: $submissionId) {
      reactions {
        ...StageReaction
      }
    }
  }
  ${StageReactionFragmentDoc}
`;

/**
 * __useOnReactionsCreatedSubscription__
 *
 * To run a query within a React component, call `useOnReactionsCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnReactionsCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnReactionsCreatedSubscription({
 *   variables: {
 *      submissionId: // value for 'submissionId'
 *   },
 * });
 */
export function useOnReactionsCreatedSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    OnReactionsCreatedSubscription,
    OnReactionsCreatedSubscriptionVariables
  > &
    (
      | { variables: OnReactionsCreatedSubscriptionVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnReactionsCreatedSubscription,
    OnReactionsCreatedSubscriptionVariables
  >(OnReactionsCreatedDocument, options);
}
export type OnReactionsCreatedSubscriptionHookResult = ReturnType<
  typeof useOnReactionsCreatedSubscription
>;
export type OnReactionsCreatedSubscriptionResult =
  Apollo.SubscriptionResult<OnReactionsCreatedSubscription>;
export const OnSubmissionCreatedDocument = gql`
  subscription OnSubmissionCreated($engagementId: String!) {
    submissionCreated(engagementId: $engagementId) {
      submission {
        ...FullSubmission
      }
    }
  }
  ${FullSubmissionFragmentDoc}
`;

/**
 * __useOnSubmissionCreatedSubscription__
 *
 * To run a query within a React component, call `useOnSubmissionCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnSubmissionCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnSubmissionCreatedSubscription({
 *   variables: {
 *      engagementId: // value for 'engagementId'
 *   },
 * });
 */
export function useOnSubmissionCreatedSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    OnSubmissionCreatedSubscription,
    OnSubmissionCreatedSubscriptionVariables
  > &
    (
      | { variables: OnSubmissionCreatedSubscriptionVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnSubmissionCreatedSubscription,
    OnSubmissionCreatedSubscriptionVariables
  >(OnSubmissionCreatedDocument, options);
}
export type OnSubmissionCreatedSubscriptionHookResult = ReturnType<
  typeof useOnSubmissionCreatedSubscription
>;
export type OnSubmissionCreatedSubscriptionResult =
  Apollo.SubscriptionResult<OnSubmissionCreatedSubscription>;
export const OnSubmissionDeletedDocument = gql`
  subscription OnSubmissionDeleted($engagementId: String!) {
    submissionDeleted(engagementId: $engagementId) {
      submissionId
    }
  }
`;

/**
 * __useOnSubmissionDeletedSubscription__
 *
 * To run a query within a React component, call `useOnSubmissionDeletedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnSubmissionDeletedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnSubmissionDeletedSubscription({
 *   variables: {
 *      engagementId: // value for 'engagementId'
 *   },
 * });
 */
export function useOnSubmissionDeletedSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    OnSubmissionDeletedSubscription,
    OnSubmissionDeletedSubscriptionVariables
  > &
    (
      | { variables: OnSubmissionDeletedSubscriptionVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnSubmissionDeletedSubscription,
    OnSubmissionDeletedSubscriptionVariables
  >(OnSubmissionDeletedDocument, options);
}
export type OnSubmissionDeletedSubscriptionHookResult = ReturnType<
  typeof useOnSubmissionDeletedSubscription
>;
export type OnSubmissionDeletedSubscriptionResult =
  Apollo.SubscriptionResult<OnSubmissionDeletedSubscription>;
export const OnMockReactionsCreatedDocument = gql`
  subscription OnMockReactionsCreated($submissionId: String!) {
    mockReactionsCreated(submissionId: $submissionId) {
      reactions {
        ...StageReaction
      }
    }
  }
  ${StageReactionFragmentDoc}
`;

/**
 * __useOnMockReactionsCreatedSubscription__
 *
 * To run a query within a React component, call `useOnMockReactionsCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnMockReactionsCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnMockReactionsCreatedSubscription({
 *   variables: {
 *      submissionId: // value for 'submissionId'
 *   },
 * });
 */
export function useOnMockReactionsCreatedSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    OnMockReactionsCreatedSubscription,
    OnMockReactionsCreatedSubscriptionVariables
  > &
    (
      | {
          variables: OnMockReactionsCreatedSubscriptionVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnMockReactionsCreatedSubscription,
    OnMockReactionsCreatedSubscriptionVariables
  >(OnMockReactionsCreatedDocument, options);
}
export type OnMockReactionsCreatedSubscriptionHookResult = ReturnType<
  typeof useOnMockReactionsCreatedSubscription
>;
export type OnMockReactionsCreatedSubscriptionResult =
  Apollo.SubscriptionResult<OnMockReactionsCreatedSubscription>;
export const OnMockSubmissionCreatedDocument = gql`
  subscription OnMockSubmissionCreated($engagementId: String!) {
    mockSubmissionCreated(engagementId: $engagementId) {
      submission {
        ...FullSubmission
      }
    }
  }
  ${FullSubmissionFragmentDoc}
`;

/**
 * __useOnMockSubmissionCreatedSubscription__
 *
 * To run a query within a React component, call `useOnMockSubmissionCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnMockSubmissionCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnMockSubmissionCreatedSubscription({
 *   variables: {
 *      engagementId: // value for 'engagementId'
 *   },
 * });
 */
export function useOnMockSubmissionCreatedSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    OnMockSubmissionCreatedSubscription,
    OnMockSubmissionCreatedSubscriptionVariables
  > &
    (
      | {
          variables: OnMockSubmissionCreatedSubscriptionVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnMockSubmissionCreatedSubscription,
    OnMockSubmissionCreatedSubscriptionVariables
  >(OnMockSubmissionCreatedDocument, options);
}
export type OnMockSubmissionCreatedSubscriptionHookResult = ReturnType<
  typeof useOnMockSubmissionCreatedSubscription
>;
export type OnMockSubmissionCreatedSubscriptionResult =
  Apollo.SubscriptionResult<OnMockSubmissionCreatedSubscription>;
export const OnMockSubmissionDeletedDocument = gql`
  subscription OnMockSubmissionDeleted($engagementId: String!) {
    mockSubmissionDeleted(engagementId: $engagementId) {
      submissionId
    }
  }
`;

/**
 * __useOnMockSubmissionDeletedSubscription__
 *
 * To run a query within a React component, call `useOnMockSubmissionDeletedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnMockSubmissionDeletedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnMockSubmissionDeletedSubscription({
 *   variables: {
 *      engagementId: // value for 'engagementId'
 *   },
 * });
 */
export function useOnMockSubmissionDeletedSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    OnMockSubmissionDeletedSubscription,
    OnMockSubmissionDeletedSubscriptionVariables
  > &
    (
      | {
          variables: OnMockSubmissionDeletedSubscriptionVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnMockSubmissionDeletedSubscription,
    OnMockSubmissionDeletedSubscriptionVariables
  >(OnMockSubmissionDeletedDocument, options);
}
export type OnMockSubmissionDeletedSubscriptionHookResult = ReturnType<
  typeof useOnMockSubmissionDeletedSubscription
>;
export type OnMockSubmissionDeletedSubscriptionResult =
  Apollo.SubscriptionResult<OnMockSubmissionDeletedSubscription>;
